function BCSfFilterCallback(e) {
    bcsffilter.afterGetFilterData(e, e.event_type)
}

function viewMoreFilterOption(e) {
    var t = "." + bcsffilter.getClass("filterBlockContent"),
        i = jQ(e).parents(bcsffilter.selector.filterTreeHorizontal).length > 0 ? t + "-inner" : t,
        n = jQ(e).parents("." + bcsffilter.class.filterOption).find(t),
        r = "." + bcsffilter.getClass("filterOptionViewMoreList");
    e = jQ(e).parent(), jQ(e).siblings(i).css({
        "overflow-y": "auto"
    }), jQ(e).siblings(i).find("li").show(), 1 == n.data("has-scrollbar") && bcsffilter.buildFilterScrollbar(n);
    var o = jQ(r).length > 0 ? jQ(r).val().split(",") : [];
    o.push(jQ(e).parents("." + bcsffilter.class.filterOption).attr("data-id")), jQ(r).val(o.join(","));
    var a = bcsffilter.getTemplate("filterOptionViewLess").replace(/{{label.viewLess}}/g, bcsffilter.getSettingValue("label.viewLess"));
    jQ(e).after(a), jQ(e).remove()
}

function viewLessFilterOption(e) {
    var t = "." + bcsffilter.getClass("filterBlockContent"),
        i = jQ(e).parents(bcsffilter.selector.filterTreeHorizontal).length > 0 ? t + "-inner" : t,
        n = jQ(e).parents("." + bcsffilter.class.filterOption).find(t),
        r = "." + bcsffilter.getClass("filterOptionViewMoreList"),
        o = jQ(e).parents(bcsffilter.selector.filterTreeHorizontal).length > 0;
    e = jQ(e).parent();
    var a = jQ(e).parents("." + bcsffilter.class.filterOption).data("display-type");
    1 == n.data("has-scrollbar") && bcsffilter.removeScrollbar(jQ(e).siblings(i));
    var s = o ? bcsffilter.getSettingValue("general.startViewMoreH") : bcsffilter.getSettingValue("general.startViewMore"),
        l = s.hasOwnProperty(a) ? s[a] : 15;
    jQ(e).siblings(i).find("li:gt(" + (l - 1) + ")").hide(), jQ(e).siblings(i).css({
        overflow: "hidden"
    });
    var c = jQ(r).length > 0 ? jQ(r).val().split(",") : [],
        u = jQ(e).parents("." + bcsffilter.class.filterOption).attr("data-id");
    c = jQ.grep(c, function(e) {
        return e !== u
    }), jQ(r).val(c.join(","));
    var p = bcsffilter.getTemplate("filterOptionViewMore").replace(/{{label.viewMore}}/g, bcsffilter.getSettingValue("label.viewMore"));
    jQ(e).after(p), jQ(e).remove()
}

function onInteractWithFilterOptionValue(e, t, i, n, r, o) {
    var a = bcsffilter,
        s = jQ(t).data("count");
    o = void 0 !== o && "true" === o;
    if (a.isMobile() && "style2" == a.mobileStyle) e.preventDefault(), (s > 0 || !0 === o && "collection" == i) && (a.internalClick = !0, "single" == r && jQ(".bc-sf-filter-option-block-active").find("ul li").children().removeClass("selected"), jQ(t).toggleClass("selected"), jQ(t).siblings().toggleClass("selected"), a.buildFilterSelectionMobile());
    else if (!1 === o && (e.preventDefault(), s > 0 || null == s)) {
        a.internalClick = !0;
        var l = jQ(t).attr("data-id"),
            c = decodeURIComponent(jQ(t).attr("data-value"));
        "collection" == i && (a.queryParams.collection_scope = a.collectionId = jQ(t).data("collection-scope"));
        var u = "list" != n || "single" != r || "collection" != i && "sub_category" != n ? a.buildFilterOptionLink(l, c, i, n, r) : jQ(t).attr("href");
        a.onChangeData(u, i, c, l)
    }
}

function onSelectFilterOptionItem(e, t) {
    if (jQ(t).data("count") > 0) {
        bcsffilter.selectFilter = !0;
        var i = jQ(t).data("value").toString(),
            n = jQ(t).parents("." + bcsffilter.class.filterOption).data("selected") || [];
        jQ(t).hasClass("selected") ? (jQ(t).parent().children().removeClass("selected"), jQ(t).parent().children().attr("aria-expanded", "false"), n.length && n.splice(n.indexOf(i), 1)) : (jQ(t).parent().children().addClass("selected"), jQ(t).parent().children().attr("aria-expanded", "true"), n.push(i)), n = n.filter(function(e) {
            return e.length > 0
        }), jQ(t).parents("." + bcsffilter.class.filterOption).attr("data-selected", JSON.stringify(n))
    }
}

function clearAllFilterOptions(e) {
    jQ("#" + bcsffilter.selector.filterOptionOpenValue).val(null), bcsffilter.internalClick = !0;
    for (var t = window.location.search.substr(1).split("&"), i = [], n = 0; n < t.length; n++)(t[n].indexOf("sort=") > -1 || t[n].indexOf("display=") > -1 || t[n].indexOf("q=") > -1) && i.push(t[n]);
    var r = window.location.href.split("?")[0];
    i.length > 0 && (r += "?" + i.join("&")), bcsffilter.onChangeData(r, "clearAllFilterOptions")
}

function clearFilterOption(e, t, i) {
    if (e.preventDefault(), bcsffilter.internalClick = !0, bcsffilter.queryParams.hasOwnProperty(i)) {
        var n = window.location.href.split("?")[0];
        if (window.location.search.length) {
            for (var r, o = [], a = [], s = 0, l = window.location.search.substr(1).split("&"); s < l.length; s++)
                if ((r = l[s].split("=")).length > 1) {
                    var c = r[0],
                        u = r[1];
                    c != i && "_" != c && c != i + "_and_condition" && c != i + "_show_exact_rating" && (c.indexOf("pf_") > -1 ? o.push(c + "=" + u) : "page" != c && a.push(c + "=" + u))
                }(o.length > 0 || a.length > 0) && (a.length > 0 ? (n += "?", n += a.join("&"), o.length > 0 && (n += "&_=" + bcsffilter.prefix + "&" + o.join("&"))) : o.length > 0 && (n += "?_=" + bcsffilter.prefix + "&" + o.join("&")))
        }
        i.indexOf("pf_c_") > -1 && (n = removeCollectionScopeParamFromUrl(n)), jQ('[data-id="' + i + '"]').data("keep-scroll-disabled", !0), bcsffilter.onChangeData(n, "f")
    }
}

function applyFilterOption() {
    bcsffilter.buildFilterSelectionMobile(), showResultMobile()
}

function showResultMobile(e) {
    jQ(".bc-sf-filter-option-amount").hide();
    var t = jQ(".bc-sf-filter-option-block-active"),
        i = t.data("type"),
        n = "&sort=" + bcsffilter.queryParams.sort + "&display=" + bcsffilter.queryParams.display,
        r = window.location.pathname + "?_=pf" + n + jQ("#bc-sf-filter-params").val(),
        o = "filter";
    bcsffilter.isCollectionParam(i) && t.find(".selected").length > 0 && (r = t.find(".selected").attr("href"), bcsffilter.queryParams.collection_scope = bcsffilter.collectionId = jQ(".bc-sf-filter-option-block-active").find(".selected").data("collection-scope"), o = "collection"), bcsffilter.onChangeData(r, o, "", function() {
        var e = jQ("#bc-sf-filter-options-wrapper");
        e.length > 0 && e.animate({
            width: "toggle"
        }, "fast", function() {
            var e = bcsffilter.class;
            jQ("." + e.filterOption).show(), jQ("." + e.filterBlockTitle).show(), jQ("." + e.filterBlockContent).hide(), jQ("." + e.filterOption).removeClass("bc-sf-filter-option-block-active")
        })
    }), void 0 !== e && !0 === e && closeFilterMobile()
}

function clearFilterOptionMobile() {
    var e = jQ(".bc-sf-filter-option-block-active"),
        t = e.attr("data-id");
    if ("range" == e.data("display-type")) {
        var i = e.find(".bc-sf-filter-option-range-slider").attr("id"),
            n = document.getElementById(i),
            r = n.noUiSlider.options.range;
        n.noUiSlider.set([r.min, r.max]), jQ("#" + i).removeClass("selected")
    } else e.each(function() {
        jQ(this).find("ul li").children().removeClass("selected"), bcsffilter.queryParams.hasOwnProperty(t) && bcsffilter.queryParams[t] && bcsffilter.queryParams[t].length && (bcsffilter.queryParams[t] = [])
    });
    bcsffilter.buildFilterSelectionMobile()
}

function closeFilterMobile() {
    jQ("#bc-sf-filter-tree").removeClass("bc-sf-filter-tree-mobile-open")
}

function onInteractWithToolbar(e, t, i, n) {
    e.preventDefault(), bcsffilter.internalClick = !0;
    var r = bcsffilter.buildToolbarLink(t, i, n);
    bcsffilter.onChangeData(r, t)
}

function closeSuggestionMobile(e, t) {
    jQ(e).autocomplete("close"), jQ("." + bcsffilter.class.searchSuggestion + '[data-search-box="' + e + '"]').parent().hide(), (t = void 0 !== t && t) && jQ(".bc-sf-search-suggestion-mobile-top-panel,.bc-sf-search-suggestion-mobile-overlay").hide(), setValueAllSearchBoxes(), jQ(".bc-sf-search-no-tabindex").attr("tabindex", -1), jQ("body").hasClass(bcsffilter.getClass("searchSuggestionMobileOpen")) && jQ("body").removeClass(bcsffilter.getClass("searchSuggestionMobileOpen")), bcsffilter.afterCloseSuggestionMobile(e, t)
}

function clearSuggestionMobile(e) {
    hideClearSuggestionBtn(), bcsffilter.currentTerm = "", setValueAllSearchBoxes(), closeSuggestionMobile(e), jQ(e).focus()
}

function setValueAllSearchBoxes(e) {
    e = void 0 !== e ? e : bcsffilter.currentTerm;
    jQ('input[name="' + bcsffilter.searchTermKey + '"]').val(e)
}

function submitSearchFormMobile(e, t) {
    var i = bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm, e, t);
    bcsffilter.submitSearch(bcsffilter.currentTerm, e, i, t)
}

function beforeSubmitSearchForm(e, t) {
    var i = jQ(e).val();
    !i && t && t.target && (i = t.target.value);
    var n = bcsffilter.getSearchRedirectUrl(i);
    bcsffilter.submitSearch(i, e, n, t)
}

function getSuggestionInstance(e) {
    if (jQ(e).data("ui-autocomplete")) {
        var t = jQ(e).autocomplete("instance");
        if (void 0 !== t) return t.menu.element[0]
    }
}

function getSuggestionPosition(e) {
    var t = bcsffilter.getSettingValue("search.suggestionPosition");
    if ("" != t) return t;
    var i = jQ(window).width() / 2;
    return jQ(e).offset().left < i ? "left" : "right"
}

function BCSfSuggestionCallback(e) {
    var t = bcsffilter,
        i = t.suggestionCache;
    if (e.hasOwnProperty("prev_query")) {
        var n = e.prev_query;
        if (i.hasOwnProperty(n)) {
            var r, o = i[n],
                a = ["collections", "did_you_mean", "pages", "suggestions", "suggest_query"],
                s = a.length;
            for (r = 0; r < s; r++) e[a[r]] = getValueInObjectArray(a[r], o);
            e.prev_total_product = getValueInObjectArray("total_product", o), o[t.findIndexArray("products", o, "key")].values = e.products, o.push({
                key: "local_cache",
                values: !0
            }), o.push({
                key: "suggest_total_product",
                values: e.total_product
            }), t.suggestionCache[n] = o
        }
    }
    suggestionCallback(jQ.map(e, function(e, t) {
        return {
            key: t,
            values: e
        }
    }))
}

function hideClearSuggestionBtn() {
    jQ(".bc-sf-search-btn-clear-suggestion").hide()
}

function showClearSuggestionBtn() {
    jQ(".bc-sf-search-btn-clear-suggestion").show()
}

function removePageParamFromUrl(e) {
    var t = bcsffilter;
    return t.queryParams.hasOwnProperty("page") && (e = e.replace("&page=" + t.queryParams.page, "").replace("?page=" + t.queryParams.page + "&", "?").replace("?page=" + t.queryParams.page, "")), e
}

function removeCollectionScopeParamFromUrl(e) {
    var t = bcsffilter;
    return t.queryParams.hasOwnProperty("collection_scope") && (e = e.replace("&collection_scope=" + t.queryParams.collection_scope, "")), e
}

function encodeURIParamValue(e) {
    return encodeURIComponent(e).replace(/&/g, "%26").replace(/'/g, "%27").replace(/\*/g, "%2A")
}

function convertObjectToArray(e) {
    return Object.keys(e).map(function(t) {
        return e[t]
    })
}

function sortArrayObject(e, t) {
    void 0 !== t && e.sort(function(e, i) {
        var n = e[t],
            r = i[t];
        return "string" == typeof n && (n = n.toLowerCase()), "string" == typeof r && (r = r.toLowerCase()), n < r ? -1 : n > r ? 1 : 0
    })
}

function getParam(e, t) {
    t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
    var i = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
    return i ? i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "" : null
}

function mergeObject(e, t) {
    for (var i in t) try {
        e[i] = t[i].constructor == Object ? mergeObject(e[i], t[i]) : t[i]
    } catch (n) {
        e[i] = t[i]
    }
    return e
}



function capitalize(e, t, i) {
    i = void 0 !== i && i;
    return (t = void 0 !== t && t) && (e = e.toLowerCase()), i ? e.charAt(0).toUpperCase() + e.slice(1) : e.replace(/(?:^|\s)\S/g, function(e) {
        return e.toUpperCase()
    })
}

function getValueInObjectArray(e, t, i, n) {
    void 0 === i && (i = "key"), void 0 === n && (n = "values");
    var r = bcsffilter.findIndexArray(e, t, i);
    return r > -1 && t[r].hasOwnProperty(n) ? t[r][n] : ""
}

function isInt(e) {
    return Number(e) === e && e % 1 == 0
}

function isFloat(e) {
    return Number(e) === e && e % 1 != 0
}

function getNumberDecimals(e) {
    return (e.toString().split(".")[1] || []).length
}

function uniq(e) {
    return e.filter(function(e, t, i) {
        return i.indexOf(e) === t
    })
}

function stripHtml(e) {
    return jQ("<p>" + e + "</p>").text()
}

function stripScriptTag(e) {
    if (e) return e.replace(/<script[^>]*>.*?<\/script>/gi, "")
}

function getFilePath(e, t, i) {
    var n = bcsffilter,
        r = (t = void 0 !== t ? t : "png", i = void 0 !== i ? i : "1", n.fileUrl.lastIndexOf("?"));
    if (r > 0) var o = n.fileUrl.substring(0, r);
    else o = n.fileUrl;
    return o + (e + ".") + t + "?v=" + i
}! function(e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    function i(e) {
        var t = e.length,
            i = J.type(e);
        return "function" !== i && !J.isWindow(e) && (!(1 !== e.nodeType || !t) || "array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }

    function n(e, t, i) {
        if (J.isFunction(t)) return J.grep(e, function(e, n) {
            return !!t.call(e, n, e) !== i
        });
        if (t.nodeType) return J.grep(e, function(e) {
            return e === t !== i
        });
        if ("string" == typeof t) {
            if (oe.test(t)) return J.filter(t, e, i);
            t = J.filter(t, e)
        }
        return J.grep(e, function(e) {
            return J.inArray(e, t) >= 0 !== i
        })
    }

    function r(e, t) {
        do {
            e = e[t]
        } while (e && 1 !== e.nodeType);
        return e
    }

    function o() {
        se.addEventListener ? (se.removeEventListener("DOMContentLoaded", a, !1), e.removeEventListener("load", a, !1)) : (se.detachEvent("onreadystatechange", a), e.detachEvent("onload", a))
    }

    function a() {
        (se.addEventListener || "load" === event.type || "complete" === se.readyState) && (o(), J.ready())
    }

    function s(e, t, i) {
        if (void 0 === i && 1 === e.nodeType) {
            var n = "data-" + t.replace(ve, "-$1").toLowerCase();
            if ("string" == typeof(i = e.getAttribute(n))) {
                try {
                    i = "true" === i || "false" !== i && ("null" === i ? null : +i + "" === i ? +i : me.test(i) ? J.parseJSON(i) : i)
                } catch (e) {}
                J.data(e, t, i)
            } else i = void 0
        }
        return i
    }

    function l(e) {
        var t;
        for (t in e)
            if (("data" !== t || !J.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
        return !0
    }

    function c(e, t, i, n) {
        if (J.acceptData(e)) {
            var r, o, a = J.expando,
                s = e.nodeType,
                l = s ? J.cache : e,
                c = s ? e[a] : e[a] && a;
            if (c && l[c] && (n || l[c].data) || void 0 !== i || "string" != typeof t) return c || (c = s ? e[a] = R.pop() || J.guid++ : a), l[c] || (l[c] = s ? {} : {
                toJSON: J.noop
            }), ("object" == typeof t || "function" == typeof t) && (n ? l[c] = J.extend(l[c], t) : l[c].data = J.extend(l[c].data, t)), o = l[c], n || (o.data || (o.data = {}), o = o.data), void 0 !== i && (o[J.camelCase(t)] = i), "string" == typeof t ? null == (r = o[t]) && (r = o[J.camelCase(t)]) : r = o, r
        }
    }

    function u(e, t, i) {
        if (J.acceptData(e)) {
            var n, r, o = e.nodeType,
                a = o ? J.cache : e,
                s = o ? e[J.expando] : J.expando;
            if (a[s]) {
                if (t && (n = i ? a[s] : a[s].data)) {
                    J.isArray(t) ? t = t.concat(J.map(t, J.camelCase)) : t in n ? t = [t] : t = (t = J.camelCase(t)) in n ? [t] : t.split(" "), r = t.length;
                    for (; r--;) delete n[t[r]];
                    if (i ? !l(n) : !J.isEmptyObject(n)) return
                }(i || (delete a[s].data, l(a[s]))) && (o ? J.cleanData([e], !0) : G.deleteExpando || a != a.window ? delete a[s] : a[s] = null)
            }
        }
    }

    function p() {
        return !0
    }

    function d() {
        return !1
    }

    function f() {
        try {
            return se.activeElement
        } catch (e) {}
    }

    function h(e) {
        var t = Oe.split("|"),
            i = e.createDocumentFragment();
        if (i.createElement)
            for (; t.length;) i.createElement(t.pop());
        return i
    }

    function g(e, t) {
        var i, n, r = 0,
            o = typeof e.getElementsByTagName !== ge ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== ge ? e.querySelectorAll(t || "*") : void 0;
        if (!o)
            for (o = [], i = e.childNodes || e; null != (n = i[r]); r++) !t || J.nodeName(n, t) ? o.push(n) : J.merge(o, g(n, t));
        return void 0 === t || t && J.nodeName(e, t) ? J.merge([e], o) : o
    }

    function m(e) {
        Ce.test(e.type) && (e.defaultChecked = e.checked)
    }

    function v(e, t) {
        return J.nodeName(e, "table") && J.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }

    function b(e) {
        return e.type = (null !== J.find.attr(e, "type")) + "/" + e.type, e
    }

    function y(e) {
        var t = De.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e
    }

    function S(e, t) {
        for (var i, n = 0; null != (i = e[n]); n++) J._data(i, "globalEval", !t || J._data(t[n], "globalEval"))
    }

    function w(e, t) {
        if (1 === t.nodeType && J.hasData(e)) {
            var i, n, r, o = J._data(e),
                a = J._data(t, o),
                s = o.events;
            if (s)
                for (i in delete a.handle, a.events = {}, s)
                    for (n = 0, r = s[i].length; r > n; n++) J.event.add(t, i, s[i][n]);
            a.data && (a.data = J.extend({}, a.data))
        }
    }

    function C(e, t) {
        var i, n, r;
        if (1 === t.nodeType) {
            if (i = t.nodeName.toLowerCase(), !G.noCloneEvent && t[J.expando]) {
                for (n in (r = J._data(t)).events) J.removeEvent(t, n, r.handle);
                t.removeAttribute(J.expando)
            }
            "script" === i && t.text !== e.text ? (b(t).text = e.text, y(t)) : "object" === i ? (t.parentNode && (t.outerHTML = e.outerHTML), G.html5Clone && e.innerHTML && !J.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === i && Ce.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === i ? t.defaultSelected = t.selected = e.defaultSelected : ("input" === i || "textarea" === i) && (t.defaultValue = e.defaultValue)
        }
    }

    function x(t, i) {
        var n, r = J(i.createElement(t)).appendTo(i.body),
            o = e.getDefaultComputedStyle && (n = e.getDefaultComputedStyle(r[0])) ? n.display : J.css(r[0], "display");
        return r.detach(), o
    }

    function j(e) {
        var t = se,
            i = ze[e];
        return i || ("none" !== (i = x(e, t)) && i || ((t = ((qe = (qe || J("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentWindow || qe[0].contentDocument).document).write(), t.close(), i = x(e, t), qe.detach()), ze[e] = i), i
    }

    function T(e, t) {
        return {
            get: function() {
                var i = e();
                if (null != i) return i ? void delete this.get : (this.get = t).apply(this, arguments)
            }
        }
    }

    function P(e, t) {
        if (t in e) return t;
        for (var i = t.charAt(0).toUpperCase() + t.slice(1), n = t, r = nt.length; r--;)
            if ((t = nt[r] + i) in e) return t;
        return n
    }

    function F(e, t) {
        for (var i, n, r, o = [], a = 0, s = e.length; s > a; a++)(n = e[a]).style && (o[a] = J._data(n, "olddisplay"), i = n.style.display, t ? (o[a] || "none" !== i || (n.style.display = ""), "" === n.style.display && Se(n) && (o[a] = J._data(n, "olddisplay", j(n.nodeName)))) : (r = Se(n), (i && "none" !== i || !r) && J._data(n, "olddisplay", r ? i : J.css(n, "display"))));
        for (a = 0; s > a; a++)(n = e[a]).style && (t && "none" !== n.style.display && "" !== n.style.display || (n.style.display = t ? o[a] || "" : "none"));
        return e
    }

    function O(e, t, i) {
        var n = Ze.exec(t);
        return n ? Math.max(0, n[1] - (i || 0)) + (n[2] || "px") : t
    }

    function k(e, t, i, n, r) {
        for (var o = i === (n ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; 4 > o; o += 2) "margin" === i && (a += J.css(e, i + ye[o], !0, r)), n ? ("content" === i && (a -= J.css(e, "padding" + ye[o], !0, r)), "margin" !== i && (a -= J.css(e, "border" + ye[o] + "Width", !0, r))) : (a += J.css(e, "padding" + ye[o], !0, r), "padding" !== i && (a += J.css(e, "border" + ye[o] + "Width", !0, r)));
        return a
    }

    function _(e, t, i) {
        var n = !0,
            r = "width" === t ? e.offsetWidth : e.offsetHeight,
            o = We(e),
            a = G.boxSizing && "border-box" === J.css(e, "boxSizing", !1, o);
        if (0 >= r || null == r) {
            if ((0 > (r = Ue(e, t, o)) || null == r) && (r = e.style[t]), Xe.test(r)) return r;
            n = a && (G.boxSizingReliable() || r === e.style[t]), r = parseFloat(r) || 0
        }
        return r + k(e, t, i || (a ? "border" : "content"), n, o) + "px"
    }

    function B(e, t, i, n, r) {
        return new B.prototype.init(e, t, i, n, r)
    }

    function L() {
        return setTimeout(function() {
            rt = void 0
        }), rt = J.now()
    }

    function Q(e, t) {
        var i, n = {
                height: e
            },
            r = 0;
        for (t = t ? 1 : 0; 4 > r; r += 2 - t) n["margin" + (i = ye[r])] = n["padding" + i] = e;
        return t && (n.opacity = n.width = e), n
    }

    function M(e, t, i) {
        for (var n, r = (ut[t] || []).concat(ut["*"]), o = 0, a = r.length; a > o; o++)
            if (n = r[o].call(i, t, e)) return n
    }

    function E(e, t, i) {
        var n, r, o = 0,
            a = ct.length,
            s = J.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (r) return !1;
                for (var t = rt || L(), i = Math.max(0, c.startTime + c.duration - t), n = 1 - (i / c.duration || 0), o = 0, a = c.tweens.length; a > o; o++) c.tweens[o].run(n);
                return s.notifyWith(e, [c, n, i]), 1 > n && a ? i : (s.resolveWith(e, [c]), !1)
            },
            c = s.promise({
                elem: e,
                props: J.extend({}, t),
                opts: J.extend(!0, {
                    specialEasing: {}
                }, i),
                originalProperties: t,
                originalOptions: i,
                startTime: rt || L(),
                duration: i.duration,
                tweens: [],
                createTween: function(t, i) {
                    var n = J.Tween(e, c.opts, t, i, c.opts.specialEasing[t] || c.opts.easing);
                    return c.tweens.push(n), n
                },
                stop: function(t) {
                    var i = 0,
                        n = t ? c.tweens.length : 0;
                    if (r) return this;
                    for (r = !0; n > i; i++) c.tweens[i].run(1);
                    return t ? s.resolveWith(e, [c, t]) : s.rejectWith(e, [c, t]), this
                }
            }),
            u = c.props;
        for (function(e, t) {
                var i, n, r, o, a;
                for (i in e)
                    if (r = t[n = J.camelCase(i)], o = e[i], J.isArray(o) && (r = o[1], o = e[i] = o[0]), i !== n && (e[n] = o, delete e[i]), (a = J.cssHooks[n]) && "expand" in a)
                        for (i in o = a.expand(o), delete e[n], o) i in e || (e[i] = o[i], t[i] = r);
                    else t[n] = r
            }(u, c.opts.specialEasing); a > o; o++)
            if (n = ct[o].call(c, e, u, c.opts)) return n;
        return J.map(u, M, c), J.isFunction(c.opts.start) && c.opts.start.call(e, c), J.fx.timer(J.extend(l, {
            elem: e,
            anim: c,
            queue: c.opts.queue
        })), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
    }

    function I(e) {
        return function(t, i) {
            "string" != typeof t && (i = t, t = "*");
            var n, r = 0,
                o = t.toLowerCase().match(de) || [];
            if (J.isFunction(i))
                for (; n = o[r++];) "+" === n.charAt(0) ? (n = n.slice(1) || "*", (e[n] = e[n] || []).unshift(i)) : (e[n] = e[n] || []).push(i)
        }
    }

    function A(e, t, i, n) {
        function r(s) {
            var l;
            return o[s] = !0, J.each(e[s] || [], function(e, s) {
                var c = s(t, i, n);
                return "string" != typeof c || a || o[c] ? a ? !(l = c) : void 0 : (t.dataTypes.unshift(c), r(c), !1)
            }), l
        }
        var o = {},
            a = e === Qt;
        return r(t.dataTypes[0]) || !o["*"] && r("*")
    }

    function V(e, t) {
        var i, n, r = J.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
        return i && J.extend(!0, e, i), e
    }

    function D(e, t, i, n) {
        var r;
        if (J.isArray(t)) J.each(t, function(t, r) {
            i || It.test(e) ? n(e, r) : D(e + "[" + ("object" == typeof r ? t : "") + "]", r, i, n)
        });
        else if (i || "object" !== J.type(t)) n(e, t);
        else
            for (r in t) D(e + "[" + r + "]", t[r], i, n)
    }

    function H() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    }

    function N(e) {
        return J.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow)
    }
    var R = [],
        q = R.slice,
        z = R.concat,
        W = R.push,
        U = R.indexOf,
        $ = {},
        X = $.toString,
        Y = $.hasOwnProperty,
        G = {},
        J = function(e, t) {
            return new J.fn.init(e, t)
        },
        K = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        Z = /^-ms-/,
        ee = /-([\da-z])/gi,
        te = function(e, t) {
            return t.toUpperCase()
        };
    J.fn = J.prototype = {
        jquery: "1.11.1",
        constructor: J,
        selector: "",
        length: 0,
        toArray: function() {
            return q.call(this)
        },
        get: function(e) {
            return null != e ? 0 > e ? this[e + this.length] : this[e] : q.call(this)
        },
        pushStack: function(e) {
            var t = J.merge(this.constructor(), e);
            return t.prevObject = this, t.context = this.context, t
        },
        each: function(e, t) {
            return J.each(this, e, t)
        },
        map: function(e) {
            return this.pushStack(J.map(this, function(t, i) {
                return e.call(t, i, t)
            }))

        },
        slice: function() {
            return this.pushStack(q.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length,
                i = +e + (0 > e ? t : 0);
            return this.pushStack(i >= 0 && t > i ? [this[i]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor(null)
        },
        push: W,
        sort: R.sort,
        splice: R.splice
    }, J.extend = J.fn.extend = function() {
        var e, t, i, n, r, o, a = arguments[0] || {},
            s = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == typeof a || J.isFunction(a) || (a = {}), s === l && (a = this, s--); l > s; s++)
            if (null != (r = arguments[s]))
                for (n in r) e = a[n], a !== (i = r[n]) && (c && i && (J.isPlainObject(i) || (t = J.isArray(i))) ? (t ? (t = !1, o = e && J.isArray(e) ? e : []) : o = e && J.isPlainObject(e) ? e : {}, a[n] = J.extend(c, o, i)) : void 0 !== i && (a[n] = i));
        return a
    }, J.extend({
        expando: "jQuery" + ("1.11.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isFunction: function(e) {
            return "function" === J.type(e)
        },
        isArray: Array.isArray || function(e) {
            return "array" === J.type(e)
        },
        isWindow: function(e) {
            return null != e && e == e.window
        },
        isNumeric: function(e) {
            return !J.isArray(e) && e - parseFloat(e) >= 0
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        isPlainObject: function(e) {
            var t;
            if (!e || "object" !== J.type(e) || e.nodeType || J.isWindow(e)) return !1;
            try {
                if (e.constructor && !Y.call(e, "constructor") && !Y.call(e.constructor.prototype, "isPrototypeOf")) return !1
            } catch (e) {
                return !1
            }
            if (G.ownLast)
                for (t in e) return Y.call(e, t);
            for (t in e);
            return void 0 === t || Y.call(e, t)
        },
        type: function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? $[X.call(e)] || "object" : typeof e
        },
        globalEval: function(t) {
            t && J.trim(t) && (e.execScript || function(t) {
                e.eval.call(e, t)
            })(t)
        },
        camelCase: function(e) {
            return e.replace(Z, "ms-").replace(ee, te)
        },
        nodeName: function(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        },
        each: function(e, t, n) {
            var r = 0,
                o = e.length,
                a = i(e);
            if (n) {
                if (a)
                    for (; o > r && !1 !== t.apply(e[r], n); r++);
                else
                    for (r in e)
                        if (!1 === t.apply(e[r], n)) break
            } else if (a)
                for (; o > r && !1 !== t.call(e[r], r, e[r]); r++);
            else
                for (r in e)
                    if (!1 === t.call(e[r], r, e[r])) break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(K, "")
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (i(Object(e)) ? J.merge(n, "string" == typeof e ? [e] : e) : W.call(n, e)), n
        },
        inArray: function(e, t, i) {
            var n;
            if (t) {
                if (U) return U.call(t, e, i);
                for (n = t.length, i = i ? 0 > i ? Math.max(0, n + i) : i : 0; n > i; i++)
                    if (i in t && t[i] === e) return i
            }
            return -1
        },
        merge: function(e, t) {
            for (var i = +t.length, n = 0, r = e.length; i > n;) e[r++] = t[n++];
            if (i != i)
                for (; void 0 !== t[n];) e[r++] = t[n++];
            return e.length = r, e
        },
        grep: function(e, t, i) {
            for (var n = [], r = 0, o = e.length, a = !i; o > r; r++) !t(e[r], r) !== a && n.push(e[r]);
            return n
        },
        map: function(e, t, n) {
            var r, o = 0,
                a = e.length,
                s = [];
            if (i(e))
                for (; a > o; o++) null != (r = t(e[o], o, n)) && s.push(r);
            else
                for (o in e) null != (r = t(e[o], o, n)) && s.push(r);
            return z.apply([], s)
        },
        guid: 1,
        proxy: function(e, t) {
            var i, n, r;
            return "string" == typeof t && (r = e[t], t = e, e = r), J.isFunction(e) ? (i = q.call(arguments, 2), (n = function() {
                return e.apply(t || this, i.concat(q.call(arguments)))
            }).guid = e.guid = e.guid || J.guid++, n) : void 0
        },
        now: function() {
            return +new Date
        },
        support: G
    }), J.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(e, t) {
        $["[object " + t + "]"] = t.toLowerCase()
    });
    var ie = function(e) {
        function t(e, t, i, n) {
            var r, o, a, s, c, p, d, f, h, g;
            if ((t ? t.ownerDocument || t : V) !== _ && k(t), i = i || [], !e || "string" != typeof e) return i;
            if (1 !== (s = (t = t || _).nodeType) && 9 !== s) return [];
            if (L && !n) {
                if (r = me.exec(e))
                    if (a = r[1]) {
                        if (9 === s) {
                            if (!(o = t.getElementById(a)) || !o.parentNode) return i;
                            if (o.id === a) return i.push(o), i
                        } else if (t.ownerDocument && (o = t.ownerDocument.getElementById(a)) && I(t, o) && o.id === a) return i.push(o), i
                    } else {
                        if (r[2]) return J.apply(i, t.getElementsByTagName(e)), i;
                        if ((a = r[3]) && y.getElementsByClassName && t.getElementsByClassName) return J.apply(i, t.getElementsByClassName(a)), i
                    } if (y.qsa && (!Q || !Q.test(e))) {
                    if (f = d = A, h = t, g = 9 === s && e, 1 === s && "object" !== t.nodeName.toLowerCase()) {
                        for (p = x(e), (d = t.getAttribute("id")) ? f = d.replace(be, "\\$&") : t.setAttribute("id", f), f = "[id='" + f + "'] ", c = p.length; c--;) p[c] = f + u(p[c]);
                        h = ve.test(e) && l(t.parentNode) || t, g = p.join(",")
                    }
                    if (g) try {
                        return J.apply(i, h.querySelectorAll(g)), i
                    } catch (e) {} finally {
                        d || t.removeAttribute("id")
                    }
                }
            }
            return T(e.replace(ae, "$1"), t, i, n)
        }

        function i() {
            var e = [];
            return function t(i, n) {
                return e.push(i + " ") > S.cacheLength && delete t[e.shift()], t[i + " "] = n
            }
        }

        function n(e) {
            return e[A] = !0, e
        }

        function r(e) {
            var t = _.createElement("div");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function o(e, t) {
            for (var i = e.split("|"), n = e.length; n--;) S.attrHandle[i[n]] = t
        }

        function a(e, t) {
            var i = t && e,
                n = i && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || U) - (~e.sourceIndex || U);
            if (n) return n;
            if (i)
                for (; i = i.nextSibling;)
                    if (i === t) return -1;
            return e ? 1 : -1
        }

        function s(e) {
            return n(function(t) {
                return t = +t, n(function(i, n) {
                    for (var r, o = e([], i.length, t), a = o.length; a--;) i[r = o[a]] && (i[r] = !(n[r] = i[r]))
                })
            })
        }

        function l(e) {
            return e && typeof e.getElementsByTagName !== W && e
        }

        function c() {}

        function u(e) {
            for (var t = 0, i = e.length, n = ""; i > t; t++) n += e[t].value;
            return n
        }

        function p(e, t, i) {
            var n = t.dir,
                r = i && "parentNode" === n,
                o = H++;
            return t.first ? function(t, i, o) {
                for (; t = t[n];)
                    if (1 === t.nodeType || r) return e(t, i, o)
            } : function(t, i, a) {
                var s, l, c = [D, o];
                if (a) {
                    for (; t = t[n];)
                        if ((1 === t.nodeType || r) && e(t, i, a)) return !0
                } else
                    for (; t = t[n];)
                        if (1 === t.nodeType || r) {
                            if ((s = (l = t[A] || (t[A] = {}))[n]) && s[0] === D && s[1] === o) return c[2] = s[2];
                            if (l[n] = c, c[2] = e(t, i, a)) return !0
                        }
            }
        }

        function d(e) {
            return e.length > 1 ? function(t, i, n) {
                for (var r = e.length; r--;)
                    if (!e[r](t, i, n)) return !1;
                return !0
            } : e[0]
        }

        function f(e, i, n) {
            for (var r = 0, o = i.length; o > r; r++) t(e, i[r], n);
            return n
        }

        function h(e, t, i, n, r) {
            for (var o, a = [], s = 0, l = e.length, c = null != t; l > s; s++)(o = e[s]) && (!i || i(o, n, r)) && (a.push(o), c && t.push(s));
            return a
        }

        function g(e, t, i, r, o, a) {
            return r && !r[A] && (r = g(r)), o && !o[A] && (o = g(o, a)), n(function(n, a, s, l) {
                var c, u, p, d = [],
                    g = [],
                    m = a.length,
                    v = n || f(t || "*", s.nodeType ? [s] : s, []),
                    b = !e || !n && t ? v : h(v, d, e, s, l),
                    y = i ? o || (n ? e : m || r) ? [] : a : b;
                if (i && i(b, y, s, l), r)
                    for (c = h(y, g), r(c, [], s, l), u = c.length; u--;)(p = c[u]) && (y[g[u]] = !(b[g[u]] = p));
                if (n) {
                    if (o || e) {
                        if (o) {
                            for (c = [], u = y.length; u--;)(p = y[u]) && c.push(b[u] = p);
                            o(null, y = [], c, l)
                        }
                        for (u = y.length; u--;)(p = y[u]) && (c = o ? Z.call(n, p) : d[u]) > -1 && (n[c] = !(a[c] = p))
                    }
                } else y = h(y === a ? y.splice(m, y.length) : y), o ? o(null, a, y, l) : J.apply(a, y)
            })
        }

        function m(e) {
            for (var t, i, n, r = e.length, o = S.relative[e[0].type], a = o || S.relative[" "], s = o ? 1 : 0, l = p(function(e) {
                    return e === t
                }, a, !0), c = p(function(e) {
                    return Z.call(t, e) > -1
                }, a, !0), f = [function(e, i, n) {
                    return !o && (n || i !== P) || ((t = i).nodeType ? l(e, i, n) : c(e, i, n))
                }]; r > s; s++)
                if (i = S.relative[e[s].type]) f = [p(d(f), i)];
                else {
                    if ((i = S.filter[e[s].type].apply(null, e[s].matches))[A]) {
                        for (n = ++s; r > n && !S.relative[e[n].type]; n++);
                        return g(s > 1 && d(f), s > 1 && u(e.slice(0, s - 1).concat({
                            value: " " === e[s - 2].type ? "*" : ""
                        })).replace(ae, "$1"), i, n > s && m(e.slice(s, n)), r > n && m(e = e.slice(n)), r > n && u(e))
                    }
                    f.push(i)
                } return d(f)
        }

        function v(e, i) {
            var r = i.length > 0,
                o = e.length > 0,
                a = function(n, a, s, l, c) {
                    var u, p, d, f = 0,
                        g = "0",
                        m = n && [],
                        v = [],
                        b = P,
                        y = n || o && S.find.TAG("*", c),
                        w = D += null == b ? 1 : Math.random() || .1,
                        C = y.length;
                    for (c && (P = a !== _ && a); g !== C && null != (u = y[g]); g++) {
                        if (o && u) {
                            for (p = 0; d = e[p++];)
                                if (d(u, a, s)) {
                                    l.push(u);
                                    break
                                } c && (D = w)
                        }
                        r && ((u = !d && u) && f--, n && m.push(u))
                    }
                    if (f += g, r && g !== f) {
                        for (p = 0; d = i[p++];) d(m, v, a, s);
                        if (n) {
                            if (f > 0)
                                for (; g--;) m[g] || v[g] || (v[g] = Y.call(l));
                            v = h(v)
                        }
                        J.apply(l, v), c && !n && v.length > 0 && f + i.length > 1 && t.uniqueSort(l)
                    }
                    return c && (D = w, P = b), m
                };
            return r ? n(a) : a
        }
        var b, y, S, w, C, x, j, T, P, F, O, k, _, B, L, Q, M, E, I, A = "sizzle" + -new Date,
            V = e.document,
            D = 0,
            H = 0,
            N = i(),
            R = i(),
            q = i(),
            z = function(e, t) {
                return e === t && (O = !0), 0
            },
            W = "undefined",
            U = 1 << 31,
            $ = {}.hasOwnProperty,
            X = [],
            Y = X.pop,
            G = X.push,
            J = X.push,
            K = X.slice,
            Z = X.indexOf || function(e) {
                for (var t = 0, i = this.length; i > t; t++)
                    if (this[t] === e) return t;
                return -1
            },
            ee = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            te = "[\\x20\\t\\r\\n\\f]",
            ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            ne = ie.replace("w", "w#"),
            re = "\\[" + te + "*(" + ie + ")(?:" + te + "*([*^$|!~]?=)" + te + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ne + "))|)" + te + "*\\]",
            oe = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + re + ")*)|.*)\\)|)",
            ae = new RegExp("^" + te + "+|((?:^|[^\\\\])(?:\\\\.)*)" + te + "+$", "g"),
            se = new RegExp("^" + te + "*," + te + "*"),
            le = new RegExp("^" + te + "*([>+~]|" + te + ")" + te + "*"),
            ce = new RegExp("=" + te + "*([^\\]'\"]*?)" + te + "*\\]", "g"),
            ue = new RegExp(oe),
            pe = new RegExp("^" + ne + "$"),
            de = {
                ID: new RegExp("^#(" + ie + ")"),
                CLASS: new RegExp("^\\.(" + ie + ")"),
                TAG: new RegExp("^(" + ie.replace("w", "w*") + ")"),
                ATTR: new RegExp("^" + re),
                PSEUDO: new RegExp("^" + oe),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + te + "*(even|odd|(([+-]|)(\\d*)n|)" + te + "*(?:([+-]|)" + te + "*(\\d+)|))" + te + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + ee + ")$", "i"),
                needsContext: new RegExp("^" + te + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + te + "*((?:-\\d)?\\d*)" + te + "*\\)|)(?=[^-]|$)", "i")
            },
            fe = /^(?:input|select|textarea|button)$/i,
            he = /^h\d$/i,
            ge = /^[^{]+\{\s*\[native \w/,
            me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ve = /[+~]/,
            be = /'|\\/g,
            ye = new RegExp("\\\\([\\da-f]{1,6}" + te + "?|(" + te + ")|.)", "ig"),
            Se = function(e, t, i) {
                var n = "0x" + t - 65536;
                return n != n || i ? t : 0 > n ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)
            };
        try {
            J.apply(X = K.call(V.childNodes), V.childNodes), X[V.childNodes.length].nodeType
        } catch (e) {
            J = {
                apply: X.length ? function(e, t) {
                    G.apply(e, K.call(t))
                } : function(e, t) {
                    for (var i = e.length, n = 0; e[i++] = t[n++];);
                    e.length = i - 1
                }
            }
        }
        for (b in y = t.support = {}, C = t.isXML = function(e) {
                var t = e && (e.ownerDocument || e).documentElement;
                return !!t && "HTML" !== t.nodeName
            }, k = t.setDocument = function(e) {
                var t, i = e ? e.ownerDocument || e : V,
                    n = i.defaultView;
                return i !== _ && 9 === i.nodeType && i.documentElement ? (_ = i, B = i.documentElement, L = !C(i), n && n !== n.top && (n.addEventListener ? n.addEventListener("unload", function() {
                    k()
                }, !1) : n.attachEvent && n.attachEvent("onunload", function() {
                    k()
                })), y.attributes = r(function(e) {
                    return e.className = "i", !e.getAttribute("className")
                }), y.getElementsByTagName = r(function(e) {
                    return e.appendChild(i.createComment("")), !e.getElementsByTagName("*").length
                }), y.getElementsByClassName = ge.test(i.getElementsByClassName) && r(function(e) {
                    return e.innerHTML = "<div class='a'></div><div class='a i'></div>", e.firstChild.className = "i", 2 === e.getElementsByClassName("i").length
                }), y.getById = r(function(e) {
                    return B.appendChild(e).id = A, !i.getElementsByName || !i.getElementsByName(A).length
                }), y.getById ? (S.find.ID = function(e, t) {
                    if (typeof t.getElementById !== W && L) {
                        var i = t.getElementById(e);
                        return i && i.parentNode ? [i] : []
                    }
                }, S.filter.ID = function(e) {
                    var t = e.replace(ye, Se);
                    return function(e) {
                        return e.getAttribute("id") === t
                    }
                }) : (delete S.find.ID, S.filter.ID = function(e) {
                    var t = e.replace(ye, Se);
                    return function(e) {
                        var i = typeof e.getAttributeNode !== W && e.getAttributeNode("id");
                        return i && i.value === t
                    }
                }), S.find.TAG = y.getElementsByTagName ? function(e, t) {
                    return typeof t.getElementsByTagName !== W ? t.getElementsByTagName(e) : void 0
                } : function(e, t) {
                    var i, n = [],
                        r = 0,
                        o = t.getElementsByTagName(e);
                    if ("*" === e) {
                        for (; i = o[r++];) 1 === i.nodeType && n.push(i);
                        return n
                    }

                    return o
                }, S.find.CLASS = y.getElementsByClassName && function(e, t) {
                    return typeof t.getElementsByClassName !== W && L ? t.getElementsByClassName(e) : void 0
                }, M = [], Q = [], (y.qsa = ge.test(i.querySelectorAll)) && (r(function(e) {
                    e.innerHTML = "<select msallowclip=''><option selected=''></option></select>", e.querySelectorAll("[msallowclip^='']").length && Q.push("[*^$]=" + te + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || Q.push("\\[" + te + "*(?:value|" + ee + ")"), e.querySelectorAll(":checked").length || Q.push(":checked")
                }), r(function(e) {
                    var t = i.createElement("input");
                    t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && Q.push("name" + te + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || Q.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), Q.push(",.*:")
                })), (y.matchesSelector = ge.test(E = B.matches || B.webkitMatchesSelector || B.mozMatchesSelector || B.oMatchesSelector || B.msMatchesSelector)) && r(function(e) {
                    y.disconnectedMatch = E.call(e, "div"), E.call(e, "[s!='']:x"), M.push("!=", oe)
                }), Q = Q.length && new RegExp(Q.join("|")), M = M.length && new RegExp(M.join("|")), t = ge.test(B.compareDocumentPosition), I = t || ge.test(B.contains) ? function(e, t) {
                    var i = 9 === e.nodeType ? e.documentElement : e,
                        n = t && t.parentNode;
                    return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)))
                } : function(e, t) {
                    if (t)
                        for (; t = t.parentNode;)
                            if (t === e) return !0;
                    return !1
                }, z = t ? function(e, t) {
                    if (e === t) return O = !0, 0;
                    var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !y.sortDetached && t.compareDocumentPosition(e) === n ? e === i || e.ownerDocument === V && I(V, e) ? -1 : t === i || t.ownerDocument === V && I(V, t) ? 1 : F ? Z.call(F, e) - Z.call(F, t) : 0 : 4 & n ? -1 : 1)
                } : function(e, t) {
                    if (e === t) return O = !0, 0;
                    var n, r = 0,
                        o = e.parentNode,
                        s = t.parentNode,
                        l = [e],
                        c = [t];
                    if (!o || !s) return e === i ? -1 : t === i ? 1 : o ? -1 : s ? 1 : F ? Z.call(F, e) - Z.call(F, t) : 0;
                    if (o === s) return a(e, t);
                    for (n = e; n = n.parentNode;) l.unshift(n);
                    for (n = t; n = n.parentNode;) c.unshift(n);
                    for (; l[r] === c[r];) r++;
                    return r ? a(l[r], c[r]) : l[r] === V ? -1 : c[r] === V ? 1 : 0
                }, i) : _
            }, t.matches = function(e, i) {
                return t(e, null, null, i)
            }, t.matchesSelector = function(e, i) {
                if ((e.ownerDocument || e) !== _ && k(e), i = i.replace(ce, "='$1']"), !(!y.matchesSelector || !L || M && M.test(i) || Q && Q.test(i))) try {
                    var n = E.call(e, i);
                    if (n || y.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n
                } catch (e) {}
                return t(i, _, null, [e]).length > 0
            }, t.contains = function(e, t) {
                return (e.ownerDocument || e) !== _ && k(e), I(e, t)
            }, t.attr = function(e, t) {
                (e.ownerDocument || e) !== _ && k(e);
                var i = S.attrHandle[t.toLowerCase()],
                    n = i && $.call(S.attrHandle, t.toLowerCase()) ? i(e, t, !L) : void 0;
                return void 0 !== n ? n : y.attributes || !L ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
            }, t.error = function(e) {
                throw new Error("Syntax error, unrecognized expression: " + e)
            }, t.uniqueSort = function(e) {
                var t, i = [],
                    n = 0,
                    r = 0;
                if (O = !y.detectDuplicates, F = !y.sortStable && e.slice(0), e.sort(z), O) {
                    for (; t = e[r++];) t === e[r] && (n = i.push(r));
                    for (; n--;) e.splice(i[n], 1)
                }
                return F = null, e
            }, w = t.getText = function(e) {
                var t, i = "",
                    n = 0,
                    r = e.nodeType;
                if (r) {
                    if (1 === r || 9 === r || 11 === r) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) i += w(e)
                    } else if (3 === r || 4 === r) return e.nodeValue
                } else
                    for (; t = e[n++];) i += w(t);
                return i
            }, (S = t.selectors = {
                cacheLength: 50,
                createPseudo: n,
                match: de,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(e) {
                        return e[1] = e[1].replace(ye, Se), e[3] = (e[3] || e[4] || e[5] || "").replace(ye, Se), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                    },
                    CHILD: function(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
                    },
                    PSEUDO: function(e) {
                        var t, i = !e[6] && e[2];
                        return de.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && ue.test(i) && (t = x(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t), e[2] = i.slice(0, t)), e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(e) {
                        var t = e.replace(ye, Se).toLowerCase();
                        return "*" === e ? function() {
                            return !0
                        } : function(e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t
                        }
                    },
                    CLASS: function(e) {
                        var t = N[e + " "];
                        return t || (t = new RegExp("(^|" + te + ")" + e + "(" + te + "|$)")) && N(e, function(e) {
                            return t.test("string" == typeof e.className && e.className || typeof e.getAttribute !== W && e.getAttribute("class") || "")
                        })
                    },
                    ATTR: function(e, i, n) {
                        return function(r) {
                            var o = t.attr(r, e);
                            return null == o ? "!=" === i : !i || (o += "", "=" === i ? o === n : "!=" === i ? o !== n : "^=" === i ? n && 0 === o.indexOf(n) : "*=" === i ? n && o.indexOf(n) > -1 : "$=" === i ? n && o.slice(-n.length) === n : "~=" === i ? (" " + o + " ").indexOf(n) > -1 : "|=" === i && (o === n || o.slice(0, n.length + 1) === n + "-"))
                        }
                    },
                    CHILD: function(e, t, i, n, r) {
                        var o = "nth" !== e.slice(0, 3),
                            a = "last" !== e.slice(-4),
                            s = "of-type" === t;
                        return 1 === n && 0 === r ? function(e) {
                            return !!e.parentNode
                        } : function(t, i, l) {
                            var c, u, p, d, f, h, g = o !== a ? "nextSibling" : "previousSibling",
                                m = t.parentNode,
                                v = s && t.nodeName.toLowerCase(),
                                b = !l && !s;
                            if (m) {
                                if (o) {
                                    for (; g;) {
                                        for (p = t; p = p[g];)
                                            if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                        h = g = "only" === e && !h && "nextSibling"
                                    }
                                    return !0
                                }
                                if (h = [a ? m.firstChild : m.lastChild], a && b) {
                                    for (f = (c = (u = m[A] || (m[A] = {}))[e] || [])[0] === D && c[1], d = c[0] === D && c[2], p = f && m.childNodes[f]; p = ++f && p && p[g] || (d = f = 0) || h.pop();)
                                        if (1 === p.nodeType && ++d && p === t) {
                                            u[e] = [D, f, d];
                                            break
                                        }
                                } else if (b && (c = (t[A] || (t[A] = {}))[e]) && c[0] === D) d = c[1];
                                else
                                    for (;
                                        (p = ++f && p && p[g] || (d = f = 0) || h.pop()) && ((s ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++d || (b && ((p[A] || (p[A] = {}))[e] = [D, d]), p !== t)););
                                return (d -= r) === n || d % n == 0 && d / n >= 0
                            }
                        }
                    },
                    PSEUDO: function(e, i) {
                        var r, o = S.pseudos[e] || S.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                        return o[A] ? o(i) : o.length > 1 ? (r = [e, e, "", i], S.setFilters.hasOwnProperty(e.toLowerCase()) ? n(function(e, t) {
                            for (var n, r = o(e, i), a = r.length; a--;) e[n = Z.call(e, r[a])] = !(t[n] = r[a])
                        }) : function(e) {
                            return o(e, 0, r)
                        }) : o
                    }
                },
                pseudos: {
                    not: n(function(e) {
                        var t = [],
                            i = [],
                            r = j(e.replace(ae, "$1"));
                        return r[A] ? n(function(e, t, i, n) {
                            for (var o, a = r(e, null, n, []), s = e.length; s--;)(o = a[s]) && (e[s] = !(t[s] = o))
                        }) : function(e, n, o) {
                            return t[0] = e, r(t, null, o, i), !i.pop()
                        }
                    }),
                    has: n(function(e) {
                        return function(i) {
                            return t(e, i).length > 0
                        }
                    }),
                    contains: n(function(e) {
                        return function(t) {
                            return (t.textContent || t.innerText || w(t)).indexOf(e) > -1
                        }
                    }),
                    lang: n(function(e) {
                        return pe.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(ye, Se).toLowerCase(),
                            function(t) {
                                var i;
                                do {
                                    if (i = L ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1
                            }
                    }),
                    target: function(t) {
                        var i = e.location && e.location.hash;
                        return i && i.slice(1) === t.id
                    },
                    root: function(e) {
                        return e === B
                    },
                    focus: function(e) {
                        return e === _.activeElement && (!_.hasFocus || _.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: function(e) {
                        return !1 === e.disabled
                    },
                    disabled: function(e) {
                        return !0 === e.disabled
                    },
                    checked: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                    },
                    selected: function(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                    },
                    empty: function(e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(e) {
                        return !S.pseudos.empty(e)
                    },
                    header: function(e) {
                        return he.test(e.nodeName)
                    },
                    input: function(e) {
                        return fe.test(e.nodeName)
                    },
                    button: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && "button" === e.type || "button" === t
                    },
                    text: function(e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    },
                    first: s(function() {
                        return [0]
                    }),
                    last: s(function(e, t) {
                        return [t - 1]
                    }),
                    eq: s(function(e, t, i) {
                        return [0 > i ? i + t : i]
                    }),
                    even: s(function(e, t) {
                        for (var i = 0; t > i; i += 2) e.push(i);
                        return e
                    }),
                    odd: s(function(e, t) {
                        for (var i = 1; t > i; i += 2) e.push(i);
                        return e
                    }),
                    lt: s(function(e, t, i) {
                        for (var n = 0 > i ? i + t : i; --n >= 0;) e.push(n);
                        return e
                    }),
                    gt: s(function(e, t, i) {
                        for (var n = 0 > i ? i + t : i; ++n < t;) e.push(n);
                        return e
                    })
                }
            }).pseudos.nth = S.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) S.pseudos[b] = function(e) {
            return function(t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }(b);
        for (b in {
                submit: !0,
                reset: !0
            }) S.pseudos[b] = function(e) {
            return function(t) {
                var i = t.nodeName.toLowerCase();
                return ("input" === i || "button" === i) && t.type === e
            }
        }(b);
        return c.prototype = S.filters = S.pseudos, S.setFilters = new c, x = t.tokenize = function(e, i) {
            var n, r, o, a, s, l, c, u = R[e + " "];
            if (u) return i ? 0 : u.slice(0);
            for (s = e, l = [], c = S.preFilter; s;) {
                for (a in (!n || (r = se.exec(s))) && (r && (s = s.slice(r[0].length) || s), l.push(o = [])), n = !1, (r = le.exec(s)) && (n = r.shift(), o.push({
                        value: n,
                        type: r[0].replace(ae, " ")
                    }), s = s.slice(n.length)), S.filter) !(r = de[a].exec(s)) || c[a] && !(r = c[a](r)) || (n = r.shift(), o.push({
                    value: n,
                    type: a,
                    matches: r
                }), s = s.slice(n.length));
                if (!n) break
            }
            return i ? s.length : s ? t.error(e) : R(e, l).slice(0)
        }, j = t.compile = function(e, t) {
            var i, n = [],
                r = [],
                o = q[e + " "];
            if (!o) {
                for (t || (t = x(e)), i = t.length; i--;)(o = m(t[i]))[A] ? n.push(o) : r.push(o);
                (o = q(e, v(r, n))).selector = e
            }
            return o
        }, T = t.select = function(e, t, i, n) {
            var r, o, a, s, c, p = "function" == typeof e && e,
                d = !n && x(e = p.selector || e);
            if (i = i || [], 1 === d.length) {
                if ((o = d[0] = d[0].slice(0)).length > 2 && "ID" === (a = o[0]).type && y.getById && 9 === t.nodeType && L && S.relative[o[1].type]) {
                    if (!(t = (S.find.ID(a.matches[0].replace(ye, Se), t) || [])[0])) return i;
                    p && (t = t.parentNode), e = e.slice(o.shift().value.length)
                }
                for (r = de.needsContext.test(e) ? 0 : o.length; r-- && (a = o[r], !S.relative[s = a.type]);)
                    if ((c = S.find[s]) && (n = c(a.matches[0].replace(ye, Se), ve.test(o[0].type) && l(t.parentNode) || t))) {
                        if (o.splice(r, 1), !(e = n.length && u(o))) return J.apply(i, n), i;
                        break
                    }
            }
            return (p || j(e, d))(n, t, !L, i, ve.test(e) && l(t.parentNode) || t), i
        }, y.sortStable = A.split("").sort(z).join("") === A, y.detectDuplicates = !!O, k(), y.sortDetached = r(function(e) {
            return 1 & e.compareDocumentPosition(_.createElement("div"))
        }), r(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function(e, t, i) {
            return i ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), y.attributes && r(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || o("value", function(e, t, i) {
            return i || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
        }), r(function(e) {
            return null == e.getAttribute("disabled")
        }) || o(ee, function(e, t, i) {
            var n;
            return i ? void 0 : !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
        }), t
    }(e);
    J.find = ie, J.expr = ie.selectors, J.expr[":"] = J.expr.pseudos, J.unique = ie.uniqueSort, J.text = ie.getText, J.isXMLDoc = ie.isXML, J.contains = ie.contains;
    var ne = J.expr.match.needsContext,
        re = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
        oe = /^.[^:#\[\.,]*$/;
    J.filter = function(e, t, i) {
        var n = t[0];
        return i && (e = ":not(" + e + ")"), 1 === t.length && 1 === n.nodeType ? J.find.matchesSelector(n, e) ? [n] : [] : J.find.matches(e, J.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, J.fn.extend({
        find: function(e) {
            var t, i = [],
                n = this,
                r = n.length;
            if ("string" != typeof e) return this.pushStack(J(e).filter(function() {
                for (t = 0; r > t; t++)
                    if (J.contains(n[t], this)) return !0
            }));
            for (t = 0; r > t; t++) J.find(e, n[t], i);
            return (i = this.pushStack(r > 1 ? J.unique(i) : i)).selector = this.selector ? this.selector + " " + e : e, i
        },
        filter: function(e) {
            return this.pushStack(n(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(n(this, e || [], !0))
        },
        is: function(e) {
            return !!n(this, "string" == typeof e && ne.test(e) ? J(e) : e || [], !1).length
        }
    });
    var ae, se = e.document,
        le = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (J.fn.init = function(e, t) {
        var i, n;
        if (!e) return this;
        if ("string" == typeof e) {
            if (!(i = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : le.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || ae).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (t = t instanceof J ? t[0] : t, J.merge(this, J.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : se, !0)), re.test(i[1]) && J.isPlainObject(t))
                    for (i in t) J.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this
            }
            if ((n = se.getElementById(i[2])) && n.parentNode) {
                if (n.id !== i[2]) return ae.find(e);
                this.length = 1, this[0] = n
            }
            return this.context = se, this.selector = e, this
        }
        return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : J.isFunction(e) ? void 0 !== ae.ready ? ae.ready(e) : e(J) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), J.makeArray(e, this))
    }).prototype = J.fn, ae = J(se);
    var ce = /^(?:parents|prev(?:Until|All))/,
        ue = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
    J.extend({
        dir: function(e, t, i) {
            for (var n = [], r = e[t]; r && 9 !== r.nodeType && (void 0 === i || 1 !== r.nodeType || !J(r).is(i));) 1 === r.nodeType && n.push(r), r = r[t];
            return n
        },
        sibling: function(e, t) {
            for (var i = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && i.push(e);
            return i
        }
    }), J.fn.extend({
        has: function(e) {
            var t, i = J(e, this),
                n = i.length;
            return this.filter(function() {
                for (t = 0; n > t; t++)
                    if (J.contains(this, i[t])) return !0
            })
        },
        closest: function(e, t) {
            for (var i, n = 0, r = this.length, o = [], a = ne.test(e) || "string" != typeof e ? J(e, t || this.context) : 0; r > n; n++)
                for (i = this[n]; i && i !== t; i = i.parentNode)
                    if (i.nodeType < 11 && (a ? a.index(i) > -1 : 1 === i.nodeType && J.find.matchesSelector(i, e))) {
                        o.push(i);
                        break
                    } return this.pushStack(o.length > 1 ? J.unique(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? J.inArray(this[0], J(e)) : J.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(J.unique(J.merge(this.get(), J(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), J.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return J.dir(e, "parentNode")
        },
        parentsUntil: function(e, t, i) {
            return J.dir(e, "parentNode", i)
        },
        next: function(e) {
            return r(e, "nextSibling")
        },
        prev: function(e) {
            return r(e, "previousSibling")
        },
        nextAll: function(e) {
            return J.dir(e, "nextSibling")
        },
        prevAll: function(e) {
            return J.dir(e, "previousSibling")
        },
        nextUntil: function(e, t, i) {
            return J.dir(e, "nextSibling", i)
        },
        prevUntil: function(e, t, i) {
            return J.dir(e, "previousSibling", i)
        },
        siblings: function(e) {
            return J.sibling((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return J.sibling(e.firstChild)
        },
        contents: function(e) {
            return J.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : J.merge([], e.childNodes)
        }
    }, function(e, t) {
        J.fn[e] = function(i, n) {
            var r = J.map(this, t, i);
            return "Until" !== e.slice(-5) && (n = i), n && "string" == typeof n && (r = J.filter(n, r)), this.length > 1 && (ue[e] || (r = J.unique(r)), ce.test(e) && (r = r.reverse())), this.pushStack(r)
        }
    });
    var pe, de = /\S+/g,
        fe = {};
    J.Callbacks = function(e) {
        e = "string" == typeof e ? fe[e] || function(e) {
            var t = fe[e] = {};
            return J.each(e.match(de) || [], function(e, i) {
                t[i] = !0
            }), t
        }(e) : J.extend({}, e);
        var t, i, n, r, o, a, s = [],
            l = !e.once && [],
            c = function(p) {
                for (i = e.memory && p, n = !0, o = a || 0, a = 0, r = s.length, t = !0; s && r > o; o++)
                    if (!1 === s[o].apply(p[0], p[1]) && e.stopOnFalse) {
                        i = !1;
                        break
                    } t = !1, s && (l ? l.length && c(l.shift()) : i ? s = [] : u.disable())
            },
            u = {
                add: function() {
                    if (s) {
                        var n = s.length;
                        ! function t(i) {
                            J.each(i, function(i, n) {
                                var r = J.type(n);
                                "function" === r ? e.unique && u.has(n) || s.push(n) : n && n.length && "string" !== r && t(n)
                            })
                        }(arguments), t ? r = s.length : i && (a = n, c(i))
                    }
                    return this
                },
                remove: function() {
                    return s && J.each(arguments, function(e, i) {
                        for (var n;
                            (n = J.inArray(i, s, n)) > -1;) s.splice(n, 1), t && (r >= n && r--, o >= n && o--)
                    }), this
                },
                has: function(e) {
                    return e ? J.inArray(e, s) > -1 : !(!s || !s.length)
                },
                empty: function() {
                    return s = [], r = 0, this
                },
                disable: function() {
                    return s = l = i = void 0, this
                },
                disabled: function() {
                    return !s
                },
                lock: function() {
                    return l = void 0, i || u.disable(), this
                },
                locked: function() {
                    return !l
                },
                fireWith: function(e, i) {
                    return !s || n && !l || (i = [e, (i = i || []).slice ? i.slice() : i], t ? l.push(i) : c(i)), this
                },
                fire: function() {
                    return u.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!n
                }
            };
        return u
    }, J.extend({
        Deferred: function(e) {
            var t = [
                    ["resolve", "done", J.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", J.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", J.Callbacks("memory")]
                ],
                i = "pending",
                n = {
                    state: function() {
                        return i
                    },
                    always: function() {
                        return r.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var e = arguments;
                        return J.Deferred(function(i) {
                            J.each(t, function(t, o) {
                                var a = J.isFunction(e[t]) && e[t];
                                r[o[1]](function() {
                                    var e = a && a.apply(this, arguments);
                                    e && J.isFunction(e.promise) ? e.promise().done(i.resolve).fail(i.reject).progress(i.notify) : i[o[0] + "With"](this === n ? i.promise() : this, a ? [e] : arguments)
                                })
                            }), e = null
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? J.extend(e, n) : n
                    }
                },
                r = {};
            return n.pipe = n.then, J.each(t, function(e, o) {
                var a = o[2],
                    s = o[3];
                n[o[1]] = a.add, s && a.add(function() {
                    i = s
                }, t[1 ^ e][2].disable, t[2][2].lock), r[o[0]] = function() {
                    return r[o[0] + "With"](this === r ? n : this, arguments), this
                }, r[o[0] + "With"] = a.fireWith
            }), n.promise(r), e && e.call(r, r), r
        },
        when: function(e) {
            var t, i, n, r = 0,
                o = q.call(arguments),
                a = o.length,
                s = 1 !== a || e && J.isFunction(e.promise) ? a : 0,
                l = 1 === s ? e : J.Deferred(),
                c = function(e, i, n) {
                    return function(r) {
                        i[e] = this, n[e] = arguments.length > 1 ? q.call(arguments) : r, n === t ? l.notifyWith(i, n) : --s || l.resolveWith(i, n)
                    }
                };
            if (a > 1)
                for (t = new Array(a), i = new Array(a), n = new Array(a); a > r; r++) o[r] && J.isFunction(o[r].promise) ? o[r].promise().done(c(r, n, o)).fail(l.reject).progress(c(r, i, t)) : --s;
            return s || l.resolveWith(n, o), l.promise()
        }
    }), J.fn.ready = function(e) {
        return J.ready.promise().done(e), this
    }, J.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(e) {
            e ? J.readyWait++ : J.ready(!0)
        },
        ready: function(e) {
            if (!0 === e ? !--J.readyWait : !J.isReady) {
                if (!se.body) return setTimeout(J.ready);
                J.isReady = !0, !0 !== e && --J.readyWait > 0 || (pe.resolveWith(se, [J]), J.fn.triggerHandler && (J(se).triggerHandler("ready"), J(se).off("ready")))
            }
        }
    }), J.ready.promise = function(t) {
        if (!pe)
            if (pe = J.Deferred(), "complete" === se.readyState) setTimeout(J.ready);
            else if (se.addEventListener) se.addEventListener("DOMContentLoaded", a, !1), e.addEventListener("load", a, !1);
        else {
            se.attachEvent("onreadystatechange", a), e.attachEvent("onload", a);
            var i = !1;
            try {
                i = null == e.frameElement && se.documentElement
            } catch (e) {}
            i && i.doScroll && function e() {
                if (!J.isReady) {
                    try {
                        i.doScroll("left")
                    } catch (t) {
                        return setTimeout(e, 50)
                    }
                    o(), J.ready()
                }
            }()
        }
        return pe.promise(t)
    };
    var he, ge = "undefined";
    for (he in J(G)) break;
    G.ownLast = "0" !== he, G.inlineBlockNeedsLayout = !1, J(function() {
            var e, t, i, n;
            (i = se.getElementsByTagName("body")[0]) && i.style && (t = se.createElement("div"), (n = se.createElement("div")).style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", i.appendChild(n).appendChild(t), typeof t.style.zoom !== ge && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", G.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (i.style.zoom = 1)), i.removeChild(n))
        }),
        function() {
            var e = se.createElement("div");
            if (null == G.deleteExpando) {
                G.deleteExpando = !0;
                try {
                    delete e.test
                } catch (e) {
                    G.deleteExpando = !1
                }
            }
            e = null
        }(), J.acceptData = function(e) {
            var t = J.noData[(e.nodeName + " ").toLowerCase()],
                i = +e.nodeType || 1;
            return (1 === i || 9 === i) && (!t || !0 !== t && e.getAttribute("classid") === t)
        };
    var me = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        ve = /([A-Z])/g;
    J.extend({
        cache: {},
        noData: {
            "applet ": !0,
            "embed ": !0,
            "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
        },
        hasData: function(e) {
            return !!(e = e.nodeType ? J.cache[e[J.expando]] : e[J.expando]) && !l(e)
        },
        data: function(e, t, i) {
            return c(e, t, i)
        },
        removeData: function(e, t) {
            return u(e, t)
        },
        _data: function(e, t, i) {
            return c(e, t, i, !0)
        },
        _removeData: function(e, t) {
            return u(e, t, !0)
        }
    }), J.fn.extend({
        data: function(e, t) {
            var i, n, r, o = this[0],
                a = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (r = J.data(o), 1 === o.nodeType && !J._data(o, "parsedAttrs"))) {
                    for (i = a.length; i--;) a[i] && (0 === (n = a[i].name).indexOf("data-") && s(o, n = J.camelCase(n.slice(5)), r[n]));
                    J._data(o, "parsedAttrs", !0)
                }
                return r
            }
            return "object" == typeof e ? this.each(function() {
                J.data(this, e)
            }) : arguments.length > 1 ? this.each(function() {
                J.data(this, e, t)
            }) : o ? s(o, e, J.data(o, e)) : void 0
        },
        removeData: function(e) {
            return this.each(function() {
                J.removeData(this, e)
            })
        }
    }), J.extend({
        queue: function(e, t, i) {
            var n;
            return e ? (t = (t || "fx") + "queue", n = J._data(e, t), i && (!n || J.isArray(i) ? n = J._data(e, t, J.makeArray(i)) : n.push(i)), n || []) : void 0
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var i = J.queue(e, t),
                n = i.length,
                r = i.shift(),
                o = J._queueHooks(e, t);
            "inprogress" === r && (r = i.shift(), n--), r && ("fx" === t && i.unshift("inprogress"), delete o.stop, r.call(e, function() {
                J.dequeue(e, t)
            }, o)), !n && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var i = t + "queueHooks";
            return J._data(e, i) || J._data(e, i, {
                empty: J.Callbacks("once memory").add(function() {
                    J._removeData(e, t + "queue"), J._removeData(e, i)
                })
            })
        }
    }), J.fn.extend({
        queue: function(e, t) {
            var i = 2;
            return "string" != typeof e && (t = e, e = "fx", i--), arguments.length < i ? J.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var i = J.queue(this, e, t);
                J._queueHooks(this, e), "fx" === e && "inprogress" !== i[0] && J.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                J.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var i, n = 1,
                r = J.Deferred(),
                o = this,
                a = this.length,
                s = function() {
                    --n || r.resolveWith(o, [o])
                };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;)(i = J._data(o[a], e + "queueHooks")) && i.empty && (n++, i.empty.add(s));
            return s(), r.promise(t)
        }
    });
    var be = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        ye = ["Top", "Right", "Bottom", "Left"],
        Se = function(e, t) {
            return e = t || e, "none" === J.css(e, "display") || !J.contains(e.ownerDocument, e)
        },
        we = J.access = function(e, t, i, n, r, o, a) {
            var s = 0,
                l = e.length,
                c = null == i;
            if ("object" === J.type(i))
                for (s in r = !0, i) J.access(e, t, s, i[s], !0, o, a);
            else if (void 0 !== n && (r = !0, J.isFunction(n) || (a = !0), c && (a ? (t.call(e, n), t = null) : (c = t, t = function(e, t, i) {
                    return c.call(J(e), i)
                })), t))
                for (; l > s; s++) t(e[s], i, a ? n : n.call(e[s], s, t(e[s], i)));
            return r ? e : c ? t.call(e) : l ? t(e[0], i) : o
        },
        Ce = /^(?:checkbox|radio)$/i;
    ! function() {
        var e = se.createElement("input"),
            t = se.createElement("div"),
            i = se.createDocumentFragment();
        if (t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", G.leadingWhitespace = 3 === t.firstChild.nodeType, G.tbody = !t.getElementsByTagName("tbody").length, G.htmlSerialize = !!t.getElementsByTagName("link").length, G.html5Clone = "<:nav></:nav>" !== se.createElement("nav").cloneNode(!0).outerHTML, e.type = "checkbox", e.checked = !0, i.appendChild(e), G.appendChecked = e.checked, t.innerHTML = "<textarea>x</textarea>", G.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, i.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", G.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, G.noCloneEvent = !0, t.attachEvent && (t.attachEvent("onclick", function() {
                G.noCloneEvent = !1
            }), t.cloneNode(!0).click()), null == G.deleteExpando) {
            G.deleteExpando = !0;
            try {
                delete t.test
            } catch (e) {
                G.deleteExpando = !1
            }
        }
    }(),
    function() {
        var t, i, n = se.createElement("div");
        for (t in {
                submit: !0,
                change: !0,
                focusin: !0
            }) i = "on" + t, (G[t + "Bubbles"] = i in e) || (n.setAttribute(i, "t"), G[t + "Bubbles"] = !1 === n.attributes[i].expando);
        n = null
    }();
    var xe = /^(?:input|select|textarea)$/i,
        je = /^key/,
        Te = /^(?:mouse|pointer|contextmenu)|click/,
        Pe = /^(?:focusinfocus|focusoutblur)$/,
        Fe = /^([^.]*)(?:\.(.+)|)$/;
    J.event = {
        global: {},
        add: function(e, t, i, n, r) {
            var o, a, s, l, c, u, p, d, f, h, g, m = J._data(e);
            if (m) {
                for (i.handler && (i = (l = i).handler, r = l.selector), i.guid || (i.guid = J.guid++), (a = m.events) || (a = m.events = {}), (u = m.handle) || ((u = m.handle = function(e) {
                        return typeof J === ge || e && J.event.triggered === e.type ? void 0 : J.event.dispatch.apply(u.elem, arguments)
                    }).elem = e), s = (t = (t || "").match(de) || [""]).length; s--;) f = g = (o = Fe.exec(t[s]) || [])[1], h = (o[2] || "").split(".").sort(), f && (c = J.event.special[f] || {}, f = (r ? c.delegateType : c.bindType) || f, c = J.event.special[f] || {}, p = J.extend({
                    type: f,
                    origType: g,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: r,
                    needsContext: r && J.expr.match.needsContext.test(r),
                    namespace: h.join(".")
                }, l), (d = a[f]) || ((d = a[f] = []).delegateCount = 0, c.setup && !1 !== c.setup.call(e, n, h, u) || (e.addEventListener ? e.addEventListener(f, u, !1) : e.attachEvent && e.attachEvent("on" + f, u))), c.add && (c.add.call(e, p), p.handler.guid || (p.handler.guid = i.guid)), r ? d.splice(d.delegateCount++, 0, p) : d.push(p), J.event.global[f] = !0);
                e = null
            }
        },
        remove: function(e, t, i, n, r) {
            var o, a, s, l, c, u, p, d, f, h, g, m = J.hasData(e) && J._data(e);
            if (m && (u = m.events)) {
                for (c = (t = (t || "").match(de) || [""]).length; c--;)
                    if (f = g = (s = Fe.exec(t[c]) || [])[1], h = (s[2] || "").split(".").sort(), f) {
                        for (p = J.event.special[f] || {}, d = u[f = (n ? p.delegateType : p.bindType) || f] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), l = o = d.length; o--;) a = d[o], !r && g !== a.origType || i && i.guid !== a.guid || s && !s.test(a.namespace) || n && n !== a.selector && ("**" !== n || !a.selector) || (d.splice(o, 1), a.selector && d.delegateCount--, p.remove && p.remove.call(e, a));
                        l && !d.length && (p.teardown && !1 !== p.teardown.call(e, h, m.handle) || J.removeEvent(e, f, m.handle), delete u[f])
                    } else
                        for (f in u) J.event.remove(e, f + t[c], i, n, !0);
                J.isEmptyObject(u) && (delete m.handle, J._removeData(e, "events"))
            }
        },
        trigger: function(t, i, n, r) {
            var o, a, s, l, c, u, p, d = [n || se],
                f = Y.call(t, "type") ? t.type : t,
                h = Y.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = u = n = n || se, 3 !== n.nodeType && 8 !== n.nodeType && !Pe.test(f + J.event.triggered) && (f.indexOf(".") >= 0 && (h = f.split("."), f = h.shift(), h.sort()), a = f.indexOf(":") < 0 && "on" + f, (t = t[J.expando] ? t : new J.Event(f, "object" == typeof t && t)).isTrigger = r ? 2 : 3, t.namespace = h.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), i = null == i ? [t] : J.makeArray(i, [t]), c = J.event.special[f] || {}, r || !c.trigger || !1 !== c.trigger.apply(n, i))) {
                if (!r && !c.noBubble && !J.isWindow(n)) {
                    for (l = c.delegateType || f, Pe.test(l + f) || (s = s.parentNode); s; s = s.parentNode) d.push(s), u = s;
                    u === (n.ownerDocument || se) && d.push(u.defaultView || u.parentWindow || e)
                }
                for (p = 0;
                    (s = d[p++]) && !t.isPropagationStopped();) t.type = p > 1 ? l : c.bindType || f, (o = (J._data(s, "events") || {})[t.type] && J._data(s, "handle")) && o.apply(s, i), (o = a && s[a]) && o.apply && J.acceptData(s) && (t.result = o.apply(s, i), !1 === t.result && t.preventDefault());
                if (t.type = f, !r && !t.isDefaultPrevented() && (!c._default || !1 === c._default.apply(d.pop(), i)) && J.acceptData(n) && a && n[f] && !J.isWindow(n)) {
                    (u = n[a]) && (n[a] = null), J.event.triggered = f;
                    try {
                        n[f]()
                    } catch (e) {}
                    J.event.triggered = void 0, u && (n[a] = u)
                }
                return t.result
            }
        },
        dispatch: function(e) {
            e = J.event.fix(e);
            var t, i, n, r, o, a = [],
                s = q.call(arguments),
                l = (J._data(this, "events") || {})[e.type] || [],
                c = J.event.special[e.type] || {};
            if (s[0] = e, e.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, e)) {
                for (a = J.event.handlers.call(this, e, l), t = 0;
                    (r = a[t++]) && !e.isPropagationStopped();)
                    for (e.currentTarget = r.elem, o = 0;
                        (n = r.handlers[o++]) && !e.isImmediatePropagationStopped();)(!e.namespace_re || e.namespace_re.test(n.namespace)) && (e.handleObj = n, e.data = n.data, void 0 !== (i = ((J.event.special[n.origType] || {}).handle || n.handler).apply(r.elem, s)) && !1 === (e.result = i) && (e.preventDefault(), e.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, e), e.result
            }
        },
        handlers: function(e, t) {
            var i, n, r, o, a = [],
                s = t.delegateCount,
                l = e.target;
            if (s && l.nodeType && (!e.button || "click" !== e.type))
                for (; l != this; l = l.parentNode || this)
                    if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
                        for (r = [], o = 0; s > o; o++) void 0 === r[i = (n = t[o]).selector + " "] && (r[i] = n.needsContext ? J(i, this).index(l) >= 0 : J.find(i, this, null, [l]).length), r[i] && r.push(n);
                        r.length && a.push({
                            elem: l,
                            handlers: r
                        })
                    } return s < t.length && a.push({
                elem: this,
                handlers: t.slice(s)
            }), a
        },
        fix: function(e) {
            if (e[J.expando]) return e;
            var t, i, n, r = e.type,
                o = e,
                a = this.fixHooks[r];
            for (a || (this.fixHooks[r] = a = Te.test(r) ? this.mouseHooks : je.test(r) ? this.keyHooks : {}), n = a.props ? this.props.concat(a.props) : this.props, e = new J.Event(o), t = n.length; t--;) e[i = n[t]] = o[i];
            return e.target || (e.target = o.srcElement || se), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, a.filter ? a.filter(e, o) : e
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(e, t) {
                var i, n, r, o = t.button,
                    a = t.fromElement;
                return null == e.pageX && null != t.clientX && (r = (n = e.target.ownerDocument || se).documentElement, i = n.body, e.pageX = t.clientX + (r && r.scrollLeft || i && i.scrollLeft || 0) - (r && r.clientLeft || i && i.clientLeft || 0), e.pageY = t.clientY + (r && r.scrollTop || i && i.scrollTop || 0) - (r && r.clientTop || i && i.clientTop || 0)), !e.relatedTarget && a && (e.relatedTarget = a === e.target ? t.toElement : a), e.which || void 0 === o || (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), e
            }
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== f() && this.focus) try {
                        return this.focus(), !1
                    } catch (e) {}
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === f() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return J.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0
                },
                _default: function(e) {
                    return J.nodeName(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        },
        simulate: function(e, t, i, n) {
            var r = J.extend(new J.Event, i, {
                type: e,
                isSimulated: !0,
                originalEvent: {}
            });
            n ? J.event.trigger(r, null, t) : J.event.dispatch.call(t, r), r.isDefaultPrevented() && i.preventDefault()
        }
    }, J.removeEvent = se.removeEventListener ? function(e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i, !1)
    } : function(e, t, i) {
        var n = "on" + t;
        e.detachEvent && (typeof e[n] === ge && (e[n] = null), e.detachEvent(n, i))
    }, J.Event = function(e, t) {
        return this instanceof J.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? p : d) : this.type = e, t && J.extend(this, t), this.timeStamp = e && e.timeStamp || J.now(), void(this[J.expando] = !0)) : new J.Event(e, t)
    }, J.Event.prototype = {
        isDefaultPrevented: d,
        isPropagationStopped: d,
        isImmediatePropagationStopped: d,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = p, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1)
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = p, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0)
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = p, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, J.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        J.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var i, n = e.relatedTarget,
                    r = e.handleObj;
                return (!n || n !== this && !J.contains(this, n)) && (e.type = r.origType, i = r.handler.apply(this, arguments), e.type = t), i
            }
        }
    }), G.submitBubbles || (J.event.special.submit = {
        setup: function() {
            return !J.nodeName(this, "form") && void J.event.add(this, "click._submit keypress._submit", function(e) {
                var t = e.target,
                    i = J.nodeName(t, "input") || J.nodeName(t, "button") ? t.form : void 0;
                i && !J._data(i, "submitBubbles") && (J.event.add(i, "submit._submit", function(e) {
                    e._submit_bubble = !0
                }), J._data(i, "submitBubbles", !0))
            })
        },
        postDispatch: function(e) {
            e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && J.event.simulate("submit", this.parentNode, e, !0))
        },
        teardown: function() {
            return !J.nodeName(this, "form") && void J.event.remove(this, "._submit")
        }
    }), G.changeBubbles || (J.event.special.change = {
        setup: function() {
            return xe.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (J.event.add(this, "propertychange._change", function(e) {
                "checked" === e.originalEvent.propertyName && (this._just_changed = !0)
            }), J.event.add(this, "click._change", function(e) {
                this._just_changed && !e.isTrigger && (this._just_changed = !1), J.event.simulate("change", this, e, !0)
            })), !1) : void J.event.add(this, "beforeactivate._change", function(e) {
                var t = e.target;
                xe.test(t.nodeName) && !J._data(t, "changeBubbles") && (J.event.add(t, "change._change", function(e) {
                    !this.parentNode || e.isSimulated || e.isTrigger || J.event.simulate("change", this.parentNode, e, !0)
                }), J._data(t, "changeBubbles", !0))
            })
        },
        handle: function(e) {
            var t = e.target;
            return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0
        },
        teardown: function() {
            return J.event.remove(this, "._change"), !xe.test(this.nodeName)
        }
    }), G.focusinBubbles || J.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var i = function(e) {
            J.event.simulate(t, e.target, J.event.fix(e), !0)
        };
        J.event.special[t] = {
            setup: function() {
                var n = this.ownerDocument || this,
                    r = J._data(n, t);
                r || n.addEventListener(e, i, !0), J._data(n, t, (r || 0) + 1)
            },
            teardown: function() {
                var n = this.ownerDocument || this,
                    r = J._data(n, t) - 1;
                r ? J._data(n, t, r) : (n.removeEventListener(e, i, !0), J._removeData(n, t))
            }
        }
    }), J.fn.extend({
        on: function(e, t, i, n, r) {
            var o, a;
            if ("object" == typeof e) {
                for (o in "string" != typeof t && (i = i || t, t = void 0), e) this.on(o, t, i, e[o], r);
                return this
            }
            if (null == i && null == n ? (n = t, i = t = void 0) : null == n && ("string" == typeof t ? (n = i, i = void 0) : (n = i, i = t, t = void 0)), !1 === n) n = d;
            else if (!n) return this;
            return 1 === r && (a = n, (n = function(e) {
                return J().off(e), a.apply(this, arguments)
            }).guid = a.guid || (a.guid = J.guid++)), this.each(function() {
                J.event.add(this, e, n, i, t)
            })
        },
        one: function(e, t, i, n) {
            return this.on(e, t, i, n, 1)
        },
        off: function(e, t, i) {
            var n, r;
            if (e && e.preventDefault && e.handleObj) return n = e.handleObj, J(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
            if ("object" == typeof e) {
                for (r in e) this.off(r, t, e[r]);
                return this
            }
            return (!1 === t || "function" == typeof t) && (i = t, t = void 0), !1 === i && (i = d), this.each(function() {
                J.event.remove(this, e, i, t)
            })
        },
        trigger: function(e, t) {
            return this.each(function() {
                J.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var i = this[0];
            return i ? J.event.trigger(e, t, i, !0) : void 0
        }
    });
    var Oe = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
        ke = / jQuery\d+="(?:null|\d+)"/g,
        _e = new RegExp("<(?:" + Oe + ")[\\s/>]", "i"),
        Be = /^\s+/,
        Le = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
        Qe = /<([\w:]+)/,
        Me = /<tbody/i,
        Ee = /<|&#?\w+;/,
        Ie = /<(?:script|style|link)/i,
        Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Ve = /^$|\/(?:java|ecma)script/i,
        De = /^true\/(.*)/,
        He = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
        Ne = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            legend: [1, "<fieldset>", "</fieldset>"],
            area: [1, "<map>", "</map>"],
            param: [1, "<object>", "</object>"],
            thead: [1, "<table>", "</table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: G.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
        },
        Re = h(se).appendChild(se.createElement("div"));
    Ne.optgroup = Ne.option, Ne.tbody = Ne.tfoot = Ne.colgroup = Ne.caption = Ne.thead, Ne.th = Ne.td, J.extend({
        clone: function(e, t, i) {
            var n, r, o, a, s, l = J.contains(e.ownerDocument, e);
            if (G.html5Clone || J.isXMLDoc(e) || !_e.test("<" + e.nodeName + ">") ? o = e.cloneNode(!0) : (Re.innerHTML = e.outerHTML, Re.removeChild(o = Re.firstChild)), !(G.noCloneEvent && G.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || J.isXMLDoc(e)))
                for (n = g(o), s = g(e), a = 0; null != (r = s[a]); ++a) n[a] && C(r, n[a]);
            if (t)
                if (i)
                    for (s = s || g(e), n = n || g(o), a = 0; null != (r = s[a]); a++) w(r, n[a]);
                else w(e, o);
            return (n = g(o, "script")).length > 0 && S(n, !l && g(e, "script")), n = s = r = null, o
        },
        buildFragment: function(e, t, i, n) {
            for (var r, o, a, s, l, c, u, p = e.length, d = h(t), f = [], v = 0; p > v; v++)
                if ((o = e[v]) || 0 === o)
                    if ("object" === J.type(o)) J.merge(f, o.nodeType ? [o] : o);
                    else if (Ee.test(o)) {
                for (s = s || d.appendChild(t.createElement("div")), l = (Qe.exec(o) || ["", ""])[1].toLowerCase(), u = Ne[l] || Ne._default, s.innerHTML = u[1] + o.replace(Le, "<$1></$2>") + u[2], r = u[0]; r--;) s = s.lastChild;
                if (!G.leadingWhitespace && Be.test(o) && f.push(t.createTextNode(Be.exec(o)[0])), !G.tbody)
                    for (r = (o = "table" !== l || Me.test(o) ? "<table>" !== u[1] || Me.test(o) ? 0 : s : s.firstChild) && o.childNodes.length; r--;) J.nodeName(c = o.childNodes[r], "tbody") && !c.childNodes.length && o.removeChild(c);
                for (J.merge(f, s.childNodes), s.textContent = ""; s.firstChild;) s.removeChild(s.firstChild);
                s = d.lastChild
            } else f.push(t.createTextNode(o));
            for (s && d.removeChild(s), G.appendChecked || J.grep(g(f, "input"), m), v = 0; o = f[v++];)
                if ((!n || -1 === J.inArray(o, n)) && (a = J.contains(o.ownerDocument, o), s = g(d.appendChild(o), "script"), a && S(s), i))
                    for (r = 0; o = s[r++];) Ve.test(o.type || "") && i.push(o);
            return s = null, d
        },
        cleanData: function(e, t) {
            for (var i, n, r, o, a = 0, s = J.expando, l = J.cache, c = G.deleteExpando, u = J.event.special; null != (i = e[a]); a++)
                if ((t || J.acceptData(i)) && (o = (r = i[s]) && l[r])) {
                    if (o.events)
                        for (n in o.events) u[n] ? J.event.remove(i, n) : J.removeEvent(i, n, o.handle);
                    l[r] && (delete l[r], c ? delete i[s] : typeof i.removeAttribute !== ge ? i.removeAttribute(s) : i[s] = null, R.push(r))
                }
        }
    }), J.fn.extend({
        text: function(e) {
            return we(this, function(e) {
                return void 0 === e ? J.text(this) : this.empty().append((this[0] && this[0].ownerDocument || se).createTextNode(e))
            }, null, e, arguments.length)
        },
        append: function() {
            return this.domManip(arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || v(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return this.domManip(arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = v(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        remove: function(e, t) {
            for (var i, n = e ? J.filter(e, this) : this, r = 0; null != (i = n[r]); r++) t || 1 !== i.nodeType || J.cleanData(g(i)), i.parentNode && (t && J.contains(i.ownerDocument, i) && S(g(i, "script")), i.parentNode.removeChild(i));
            return this
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) {
                for (1 === e.nodeType && J.cleanData(g(e, !1)); e.firstChild;) e.removeChild(e.firstChild);
                e.options && J.nodeName(e, "select") && (e.options.length = 0)
            }
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return J.clone(this, e, t)
            })
        },
        html: function(e) {
            return we(this, function(e) {
                var t = this[0] || {},
                    i = 0,
                    n = this.length;
                if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(ke, "") : void 0;
                if (!("string" != typeof e || Ie.test(e) || !G.htmlSerialize && _e.test(e) || !G.leadingWhitespace && Be.test(e) || Ne[(Qe.exec(e) || ["", ""])[1].toLowerCase()])) {
                    e = e.replace(Le, "<$1></$2>");
                    try {
                        for (; n > i; i++) 1 === (t = this[i] || {}).nodeType && (J.cleanData(g(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = arguments[0];
            return this.domManip(arguments, function(t) {
                e = this.parentNode, J.cleanData(g(this)), e && e.replaceChild(t, this)
            }), e && (e.length || e.nodeType) ? this : this.remove()
        },
        detach: function(e) {
            return this.remove(e, !0)
        },
        domManip: function(e, t) {
            e = z.apply([], e);
            var i, n, r, o, a, s, l = 0,
                c = this.length,
                u = this,
                p = c - 1,
                d = e[0],
                f = J.isFunction(d);
            if (f || c > 1 && "string" == typeof d && !G.checkClone && Ae.test(d)) return this.each(function(i) {
                var n = u.eq(i);
                f && (e[0] = d.call(this, i, n.html())), n.domManip(e, t)
            });
            if (c && (i = (s = J.buildFragment(e, this[0].ownerDocument, !1, this)).firstChild, 1 === s.childNodes.length && (s = i), i)) {
                for (r = (o = J.map(g(s, "script"), b)).length; c > l; l++) n = s, l !== p && (n = J.clone(n, !0, !0), r && J.merge(o, g(n, "script"))), t.call(this[l], n, l);
                if (r)
                    for (a = o[o.length - 1].ownerDocument, J.map(o, y), l = 0; r > l; l++) n = o[l], Ve.test(n.type || "") && !J._data(n, "globalEval") && J.contains(a, n) && (n.src ? J._evalUrl && J._evalUrl(n.src) : J.globalEval((n.text || n.textContent || n.innerHTML || "").replace(He, "")));
                s = i = null
            }
            return this
        }
    }), J.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        J.fn[e] = function(e) {
            for (var i, n = 0, r = [], o = J(e), a = o.length - 1; a >= n; n++) i = n === a ? this : this.clone(!0), J(o[n])[t](i), W.apply(r, i.get());
            return this.pushStack(r)
        }
    });
    var qe, ze = {};
    ! function() {
        var e;
        G.shrinkWrapBlocks = function() {
            return null != e ? e : (e = !1, (i = se.getElementsByTagName("body")[0]) && i.style ? (t = se.createElement("div"), (n = se.createElement("div")).style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", i.appendChild(n).appendChild(t), typeof t.style.zoom !== ge && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", t.appendChild(se.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), i.removeChild(n), e) : void 0);
            var t, i, n
        }
    }();
    var We, Ue, $e = /^margin/,
        Xe = new RegExp("^(" + be + ")(?!px)[a-z%]+$", "i"),
        Ye = /^(top|right|bottom|left)$/;
    e.getComputedStyle ? (We = function(e) {
            return e.ownerDocument.defaultView.getComputedStyle(e, null)
        }, Ue = function(e, t, i) {
            var n, r, o, a, s = e.style;
            return a = (i = i || We(e)) ? i.getPropertyValue(t) || i[t] : void 0, i && ("" !== a || J.contains(e.ownerDocument, e) || (a = J.style(e, t)), Xe.test(a) && $e.test(t) && (n = s.width, r = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = i.width, s.width = n, s.minWidth = r, s.maxWidth = o)), void 0 === a ? a : a + ""
        }) : se.documentElement.currentStyle && (We = function(e) {
            return e.currentStyle
        }, Ue = function(e, t, i) {
            var n, r, o, a, s = e.style;
            return null == (a = (i = i || We(e)) ? i[t] : void 0) && s && s[t] && (a = s[t]), Xe.test(a) && !Ye.test(t) && (n = s.left, (o = (r = e.runtimeStyle) && r.left) && (r.left = e.currentStyle.left), s.left = "fontSize" === t ? "1em" : a, a = s.pixelLeft + "px", s.left = n, o && (r.left = o)), void 0 === a ? a : a + "" || "auto"
        }),
        function() {
            function t() {
                var t, i, n, r;
                (i = se.getElementsByTagName("body")[0]) && i.style && (t = se.createElement("div"), (n = se.createElement("div")).style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", i.appendChild(n).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", o = a = !1, l = !0, e.getComputedStyle && (o = "1%" !== (e.getComputedStyle(t, null) || {}).top, a = "4px" === (e.getComputedStyle(t, null) || {
                    width: "4px"
                }).width, (r = t.appendChild(se.createElement("div"))).style.cssText = t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", r.style.marginRight = r.style.width = "0", t.style.width = "1px", l = !parseFloat((e.getComputedStyle(r, null) || {}).marginRight)), t.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", (r = t.getElementsByTagName("td"))[0].style.cssText = "margin:0;border:0;padding:0;display:none", (s = 0 === r[0].offsetHeight) && (r[0].style.display = "", r[1].style.display = "none", s = 0 === r[0].offsetHeight), i.removeChild(n))
            }
            var i, n, r, o, a, s, l;
            (i = se.createElement("div")).innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", (n = (r = i.getElementsByTagName("a")[0]) && r.style) && (n.cssText = "float:left;opacity:.5", G.opacity = "0.5" === n.opacity, G.cssFloat = !!n.cssFloat, i.style.backgroundClip = "content-box", i.cloneNode(!0).style.backgroundClip = "", G.clearCloneStyle = "content-box" === i.style.backgroundClip, G.boxSizing = "" === n.boxSizing || "" === n.MozBoxSizing || "" === n.WebkitBoxSizing, J.extend(G, {
                reliableHiddenOffsets: function() {
                    return null == s && t(), s
                },
                boxSizingReliable: function() {
                    return null == a && t(), a
                },
                pixelPosition: function() {
                    return null == o && t(), o
                },
                reliableMarginRight: function() {
                    return null == l && t(), l
                }
            }))
        }(), J.swap = function(e, t, i, n) {
            var r, o, a = {};
            for (o in t) a[o] = e.style[o], e.style[o] = t[o];
            for (o in r = i.apply(e, n || []), t) e.style[o] = a[o];
            return r
        };
    var Ge = /alpha\([^)]*\)/i,
        Je = /opacity\s*=\s*([^)]*)/,
        Ke = /^(none|table(?!-c[ea]).+)/,
        Ze = new RegExp("^(" + be + ")(.*)$", "i"),
        et = new RegExp("^([+-])=(" + be + ")", "i"),
        tt = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        it = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        nt = ["Webkit", "O", "Moz", "ms"];
    J.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var i = Ue(e, "opacity");
                        return "" === i ? "1" : i
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: G.cssFloat ? "cssFloat" : "styleFloat"
        },
        style: function(e, t, i, n) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, o, a, s = J.camelCase(t),
                    l = e.style;
                if (t = J.cssProps[s] || (J.cssProps[s] = P(l, s)), a = J.cssHooks[t] || J.cssHooks[s], void 0 === i) return a && "get" in a && void 0 !== (r = a.get(e, !1, n)) ? r : l[t];
                if ("string" === (o = typeof i) && (r = et.exec(i)) && (i = (r[1] + 1) * r[2] + parseFloat(J.css(e, t)), o = "number"), null != i && i == i && ("number" !== o || J.cssNumber[s] || (i += "px"), G.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (l[t] = "inherit"), !(a && "set" in a && void 0 === (i = a.set(e, i, n))))) try {
                    l[t] = i
                } catch (e) {}
            }
        },
        css: function(e, t, i, n) {
            var r, o, a, s = J.camelCase(t);
            return t = J.cssProps[s] || (J.cssProps[s] = P(e.style, s)), (a = J.cssHooks[t] || J.cssHooks[s]) && "get" in a && (o = a.get(e, !0, i)), void 0 === o && (o = Ue(e, t, n)), "normal" === o && t in it && (o = it[t]), "" === i || i ? (r = parseFloat(o), !0 === i || J.isNumeric(r) ? r || 0 : o) : o
        }
    }), J.each(["height", "width"], function(e, t) {
        J.cssHooks[t] = {
            get: function(e, i, n) {
                return i ? Ke.test(J.css(e, "display")) && 0 === e.offsetWidth ? J.swap(e, tt, function() {
                    return _(e, t, n)
                }) : _(e, t, n) : void 0
            },
            set: function(e, i, n) {
                var r = n && We(e);
                return O(0, i, n ? k(e, t, n, G.boxSizing && "border-box" === J.css(e, "boxSizing", !1, r), r) : 0)
            }
        }
    }), G.opacity || (J.cssHooks.opacity = {
        get: function(e, t) {
            return Je.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : ""
        },
        set: function(e, t) {
            var i = e.style,
                n = e.currentStyle,
                r = J.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
                o = n && n.filter || i.filter || "";
            i.zoom = 1, (t >= 1 || "" === t) && "" === J.trim(o.replace(Ge, "")) && i.removeAttribute && (i.removeAttribute("filter"), "" === t || n && !n.filter) || (i.filter = Ge.test(o) ? o.replace(Ge, r) : o + " " + r)
        }
    }), J.cssHooks.marginRight = T(G.reliableMarginRight, function(e, t) {
        return t ? J.swap(e, {
            display: "inline-block"
        }, Ue, [e, "marginRight"]) : void 0
    }), J.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        J.cssHooks[e + t] = {
            expand: function(i) {
                for (var n = 0, r = {}, o = "string" == typeof i ? i.split(" ") : [i]; 4 > n; n++) r[e + ye[n] + t] = o[n] || o[n - 2] || o[0];
                return r
            }
        }, $e.test(e) || (J.cssHooks[e + t].set = O)
    }), J.fn.extend({
        css: function(e, t) {
            return we(this, function(e, t, i) {
                var n, r, o = {},
                    a = 0;
                if (J.isArray(t)) {
                    for (n = We(e), r = t.length; r > a; a++) o[t[a]] = J.css(e, t[a], !1, n);
                    return o
                }
                return void 0 !== i ? J.style(e, t, i) : J.css(e, t)
            }, e, t, arguments.length > 1)
        },
        show: function() {
            return F(this, !0)
        },
        hide: function() {
            return F(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                Se(this) ? J(this).show() : J(this).hide()
            })
        }
    }), J.Tween = B, B.prototype = {
        constructor: B,
        init: function(e, t, i, n, r, o) {
            this.elem = e, this.prop = i, this.easing = r || "swing", this.options = t, this.start = this.now = this.cur(), this.end = n, this.unit = o || (J.cssNumber[i] ? "" : "px")
        },
        cur: function() {
            var e = B.propHooks[this.prop];
            return e && e.get ? e.get(this) : B.propHooks._default.get(this)
        },
        run: function(e) {
            var t, i = B.propHooks[this.prop];
            return this.pos = t = this.options.duration ? J.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : B.propHooks._default.set(this), this
        }
    }, B.prototype.init.prototype = B.prototype, B.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = J.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0 : e.elem[e.prop]
            },
            set: function(e) {
                J.fx.step[e.prop] ? J.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[J.cssProps[e.prop]] || J.cssHooks[e.prop]) ? J.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
            }
        }
    }, B.propHooks.scrollTop = B.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, J.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        }
    }, J.fx = B.prototype.init, J.fx.step = {};
    var rt, ot, at = /^(?:toggle|show|hide)$/,
        st = new RegExp("^(?:([+-])=|)(" + be + ")([a-z%]*)$", "i"),
        lt = /queueHooks$/,
        ct = [function(e, t, i) {
            var n, r, o, a, s, l, c, u = this,
                p = {},
                d = e.style,
                f = e.nodeType && Se(e),
                h = J._data(e, "fxshow");
            for (n in i.queue || (null == (s = J._queueHooks(e, "fx")).unqueued && (s.unqueued = 0, l = s.empty.fire, s.empty.fire = function() {
                    s.unqueued || l()
                }), s.unqueued++, u.always(function() {
                    u.always(function() {
                        s.unqueued--, J.queue(e, "fx").length || s.empty.fire()
                    })
                })), 1 === e.nodeType && ("height" in t || "width" in t) && (i.overflow = [d.overflow, d.overflowX, d.overflowY], "inline" === ("none" === (c = J.css(e, "display")) ? J._data(e, "olddisplay") || j(e.nodeName) : c) && "none" === J.css(e, "float") && (G.inlineBlockNeedsLayout && "inline" !== j(e.nodeName) ? d.zoom = 1 : d.display = "inline-block")), i.overflow && (d.overflow = "hidden", G.shrinkWrapBlocks() || u.always(function() {
                    d.overflow = i.overflow[0], d.overflowX = i.overflow[1], d.overflowY = i.overflow[2]
                })), t)
                if (r = t[n], at.exec(r)) {
                    if (delete t[n], o = o || "toggle" === r, r === (f ? "hide" : "show")) {
                        if ("show" !== r || !h || void 0 === h[n]) continue;
                        f = !0
                    }
                    p[n] = h && h[n] || J.style(e, n)
                } else c = void 0;
            if (J.isEmptyObject(p)) "inline" === ("none" === c ? j(e.nodeName) : c) && (d.display = c);
            else
                for (n in h ? "hidden" in h && (f = h.hidden) : h = J._data(e, "fxshow", {}), o && (h.hidden = !f), f ? J(e).show() : u.done(function() {
                        J(e).hide()
                    }), u.done(function() {
                        var t;
                        for (t in J._removeData(e, "fxshow"), p) J.style(e, t, p[t])
                    }), p) a = M(f ? h[n] : 0, n, u), n in h || (h[n] = a.start, f && (a.end = a.start, a.start = "width" === n || "height" === n ? 1 : 0))
        }],
        ut = {
            "*": [function(e, t) {
                var i = this.createTween(e, t),
                    n = i.cur(),
                    r = st.exec(t),
                    o = r && r[3] || (J.cssNumber[e] ? "" : "px"),
                    a = (J.cssNumber[e] || "px" !== o && +n) && st.exec(J.css(i.elem, e)),
                    s = 1,
                    l = 20;
                if (a && a[3] !== o) {
                    o = o || a[3], r = r || [], a = +n || 1;
                    do {
                        a /= s = s || ".5", J.style(i.elem, e, a + o)
                    } while (s !== (s = i.cur() / n) && 1 !== s && --l)
                }
                return r && (a = i.start = +a || +n || 0, i.unit = o, i.end = r[1] ? a + (r[1] + 1) * r[2] : +r[2]), i
            }]
        };
    J.Animation = J.extend(E, {
            tweener: function(e, t) {
                J.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");
                for (var i, n = 0, r = e.length; r > n; n++) i = e[n], ut[i] = ut[i] || [], ut[i].unshift(t)
            },
            prefilter: function(e, t) {
                t ? ct.unshift(e) : ct.push(e)
            }
        }), J.speed = function(e, t, i) {
            var n = e && "object" == typeof e ? J.extend({}, e) : {
                complete: i || !i && t || J.isFunction(e) && e,
                duration: e,
                easing: i && t || t && !J.isFunction(t) && t
            };
            return n.duration = J.fx.off ? 0 : "number" == typeof n.duration ? n.duration : n.duration in J.fx.speeds ? J.fx.speeds[n.duration] : J.fx.speeds._default, (null == n.queue || !0 === n.queue) && (n.queue = "fx"), n.old = n.complete, n.complete = function() {
                J.isFunction(n.old) && n.old.call(this), n.queue && J.dequeue(this, n.queue)
            }, n
        }, J.fn.extend({
            fadeTo: function(e, t, i, n) {
                return this.filter(Se).css("opacity", 0).show().end().animate({
                    opacity: t
                }, e, i, n)
            },
            animate: function(e, t, i, n) {
                var r = J.isEmptyObject(e),
                    o = J.speed(t, i, n),
                    a = function() {
                        var t = E(this, J.extend({}, e), o);
                        (r || J._data(this, "finish")) && t.stop(!0)
                    };
                return a.finish = a, r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
            },
            stop: function(e, t, i) {
                var n = function(e) {
                    var t = e.stop;
                    delete e.stop, t(i)
                };
                return "string" != typeof e && (i = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function() {
                    var t = !0,
                        r = null != e && e + "queueHooks",
                        o = J.timers,
                        a = J._data(this);
                    if (r) a[r] && a[r].stop && n(a[r]);
                    else
                        for (r in a) a[r] && a[r].stop && lt.test(r) && n(a[r]);
                    for (r = o.length; r--;) o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(i), t = !1, o.splice(r, 1));
                    (t || !i) && J.dequeue(this, e)
                })
            },
            finish: function(e) {
                return !1 !== e && (e = e || "fx"), this.each(function() {
                    var t, i = J._data(this),
                        n = i[e + "queue"],
                        r = i[e + "queueHooks"],
                        o = J.timers,
                        a = n ? n.length : 0;
                    for (i.finish = !0, J.queue(this, e, []), r && r.stop && r.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                    for (t = 0; a > t; t++) n[t] && n[t].finish && n[t].finish.call(this);
                    delete i.finish
                })
            }
        }), J.each(["toggle", "show", "hide"], function(e, t) {
            var i = J.fn[t];
            J.fn[t] = function(e, n, r) {
                return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(Q(t, !0), e, n, r)
            }
        }), J.each({
            slideDown: Q("show"),
            slideUp: Q("hide"),
            slideToggle: Q("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(e, t) {
            J.fn[e] = function(e, i, n) {
                return this.animate(t, e, i, n)
            }
        }), J.timers = [], J.fx.tick = function() {
            var e, t = J.timers,
                i = 0;
            for (rt = J.now(); i < t.length; i++)(e = t[i])() || t[i] !== e || t.splice(i--, 1);
            t.length || J.fx.stop(), rt = void 0

        }, J.fx.timer = function(e) {
            J.timers.push(e), e() ? J.fx.start() : J.timers.pop()
        }, J.fx.interval = 13, J.fx.start = function() {
            ot || (ot = setInterval(J.fx.tick, J.fx.interval))
        }, J.fx.stop = function() {
            clearInterval(ot), ot = null
        }, J.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        }, J.fn.delay = function(e, t) {
            return e = J.fx && J.fx.speeds[e] || e, t = t || "fx", this.queue(t, function(t, i) {
                var n = setTimeout(t, e);
                i.stop = function() {
                    clearTimeout(n)
                }
            })
        },
        function() {
            var e, t, i, n, r;
            (t = se.createElement("div")).setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", n = t.getElementsByTagName("a")[0], r = (i = se.createElement("select")).appendChild(se.createElement("option")), e = t.getElementsByTagName("input")[0], n.style.cssText = "top:1px", G.getSetAttribute = "t" !== t.className, G.style = /top/.test(n.getAttribute("style")), G.hrefNormalized = "/a" === n.getAttribute("href"), G.checkOn = !!e.value, G.optSelected = r.selected, G.enctype = !!se.createElement("form").enctype, i.disabled = !0, G.optDisabled = !r.disabled, (e = se.createElement("input")).setAttribute("value", ""), G.input = "" === e.getAttribute("value"), e.value = "t", e.setAttribute("type", "radio"), G.radioValue = "t" === e.value
        }();
    var pt = /\r/g;
    J.fn.extend({
        val: function(e) {
            var t, i, n, r = this[0];
            return arguments.length ? (n = J.isFunction(e), this.each(function(i) {
                var r;
                1 === this.nodeType && (null == (r = n ? e.call(this, i, J(this).val()) : e) ? r = "" : "number" == typeof r ? r += "" : J.isArray(r) && (r = J.map(r, function(e) {
                    return null == e ? "" : e + ""
                })), (t = J.valHooks[this.type] || J.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, r, "value") || (this.value = r))
            })) : r ? (t = J.valHooks[r.type] || J.valHooks[r.nodeName.toLowerCase()]) && "get" in t && void 0 !== (i = t.get(r, "value")) ? i : "string" == typeof(i = r.value) ? i.replace(pt, "") : null == i ? "" : i : void 0
        }
    }), J.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = J.find.attr(e, "value");
                    return null != t ? t : J.trim(J.text(e))
                }
            },
            select: {
                get: function(e) {
                    for (var t, i, n = e.options, r = e.selectedIndex, o = "select-one" === e.type || 0 > r, a = o ? null : [], s = o ? r + 1 : n.length, l = 0 > r ? s : o ? r : 0; s > l; l++)
                        if (!(!(i = n[l]).selected && l !== r || (G.optDisabled ? i.disabled : null !== i.getAttribute("disabled")) || i.parentNode.disabled && J.nodeName(i.parentNode, "optgroup"))) {
                            if (t = J(i).val(), o) return t;
                            a.push(t)
                        } return a
                },
                set: function(e, t) {
                    for (var i, n, r = e.options, o = J.makeArray(t), a = r.length; a--;)
                        if (n = r[a], J.inArray(J.valHooks.option.get(n), o) >= 0) try {
                            n.selected = i = !0
                        } catch (e) {
                            n.scrollHeight
                        } else n.selected = !1;
                    return i || (e.selectedIndex = -1), r
                }
            }
        }
    }), J.each(["radio", "checkbox"], function() {
        J.valHooks[this] = {
            set: function(e, t) {
                return J.isArray(t) ? e.checked = J.inArray(J(e).val(), t) >= 0 : void 0
            }
        }, G.checkOn || (J.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    });
    var dt, ft, ht = J.expr.attrHandle,
        gt = /^(?:checked|selected)$/i,
        mt = G.getSetAttribute,
        vt = G.input;
    J.fn.extend({
        attr: function(e, t) {
            return we(this, J.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                J.removeAttr(this, e)
            })
        }
    }), J.extend({
        attr: function(e, t, i) {
            var n, r, o = e.nodeType;
            if (e && 3 !== o && 8 !== o && 2 !== o) return typeof e.getAttribute === ge ? J.prop(e, t, i) : (1 === o && J.isXMLDoc(e) || (t = t.toLowerCase(), n = J.attrHooks[t] || (J.expr.match.bool.test(t) ? ft : dt)), void 0 === i ? n && "get" in n && null !== (r = n.get(e, t)) ? r : null == (r = J.find.attr(e, t)) ? void 0 : r : null !== i ? n && "set" in n && void 0 !== (r = n.set(e, i, t)) ? r : (e.setAttribute(t, i + ""), i) : void J.removeAttr(e, t))
        },
        removeAttr: function(e, t) {
            var i, n, r = 0,
                o = t && t.match(de);
            if (o && 1 === e.nodeType)
                for (; i = o[r++];) n = J.propFix[i] || i, J.expr.match.bool.test(i) ? vt && mt || !gt.test(i) ? e[n] = !1 : e[J.camelCase("default-" + i)] = e[n] = !1 : J.attr(e, i, ""), e.removeAttribute(mt ? i : n)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!G.radioValue && "radio" === t && J.nodeName(e, "input")) {
                        var i = e.value;
                        return e.setAttribute("type", t), i && (e.value = i), t
                    }
                }
            }
        }
    }), ft = {
        set: function(e, t, i) {
            return !1 === t ? J.removeAttr(e, i) : vt && mt || !gt.test(i) ? e.setAttribute(!mt && J.propFix[i] || i, i) : e[J.camelCase("default-" + i)] = e[i] = !0, i
        }
    }, J.each(J.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var i = ht[t] || J.find.attr;
        ht[t] = vt && mt || !gt.test(t) ? function(e, t, n) {
            var r, o;
            return n || (o = ht[t], ht[t] = r, r = null != i(e, t, n) ? t.toLowerCase() : null, ht[t] = o), r
        } : function(e, t, i) {
            return i ? void 0 : e[J.camelCase("default-" + t)] ? t.toLowerCase() : null
        }
    }), vt && mt || (J.attrHooks.value = {
        set: function(e, t, i) {
            return J.nodeName(e, "input") ? void(e.defaultValue = t) : dt && dt.set(e, t, i)
        }
    }), mt || (dt = {
        set: function(e, t, i) {
            var n = e.getAttributeNode(i);
            return n || e.setAttributeNode(n = e.ownerDocument.createAttribute(i)), n.value = t += "", "value" === i || t === e.getAttribute(i) ? t : void 0
        }
    }, ht.id = ht.name = ht.coords = function(e, t, i) {
        var n;
        return i ? void 0 : (n = e.getAttributeNode(t)) && "" !== n.value ? n.value : null
    }, J.valHooks.button = {
        get: function(e, t) {
            var i = e.getAttributeNode(t);
            return i && i.specified ? i.value : void 0
        },
        set: dt.set
    }, J.attrHooks.contenteditable = {
        set: function(e, t, i) {
            dt.set(e, "" !== t && t, i)
        }
    }, J.each(["width", "height"], function(e, t) {
        J.attrHooks[t] = {
            set: function(e, i) {
                return "" === i ? (e.setAttribute(t, "auto"), i) : void 0
            }
        }
    })), G.style || (J.attrHooks.style = {
        get: function(e) {
            return e.style.cssText || void 0
        },
        set: function(e, t) {
            return e.style.cssText = t + ""
        }
    });
    var bt = /^(?:input|select|textarea|button|object)$/i,
        yt = /^(?:a|area)$/i;
    J.fn.extend({
        prop: function(e, t) {
            return we(this, J.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return e = J.propFix[e] || e, this.each(function() {
                try {
                    this[e] = void 0, delete this[e]
                } catch (e) {}
            })
        }
    }), J.extend({
        propFix: {
            for: "htmlFor",
            class: "className"
        },
        prop: function(e, t, i) {
            var n, r, o = e.nodeType;
            if (e && 3 !== o && 8 !== o && 2 !== o) return (1 !== o || !J.isXMLDoc(e)) && (t = J.propFix[t] || t, r = J.propHooks[t]), void 0 !== i ? r && "set" in r && void 0 !== (n = r.set(e, i, t)) ? n : e[t] = i : r && "get" in r && null !== (n = r.get(e, t)) ? n : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = J.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : bt.test(e.nodeName) || yt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        }
    }), G.hrefNormalized || J.each(["href", "src"], function(e, t) {
        J.propHooks[t] = {
            get: function(e) {
                return e.getAttribute(t, 4)
            }
        }
    }), G.optSelected || (J.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null
        }
    }), J.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        J.propFix[this.toLowerCase()] = this
    }), G.enctype || (J.propFix.enctype = "encoding");
    var St = /[\t\r\n\f]/g;
    J.fn.extend({
        addClass: function(e) {
            var t, i, n, r, o, a, s = 0,
                l = this.length,
                c = "string" == typeof e && e;
            if (J.isFunction(e)) return this.each(function(t) {
                J(this).addClass(e.call(this, t, this.className))
            });
            if (c)
                for (t = (e || "").match(de) || []; l > s; s++)
                    if (n = 1 === (i = this[s]).nodeType && (i.className ? (" " + i.className + " ").replace(St, " ") : " ")) {
                        for (o = 0; r = t[o++];) n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                        a = J.trim(n), i.className !== a && (i.className = a)
                    } return this
        },
        removeClass: function(e) {
            var t, i, n, r, o, a, s = 0,
                l = this.length,
                c = 0 === arguments.length || "string" == typeof e && e;
            if (J.isFunction(e)) return this.each(function(t) {
                J(this).removeClass(e.call(this, t, this.className))
            });
            if (c)
                for (t = (e || "").match(de) || []; l > s; s++)
                    if (n = 1 === (i = this[s]).nodeType && (i.className ? (" " + i.className + " ").replace(St, " ") : "")) {
                        for (o = 0; r = t[o++];)
                            for (; n.indexOf(" " + r + " ") >= 0;) n = n.replace(" " + r + " ", " ");
                        a = e ? J.trim(n) : "", i.className !== a && (i.className = a)
                    } return this
        },
        toggleClass: function(e, t) {
            var i = typeof e;
            return "boolean" == typeof t && "string" === i ? t ? this.addClass(e) : this.removeClass(e) : this.each(J.isFunction(e) ? function(i) {
                J(this).toggleClass(e.call(this, i, this.className, t), t)
            } : function() {
                if ("string" === i)
                    for (var t, n = 0, r = J(this), o = e.match(de) || []; t = o[n++];) r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
                else(i === ge || "boolean" === i) && (this.className && J._data(this, "__className__", this.className), this.className = this.className || !1 === e ? "" : J._data(this, "__className__") || "")
            })
        },
        hasClass: function(e) {
            for (var t = " " + e + " ", i = 0, n = this.length; n > i; i++)
                if (1 === this[i].nodeType && (" " + this[i].className + " ").replace(St, " ").indexOf(t) >= 0) return !0;
            return !1
        }
    }), J.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
        J.fn[t] = function(e, i) {
            return arguments.length > 0 ? this.on(t, null, e, i) : this.trigger(t)
        }
    }), J.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        },
        bind: function(e, t, i) {
            return this.on(e, null, t, i)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, i, n) {
            return this.on(t, e, i, n)
        },
        undelegate: function(e, t, i) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i)
        }
    });
    var wt = J.now(),
        Ct = /\?/,
        xt = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    J.parseJSON = function(t) {
        if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
        var i, n = null,
            r = J.trim(t + "");
        return r && !J.trim(r.replace(xt, function(e, t, r, o) {
            return i && t && (n = 0), 0 === n ? e : (i = r || t, n += !o - !r, "")
        })) ? Function("return " + r)() : J.error("Invalid JSON: " + t)
    }, J.parseXML = function(t) {
        var i;
        if (!t || "string" != typeof t) return null;
        try {
            e.DOMParser ? i = (new DOMParser).parseFromString(t, "text/xml") : ((i = new ActiveXObject("Microsoft.XMLDOM")).async = "false", i.loadXML(t))
        } catch (e) {
            i = void 0
        }
        return i && i.documentElement && !i.getElementsByTagName("parsererror").length || J.error("Invalid XML: " + t), i
    };
    var jt, Tt, Pt = /#.*$/,
        Ft = /([?&])_=[^&]*/,
        Ot = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
        kt = /^(?:GET|HEAD)$/,
        _t = /^\/\//,
        Bt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
        Lt = {},
        Qt = {},
        Mt = "*/".concat("*");
    try {
        Tt = location.href
    } catch (e) {
        (Tt = se.createElement("a")).href = "", Tt = Tt.href
    }
    jt = Bt.exec(Tt.toLowerCase()) || [], J.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Tt,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(jt[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Mt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /xml/,
                html: /html/,
                json: /json/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": J.parseJSON,
                "text xml": J.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? V(V(e, J.ajaxSettings), t) : V(J.ajaxSettings, e)
        },
        ajaxPrefilter: I(Lt),
        ajaxTransport: I(Qt),

        ajax: function(e, t) {
            function i(e, t, i, n) {
                var r, u, v, b, S, C = t;
                2 !== y && (y = 2, s && clearTimeout(s), c = void 0, a = n || "", w.readyState = e > 0 ? 4 : 0, r = e >= 200 && 300 > e || 304 === e, i && (b = function(e, t, i) {
                    for (var n, r, o, a, s = e.contents, l = e.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (r)
                        for (a in s)
                            if (s[a] && s[a].test(r)) {
                                l.unshift(a);
                                break
                            } if (l[0] in i) o = l[0];
                    else {
                        for (a in i) {
                            if (!l[0] || e.converters[a + " " + l[0]]) {
                                o = a;
                                break
                            }
                            n || (n = a)
                        }
                        o = o || n
                    }
                    return o ? (o !== l[0] && l.unshift(o), i[o]) : void 0
                }(p, w, i)), b = function(e, t, i, n) {
                    var r, o, a, s, l, c = {},
                        u = e.dataTypes.slice();
                    if (u[1])
                        for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
                    for (o = u.shift(); o;)
                        if (e.responseFields[o] && (i[e.responseFields[o]] = t), !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = o, o = u.shift())
                            if ("*" === o) o = l;
                            else if ("*" !== l && l !== o) {
                        if (!(a = c[l + " " + o] || c["* " + o]))
                            for (r in c)
                                if ((s = r.split(" "))[1] === o && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                                    !0 === a ? a = c[r] : !0 !== c[r] && (o = s[0], u.unshift(s[1]));
                                    break
                                } if (!0 !== a)
                            if (a && e.throws) t = a(t);
                            else try {
                                t = a(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: a ? e : "No conversion from " + l + " to " + o
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: t
                    }
                }(p, b, w, r), r ? (p.ifModified && ((S = w.getResponseHeader("Last-Modified")) && (J.lastModified[o] = S), (S = w.getResponseHeader("etag")) && (J.etag[o] = S)), 204 === e || "HEAD" === p.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = b.state, u = b.data, r = !(v = b.error))) : (v = C, (e || !C) && (C = "error", 0 > e && (e = 0))), w.status = e, w.statusText = (t || C) + "", r ? h.resolveWith(d, [u, C, w]) : h.rejectWith(d, [w, C, v]), w.statusCode(m), m = void 0, l && f.trigger(r ? "ajaxSuccess" : "ajaxError", [w, p, r ? u : v]), g.fireWith(d, [w, C]), l && (f.trigger("ajaxComplete", [w, p]), --J.active || J.event.trigger("ajaxStop")))
            }
            "object" == typeof e && (t = e, e = void 0), t = t || {};
            var n, r, o, a, s, l, c, u, p = J.ajaxSetup({}, t),
                d = p.context || p,
                f = p.context && (d.nodeType || d.jquery) ? J(d) : J.event,
                h = J.Deferred(),
                g = J.Callbacks("once memory"),
                m = p.statusCode || {},
                v = {},
                b = {},
                y = 0,
                S = "canceled",
                w = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (2 === y) {
                            if (!u)
                                for (u = {}; t = Ot.exec(a);) u[t[1].toLowerCase()] = t[2];
                            t = u[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    },
                    getAllResponseHeaders: function() {
                        return 2 === y ? a : null
                    },
                    setRequestHeader: function(e, t) {
                        var i = e.toLowerCase();
                        return y || (e = b[i] = b[i] || e, v[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return y || (p.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (2 > y)
                                for (t in e) m[t] = [m[t], e[t]];
                            else w.always(e[w.status]);
                        return this
                    },
                    abort: function(e) {
                        var t = e || S;
                        return c && c.abort(t), i(0, t), this
                    }
                };
            if (h.promise(w).complete = g.add, w.success = w.done, w.error = w.fail, p.url = ((e || p.url || Tt) + "").replace(Pt, "").replace(_t, jt[1] + "//"), p.type = t.method || t.type || p.method || p.type, p.dataTypes = J.trim(p.dataType || "*").toLowerCase().match(de) || [""], null == p.crossDomain && (n = Bt.exec(p.url.toLowerCase()), p.crossDomain = !(!n || n[1] === jt[1] && n[2] === jt[2] && (n[3] || ("http:" === n[1] ? "80" : "443")) === (jt[3] || ("http:" === jt[1] ? "80" : "443")))), p.data && p.processData && "string" != typeof p.data && (p.data = J.param(p.data, p.traditional)), A(Lt, p, t, w), 2 === y) return w;
            for (r in (l = p.global) && 0 == J.active++ && J.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !kt.test(p.type), o = p.url, p.hasContent || (p.data && (o = p.url += (Ct.test(o) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (p.url = Ft.test(o) ? o.replace(Ft, "$1_=" + wt++) : o + (Ct.test(o) ? "&" : "?") + "_=" + wt++)), p.ifModified && (J.lastModified[o] && w.setRequestHeader("If-Modified-Since", J.lastModified[o]), J.etag[o] && w.setRequestHeader("If-None-Match", J.etag[o])), (p.data && p.hasContent && !1 !== p.contentType || t.contentType) && w.setRequestHeader("Content-Type", p.contentType), w.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Mt + "; q=0.01" : "") : p.accepts["*"]), p.headers) w.setRequestHeader(r, p.headers[r]);
            if (p.beforeSend && (!1 === p.beforeSend.call(d, w, p) || 2 === y)) return w.abort();
            for (r in S = "abort", {
                    success: 1,
                    error: 1,
                    complete: 1
                }) w[r](p[r]);
            if (c = A(Qt, p, t, w)) {
                w.readyState = 1, l && f.trigger("ajaxSend", [w, p]), p.async && p.timeout > 0 && (s = setTimeout(function() {
                    w.abort("timeout")
                }, p.timeout));
                try {
                    y = 1, c.send(v, i)
                } catch (e) {
                    if (!(2 > y)) throw e;
                    i(-1, e)
                }
            } else i(-1, "No Transport");
            return w
        },
        getJSON: function(e, t, i) {
            return J.get(e, t, i, "json")
        },
        getScript: function(e, t) {
            return J.get(e, void 0, t, "script")
        }
    }), J.each(["get", "post"], function(e, t) {
        J[t] = function(e, i, n, r) {
            return J.isFunction(i) && (r = r || n, n = i, i = void 0), J.ajax({
                url: e,
                type: t,
                dataType: r,
                data: i,
                success: n
            })
        }
    }), J.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        J.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), J._evalUrl = function(e) {
        return J.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }, J.fn.extend({
        wrapAll: function(e) {
            if (J.isFunction(e)) return this.each(function(t) {
                J(this).wrapAll(e.call(this, t))
            });
            if (this[0]) {
                var t = J(e, this[0].ownerDocument).eq(0).clone(!0);
                this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                    for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) e = e.firstChild;
                    return e
                }).append(this)
            }
            return this
        },
        wrapInner: function(e) {
            return this.each(J.isFunction(e) ? function(t) {
                J(this).wrapInner(e.call(this, t))
            } : function() {
                var t = J(this),
                    i = t.contents();
                i.length ? i.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = J.isFunction(e);
            return this.each(function(i) {
                J(this).wrapAll(t ? e.call(this, i) : e)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                J.nodeName(this, "body") || J(this).replaceWith(this.childNodes)
            }).end()
        }
    }), J.expr.filters.hidden = function(e) {
        return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !G.reliableHiddenOffsets() && "none" === (e.style && e.style.display || J.css(e, "display"))
    }, J.expr.filters.visible = function(e) {
        return !J.expr.filters.hidden(e)
    };
    var Et = /%20/g,
        It = /\[\]$/,
        At = /\r?\n/g,
        Vt = /^(?:submit|button|image|reset|file)$/i,
        Dt = /^(?:input|select|textarea|keygen)/i;
    J.param = function(e, t) {
        var i, n = [],
            r = function(e, t) {
                t = J.isFunction(t) ? t() : null == t ? "" : t, n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
            };
        if (void 0 === t && (t = J.ajaxSettings && J.ajaxSettings.traditional), J.isArray(e) || e.jquery && !J.isPlainObject(e)) J.each(e, function() {
            r(this.name, this.value)
        });
        else
            for (i in e) D(i, e[i], t, r);
        return n.join("&").replace(Et, "+")
    }, J.fn.extend({
        serialize: function() {
            return J.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = J.prop(this, "elements");
                return e ? J.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !J(this).is(":disabled") && Dt.test(this.nodeName) && !Vt.test(e) && (this.checked || !Ce.test(e))
            }).map(function(e, t) {
                var i = J(this).val();
                return null == i ? null : J.isArray(i) ? J.map(i, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(At, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: i.replace(At, "\r\n")
                }
            }).get()
        }
    }), J.ajaxSettings.xhr = void 0 !== e.ActiveXObject ? function() {
        return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && H() || function() {
            try {
                return new e.ActiveXObject("Microsoft.XMLHTTP")
            } catch (e) {}
        }()
    } : H;
    var Ht = 0,
        Nt = {},
        Rt = J.ajaxSettings.xhr();
    e.ActiveXObject && J(e).on("unload", function() {
        for (var e in Nt) Nt[e](void 0, !0)
    }), G.cors = !!Rt && "withCredentials" in Rt, (Rt = G.ajax = !!Rt) && J.ajaxTransport(function(e) {
        var t;
        if (!e.crossDomain || G.cors) return {
            send: function(i, n) {
                var r, o = e.xhr(),
                    a = ++Ht;
                if (o.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                    for (r in e.xhrFields) o[r] = e.xhrFields[r];
                for (r in e.mimeType && o.overrideMimeType && o.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i) void 0 !== i[r] && o.setRequestHeader(r, i[r] + "");
                o.send(e.hasContent && e.data || null), t = function(i, r) {
                    var s, l, c;
                    if (t && (r || 4 === o.readyState))
                        if (delete Nt[a], t = void 0, o.onreadystatechange = J.noop, r) 4 !== o.readyState && o.abort();
                        else {
                            c = {}, s = o.status, "string" == typeof o.responseText && (c.text = o.responseText);
                            try {
                                l = o.statusText
                            } catch (e) {
                                l = ""
                            }
                            s || !e.isLocal || e.crossDomain ? 1223 === s && (s = 204) : s = c.text ? 200 : 404
                        } c && n(s, l, c, o.getAllResponseHeaders())
                }, e.async ? 4 === o.readyState ? setTimeout(t) : o.onreadystatechange = Nt[a] = t : t()
            },
            abort: function() {
                t && t(void 0, !0)
            }
        }
    }), J.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /(?:java|ecma)script/
        },
        converters: {
            "text script": function(e) {
                return J.globalEval(e), e
            }
        }
    }), J.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1)
    }), J.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, i = se.head || J("head")[0] || se.documentElement;
            return {
                send: function(n, r) {
                    (t = se.createElement("script")).async = !0, e.scriptCharset && (t.charset = e.scriptCharset), t.src = e.url, t.onload = t.onreadystatechange = function(e, i) {
                        (i || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, t.parentNode && t.parentNode.removeChild(t), t = null, i || r(200, "success"))
                    }, i.insertBefore(t, i.firstChild)
                },
                abort: function() {
                    t && t.onload(void 0, !0)
                }
            }
        }
    });
    var qt = [],
        zt = /(=)\?(?=&|$)|\?\?/;
    J.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = qt.pop() || J.expando + "_" + wt++;
            return this[e] = !0, e
        }
    }), J.ajaxPrefilter("json jsonp", function(t, i, n) {
        var r, o, a, s = !1 !== t.jsonp && (zt.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && zt.test(t.data) && "data");
        return s || "jsonp" === t.dataTypes[0] ? (r = t.jsonpCallback = J.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(zt, "$1" + r) : !1 !== t.jsonp && (t.url += (Ct.test(t.url) ? "&" : "?") + t.jsonp + "=" + r), t.converters["script json"] = function() {
            return a || J.error(r + " was not called"), a[0]
        }, t.dataTypes[0] = "json", o = e[r], e[r] = function() {
            a = arguments
        }, n.always(function() {
            e[r] = o, t[r] && (t.jsonpCallback = i.jsonpCallback, qt.push(r)), a && J.isFunction(o) && o(a[0]), a = o = void 0
        }), "script") : void 0
    }), J.parseHTML = function(e, t, i) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (i = t, t = !1), t = t || se;
        var n = re.exec(e),
            r = !i && [];
        return n ? [t.createElement(n[1])] : (n = J.buildFragment([e], t, r), r && r.length && J(r).remove(), J.merge([], n.childNodes))
    };
    var Wt = J.fn.load;
    J.fn.load = function(e, t, i) {
        if ("string" != typeof e && Wt) return Wt.apply(this, arguments);
        var n, r, o, a = this,
            s = e.indexOf(" ");
        return s >= 0 && (n = J.trim(e.slice(s, e.length)), e = e.slice(0, s)), J.isFunction(t) ? (i = t, t = void 0) : t && "object" == typeof t && (o = "POST"), a.length > 0 && J.ajax({
            url: e,
            type: o,
            dataType: "html",
            data: t
        }).done(function(e) {
            r = arguments, a.html(n ? J("<div>").append(J.parseHTML(e)).find(n) : e)
        }).complete(i && function(e, t) {
            a.each(i, r || [e.responseText, t, e])
        }), this
    }, J.expr.filters.animated = function(e) {
        return J.grep(J.timers, function(t) {
            return e === t.elem
        }).length
    };
    var Ut = e.document.documentElement;
    J.offset = {
        setOffset: function(e, t, i) {
            var n, r, o, a, s, l, c = J.css(e, "position"),
                u = J(e),
                p = {};
            "static" === c && (e.style.position = "relative"), s = u.offset(), o = J.css(e, "top"), l = J.css(e, "left"), ("absolute" === c || "fixed" === c) && J.inArray("auto", [o, l]) > -1 ? (a = (n = u.position()).top, r = n.left) : (a = parseFloat(o) || 0, r = parseFloat(l) || 0), J.isFunction(t) && (t = t.call(e, i, s)), null != t.top && (p.top = t.top - s.top + a), null != t.left && (p.left = t.left - s.left + r), "using" in t ? t.using.call(e, p) : u.css(p)
        }
    }, J.fn.extend({
        offset: function(e) {
            if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                J.offset.setOffset(this, e, t)
            });
            var t, i, n = {
                    top: 0,
                    left: 0
                },
                r = this[0],
                o = r && r.ownerDocument;
            return o ? (t = o.documentElement, J.contains(t, r) ? (typeof r.getBoundingClientRect !== ge && (n = r.getBoundingClientRect()), i = N(o), {
                top: n.top + (i.pageYOffset || t.scrollTop) - (t.clientTop || 0),
                left: n.left + (i.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
            }) : n) : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, i = {
                        top: 0,
                        left: 0
                    },
                    n = this[0];
                return "fixed" === J.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), J.nodeName(e[0], "html") || (i = e.offset()), i.top += J.css(e[0], "borderTopWidth", !0), i.left += J.css(e[0], "borderLeftWidth", !0)), {
                    top: t.top - i.top - J.css(n, "marginTop", !0),
                    left: t.left - i.left - J.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent || Ut; e && !J.nodeName(e, "html") && "static" === J.css(e, "position");) e = e.offsetParent;
                return e || Ut
            })
        }
    }), J.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var i = /Y/.test(t);
        J.fn[e] = function(n) {
            return we(this, function(e, n, r) {
                var o = N(e);
                return void 0 === r ? o ? t in o ? o[t] : o.document.documentElement[n] : e[n] : void(o ? o.scrollTo(i ? J(o).scrollLeft() : r, i ? r : J(o).scrollTop()) : e[n] = r)
            }, e, n, arguments.length, null)
        }
    }), J.each(["top", "left"], function(e, t) {
        J.cssHooks[t] = T(G.pixelPosition, function(e, i) {
            return i ? (i = Ue(e, t), Xe.test(i) ? J(e).position()[t] + "px" : i) : void 0
        })
    }), J.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        J.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(i, n) {
            J.fn[n] = function(n, r) {
                var o = arguments.length && (i || "boolean" != typeof n),
                    a = i || (!0 === n || !0 === r ? "margin" : "border");
                return we(this, function(t, i, n) {
                    var r;
                    return J.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (r = t.documentElement, Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === n ? J.css(t, i, a) : J.style(t, i, n, a)
                }, t, o ? n : void 0, o, null)
            }
        })
    }), J.fn.size = function() {
        return this.length
    }, J.fn.andSelf = J.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return J
    });
    var $t = e.jQuery,
        Xt = e.$;
    return J.noConflict = function(t) {
        return e.$ === J && (e.$ = Xt), t && e.jQuery === J && (e.jQuery = $t), J
    }, typeof t === ge && (e.jQuery = e.$ = J), J
}),
function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery)
}(function(e) {
    e.ui = e.ui || {}, e.ui.version = "1.12.1";
    var t = 0,
        i = Array.prototype.slice;
    e.cleanData = function(t) {
            return function(i) {
                var n, r, o;
                for (o = 0; null != (r = i[o]); o++) try {
                    (n = e._data(r, "events")) && n.remove && e(r).triggerHandler("remove")
                } catch (e) {}
                t(i)
            }
        }(e.cleanData), e.widget = function(t, i, n) {
            var r, o, a, s = {},
                l = t.split(".")[0],
                c = l + "-" + (t = t.split(".")[1]);
            return n || (n = i, i = e.Widget), e.isArray(n) && (n = e.extend.apply(null, [{}].concat(n))), e.expr[":"][c.toLowerCase()] = function(t) {
                return !!e.data(t, c)
            }, e[l] = e[l] || {}, r = e[l][t], o = e[l][t] = function(e, t) {
                return this._createWidget ? void(arguments.length && this._createWidget(e, t)) : new o(e, t)
            }, e.extend(o, r, {
                version: n.version,
                _proto: e.extend({}, n),
                _childConstructors: []
            }), (a = new i).options = e.widget.extend({}, a.options), e.each(n, function(t, n) {
                return e.isFunction(n) ? void(s[t] = function() {
                    function e() {
                        return i.prototype[t].apply(this, arguments)
                    }

                    function r(e) {
                        return i.prototype[t].apply(this, e)
                    }
                    return function() {
                        var t, i = this._super,
                            o = this._superApply;
                        return this._super = e, this._superApply = r, t = n.apply(this, arguments), this._super = i, this._superApply = o, t
                    }
                }()) : void(s[t] = n)
            }), o.prototype = e.widget.extend(a, {
                widgetEventPrefix: r && a.widgetEventPrefix || t
            }, s, {
                constructor: o,
                namespace: l,
                widgetName: t,
                widgetFullName: c
            }), r ? (e.each(r._childConstructors, function(t, i) {
                var n = i.prototype;
                e.widget(n.namespace + "." + n.widgetName, o, i._proto)
            }), delete r._childConstructors) : i._childConstructors.push(o), e.widget.bridge(t, o), o
        }, e.widget.extend = function(t) {
            for (var n, r, o = i.call(arguments, 1), a = 0, s = o.length; s > a; a++)
                for (n in o[a]) r = o[a][n], o[a].hasOwnProperty(n) && void 0 !== r && (t[n] = e.isPlainObject(r) ? e.isPlainObject(t[n]) ? e.widget.extend({}, t[n], r) : e.widget.extend({}, r) : r);
            return t
        }, e.widget.bridge = function(t, n) {
            var r = n.prototype.widgetFullName || t;
            e.fn[t] = function(o) {
                var a = "string" == typeof o,
                    s = i.call(arguments, 1),
                    l = this;
                return a ? this.length || "instance" !== o ? this.each(function() {
                    var i, n = e.data(this, r);
                    return "instance" === o ? (l = n, !1) : n ? e.isFunction(n[o]) && "_" !== o.charAt(0) ? (i = n[o].apply(n, s)) !== n && void 0 !== i ? (l = i && i.jquery ? l.pushStack(i.get()) : i, !1) : void 0 : e.error("no such method '" + o + "' for " + t + " widget instance") : e.error("cannot call methods on " + t + " prior to initialization; attempted to call method '" + o + "'")
                }) : l = void 0 : (s.length && (o = e.widget.extend.apply(null, [o].concat(s))), this.each(function() {
                    var t = e.data(this, r);
                    t ? (t.option(o || {}), t._init && t._init()) : e.data(this, r, new n(o, this))
                })), l
            }
        }, e.Widget = function() {}, e.Widget._childConstructors = [], e.Widget.prototype = {
            widgetName: "widget",
            widgetEventPrefix: "",
            defaultElement: "<div>",
            options: {
                classes: {},
                disabled: !1,
                create: null
            },
            _createWidget: function(i, n) {
                n = e(n || this.defaultElement || this)[0], this.element = e(n), this.uuid = t++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = e(), this.hoverable = e(), this.focusable = e(), this.classesElementLookup = {}, n !== this && (e.data(n, this.widgetFullName, this), this._on(!0, this.element, {
                    remove: function(e) {
                        e.target === n && this.destroy()
                    }
                }), this.document = e(n.style ? n.ownerDocument : n.document || n), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this.options = e.widget.extend({}, this.options, this._getCreateOptions(), i), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init()
            },
            _getCreateOptions: function() {
                return {}
            },
            _getCreateEventData: e.noop,
            _create: e.noop,
            _init: e.noop,
            destroy: function() {
                var t = this;
                this._destroy(), e.each(this.classesElementLookup, function(e, i) {
                    t._removeClass(i, e)
                }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace)
            },
            _destroy: e.noop,
            widget: function() {
                return this.element
            },
            option: function(t, i) {
                var n, r, o, a = t;
                if (0 === arguments.length) return e.widget.extend({}, this.options);
                if ("string" == typeof t)
                    if (a = {}, n = t.split("."), t = n.shift(), n.length) {
                        for (r = a[t] = e.widget.extend({}, this.options[t]), o = 0; n.length - 1 > o; o++) r[n[o]] = r[n[o]] || {}, r = r[n[o]];
                        if (t = n.pop(), 1 === arguments.length) return void 0 === r[t] ? null : r[t];
                        r[t] = i
                    } else {
                        if (1 === arguments.length) return void 0 === this.options[t] ? null : this.options[t];
                        a[t] = i
                    } return this._setOptions(a), this
            },
            _setOptions: function(e) {
                var t;
                for (t in e) this._setOption(t, e[t]);
                return this
            },
            _setOption: function(e, t) {
                return "classes" === e && this._setOptionClasses(t), this.options[e] = t, "disabled" === e && this._setOptionDisabled(t), this
            },
            _setOptionClasses: function(t) {
                var i, n, r;
                for (i in t) r = this.classesElementLookup[i], t[i] !== this.options.classes[i] && r && r.length && (n = e(r.get()), this._removeClass(r, i), n.addClass(this._classes({
                    element: n,
                    keys: i,
                    classes: t,
                    add: !0
                })))
            },
            _setOptionDisabled: function(e) {
                this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e), e && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"))
            },
            enable: function() {
                return this._setOptions({
                    disabled: !1
                })
            },
            disable: function() {
                return this._setOptions({
                    disabled: !0
                })
            },
            _classes: function(t) {
                function i(i, o) {
                    var a, s;
                    for (s = 0; i.length > s; s++) a = r.classesElementLookup[i[s]] || e(), a = e(t.add ? e.unique(a.get().concat(t.element.get())) : a.not(t.element).get()), r.classesElementLookup[i[s]] = a, n.push(i[s]), o && t.classes[i[s]] && n.push(t.classes[i[s]])
                }
                var n = [],
                    r = this;
                return t = e.extend({
                    element: this.element,
                    classes: this.options.classes || {}
                }, t), this._on(t.element, {
                    remove: "_untrackClassesElement"
                }), t.keys && i(t.keys.match(/\S+/g) || [], !0), t.extra && i(t.extra.match(/\S+/g) || []), n.join(" ")
            },
            _untrackClassesElement: function(t) {
                var i = this;
                e.each(i.classesElementLookup, function(n, r) {
                    -1 !== e.inArray(t.target, r) && (i.classesElementLookup[n] = e(r.not(t.target).get()))
                })
            },
            _removeClass: function(e, t, i) {
                return this._toggleClass(e, t, i, !1)
            },
            _addClass: function(e, t, i) {
                return this._toggleClass(e, t, i, !0)
            },
            _toggleClass: function(e, t, i, n) {
                n = "boolean" == typeof n ? n : i;
                var r = "string" == typeof e || null === e,
                    o = {
                        extra: r ? t : i,
                        keys: r ? e : t,
                        element: r ? this.element : e,
                        add: n
                    };
                return o.element.toggleClass(this._classes(o), n), this
            },
            _on: function(t, i, n) {
                var r, o = this;
                "boolean" != typeof t && (n = i, i = t, t = !1), n ? (i = r = e(i), this.bindings = this.bindings.add(i)) : (n = i, i = this.element, r = this.widget()), e.each(n, function(n, a) {
                    function s() {
                        return t || !0 !== o.options.disabled && !e(this).hasClass("ui-state-disabled") ? ("string" == typeof a ? o[a] : a).apply(o, arguments) : void 0
                    }
                    "string" != typeof a && (s.guid = a.guid = a.guid || s.guid || e.guid++);
                    var l = n.match(/^([\w:-]*)\s*(.*)$/),
                        c = l[1] + o.eventNamespace,
                        u = l[2];
                    u ? r.on(c, u, s) : i.on(c, s)
                })
            },
            _off: function(t, i) {
                i = (i || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, t.off(i).off(i), this.bindings = e(this.bindings.not(t).get()), this.focusable = e(this.focusable.not(t).get()), this.hoverable = e(this.hoverable.not(t).get())
            },
            _delay: function(e, t) {
                var i = this;
                return setTimeout(function() {
                    return ("string" == typeof e ? i[e] : e).apply(i, arguments)
                }, t || 0)
            },
            _hoverable: function(t) {
                this.hoverable = this.hoverable.add(t), this._on(t, {
                    mouseenter: function(t) {
                        this._addClass(e(t.currentTarget), null, "ui-state-hover")
                    },
                    mouseleave: function(t) {
                        this._removeClass(e(t.currentTarget), null, "ui-state-hover")
                    }
                })
            },
            _focusable: function(t) {
                this.focusable = this.focusable.add(t), this._on(t, {
                    focusin: function(t) {
                        this._addClass(e(t.currentTarget), null, "ui-state-focus")
                    },
                    focusout: function(t) {
                        this._removeClass(e(t.currentTarget), null, "ui-state-focus")
                    }
                })
            },
            _trigger: function(t, i, n) {
                var r, o, a = this.options[t];
                if (n = n || {}, (i = e.Event(i)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), i.target = this.element[0], o = i.originalEvent)
                    for (r in o) r in i || (i[r] = o[r]);
                return this.element.trigger(i, n), !(e.isFunction(a) && !1 === a.apply(this.element[0], [i].concat(n)) || i.isDefaultPrevented())
            }
        }, e.each({
            show: "fadeIn",
            hide: "fadeOut"
        }, function(t, i) {
            e.Widget.prototype["_" + t] = function(n, r, o) {
                "string" == typeof r && (r = {
                    effect: r
                });
                var a, s = r ? !0 === r || "number" == typeof r ? i : r.effect || i : t;
                "number" == typeof(r = r || {}) && (r = {
                    duration: r
                }), a = !e.isEmptyObject(r), r.complete = o, r.delay && n.delay(r.delay), a && e.effects && e.effects.effect[s] ? n[t](r) : s !== t && n[s] ? n[s](r.duration, r.easing, o) : n.queue(function(i) {
                    e(this)[t](), o && o.call(n[0]), i()
                })
            }
        }), e.widget,
        function() {
            function t(e, t, i) {
                return [parseFloat(e[0]) * (u.test(e[0]) ? t / 100 : 1), parseFloat(e[1]) * (u.test(e[1]) ? i / 100 : 1)]
            }

            function i(t, i) {
                return parseInt(e.css(t, i), 10) || 0
            }
            var n, r = Math.max,
                o = Math.abs,
                a = /left|center|right/,
                s = /top|center|bottom/,
                l = /[\+\-]\d+(\.[\d]+)?%?/,
                c = /^\w+/,
                u = /%$/,
                p = e.fn.position;
            e.position = {
                scrollbarWidth: function() {
                    if (void 0 !== n) return n;
                    var t, i, r = e("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),
                        o = r.children()[0];
                    return e("body").append(r), t = o.offsetWidth, r.css("overflow", "scroll"), t === (i = o.offsetWidth) && (i = r[0].clientWidth), r.remove(), n = t - i
                },
                getScrollInfo: function(t) {
                    var i = t.isWindow || t.isDocument ? "" : t.element.css("overflow-x"),
                        n = t.isWindow || t.isDocument ? "" : t.element.css("overflow-y"),
                        r = "scroll" === i || "auto" === i && t.width < t.element[0].scrollWidth;
                    return {
                        width: "scroll" === n || "auto" === n && t.height < t.element[0].scrollHeight ? e.position.scrollbarWidth() : 0,
                        height: r ? e.position.scrollbarWidth() : 0
                    }
                },
                getWithinInfo: function(t) {
                    var i = e(t || window),
                        n = e.isWindow(i[0]),
                        r = !!i[0] && 9 === i[0].nodeType;
                    return {
                        element: i,
                        isWindow: n,
                        isDocument: r,
                        offset: n || r ? {
                            left: 0,
                            top: 0
                        } : e(t).offset(),
                        scrollLeft: i.scrollLeft(),
                        scrollTop: i.scrollTop(),
                        width: i.outerWidth(),
                        height: i.outerHeight()
                    }
                }
            }, e.fn.position = function(n) {
                if (!n || !n.of) return p.apply(this, arguments);
                n = e.extend({}, n);
                var u, d, f, h, g, m, v = e(n.of),
                    b = e.position.getWithinInfo(n.within),
                    y = e.position.getScrollInfo(b),
                    S = (n.collision || "flip").split(" "),
                    w = {};
                return m = function(t) {
                    var i = t[0];
                    return 9 === i.nodeType ? {
                        width: t.width(),
                        height: t.height(),
                        offset: {
                            top: 0,
                            left: 0
                        }
                    } : e.isWindow(i) ? {
                        width: t.width(),
                        height: t.height(),
                        offset: {
                            top: t.scrollTop(),
                            left: t.scrollLeft()
                        }
                    } : i.preventDefault ? {
                        width: 0,
                        height: 0,
                        offset: {
                            top: i.pageY,
                            left: i.pageX
                        }
                    } : {
                        width: t.outerWidth(),
                        height: t.outerHeight(),
                        offset: t.offset()
                    }
                }(v), v[0].preventDefault && (n.at = "left top"), d = m.width, f = m.height, h = m.offset, g = e.extend({}, h), e.each(["my", "at"], function() {
                    var e, t, i = (n[this] || "").split(" ");
                    1 === i.length && (i = a.test(i[0]) ? i.concat(["center"]) : s.test(i[0]) ? ["center"].concat(i) : ["center", "center"]), i[0] = a.test(i[0]) ? i[0] : "center", i[1] = s.test(i[1]) ? i[1] : "center", e = l.exec(i[0]), t = l.exec(i[1]), w[this] = [e ? e[0] : 0, t ? t[0] : 0], n[this] = [c.exec(i[0])[0], c.exec(i[1])[0]]
                }), 1 === S.length && (S[1] = S[0]), "right" === n.at[0] ? g.left += d : "center" === n.at[0] && (g.left += d / 2), "bottom" === n.at[1] ? g.top += f : "center" === n.at[1] && (g.top += f / 2), u = t(w.at, d, f), g.left += u[0], g.top += u[1], this.each(function() {
                    var a, s, l = e(this),
                        c = l.outerWidth(),
                        p = l.outerHeight(),
                        m = i(this, "marginLeft"),
                        C = i(this, "marginTop"),
                        x = c + m + i(this, "marginRight") + y.width,
                        j = p + C + i(this, "marginBottom") + y.height,
                        T = e.extend({}, g),
                        P = t(w.my, l.outerWidth(), l.outerHeight());
                    "right" === n.my[0] ? T.left -= c : "center" === n.my[0] && (T.left -= c / 2), "bottom" === n.my[1] ? T.top -= p : "center" === n.my[1] && (T.top -= p / 2), T.left += P[0], T.top += P[1], a = {
                        marginLeft: m,
                        marginTop: C
                    }, e.each(["left", "top"], function(t, i) {
                        e.ui.position[S[t]] && e.ui.position[S[t]][i](T, {
                            targetWidth: d,
                            targetHeight: f,
                            elemWidth: c,
                            elemHeight: p,
                            collisionPosition: a,
                            collisionWidth: x,
                            collisionHeight: j,
                            offset: [u[0] + P[0], u[1] + P[1]],
                            my: n.my,
                            at: n.at,
                            within: b,
                            elem: l
                        })
                    }), n.using && (s = function(e) {
                        var t = h.left - T.left,
                            i = t + d - c,
                            a = h.top - T.top,
                            s = a + f - p,
                            u = {
                                target: {
                                    element: v,
                                    left: h.left,
                                    top: h.top,
                                    width: d,
                                    height: f
                                },
                                element: {
                                    element: l,
                                    left: T.left,
                                    top: T.top,
                                    width: c,
                                    height: p
                                },
                                horizontal: 0 > i ? "left" : t > 0 ? "right" : "center",
                                vertical: 0 > s ? "top" : a > 0 ? "bottom" : "middle"
                            };
                        c > d && d > o(t + i) && (u.horizontal = "center"), p > f && f > o(a + s) && (u.vertical = "middle"), u.important = r(o(t), o(i)) > r(o(a), o(s)) ? "horizontal" : "vertical", n.using.call(this, e, u)
                    }), l.offset(e.extend(T, {
                        using: s
                    }))
                })
            }, e.ui.position = {
                fit: {
                    left: function(e, t) {
                        var i, n = t.within,
                            o = n.isWindow ? n.scrollLeft : n.offset.left,
                            a = n.width,
                            s = e.left - t.collisionPosition.marginLeft,
                            l = o - s,
                            c = s + t.collisionWidth - a - o;
                        t.collisionWidth > a ? l > 0 && 0 >= c ? (i = e.left + l + t.collisionWidth - a - o, e.left += l - i) : e.left = c > 0 && 0 >= l ? o : l > c ? o + a - t.collisionWidth : o : l > 0 ? e.left += l : c > 0 ? e.left -= c : e.left = r(e.left - s, e.left)
                    },
                    top: function(e, t) {
                        var i, n = t.within,
                            o = n.isWindow ? n.scrollTop : n.offset.top,
                            a = t.within.height,
                            s = e.top - t.collisionPosition.marginTop,
                            l = o - s,
                            c = s + t.collisionHeight - a - o;
                        t.collisionHeight > a ? l > 0 && 0 >= c ? (i = e.top + l + t.collisionHeight - a - o, e.top += l - i) : e.top = c > 0 && 0 >= l ? o : l > c ? o + a - t.collisionHeight : o : l > 0 ? e.top += l : c > 0 ? e.top -= c : e.top = r(e.top - s, e.top)
                    }
                },
                flip: {
                    left: function(e, t) {
                        var i, n, r = t.within,
                            a = r.offset.left + r.scrollLeft,
                            s = r.width,
                            l = r.isWindow ? r.scrollLeft : r.offset.left,
                            c = e.left - t.collisionPosition.marginLeft,
                            u = c - l,
                            p = c + t.collisionWidth - s - l,
                            d = "left" === t.my[0] ? -t.elemWidth : "right" === t.my[0] ? t.elemWidth : 0,
                            f = "left" === t.at[0] ? t.targetWidth : "right" === t.at[0] ? -t.targetWidth : 0,
                            h = -2 * t.offset[0];
                        0 > u ? (0 > (i = e.left + d + f + h + t.collisionWidth - s - a) || o(u) > i) && (e.left += d + f + h) : p > 0 && ((n = e.left - t.collisionPosition.marginLeft + d + f + h - l) > 0 || p > o(n)) && (e.left += d + f + h)
                    },
                    top: function(e, t) {
                        var i, n, r = t.within,
                            a = r.offset.top + r.scrollTop,
                            s = r.height,
                            l = r.isWindow ? r.scrollTop : r.offset.top,
                            c = e.top - t.collisionPosition.marginTop,
                            u = c - l,
                            p = c + t.collisionHeight - s - l,
                            d = "top" === t.my[1] ? -t.elemHeight : "bottom" === t.my[1] ? t.elemHeight : 0,
                            f = "top" === t.at[1] ? t.targetHeight : "bottom" === t.at[1] ? -t.targetHeight : 0,
                            h = -2 * t.offset[1];
                        0 > u ? (0 > (n = e.top + d + f + h + t.collisionHeight - s - a) || o(u) > n) && (e.top += d + f + h) : p > 0 && ((i = e.top - t.collisionPosition.marginTop + d + f + h - l) > 0 || p > o(i)) && (e.top += d + f + h)
                    }
                },
                flipfit: {
                    left: function() {
                        e.ui.position.flip.left.apply(this, arguments), e.ui.position.fit.left.apply(this, arguments)
                    },
                    top: function() {
                        e.ui.position.flip.top.apply(this, arguments), e.ui.position.fit.top.apply(this, arguments)
                    }
                }
            }
        }(), e.ui.position, e.ui.keyCode = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        }, e.fn.extend({
            uniqueId: function() {
                var e = 0;
                return function() {
                    return this.each(function() {
                        this.id || (this.id = "ui-id-" + ++e)
                    })
                }
            }(),
            removeUniqueId: function() {
                return this.each(function() {
                    /^ui-id-\d+$/.test(this.id) && e(this).removeAttr("id")
                })
            }
        }), e.ui.safeActiveElement = function(e) {
            var t;
            try {
                t = e.activeElement
            } catch (i) {
                t = e.body
            }
            return t || (t = e.body), t.nodeName || (t = e.body), t
        }, e.widget("ui.menu", {
            version: "1.12.1",
            defaultElement: "<ul>",
            delay: 300,
            options: {
                icons: {
                    submenu: "ui-icon-caret-1-e"
                },
                items: "> *",
                menus: "ul",
                position: {
                    my: "left top",
                    at: "right top"
                },
                role: "menu",
                blur: null,
                focus: null,
                select: null
            },
            _create: function() {
                this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().attr({
                    role: this.options.role,
                    tabIndex: 0
                }), this._addClass("ui-menu", "ui-widget ui-widget-content"), this._on({
                    "mousedown .ui-menu-item": function(e) {
                        e.preventDefault()
                    },
                    "click .ui-menu-item": function(t) {
                        var i = e(t.target),
                            n = e(e.ui.safeActiveElement(this.document[0]));
                        !this.mouseHandled && i.not(".ui-state-disabled").length && (this.select(t), t.isPropagationStopped() || (this.mouseHandled = !0), i.has(".ui-menu").length ? this.expand(t) : !this.element.is(":focus") && n.closest(".ui-menu").length && (this.element.trigger("focus", [!0]), this.active && 1 === this.active.parents(".ui-menu").length && clearTimeout(this.timer)))
                    },
                    "mouseenter .ui-menu-item": function(t) {
                        if (!this.previousFilter) {
                            var i = e(t.target).closest(".ui-menu-item"),
                                n = e(t.currentTarget);
                            i[0] === n[0] && (this._removeClass(n.siblings().children(".ui-state-active"), null, "ui-state-active"), this.focus(t, n))
                        }
                    },
                    mouseleave: "collapseAll",
                    "mouseleave .ui-menu": "collapseAll",
                    focus: function(e, t) {
                        var i = this.active || this.element.find(this.options.items).eq(0);
                        t || this.focus(e, i)
                    },
                    blur: function(t) {
                        this._delay(function() {
                            !e.contains(this.element[0], e.ui.safeActiveElement(this.document[0])) && this.collapseAll(t)
                        })
                    },
                    keydown: "_keydown"
                }), this.refresh(), this._on(this.document, {
                    click: function(e) {
                        this._closeOnDocumentClick(e) && this.collapseAll(e), this.mouseHandled = !1
                    }
                })
            },
            _destroy: function() {
                var t = this.element.find(".ui-menu-item").removeAttr("role aria-disabled").children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");
                this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(), t.children().each(function() {
                    var t = e(this);
                    t.data("ui-menu-submenu-caret") && t.remove()
                })
            },
            _keydown: function(t) {
                var i, n, r, o, a = !0;
                switch (t.keyCode) {
                    case e.ui.keyCode.PAGE_UP:
                        this.previousPage(t);
                        break;
                    case e.ui.keyCode.PAGE_DOWN:
                        this.nextPage(t);
                        break;
                    case e.ui.keyCode.HOME:
                        this._move("first", "first", t);
                        break;
                    case e.ui.keyCode.END:
                        this._move("last", "last", t);
                        break;
                    case e.ui.keyCode.UP:
                        this.previous(t);
                        break;
                    case e.ui.keyCode.DOWN:
                        this.next(t);
                        break;
                    case e.ui.keyCode.LEFT:
                        this.collapse(t);
                        break;
                    case e.ui.keyCode.RIGHT:
                        this.active && !this.active.is(".ui-state-disabled") && this.expand(t);
                        break;
                    case e.ui.keyCode.ENTER:
                    case e.ui.keyCode.SPACE:
                        this._activate(t);
                        break;
                    case e.ui.keyCode.ESCAPE:
                        this.collapse(t);
                        break;
                    default:
                        a = !1, n = this.previousFilter || "", o = !1, r = t.keyCode >= 96 && 105 >= t.keyCode ? "" + (t.keyCode - 96) : String.fromCharCode(t.keyCode), clearTimeout(this.filterTimer), r === n ? o = !0 : r = n + r, i = this._filterMenuItems(r), (i = o && -1 !== i.index(this.active.next()) ? this.active.nextAll(".ui-menu-item") : i).length || (r = String.fromCharCode(t.keyCode), i = this._filterMenuItems(r)), i.length ? (this.focus(t, i), this.previousFilter = r, this.filterTimer = this._delay(function() {
                            delete this.previousFilter
                        }, 1e3)) : delete this.previousFilter
                }
                a && t.preventDefault()
            },
            _activate: function(e) {
                this.active && !this.active.is(".ui-state-disabled") && (this.active.children("[aria-haspopup='true']").length ? this.expand(e) : this.select(e))
            },
            refresh: function() {
                var t, i, n, r, o = this,
                    a = this.options.icons.submenu,
                    s = this.element.find(this.options.menus);
                this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length), i = s.filter(":not(.ui-menu)").hide().attr({
                    role: this.options.role,
                    "aria-hidden": "true",
                    "aria-expanded": "false"
                }).each(function() {
                    var t = e(this),
                        i = t.prev(),
                        n = e("<span>").data("ui-menu-submenu-caret", !0);
                    o._addClass(n, "ui-menu-icon", "ui-icon " + a), i.attr("aria-haspopup", "true").prepend(n), t.attr("aria-labelledby", i.attr("id"))
                }), this._addClass(i, "ui-menu", "ui-widget ui-widget-content ui-front"), (t = s.add(this.element).find(this.options.items)).not(".ui-menu-item").each(function() {
                    var t = e(this);
                    o._isDivider(t) && o._addClass(t, "ui-menu-divider", "ui-widget-content")
                }), r = (n = t.not(".ui-menu-item, .ui-menu-divider")).children().not(".ui-menu").uniqueId().attr({
                    tabIndex: -1,
                    role: this._itemRole()
                }), this._addClass(n, "ui-menu-item")._addClass(r, "ui-menu-item-wrapper"), t.filter(".ui-state-disabled").attr("aria-disabled", "true"), this.active && !e.contains(this.element[0], this.active[0]) && this.blur()
            },
            _itemRole: function() {
                return {
                    menu: "menuitem",
                    listbox: "option"
                } [this.options.role]
            },
            _setOption: function(e, t) {
                if ("icons" === e) {
                    var i = this.element.find(".ui-menu-icon");
                    this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, t.submenu)
                }
                this._super(e, t)
            },
            _setOptionDisabled: function(e) {
                this._super(e), this.element.attr("aria-disabled", e + ""), this._toggleClass(null, "ui-state-disabled", !!e)
            },
            focus: function(e, t) {
                var i, n, r;
                this.blur(e, e && "focus" === e.type), this._scrollIntoView(t), this.active = t.first(), n = this.active.children(".ui-menu-item-wrapper"), this._addClass(n, null, "ui-state-active"), this.options.role && this.element.attr("aria-activedescendant", n.attr("id")), r = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"), this._addClass(r, null, "ui-state-active"), e && "keydown" === e.type ? this._close() : this.timer = this._delay(function() {
                    this._close()
                }, this.delay), (i = t.children(".ui-menu")).length && e && /^mouse/.test(e.type) && this._startOpening(i), this.activeMenu = t.parent(), this._trigger("focus", e, {
                    item: t
                })
            },
            _scrollIntoView: function(t) {
                var i, n, r, o, a, s;
                this._hasScroll() && (i = parseFloat(e.css(this.activeMenu[0], "borderTopWidth")) || 0, n = parseFloat(e.css(this.activeMenu[0], "paddingTop")) || 0, r = t.offset().top - this.activeMenu.offset().top - i - n, o = this.activeMenu.scrollTop(), a = this.activeMenu.height(), s = t.outerHeight(), 0 > r ? this.activeMenu.scrollTop(o + r) : r + s > a && this.activeMenu.scrollTop(o + r - a + s))
            },
            blur: function(e, t) {
                t || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active"), this._trigger("blur", e, {
                    item: this.active
                }), this.active = null)
            },
            _startOpening: function(e) {
                clearTimeout(this.timer), "true" === e.attr("aria-hidden") && (this.timer = this._delay(function() {
                    this._close(), this._open(e)
                }, this.delay))
            },
            _open: function(t) {
                var i = e.extend({
                    of: this.active
                }, this.options.position);
                clearTimeout(this.timer), this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden", "true"), t.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(i)
            },
            collapseAll: function(t, i) {
                clearTimeout(this.timer), this.timer = this._delay(function() {
                    var n = i ? this.element : e(t && t.target).closest(this.element.find(".ui-menu"));
                    n.length || (n = this.element), this._close(n), this.blur(t), this._removeClass(n.find(".ui-state-active"), null, "ui-state-active"), this.activeMenu = n
                }, this.delay)
            },
            _close: function(e) {
                e || (e = this.active ? this.active.parent() : this.element), e.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false")
            },
            _closeOnDocumentClick: function(t) {
                return !e(t.target).closest(".ui-menu").length
            },
            _isDivider: function(e) {
                return !/[^\-\u2014\u2013\s]/.test(e.text())
            },
            collapse: function(e) {
                var t = this.active && this.active.parent().closest(".ui-menu-item", this.element);
                t && t.length && (this._close(), this.focus(e, t))
            },
            expand: function(e) {
                var t = this.active && this.active.children(".ui-menu ").find(this.options.items).first();
                t && t.length && (this._open(t.parent()), this._delay(function() {
                    this.focus(e, t)
                }))
            },
            next: function(e) {
                this._move("next", "first", e)
            },
            previous: function(e) {
                this._move("prev", "last", e)
            },
            isFirstItem: function() {
                return this.active && !this.active.prevAll(".ui-menu-item").length
            },
            isLastItem: function() {
                return this.active && !this.active.nextAll(".ui-menu-item").length
            },
            _move: function(e, t, i) {
                var n;
                this.active && (n = "first" === e || "last" === e ? this.active["first" === e ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : this.active[e + "All"](".ui-menu-item").eq(0)), n && n.length && this.active || (n = this.activeMenu.find(this.options.items)[t]()), this.focus(i, n)
            },
            nextPage: function(t) {
                var i, n, r;
                return this.active ? void(this.isLastItem() || (this._hasScroll() ? (n = this.active.offset().top, r = this.element.height(), this.active.nextAll(".ui-menu-item").each(function() {
                    return 0 > (i = e(this)).offset().top - n - r
                }), this.focus(t, i)) : this.focus(t, this.activeMenu.find(this.options.items)[this.active ? "last" : "first"]()))) : void this.next(t)
            },
            previousPage: function(t) {
                var i, n, r;
                return this.active ? void(this.isFirstItem() || (this._hasScroll() ? (n = this.active.offset().top, r = this.element.height(), this.active.prevAll(".ui-menu-item").each(function() {
                    return (i = e(this)).offset().top - n + r > 0
                }), this.focus(t, i)) : this.focus(t, this.activeMenu.find(this.options.items).first()))) : void this.next(t)
            },
            _hasScroll: function() {
                return this.element.outerHeight() < this.element.prop("scrollHeight")
            },
            select: function(t) {
                this.active = this.active || e(t.target).closest(".ui-menu-item");
                var i = {
                    item: this.active
                };
                this.active.has(".ui-menu").length || this.collapseAll(t, !0), this._trigger("select", t, i)
            },
            _filterMenuItems: function(t) {
                var i = t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"),
                    n = RegExp("^" + i, "i");
                return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function() {
                    return n.test(e.trim(e(this).children(".ui-menu-item-wrapper").text()))
                })
            }
        }), e.widget("ui.autocomplete", {
            version: "1.12.1",
            defaultElement: "<input>",
            options: {
                appendTo: null,
                autoFocus: !1,
                delay: 300,
                minLength: 1,
                position: {
                    my: "left top",
                    at: "left bottom",
                    collision: "none"
                },
                source: null,
                change: null,
                close: null,
                focus: null,
                open: null,
                response: null,
                search: null,
                select: null
            },
            requestIndex: 0,
            pending: 0,
            _create: function() {
                var t, i, n, r = this.element[0].nodeName.toLowerCase(),
                    o = "textarea" === r,
                    a = "input" === r;
                this.isMultiLine = o || !a && this._isContentEditable(this.element), this.valueMethod = this.element[o || a ? "val" : "text"], this.isNewMenu = !0, this._addClass("ui-autocomplete-input"), this.element.attr("autocomplete", "off"), this._on(this.element, {
                    keydown: function(r) {
                        if (this.element.prop("readOnly")) return t = !0, n = !0, void(i = !0);
                        t = !1, n = !1, i = !1;
                        var o = e.ui.keyCode;
                        switch (r.keyCode) {
                            case o.PAGE_UP:
                                t = !0, this._move("previousPage", r);
                                break;
                            case o.PAGE_DOWN:
                                t = !0, this._move("nextPage", r);
                                break;
                            case o.UP:
                                t = !0, this._keyEvent("previous", r);
                                break;
                            case o.DOWN:
                                t = !0, this._keyEvent("next", r);
                                break;
                            case o.ENTER:
                                this.menu.active && (t = !0, r.preventDefault(), this.menu.select(r));
                                break;
                            case o.TAB:
                                this.menu.active && this.menu.select(r);
                                break;
                            case o.ESCAPE:
                                this.menu.element.is(":visible") && (this.isMultiLine || this._value(this.term), this.close(r), r.preventDefault());
                                break;
                            default:
                                i = !0, this._searchTimeout(r)
                        }
                    },
                    keypress: function(n) {
                        if (t) return t = !1, void((!this.isMultiLine || this.menu.element.is(":visible")) && n.preventDefault());
                        if (!i) {
                            var r = e.ui.keyCode;
                            switch (n.keyCode) {
                                case r.PAGE_UP:
                                    this._move("previousPage", n);
                                    break;
                                case r.PAGE_DOWN:
                                    this._move("nextPage", n);
                                    break;
                                case r.UP:
                                    this._keyEvent("previous", n);
                                    break;
                                case r.DOWN:
                                    this._keyEvent("next", n)
                            }
                        }
                    },
                    input: function(e) {
                        return n ? (n = !1, void e.preventDefault()) : void this._searchTimeout(e)
                    },
                    focus: function() {
                        this.selectedItem = null, this.previous = this._value()
                    },
                    blur: function(e) {
                        return this.cancelBlur ? void delete this.cancelBlur : (clearTimeout(this.searching), this.close(e), void this._change(e))
                    }
                }), this._initSource(), this.menu = e("<ul>").appendTo(this._appendTo()).menu({
                    role: null
                }).hide().menu("instance"), this._addClass(this.menu.element, "ui-autocomplete", "ui-front"), this._on(this.menu.element, {
                    mousedown: function(t) {
                        t.preventDefault(), this.cancelBlur = !0, this._delay(function() {
                            delete this.cancelBlur, this.element[0] !== e.ui.safeActiveElement(this.document[0]) && this.element.trigger("focus")
                        })
                    },
                    menufocus: function(t, i) {
                        var n, r;
                        return this.isNewMenu && (this.isNewMenu = !1, t.originalEvent && /^mouse/.test(t.originalEvent.type)) ? (this.menu.blur(), void this.document.one("mousemove", function() {
                            e(t.target).trigger(t.originalEvent)
                        })) : (r = i.item.data("ui-autocomplete-item"), !1 !== this._trigger("focus", t, {
                            item: r
                        }) && t.originalEvent && /^key/.test(t.originalEvent.type) && this._value(r.value), void((n = i.item.attr("aria-label") || r.value) && e.trim(n).length && (this.liveRegion.children().hide(), e("<div>").text(n).appendTo(this.liveRegion))))
                    },
                    menuselect: function(t, i) {
                        var n = i.item.data("ui-autocomplete-item"),
                            r = this.previous;
                        this.element[0] !== e.ui.safeActiveElement(this.document[0]) && (this.element.trigger("focus"), this.previous = r, this._delay(function() {
                            this.previous = r, this.selectedItem = n
                        })), !1 !== this._trigger("select", t, {
                            item: n
                        }) && this._value(n.value), this.term = this._value(), this.close(t), this.selectedItem = n
                    }
                }), this.liveRegion = e("<div>", {
                    role: "status",
                    "aria-live": "assertive",
                    "aria-relevant": "additions"
                }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this._on(this.window, {
                    beforeunload: function() {
                        this.element.removeAttr("autocomplete")
                    }
                })
            },
            _destroy: function() {
                clearTimeout(this.searching), this.element.removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove()
            },
            _setOption: function(e, t) {
                this._super(e, t), "source" === e && this._initSource(), "appendTo" === e && this.menu.element.appendTo(this._appendTo()), "disabled" === e && t && this.xhr && this.xhr.abort()
            },
            _isEventTargetInWidget: function(t) {
                var i = this.menu.element[0];
                return t.target === this.element[0] || t.target === i || e.contains(i, t.target)
            },
            _closeOnClickOutside: function(e) {
                this._isEventTargetInWidget(e) || this.close()
            },
            _appendTo: function() {
                var t = this.options.appendTo;
                return t && (t = t.jquery || t.nodeType ? e(t) : this.document.find(t).eq(0)), t && t[0] || (t = this.element.closest(".ui-front, dialog")), t.length || (t = this.document[0].body), t
            },
            _initSource: function() {
                var t, i, n = this;
                e.isArray(this.options.source) ? (t = this.options.source, this.source = function(i, n) {
                    n(e.ui.autocomplete.filter(t, i.term))
                }) : "string" == typeof this.options.source ? (i = this.options.source, this.source = function(t, r) {
                    n.xhr && n.xhr.abort(), n.xhr = e.ajax({
                        url: i,
                        data: t,
                        dataType: "json",
                        success: function(e) {
                            r(e)
                        },
                        error: function() {
                            r([])
                        }
                    })
                }) : this.source = this.options.source
            },
            _searchTimeout: function(e) {
                clearTimeout(this.searching), this.searching = this._delay(function() {
                    var t = this.term === this._value(),
                        i = this.menu.element.is(":visible"),
                        n = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
                    (!t || t && !i && !n) && (this.selectedItem = null, this.search(null, e))
                }, this.options.delay)
            },
            search: function(e, t) {
                return e = null != e ? e : this._value(), this.term = this._value(), e.length < this.options.minLength ? this.close(t) : !1 !== this._trigger("search", t) ? this._search(e) : void 0
            },
            _search: function(e) {
                this.pending++, this._addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({
                    term: e
                }, this._response())
            },
            _response: function() {
                var t = ++this.requestIndex;
                return e.proxy(function(e) {
                    t === this.requestIndex && this.__response(e), --this.pending || this._removeClass("ui-autocomplete-loading")
                }, this)
            },
            __response: function(e) {
                e && (e = this._normalize(e)), this._trigger("response", null, {
                    content: e
                }), !this.options.disabled && e && e.length && !this.cancelSearch ? (this._suggest(e), this._trigger("open")) : this._close()
            },
            close: function(e) {
                this.cancelSearch = !0, this._close(e)
            },
            _close: function(e) {
                this._off(this.document, "mousedown"), this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", e))
            },
            _change: function(e) {
                this.previous !== this._value() && this._trigger("change", e, {
                    item: this.selectedItem
                })
            },
            _normalize: function(t) {
                return t.length && t[0].label && t[0].value ? t : e.map(t, function(t) {
                    return "string" == typeof t ? {
                        label: t,
                        value: t
                    } : e.extend({}, t, {
                        label: t.label || t.value,
                        value: t.value || t.label
                    })
                })
            },
            _suggest: function(t) {
                var i = this.menu.element.empty();
                this._renderMenu(i, t), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(e.extend({
                    of: this.element
                }, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, {
                    mousedown: "_closeOnClickOutside"
                })
            },
            _resizeMenu: function() {
                var e = this.menu.element;
                e.outerWidth(Math.max(e.width("").outerWidth() + 1, this.element.outerWidth()))
            },
            _renderMenu: function(t, i) {
                var n = this;
                e.each(i, function(e, i) {
                    n._renderItemData(t, i)
                })
            },
            _renderItemData: function(e, t) {
                return this._renderItem(e, t).data("ui-autocomplete-item", t)
            },
            _renderItem: function(t, i) {
                return e("<li>").append(e("<div>").text(i.label)).appendTo(t)
            },
            _move: function(e, t) {
                return this.menu.element.is(":visible") ? this.menu.isFirstItem() && /^previous/.test(e) || this.menu.isLastItem() && /^next/.test(e) ? (this.isMultiLine || this._value(this.term), void this.menu.blur()) : void this.menu[e](t) : void this.search(null, t)
            },
            widget: function() {
                return this.menu.element
            },
            _value: function() {
                return this.valueMethod.apply(this.element, arguments)
            },
            _keyEvent: function(e, t) {
                (!this.isMultiLine || this.menu.element.is(":visible")) && (this._move(e, t), t.preventDefault())
            },
            _isContentEditable: function(e) {
                if (!e.length) return !1;
                var t = e.prop("contentEditable");
                return "inherit" === t ? this._isContentEditable(e.parent()) : "true" === t
            }
        }), e.extend(e.ui.autocomplete, {
            escapeRegex: function(e) {
                return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
            },
            filter: function(t, i) {
                var n = RegExp(e.ui.autocomplete.escapeRegex(i), "i");
                return e.grep(t, function(e) {
                    return n.test(e.label || e.value || e)
                })
            }
        }), e.widget("ui.autocomplete", e.ui.autocomplete, {
            options: {
                messages: {
                    noResults: "No search results.",
                    results: function(e) {
                        return e + (e > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate."
                    }
                }
            },
            __response: function(t) {
                var i;
                this._superApply(arguments), this.options.disabled || this.cancelSearch || (i = t && t.length ? this.options.messages.results(t.length) : this.options.messages.noResults, this.liveRegion.children().hide(), e("<div>").text(i).appendTo(this.liveRegion))
            }
        }), e.ui.autocomplete
}), void 0 === History.Adapter && ("object" != typeof JSON && (JSON = {}), function() {
        "use strict";

        function f(e) {
            return e < 10 ? "0" + e : e
        }

        function quote(e) {
            return escapable.lastIndex = 0, escapable.test(e) ? '"' + e.replace(escapable, function(e) {
                var t = meta[e];
                return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
            }) + '"' : '"' + e + '"'
        }

        function str(e, t) {
            var i, n, r, o, a, s = gap,
                l = t[e];
            switch (l && "object" == typeof l && "function" == typeof l.toJSON && (l = l.toJSON(e)), "function" == typeof rep && (l = rep.call(t, e, l)), typeof l) {
                case "string":
                    return quote(l);
                case "number":
                    return isFinite(l) ? String(l) : "null";
                case "boolean":
                case "null":
                    return String(l);
                case "object":
                    if (!l) return "null";
                    if (gap += indent, a = [], "[object Array]" === Object.prototype.toString.apply(l)) {
                        for (o = l.length, i = 0; i < o; i += 1) a[i] = str(i, l) || "null";
                        return r = 0 === a.length ? "[]" : gap ? "[\n" + gap + a.join(",\n" + gap) + "\n" + s + "]" : "[" + a.join(",") + "]", gap = s, r
                    }
                    if (rep && "object" == typeof rep)
                        for (o = rep.length, i = 0; i < o; i += 1) "string" == typeof rep[i] && ((r = str(n = rep[i], l)) && a.push(quote(n) + (gap ? ": " : ":") + r));
                    else
                        for (n in l) Object.prototype.hasOwnProperty.call(l, n) && (r = str(n, l)) && a.push(quote(n) + (gap ? ": " : ":") + r);
                    return r = 0 === a.length ? "{}" : gap ? "{\n" + gap + a.join(",\n" + gap) + "\n" + s + "}" : "{" + a.join(",") + "}", gap = s, r
            }
        }
        "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function(e) {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null
        }, String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function(e) {
            return this.valueOf()
        });
        var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            gap, indent, meta = {
                "\b": "\\b",
                "\t": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            },
            rep;
        "function" != typeof JSON.stringify && (JSON.stringify = function(e, t, i) {
            var n;
            if (gap = "", indent = "", "number" == typeof i)
                for (n = 0; n < i; n += 1) indent += " ";
            else "string" == typeof i && (indent = i);
            if (rep = t, !t || "function" == typeof t || "object" == typeof t && "number" == typeof t.length) return str("", {
                "": e
            });
            throw new Error("JSON.stringify")
        }), "function" != typeof JSON.parse && (JSON.parse = function(text, reviver) {
            function walk(e, t) {
                var i, n, r = e[t];
                if (r && "object" == typeof r)
                    for (i in r) Object.prototype.hasOwnProperty.call(r, i) && (void 0 !== (n = walk(r, i)) ? r[i] = n : delete r[i]);
                return reviver.call(e, t, r)
            }
            var j;
            if (text = String(text), cx.lastIndex = 0, cx.test(text) && (text = text.replace(cx, function(e) {
                    return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
                })), /^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) return j = eval("(" + text + ")"), "function" == typeof reviver ? walk({
                "": j
            }, "") : j;
            throw new SyntaxError("JSON.parse")
        })
    }(), function(e, t) {
        "use strict";
        var i = e.History = e.History || {},
            n = e.jQuery;
        if (void 0 !== i.Adapter) throw new Error("History.js Adapter has already been loaded...");
        i.Adapter = {
            bind: function(e, t, i) {
                n(e).bind(t, i)
            },
            trigger: function(e, t, i) {
                n(e).trigger(t, i)
            },
            extractEventData: function(e, t, i) {
                return t && t.originalEvent && t.originalEvent[e] || i && i[e] || void 0
            },
            onDomLoad: function(e) {
                n(e)
            }
        }, void 0 !== i.init && i.init()
    }(window), function(e, t) {
        "use strict";
        var i = e.document,
            n = e.setTimeout || n,
            r = e.clearTimeout || r,
            o = e.setInterval || o,
            a = e.History = e.History || {};
        if (void 0 !== a.initHtml4) throw new Error("History.js HTML4 Support has already been loaded...");
        a.initHtml4 = function() {
            if (void 0 !== a.initHtml4.initialized) return !1;
            a.initHtml4.initialized = !0, a.enabled = !0, a.savedHashes = [], a.isLastHash = function(e) {
                return e === a.getHashByIndex()
            }, a.isHashEqual = function(e, t) {
                return (e = encodeURIComponent(e).replace(/%25/g, "%")) === (t = encodeURIComponent(t).replace(/%25/g, "%"))
            }, a.saveHash = function(e) {
                return !a.isLastHash(e) && (a.savedHashes.push(e), !0)
            }, a.getHashByIndex = function(e) {
                return void 0 === e ? a.savedHashes[a.savedHashes.length - 1] : e < 0 ? a.savedHashes[a.savedHashes.length + e] : a.savedHashes[e]
            }, a.discardedHashes = {}, a.discardedStates = {}, a.discardState = function(e, t, i) {
                var n, r = a.getHashByState(e);
                return n = {
                    discardedState: e,
                    backState: i,
                    forwardState: t
                }, a.discardedStates[r] = n, !0
            }, a.discardHash = function(e, t, i) {
                var n = {
                    discardedHash: e,
                    backState: i,
                    forwardState: t
                };
                return a.discardedHashes[e] = n, !0
            }, a.discardedState = function(e) {
                var t = a.getHashByState(e);
                return a.discardedStates[t] || !1
            }, a.discardedHash = function(e) {
                return a.discardedHashes[e] || !1
            }, a.recycleState = function(e) {
                var t = a.getHashByState(e);
                return a.discardedState(e) && delete a.discardedStates[t], !0
            }, a.emulated.hashChange && (a.hashChangeInit = function() {
                a.checkerFunction = null;
                var t, n, r, s = "",
                    l = Boolean(a.getHash());
                return a.isInternetExplorer() ? ("historyjs-iframe", (t = i.createElement("iframe")).setAttribute("id", "historyjs-iframe"), t.setAttribute("src", "#"), t.style.display = "none", i.body.appendChild(t), t.contentWindow.document.open(), t.contentWindow.document.close(), n = "", r = !1, a.checkerFunction = function() {
                    if (r) return !1;
                    r = !0;
                    var i = a.getHash(),
                        o = a.getHash(t.contentWindow.document);
                    return i !== s ? (s = i, o !== i && (n = o = i, t.contentWindow.document.open(), t.contentWindow.document.close(), t.contentWindow.document.location.hash = a.escapeHash(i)), a.Adapter.trigger(e, "hashchange")) : o !== n && (n = o, l && "" === o ? a.back() : a.setHash(o, !1)), r = !1, !0
                }) : a.checkerFunction = function() {
                    var t = a.getHash() || "";
                    return t !== s && (s = t, a.Adapter.trigger(e, "hashchange")), !0
                }, a.intervalList.push(o(a.checkerFunction, a.options.hashChangeInterval)), !0
            }, a.Adapter.onDomLoad(a.hashChangeInit)), a.emulated.pushState && (a.onHashChange = function(t) {
                var i, n = t && t.newURL || a.getLocationHref(),
                    r = a.getHashByUrl(n),
                    o = null;
                return a.isLastHash(r) ? (a.busy(!1), !1) : (a.doubleCheckComplete(), a.saveHash(r), r && a.isTraditionalAnchor(r) ? (a.Adapter.trigger(e, "anchorchange"), a.busy(!1), !1) : (o = a.extractState(a.getFullUrl(r || a.getLocationHref()), !0), a.isLastSavedState(o) ? (a.busy(!1), !1) : (a.getHashByState(o), (i = a.discardedState(o)) ? (a.getHashByIndex(-2) === a.getHashByState(i.forwardState) ? a.back(!1) : a.forward(!1), !1) : (a.pushState(o.data, o.title, encodeURI(o.url), !1), !0))))
            }, a.Adapter.bind(e, "hashchange", a.onHashChange), a.pushState = function(t, i, n, r) {
                if (n = encodeURI(n).replace(/%25/g, "%"), a.getHashByUrl(n)) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
                if (!1 !== r && a.busy()) return a.pushQueue({
                    scope: a,
                    callback: a.pushState,
                    args: arguments,
                    queue: r
                }), !1;
                a.busy(!0);
                var o = a.createStateObject(t, i, n),
                    s = a.getHashByState(o),
                    l = a.getState(!1),
                    c = a.getHashByState(l),
                    u = a.getHash(),
                    p = a.expectedStateId == o.id;
                return a.storeState(o), a.expectedStateId = o.id, a.recycleState(o), a.setTitle(o), s === c ? (a.busy(!1), !1) : (a.saveState(o), p || a.Adapter.trigger(e, "statechange"), !a.isHashEqual(s, u) && !a.isHashEqual(s, a.getShortUrl(a.getLocationHref())) && a.setHash(s, !1), a.busy(!1), !0)
            }, a.replaceState = function(t, i, n, r) {
                if (n = encodeURI(n).replace(/%25/g, "%"), a.getHashByUrl(n)) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
                if (!1 !== r && a.busy()) return a.pushQueue({
                    scope: a,
                    callback: a.replaceState,
                    args: arguments,
                    queue: r
                }), !1;
                a.busy(!0);
                var o = a.createStateObject(t, i, n),
                    s = a.getHashByState(o),
                    l = a.getState(!1),
                    c = a.getHashByState(l),
                    u = a.getStateByIndex(-2);
                return a.discardState(l, o, u), s === c ? (a.storeState(o), a.expectedStateId = o.id, a.recycleState(o), a.setTitle(o), a.saveState(o), a.Adapter.trigger(e, "statechange"), a.busy(!1)) : a.pushState(o.data, o.title, o.url, !1), !0
            }), a.emulated.pushState && a.getHash() && !a.emulated.hashChange && a.Adapter.onDomLoad(function() {
                a.Adapter.trigger(e, "hashchange")
            })
        }, void 0 !== a.init && a.init()
    }(window), function(e, t) {
        "use strict";
        var i = e.console || t,
            n = e.document,
            r = e.navigator,
            o = !1,
            a = e.setTimeout,
            s = e.clearTimeout,
            l = e.setInterval,
            c = e.clearInterval,
            u = e.JSON,
            p = e.alert,
            d = e.History = e.History || {},
            f = e.history;
        try {
            (o = e.sessionStorage).setItem("TEST", "1"), o.removeItem("TEST")
        } catch (e) {
            o = !1
        }
        if (u.stringify = u.stringify || u.encode, u.parse = u.parse || u.decode, void 0 !== d.init) throw new Error("History.js Core has already been loaded...");
        d.init = function(e) {
            return void 0 !== d.Adapter && (void 0 !== d.initCore && d.initCore(), void 0 !== d.initHtml4 && d.initHtml4(), !0)
        }, d.initCore = function(h) {
            if (void 0 !== d.initCore.initialized) return !1;
            if (d.initCore.initialized = !0, d.options = d.options || {}, d.options.hashChangeInterval = d.options.hashChangeInterval || 100, d.options.safariPollInterval = d.options.safariPollInterval || 500, d.options.doubleCheckInterval = d.options.doubleCheckInterval || 500, d.options.disableSuid = d.options.disableSuid || !1, d.options.storeInterval = d.options.storeInterval || 1e3, d.options.busyDelay = d.options.busyDelay || 250, d.options.debug = d.options.debug || !1, d.options.initialTitle = d.options.initialTitle || n.title, d.options.html4Mode = d.options.html4Mode || !1, d.options.delayInit = d.options.delayInit || !1, d.intervalList = [], d.clearAllIntervals = function() {
                    var e, t = d.intervalList;
                    if (null != t) {
                        for (e = 0; e < t.length; e++) c(t[e]);
                        d.intervalList = null
                    }
                }, d.debug = function() {
                    d.options.debug && d.log.apply(d, arguments)
                }, d.log = function() {
                    var e, t, r, o, a, s = void 0 !== i && void 0 !== i.log && void 0 !== i.log.apply,
                        l = n.getElementById("log");
                    for (s ? (e = (o = Array.prototype.slice.call(arguments)).shift(), void 0 !== i.debug ? i.debug.apply(i, [e, o]) : i.log.apply(i, [e, o])) : e = "\n" + arguments[0] + "\n", t = 1, r = arguments.length; t < r; ++t) {
                        if ("object" == typeof(a = arguments[t]) && void 0 !== u) try {
                            a = u.stringify(a)
                        } catch (e) {}
                        e += "\n" + a + "\n"
                    }
                    return l ? (l.value += e + "\n-----\n", l.scrollTop = l.scrollHeight - l.clientHeight) : s || p(e), !0
                }, d.getInternetExplorerMajorVersion = function() {
                    return d.getInternetExplorerMajorVersion.cached = void 0 !== d.getInternetExplorerMajorVersion.cached ? d.getInternetExplorerMajorVersion.cached : function() {
                        for (var e = 3, t = n.createElement("div"), i = t.getElementsByTagName("i");
                            (t.innerHTML = "\x3c!--[if gt IE " + ++e + "]><i></i><![endif]--\x3e") && i[0];);
                        return e > 4 && e
                    }()
                }, d.isInternetExplorer = function() {
                    return d.isInternetExplorer.cached = void 0 !== d.isInternetExplorer.cached ? d.isInternetExplorer.cached : Boolean(d.getInternetExplorerMajorVersion())
                }, d.options.html4Mode ? d.emulated = {
                    pushState: !0,
                    hashChange: !0
                } : d.emulated = {
                    pushState: !Boolean(e.history && e.history.pushState && e.history.replaceState && !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(r.userAgent) && !/AppleWebKit\/5([0-2]|3[0-2])/i.test(r.userAgent)),
                    hashChange: Boolean(!("onhashchange" in e || "onhashchange" in n) || d.isInternetExplorer() && d.getInternetExplorerMajorVersion() < 8)
                }, d.enabled = !d.emulated.pushState, d.bugs = {
                    setHash: Boolean(!d.emulated.pushState && "Apple Computer, Inc." === r.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(r.userAgent)),
                    safariPoll: Boolean(!d.emulated.pushState && "Apple Computer, Inc." === r.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(r.userAgent)),
                    ieDoubleCheck: Boolean(d.isInternetExplorer() && d.getInternetExplorerMajorVersion() < 8),
                    hashEscape: Boolean(d.isInternetExplorer() && d.getInternetExplorerMajorVersion() < 7)
                }, d.isEmptyObject = function(e) {
                    for (var t in e)
                        if (e.hasOwnProperty(t)) return !1;
                    return !0
                }, d.cloneObject = function(e) {
                    var t, i;
                    return e ? (t = u.stringify(e), i = u.parse(t)) : i = {}, i
                }, d.getRootUrl = function() {
                    var e = n.location.protocol + "//" + (n.location.hostname || n.location.host);
                    return n.location.port && (e += ":" + n.location.port), e + "/"
                }, d.getBaseHref = function() {
                    var e = n.getElementsByTagName("base"),
                        t = "";
                    return 1 === e.length && (t = e[0].href.replace(/[^\/]+$/, "")), (t = t.replace(/\/+$/, "")) && (t += "/"), t
                }, d.getBaseUrl = function() {
                    return d.getBaseHref() || d.getBasePageUrl() || d.getRootUrl()
                }, d.getPageUrl = function() {
                    return ((d.getState(!1, !1) || {}).url || d.getLocationHref()).replace(/\/+$/, "").replace(/[^\/]+$/, function(e, t, i) {
                        return /\./.test(e) ? e : e + "/"
                    })
                }, d.getBasePageUrl = function() {
                    return d.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, function(e, t, i) {
                        return /[^\/]$/.test(e) ? "" : e
                    }).replace(/\/+$/, "") + "/"
                }, d.getFullUrl = function(e, t) {
                    var i = e,
                        n = e.substring(0, 1);
                    return t = void 0 === t || t, /[a-z]+\:\/\//.test(e) || (i = "/" === n ? d.getRootUrl() + e.replace(/^\/+/, "") : "#" === n ? d.getPageUrl().replace(/#.*/, "") + e : "?" === n ? d.getPageUrl().replace(/[\?#].*/, "") + e : t ? d.getBaseUrl() + e.replace(/^(\.\/)+/, "") : d.getBasePageUrl() + e.replace(/^(\.\/)+/, "")), i.replace(/\#$/, "")
                }, d.getShortUrl = function(e) {
                    var t = e,
                        i = d.getBaseUrl(),
                        n = d.getRootUrl();
                    return d.emulated.pushState && (t = t.replace(i, "")), t = t.replace(n, "/"), d.isTraditionalAnchor(t) && (t = "./" + t), t.replace(/^(\.\/)+/g, "./").replace(/\#$/, "")
                }, d.getLocationHref = function(e) {
                    return (e = e || n).URL === e.location.href ? e.location.href : e.location.href === decodeURIComponent(e.URL) ? e.URL : e.location.hash && decodeURIComponent(e.location.href.replace(/^[^#]+/, "")) === e.location.hash ? e.location.href : -1 == e.URL.indexOf("#") && -1 != e.location.href.indexOf("#") ? e.location.href : e.URL || e.location.href
                }, d.store = {}, d.idToState = d.idToState || {}, d.stateToId = d.stateToId || {}, d.urlToId = d.urlToId || {}, d.storedStates = d.storedStates || [], d.savedStates = d.savedStates || [], d.normalizeStore = function() {
                    d.store.idToState = d.store.idToState || {}, d.store.urlToId = d.store.urlToId || {}, d.store.stateToId = d.store.stateToId || {}
                }, d.getState = function(e, t) {
                    void 0 === e && (e = !0), void 0 === t && (t = !0);
                    var i = d.getLastSavedState();
                    return !i && t && (i = d.createStateObject()), e && ((i = d.cloneObject(i)).url = i.cleanUrl || i.url), i
                }, d.getIdByState = function(e) {
                    var t, i = d.extractId(e.url);
                    if (!i)
                        if (t = d.getStateString(e), void 0 !== d.stateToId[t]) i = d.stateToId[t];
                        else if (void 0 !== d.store.stateToId[t]) i = d.store.stateToId[t];
                    else {
                        for (; i = (new Date).getTime() + String(Math.random()).replace(/\D/g, ""), void 0 !== d.idToState[i] || void 0 !== d.store.idToState[i];);
                        d.stateToId[t] = i, d.idToState[i] = e
                    }
                    return i
                }, d.normalizeState = function(e) {
                    var t, i;
                    return e && "object" == typeof e || (e = {}), void 0 !== e.normalized ? e : (e.data && "object" == typeof e.data || (e.data = {}), (t = {}).normalized = !0, t.title = e.title || "", t.url = d.getFullUrl(e.url ? e.url : d.getLocationHref()), t.hash = d.getShortUrl(t.url), t.data = d.cloneObject(e.data), t.id = d.getIdByState(t), t.cleanUrl = t.url.replace(/\??\&_suid.*/, ""), t.url = t.cleanUrl, i = !d.isEmptyObject(t.data), (t.title || i) && !0 !== d.options.disableSuid && (t.hash = d.getShortUrl(t.url).replace(/\??\&_suid.*/, ""), /\?/.test(t.hash) || (t.hash += "?"), t.hash += "&_suid=" + t.id), t.hashedUrl = d.getFullUrl(t.hash), (d.emulated.pushState || d.bugs.safariPoll) && d.hasUrlDuplicate(t) && (t.url = t.hashedUrl), t)
                }, d.createStateObject = function(e, t, i) {
                    var n = {
                        data: e,
                        title: t,
                        url: i
                    };
                    return d.normalizeState(n)
                }, d.getStateById = function(e) {
                    return e = String(e), d.idToState[e] || d.store.idToState[e] || t
                }, d.getStateString = function(e) {
                    var t;
                    return t = {
                        data: d.normalizeState(e).data,
                        title: e.title,
                        url: e.url
                    }, u.stringify(t)
                }, d.getStateId = function(e) {
                    return d.normalizeState(e).id
                }, d.getHashByState = function(e) {
                    return d.normalizeState(e).hash
                }, d.extractId = function(e) {
                    var t, i;
                    return i = -1 != e.indexOf("#") ? e.split("#")[0] : e, (t = /(.*)\&_suid=([0-9]+)$/.exec(i)) && t[1], (t ? String(t[2] || "") : "") || !1
                }, d.isTraditionalAnchor = function(e) {
                    return !/[\/\?\.]/.test(e)
                }, d.extractState = function(e, t) {
                    var i, n, r = null;
                    return t = t || !1, (i = d.extractId(e)) && (r = d.getStateById(i)), r || (n = d.getFullUrl(e), (i = d.getIdByUrl(n) || !1) && (r = d.getStateById(i)), !r && t && !d.isTraditionalAnchor(e) && (r = d.createStateObject(null, null, n))), r
                }, d.getIdByUrl = function(e) {
                    return d.urlToId[e] || d.store.urlToId[e] || t
                }, d.getLastSavedState = function() {
                    return d.savedStates[d.savedStates.length - 1] || t
                }, d.getLastStoredState = function() {
                    return d.storedStates[d.storedStates.length - 1] || t
                }, d.hasUrlDuplicate = function(e) {
                    var t;
                    return (t = d.extractState(e.url)) && t.id !== e.id
                }, d.storeState = function(e) {
                    return d.urlToId[e.url] = e.id, d.storedStates.push(d.cloneObject(e)), e
                }, d.isLastSavedState = function(e) {
                    var t = !1;
                    return d.savedStates.length && (t = e.id === d.getLastSavedState().id), t
                }, d.saveState = function(e) {
                    return !d.isLastSavedState(e) && (d.savedStates.push(d.cloneObject(e)), !0)
                }, d.getStateByIndex = function(e) {
                    return void 0 === e ? d.savedStates[d.savedStates.length - 1] : e < 0 ? d.savedStates[d.savedStates.length + e] : d.savedStates[e]
                }, d.getCurrentIndex = function() {
                    return d.savedStates.length < 1 ? 0 : d.savedStates.length - 1
                }, d.getHash = function(e) {
                    var t = d.getLocationHref(e);
                    return d.getHashByUrl(t)
                }, d.unescapeHash = function(e) {
                    var t = d.normalizeHash(e);
                    return decodeURIComponent(t)
                }, d.normalizeHash = function(e) {
                    return e.replace(/[^#]*#/, "").replace(/#.*/, "")
                }, d.setHash = function(e, t) {
                    var i, r;
                    return !1 !== t && d.busy() ? (d.pushQueue({
                        scope: d,
                        callback: d.setHash,
                        args: arguments,
                        queue: t
                    }), !1) : (d.busy(!0), (i = d.extractState(e, !0)) && !d.emulated.pushState ? d.pushState(i.data, i.title, i.url, !1) : d.getHash() !== e && (d.bugs.setHash ? (r = d.getPageUrl(), d.pushState(null, null, r + "#" + e, !1)) : n.location.hash = e), d)
                }, d.escapeHash = function(t) {
                    var i = d.normalizeHash(t);
                    return i = e.encodeURIComponent(i), d.bugs.hashEscape || (i = i.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")), i
                }, d.getHashByUrl = function(e) {
                    var t = String(e).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
                    return d.unescapeHash(t)
                }, d.setTitle = function(e) {
                    var t, i = e.title;
                    i || (t = d.getStateByIndex(0)) && t.url === e.url && (i = t.title || d.options.initialTitle);
                    try {
                        n.getElementsByTagName("title")[0].innerHTML = i.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ")
                    } catch (e) {}
                    return n.title = i, d
                }, d.queues = [], d.busy = function(e) {
                    if (void 0 !== e ? d.busy.flag = e : void 0 === d.busy.flag && (d.busy.flag = !1), !d.busy.flag) {
                        s(d.busy.timeout);
                        var t = function() {
                            var e, i, n;
                            if (!d.busy.flag)
                                for (e = d.queues.length - 1; e >= 0; --e) 0 !== (i = d.queues[e]).length && (n = i.shift(), d.fireQueueItem(n), d.busy.timeout = a(t, d.options.busyDelay))
                        };
                        d.busy.timeout = a(t, d.options.busyDelay)
                    }
                    return d.busy.flag
                }, d.busy.flag = !1, d.fireQueueItem = function(e) {
                    return e.callback.apply(e.scope || d, e.args || [])
                }, d.pushQueue = function(e) {
                    return d.queues[e.queue || 0] = d.queues[e.queue || 0] || [], d.queues[e.queue || 0].push(e), d
                }, d.queue = function(e, t) {
                    return "function" == typeof e && (e = {
                        callback: e
                    }), void 0 !== t && (e.queue = t), d.busy() ? d.pushQueue(e) : d.fireQueueItem(e), d
                }, d.clearQueue = function() {
                    return d.busy.flag = !1, d.queues = [], d
                }, d.stateChanged = !1, d.doubleChecker = !1, d.doubleCheckComplete = function() {
                    return d.stateChanged = !0, d.doubleCheckClear(), d
                }, d.doubleCheckClear = function() {
                    return d.doubleChecker && (s(d.doubleChecker), d.doubleChecker = !1), d
                }, d.doubleCheck = function(e) {
                    return d.stateChanged = !1, d.doubleCheckClear(), d.bugs.ieDoubleCheck && (d.doubleChecker = a(function() {
                        return d.doubleCheckClear(), d.stateChanged || e(), !0
                    }, d.options.doubleCheckInterval)), d
                }, d.safariStatePoll = function() {
                    var t = d.extractState(d.getLocationHref());
                    if (!d.isLastSavedState(t)) return t || d.createStateObject(), d.Adapter.trigger(e, "popstate"), d
                }, d.back = function(e) {
                    return !1 !== e && d.busy() ? (d.pushQueue({
                        scope: d,
                        callback: d.back,
                        args: arguments,
                        queue: e
                    }), !1) : (d.busy(!0), d.doubleCheck(function() {
                        d.back(!1)
                    }), f.go(-1), !0)
                }, d.forward = function(e) {
                    return !1 !== e && d.busy() ? (d.pushQueue({
                        scope: d,
                        callback: d.forward,
                        args: arguments,
                        queue: e
                    }), !1) : (d.busy(!0), d.doubleCheck(function() {
                        d.forward(!1)
                    }), f.go(1), !0)
                }, d.go = function(e, t) {
                    var i;
                    if (e > 0)
                        for (i = 1; i <= e; ++i) d.forward(t);
                    else {
                        if (!(e < 0)) throw new Error("History.go: History.go requires a positive or negative integer passed.");
                        for (i = -1; i >= e; --i) d.back(t)
                    }
                    return d
                }, d.emulated.pushState) {
                var g = function() {};
                d.pushState = d.pushState || g, d.replaceState = d.replaceState || g
            } else d.onPopState = function(t, i) {
                var n, r, o = !1,
                    a = !1;
                return d.doubleCheckComplete(), (n = d.getHash()) ? ((r = d.extractState(n || d.getLocationHref(), !0)) ? d.replaceState(r.data, r.title, r.url, !1) : (d.Adapter.trigger(e, "anchorchange"), d.busy(!1)), d.expectedStateId = !1, !1) : ((a = (o = d.Adapter.extractEventData("state", t, i) || !1) ? d.getStateById(o) : d.expectedStateId ? d.getStateById(d.expectedStateId) : d.extractState(d.getLocationHref())) || (a = d.createStateObject(null, null, d.getLocationHref())), d.expectedStateId = !1, d.isLastSavedState(a) ? (d.busy(!1), !1) : (d.storeState(a), d.saveState(a), d.setTitle(a), d.Adapter.trigger(e, "statechange"), d.busy(!1), !0))
            }, d.Adapter.bind(e, "popstate", d.onPopState), d.pushState = function(t, i, n, r) {
                if (d.getHashByUrl(n) && d.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                if (!1 !== r && d.busy()) return d.pushQueue({
                    scope: d,
                    callback: d.pushState,
                    args: arguments,
                    queue: r
                }), !1;
                d.busy(!0);
                var o = d.createStateObject(t, i, n);
                return d.isLastSavedState(o) ? d.busy(!1) : (d.storeState(o), d.expectedStateId = o.id, f.pushState(o.id, o.title, o.url), d.Adapter.trigger(e, "popstate")), !0
            }, d.replaceState = function(t, i, n, r) {
                if (d.getHashByUrl(n) && d.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                if (!1 !== r && d.busy()) return d.pushQueue({
                    scope: d,
                    callback: d.replaceState,
                    args: arguments,
                    queue: r
                }), !1;
                d.busy(!0);
                var o = d.createStateObject(t, i, n);
                return d.isLastSavedState(o) ? d.busy(!1) : (d.storeState(o), d.expectedStateId = o.id, f.replaceState(o.id, o.title, o.url), d.Adapter.trigger(e, "popstate")), !0
            };
            if (o) {
                try {
                    d.store = u.parse(o.getItem("History.store")) || {}
                } catch (e) {
                    d.store = {}
                }
                d.normalizeStore()
            } else d.store = {}, d.normalizeStore();
            d.Adapter.bind(e, "unload", d.clearAllIntervals), d.saveState(d.storeState(d.extractState(d.getLocationHref(), !0))), o && (d.onUnload = function() {
                var e, t, i;
                try {
                    e = u.parse(o.getItem("History.store")) || {}
                } catch (t) {
                    e = {}
                }
                for (t in e.idToState = e.idToState || {}, e.urlToId = e.urlToId || {}, e.stateToId = e.stateToId || {}, d.idToState) d.idToState.hasOwnProperty(t) && (e.idToState[t] = d.idToState[t]);
                for (t in d.urlToId) d.urlToId.hasOwnProperty(t) && (e.urlToId[t] = d.urlToId[t]);
                for (t in d.stateToId) d.stateToId.hasOwnProperty(t) && (e.stateToId[t] = d.stateToId[t]);
                d.store = e, d.normalizeStore(), i = u.stringify(e);
                try {
                    o.setItem("History.store", i)
                } catch (e) {
                    if (e.code !== DOMException.QUOTA_EXCEEDED_ERR) throw e;
                    o.length && (o.removeItem("History.store"), o.setItem("History.store", i))
                }
            }, d.intervalList.push(l(d.onUnload, d.options.storeInterval)), d.Adapter.bind(e, "beforeunload", d.onUnload), d.Adapter.bind(e, "unload", d.onUnload)), d.emulated.pushState || (d.bugs.safariPoll && d.intervalList.push(l(d.safariStatePoll, d.options.safariPollInterval)), "Apple Computer, Inc." !== r.vendor && "Mozilla" !== (r.appCodeName || "") || (d.Adapter.bind(e, "hashchange", function() {
                d.Adapter.trigger(e, "popstate")
            }), d.getHash() && d.Adapter.onDomLoad(function() {
                d.Adapter.trigger(e, "hashchange")
            })))
        }, (!d.options || !d.options.delayInit) && d.init()
    }(window)),
    function(e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? module.exports = e : e(jQuery)
    }(function(e) {
        function t(t) {
            var a = t || window.event,
                s = l.call(arguments, 1),
                c = 0,
                p = 0,
                d = 0,
                f = 0,
                h = 0,
                g = 0;
            if ((t = e.event.fix(a)).type = "mousewheel", "detail" in a && (d = -1 * a.detail), "wheelDelta" in a && (d = a.wheelDelta), "wheelDeltaY" in a && (d = a.wheelDeltaY), "wheelDeltaX" in a && (p = -1 * a.wheelDeltaX), "axis" in a && a.axis === a.HORIZONTAL_AXIS && (p = -1 * d, d = 0), c = 0 === d ? p : d, "deltaY" in a && (c = d = -1 * a.deltaY), "deltaX" in a && (p = a.deltaX, 0 === d && (c = -1 * p)), 0 !== d || 0 !== p) {
                if (1 === a.deltaMode) {
                    var m = e.data(this, "mousewheel-line-height");
                    c *= m, d *= m, p *= m
                } else if (2 === a.deltaMode) {
                    var v = e.data(this, "mousewheel-page-height");
                    c *= v, d *= v, p *= v
                }
                if (f = Math.max(Math.abs(d), Math.abs(p)), (!o || f < o) && (o = f, n(a, f) && (o /= 40)), n(a, f) && (c /= 40, p /= 40, d /= 40), c = Math[c >= 1 ? "floor" : "ceil"](c / o), p = Math[p >= 1 ? "floor" : "ceil"](p / o), d = Math[d >= 1 ? "floor" : "ceil"](d / o), u.settings.normalizeOffset && this.getBoundingClientRect) {
                    var b = this.getBoundingClientRect();
                    h = t.clientX - b.left, g = t.clientY - b.top
                }
                return t.deltaX = p, t.deltaY = d, t.deltaFactor = o, t.offsetX = h, t.offsetY = g, t.deltaMode = 0, s.unshift(t, c, p, d), r && clearTimeout(r), r = setTimeout(i, 200), (e.event.dispatch || e.event.handle).apply(this, s)
            }
        }

        function i() {
            o = null
        }

        function n(e, t) {
            return u.settings.adjustOldDeltas && "mousewheel" === e.type && t % 120 == 0
        }
        var r, o, a = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
            s = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
            l = Array.prototype.slice;
        if (e.event.fixHooks)
            for (var c = a.length; c;) e.event.fixHooks[a[--c]] = e.event.mouseHooks;
        var u = e.event.special.mousewheel = {
            version: "3.1.12",
            setup: function() {
                if (this.addEventListener)
                    for (var i = s.length; i;) this.addEventListener(s[--i], t, !1);
                else this.onmousewheel = t;
                e.data(this, "mousewheel-line-height", u.getLineHeight(this)), e.data(this, "mousewheel-page-height", u.getPageHeight(this))
            },
            teardown: function() {
                if (this.removeEventListener)
                    for (var i = s.length; i;) this.removeEventListener(s[--i], t, !1);
                else this.onmousewheel = null;
                e.removeData(this, "mousewheel-line-height"), e.removeData(this, "mousewheel-page-height")
            },
            getLineHeight: function(t) {
                var i = e(t),
                    n = i["offsetParent" in e.fn ? "offsetParent" : "parent"]();
                return n.length || (n = e("body")), parseInt(n.css("fontSize"), 10) || parseInt(i.css("fontSize"), 10) || 16
            },
            getPageHeight: function(t) {
                return e(t).height()
            },
            settings: {
                adjustOldDeltas: !0,
                normalizeOffset: !0
            }
        };
        e.fn.extend({
            mousewheel: function(e) {
                return e ? this.bind("mousewheel", e) : this.trigger("mousewheel")
            },
            unmousewheel: function(e) {
                return this.unbind("mousewheel", e)
            }
        })
    }),
    function(e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
    }(function(e) {
        e.fn.jScrollPane = function(t) {
            function i(t, i) {
                function n(i) {
                    var o, s, c, u, p, h, g = !1,
                        m = !1;
                    if (T = i, void 0 === P) p = t.scrollTop(), h = t.scrollLeft(), t.css({
                        overflow: "hidden",
                        padding: 0
                    }), F = t.innerWidth() + ne, O = t.innerHeight(), t.width(F), P = e('<div class="jspPane" />').css("padding", ie).append(t.children()), k = e('<div class="jspContainer" />').css({
                        width: F + "px",
                        height: O + "px"
                    }).append(P).appendTo(t);
                    else {
                        if (t.css("width", ""), g = T.stickToBottom && function() {
                                var e = B - O;
                                return e > 20 && e - x() < 10
                            }(), m = T.stickToRight && function() {
                                var e = _ - F;
                                return e > 20 && e - C() < 10
                            }(), (u = t.innerWidth() + ne != F || t.outerHeight() != O) && (F = t.innerWidth() + ne, O = t.innerHeight(), k.css({
                                width: F + "px",
                                height: O + "px"
                            })), !u && re == _ && P.outerHeight() == B) return void t.width(F);
                        re = _, P.css("width", ""), t.width(F), k.find(">.jspVerticalBar,>.jspHorizontalBar").remove().end()
                    }
                    P.css("overflow", "auto"), _ = i.contentWidth ? i.contentWidth : P[0].scrollWidth, B = P[0].scrollHeight, P.css("overflow", ""), M = (Q = B / O) > 1, (E = (L = _ / F) > 1) || M ? (t.addClass("jspScrollable"), (o = T.maintainPosition && (V || N)) && (s = C(), c = x()), r(), a(), l(), o && (S(m ? _ - F : s, !1), y(g ? B - O : c, !1)), P.find(":input,a").unbind("focus.jsp").bind("focus.jsp", function(e) {
                        w(e.target, !1)
                    }), k.unbind(pe).bind(pe, function(e, t, i, n) {
                        N || (N = 0), V || (V = 0);
                        var r = N,
                            o = V,
                            a = e.deltaFactor || T.mouseWheelSpeed;
                        return oe.scrollBy(i * a, -n * a, !1), r == N && o == V
                    }), function() {
                        var e, t, i, n, r, o = !1;
                        k.unbind("touchstart.jsp touchmove.jsp touchend.jsp click.jsp-touchclick").bind("touchstart.jsp", function(a) {
                            var s = a.originalEvent.touches[0];
                            e = C(), t = x(), i = s.pageX, n = s.pageY, r = !1, o = !0
                        }).bind("touchmove.jsp", function(a) {
                            if (o) {
                                var s = a.originalEvent.touches[0],
                                    l = N,
                                    c = V;
                                return oe.scrollTo(e + i - s.pageX, t + n - s.pageY), r = r || Math.abs(i - s.pageX) > 5 || Math.abs(n - s.pageY) > 5, l == N && c == V
                            }
                        }).bind("touchend.jsp", function() {
                            o = !1
                        }).bind("click.jsp-touchclick", function() {
                            return r ? (r = !1, !1) : void 0
                        })
                    }(), T.enableKeyboardNavigation && function() {
                        function i() {
                            var e = N,
                                t = V;
                            switch (n) {
                                case 40:
                                    oe.scrollByY(T.keyboardSpeed, !1);
                                    break;
                                case 38:
                                    oe.scrollByY(-T.keyboardSpeed, !1);
                                    break;
                                case 34:
                                case 32:
                                    oe.scrollByY(O * T.scrollPagePercent, !1);
                                    break;
                                case 33:
                                    oe.scrollByY(-O * T.scrollPagePercent, !1);
                                    break;
                                case 39:
                                    oe.scrollByX(T.keyboardSpeed, !1);
                                    break;
                                case 37:
                                    oe.scrollByX(-T.keyboardSpeed, !1)
                            }
                            return r = e != N || t != V
                        }
                        var n, r, o = [];
                        E && o.push(Y[0]), M && o.push(R[0]), P.bind("focus.jsp", function() {
                            t.focus()
                        }), t.attr("tabindex", 0).unbind("keydown.jsp keypress.jsp").bind("keydown.jsp", function(t) {
                            if (t.target === this || o.length && e(t.target).closest(o).length) {
                                var a = N,
                                    s = V;
                                switch (t.keyCode) {
                                    case 40:
                                    case 38:
                                    case 34:
                                    case 32:
                                    case 33:
                                    case 39:
                                    case 37:
                                        n = t.keyCode, i();
                                        break;
                                    case 35:
                                        y(B - O), n = null;
                                        break;
                                    case 36:
                                        y(0), n = null
                                }
                                return !(r = t.keyCode == n && a != N || s != V)
                            }
                        }).bind("keypress.jsp", function(t) {
                            return t.keyCode == n && i(), t.target === this || o.length && e(t.target).closest(o).length ? !r : void 0
                        }), T.hideFocus ? (t.css("outline", "none"), "hideFocus" in k[0] && t.attr("hideFocus", !0)) : (t.css("outline", ""), "hideFocus" in k[0] && t.attr("hideFocus", !1))
                    }(), T.clickOnTrack && d(), function() {
                        if (location.hash && location.hash.length > 1) {
                            var t, i, n = escape(location.hash.substr(1));
                            try {
                                t = e("#" + n + ', a[name="' + n + '"]')
                            } catch (e) {
                                return
                            }
                            t.length && P.find(n) && (0 === k.scrollTop() ? i = setInterval(function() {
                                k.scrollTop() > 0 && (w(t, !0), e(document).scrollTop(k.position().top), clearInterval(i))
                            }, 50) : (w(t, !0), e(document).scrollTop(k.position().top)))
                        }
                    }(), T.hijackInternalLinks && (e(document.body).data("jspHijack") || (e(document.body).data("jspHijack", !0), e(document.body).delegate('a[href*="#"]', "click", function(t) {
                        var i, n, r, o, a, s = this.href.substr(0, this.href.indexOf("#")),
                            l = location.href;
                        if (-1 !== location.href.indexOf("#") && (l = location.href.substr(0, location.href.indexOf("#"))), s === l) {
                            i = escape(this.href.substr(this.href.indexOf("#") + 1));
                            try {
                                n = e("#" + i + ', a[name="' + i + '"]')
                            } catch (e) {
                                return
                            }
                            n.length && ((r = n.closest(".jspScrollable")).data("jsp").scrollToElement(n, !0), r[0].scrollIntoView && (o = e(window).scrollTop(), a = n.offset().top, (o > a || a > o + e(window).height()) && r[0].scrollIntoView()), t.preventDefault())
                        }
                    })))) : (t.removeClass("jspScrollable"), P.css({
                        top: 0,
                        left: 0,
                        width: k.width() - ne
                    }), k.unbind(pe), P.find(":input,a").unbind("focus.jsp"), t.attr("tabindex", "-1").removeAttr("tabindex").unbind("keydown.jsp keypress.jsp"), P.unbind(".jsp"), f()), T.autoReinitialise && !te ? te = setInterval(function() {
                        n(T)
                    }, T.autoReinitialiseDelay) : !T.autoReinitialise && te && clearInterval(te), p && t.scrollTop(0) && y(p, !1), h && t.scrollLeft(0) && S(h, !1), t.trigger("jsp-initialised", [E || M])
                }

                function r() {
                    M && (k.append(e('<div class="jspVerticalBar" />').append(e('<div class="jspCap jspCapTop" />'), e('<div class="jspTrack" />').append(e('<div class="jspDrag" />').append(e('<div class="jspDragTop" />'), e('<div class="jspDragBottom" />'))), e('<div class="jspCap jspCapBottom" />'))), R = k.find(">.jspVerticalBar"), q = R.find(">.jspTrack"), I = q.find(">.jspDrag"), T.showArrows && ($ = e('<a class="jspArrow jspArrowUp" />').bind("mousedown.jsp", u(0, -1)).bind("click.jsp", j), X = e('<a class="jspArrow jspArrowDown" />').bind("mousedown.jsp", u(0, 1)).bind("click.jsp", j), T.arrowScrollOnHover && ($.bind("mouseover.jsp", u(0, -1, $)), X.bind("mouseover.jsp", u(0, 1, X))), c(q, T.verticalArrowPositions, $, X)), W = O, k.find(">.jspVerticalBar>.jspCap:visible,>.jspVerticalBar>.jspArrow").each(function() {
                        W -= e(this).outerHeight()
                    }), I.hover(function() {
                        I.addClass("jspHover")
                    }, function() {
                        I.removeClass("jspHover")
                    }).bind("mousedown.jsp", function(t) {
                        e("html").bind("dragstart.jsp selectstart.jsp", j), I.addClass("jspActive");
                        var i = t.pageY - I.position().top;
                        return e("html").bind("mousemove.jsp", function(e) {
                            g(e.pageY - i, !1)
                        }).bind("mouseup.jsp mouseleave.jsp", h), !1
                    }), o())
                }

                function o() {
                    q.height(W + "px"), V = 0, z = T.verticalGutter + q.outerWidth(), P.width(F - z - ne);
                    try {
                        0 === R.position().left && P.css("margin-left", z + "px")
                    } catch (e) {}
                }

                function a() {
                    E && (k.append(e('<div class="jspHorizontalBar" />').append(e('<div class="jspCap jspCapLeft" />'), e('<div class="jspTrack" />').append(e('<div class="jspDrag" />').append(e('<div class="jspDragLeft" />'), e('<div class="jspDragRight" />'))), e('<div class="jspCap jspCapRight" />'))), Y = k.find(">.jspHorizontalBar"), G = Y.find(">.jspTrack"), D = G.find(">.jspDrag"), T.showArrows && (Z = e('<a class="jspArrow jspArrowLeft" />').bind("mousedown.jsp", u(-1, 0)).bind("click.jsp", j), ee = e('<a class="jspArrow jspArrowRight" />').bind("mousedown.jsp", u(1, 0)).bind("click.jsp", j), T.arrowScrollOnHover && (Z.bind("mouseover.jsp", u(-1, 0, Z)), ee.bind("mouseover.jsp", u(1, 0, ee))), c(G, T.horizontalArrowPositions, Z, ee)), D.hover(function() {
                        D.addClass("jspHover")
                    }, function() {
                        D.removeClass("jspHover")
                    }).bind("mousedown.jsp", function(t) {
                        e("html").bind("dragstart.jsp selectstart.jsp", j), D.addClass("jspActive");
                        var i = t.pageX - D.position().left;
                        return e("html").bind("mousemove.jsp", function(e) {
                            v(e.pageX - i, !1)
                        }).bind("mouseup.jsp mouseleave.jsp", h), !1
                    }), J = k.innerWidth(), s())
                }

                function s() {
                    k.find(">.jspHorizontalBar>.jspCap:visible,>.jspHorizontalBar>.jspArrow").each(function() {
                        J -= e(this).outerWidth()
                    }), G.width(J + "px"), N = 0
                }

                function l() {
                    if (E && M) {
                        var t = G.outerHeight(),
                            i = q.outerWidth();
                        W -= t, e(Y).find(">.jspCap:visible,>.jspArrow").each(function() {
                            J += e(this).outerWidth()
                        }), J -= i, O -= i, F -= t, G.parent().append(e('<div class="jspCorner" />').css("width", t + "px")), o(), s()
                    }
                    E && P.width(k.outerWidth() - ne + "px"), B = P.outerHeight(), Q = B / O, E && ((K = Math.ceil(1 / L * J)) > T.horizontalDragMaxWidth ? K = T.horizontalDragMaxWidth : K < T.horizontalDragMinWidth && (K = T.horizontalDragMinWidth), D.width(K + "px"), H = J - K, b(N)), M && ((U = Math.ceil(1 / Q * W)) > T.verticalDragMaxHeight ? U = T.verticalDragMaxHeight : U < T.verticalDragMinHeight && (U = T.verticalDragMinHeight), I.height(U + "px"), A = W - U, m(V))
                }

                function c(e, t, i, n) {
                    var r, o = "before",
                        a = "after";
                    "os" == t && (t = /Mac/.test(navigator.platform) ? "after" : "split"), t == o ? a = t : t == a && (o = t, r = i, i = n, n = r), e[o](i)[a](n)
                }

                function u(e, t, i) {
                    return function() {
                        return p(e, t, this, i), this.blur(), !1
                    }
                }

                function p(t, i, n, r) {
                    n = e(n).addClass("jspActive");
                    var o, a, s = !0,
                        l = function() {
                            0 !== t && oe.scrollByX(t * T.arrowButtonSpeed), 0 !== i && oe.scrollByY(i * T.arrowButtonSpeed), a = setTimeout(l, s ? T.initialDelay : T.arrowRepeatFreq), s = !1
                        };
                    l(), o = r ? "mouseout.jsp" : "mouseup.jsp", (r = r || e("html")).bind(o, function() {
                        n.removeClass("jspActive"), a && clearTimeout(a), a = null, r.unbind(o)
                    })
                }

                function d() {
                    f(), M && q.bind("mousedown.jsp", function(t) {
                        if (void 0 === t.originalTarget || t.originalTarget == t.currentTarget) {
                            var i, n = e(this),
                                r = n.offset(),
                                o = t.pageY - r.top - V,
                                a = !0,
                                s = function() {
                                    var e = n.offset(),
                                        r = t.pageY - e.top - U / 2,
                                        c = O * T.scrollPagePercent,
                                        u = A * c / (B - O);
                                    if (0 > o) V - u > r ? oe.scrollByY(-c) : g(r);
                                    else {
                                        if (!(o > 0)) return void l();
                                        r > V + u ? oe.scrollByY(c) : g(r)
                                    }
                                    i = setTimeout(s, a ? T.initialDelay : T.trackClickRepeatFreq), a = !1
                                },
                                l = function() {
                                    i && clearTimeout(i), i = null, e(document).unbind("mouseup.jsp", l)
                                };
                            return s(), e(document).bind("mouseup.jsp", l), !1
                        }
                    }), E && G.bind("mousedown.jsp", function(t) {
                        if (void 0 === t.originalTarget || t.originalTarget == t.currentTarget) {
                            var i, n = e(this),
                                r = n.offset(),
                                o = t.pageX - r.left - N,
                                a = !0,
                                s = function() {
                                    var e = n.offset(),
                                        r = t.pageX - e.left - K / 2,
                                        c = F * T.scrollPagePercent,
                                        u = H * c / (_ - F);
                                    if (0 > o) N - u > r ? oe.scrollByX(-c) : v(r);
                                    else {
                                        if (!(o > 0)) return void l();
                                        r > N + u ? oe.scrollByX(c) : v(r)
                                    }
                                    i = setTimeout(s, a ? T.initialDelay : T.trackClickRepeatFreq), a = !1
                                },
                                l = function() {
                                    i && clearTimeout(i), i = null, e(document).unbind("mouseup.jsp", l)
                                };
                            return s(), e(document).bind("mouseup.jsp", l), !1
                        }
                    })
                }

                function f() {
                    G && G.unbind("mousedown.jsp"), q && q.unbind("mousedown.jsp")
                }

                function h() {
                    e("html").unbind("dragstart.jsp selectstart.jsp mousemove.jsp mouseup.jsp mouseleave.jsp"), I && I.removeClass("jspActive"), D && D.removeClass("jspActive")
                }

                function g(i, n) {
                    if (M) {
                        0 > i ? i = 0 : i > A && (i = A);
                        var r = new e.Event("jsp-will-scroll-y");
                        if (t.trigger(r, [i]), !r.isDefaultPrevented()) {
                            var o = i || 0,
                                a = 0 === o,
                                s = o == A,
                                l = -(i / A) * (B - O);
                            void 0 === n && (n = T.animateScroll), n ? oe.animate(I, "top", i, m, function() {
                                t.trigger("jsp-user-scroll-y", [-l, a, s])
                            }) : (I.css("top", i), m(i), t.trigger("jsp-user-scroll-y", [-l, a, s]))
                        }
                    }
                }

                function m(e) {
                    void 0 === e && (e = I.position().top), k.scrollTop(0);
                    var i = 0 === (V = e || 0),
                        n = V == A,
                        r = -(e / A) * (B - O);
                    (ae != i || le != n) && (ae = i, le = n, t.trigger("jsp-arrow-change", [ae, le, se, ce])),
                    function(e, t) {
                        T.showArrows && ($[e ? "addClass" : "removeClass"]("jspDisabled"), X[t ? "addClass" : "removeClass"]("jspDisabled"))
                    }(i, n), P.css("top", r), t.trigger("jsp-scroll-y", [-r, i, n]).trigger("scroll")
                }

                function v(i, n) {
                    if (E) {
                        0 > i ? i = 0 : i > H && (i = H);
                        var r = new e.Event("jsp-will-scroll-x");
                        if (t.trigger(r, [i]), !r.isDefaultPrevented()) {
                            var o = i || 0,
                                a = 0 === o,
                                s = o == H,
                                l = -(i / H) * (_ - F);
                            void 0 === n && (n = T.animateScroll), n ? oe.animate(D, "left", i, b, function() {
                                t.trigger("jsp-user-scroll-x", [-l, a, s])
                            }) : (D.css("left", i), b(i), t.trigger("jsp-user-scroll-x", [-l, a, s]))
                        }
                    }
                }

                function b(e) {
                    void 0 === e && (e = D.position().left), k.scrollTop(0);
                    var i = 0 === (N = e || 0),
                        n = N == H,
                        r = -(e / H) * (_ - F);
                    (se != i || ce != n) && (se = i, ce = n, t.trigger("jsp-arrow-change", [ae, le, se, ce])),
                    function(e, t) {
                        T.showArrows && (Z[e ? "addClass" : "removeClass"]("jspDisabled"), ee[t ? "addClass" : "removeClass"]("jspDisabled"))
                    }(i, n), P.css("left", r), t.trigger("jsp-scroll-x", [-r, i, n]).trigger("scroll")
                }

                function y(e, t) {
                    g(e / (B - O) * A, t)
                }

                function S(e, t) {
                    v(e / (_ - F) * H, t)
                }

                function w(t, i, n) {
                    var r, o, a, s, l, c, u, p, d, f = 0,
                        h = 0;
                    try {
                        r = e(t)
                    } catch (e) {
                        return
                    }
                    for (o = r.outerHeight(), a = r.outerWidth(), k.scrollTop(0), k.scrollLeft(0); !r.is(".jspPane");)
                        if (f += r.position().top, h += r.position().left, r = r.offsetParent(), /^body|html$/i.test(r[0].nodeName)) return;
                    c = (s = x()) + O, s > f || i ? p = f - T.horizontalGutter : f + o > c && (p = f - O + o + T.horizontalGutter), isNaN(p) || y(p, n), u = (l = C()) + F, l > h || i ? d = h - T.horizontalGutter : h + a > u && (d = h - F + a + T.horizontalGutter), isNaN(d) || S(d, n)
                }

                function C() {
                    return -P.position().left
                }

                function x() {
                    return -P.position().top
                }

                function j() {
                    return !1
                }
                var T, P, F, O, k, _, B, L, Q, M, E, I, A, V, D, H, N, R, q, z, W, U, $, X, Y, G, J, K, Z, ee, te, ie, ne, re, oe = this,
                    ae = !0,
                    se = !0,
                    le = !1,
                    ce = !1,
                    ue = t.clone(!1, !1).empty(),
                    pe = e.fn.mwheelIntent ? "mwheelIntent.jsp" : "mousewheel.jsp";
                "border-box" === t.css("box-sizing") ? (ie = 0, ne = 0) : (ie = t.css("paddingTop") + " " + t.css("paddingRight") + " " + t.css("paddingBottom") + " " + t.css("paddingLeft"), ne = (parseInt(t.css("paddingLeft"), 10) || 0) + (parseInt(t.css("paddingRight"), 10) || 0)), e.extend(oe, {
                    reinitialise: function(t) {
                        n(t = e.extend({}, T, t))
                    },
                    scrollToElement: function(e, t, i) {
                        w(e, t, i)
                    },
                    scrollTo: function(e, t, i) {
                        S(e, i), y(t, i)
                    },
                    scrollToX: function(e, t) {
                        S(e, t)
                    },
                    scrollToY: function(e, t) {
                        y(e, t)
                    },
                    scrollToPercentX: function(e, t) {
                        S(e * (_ - F), t)
                    },
                    scrollToPercentY: function(e, t) {
                        y(e * (B - O), t)
                    },
                    scrollBy: function(e, t, i) {
                        oe.scrollByX(e, i), oe.scrollByY(t, i)
                    },
                    scrollByX: function(e, t) {
                        v((C() + Math[0 > e ? "floor" : "ceil"](e)) / (_ - F) * H, t)
                    },
                    scrollByY: function(e, t) {
                        g((x() + Math[0 > e ? "floor" : "ceil"](e)) / (B - O) * A, t)
                    },
                    positionDragX: function(e, t) {
                        v(e, t)
                    },
                    positionDragY: function(e, t) {
                        g(e, t)
                    },
                    animate: function(e, t, i, n, r) {
                        var o = {};
                        o[t] = i, e.animate(o, {
                            duration: T.animateDuration,
                            easing: T.animateEase,
                            queue: !1,
                            step: n,
                            complete: r
                        })
                    },
                    getContentPositionX: function() {
                        return C()
                    },
                    getContentPositionY: function() {
                        return x()
                    },
                    getContentWidth: function() {
                        return _
                    },
                    getContentHeight: function() {
                        return B
                    },
                    getPercentScrolledX: function() {
                        return C() / (_ - F)
                    },
                    getPercentScrolledY: function() {
                        return x() / (B - O)
                    },
                    getIsScrollableH: function() {
                        return E
                    },
                    getIsScrollableV: function() {
                        return M
                    },
                    getContentPane: function() {
                        return P
                    },
                    scrollToBottom: function(e) {
                        g(A, e)
                    },
                    hijackInternalLinks: e.noop,
                    destroy: function() {
                        var e, i;
                        e = x(), i = C(), t.removeClass("jspScrollable").unbind(".jsp"), P.unbind(".jsp"), t.replaceWith(ue.append(P.children())), ue.scrollTop(e), ue.scrollLeft(i), te && clearInterval(te)
                    }
                }), n(i)
            }
            return t = e.extend({}, e.fn.jScrollPane.defaults, t), e.each(["arrowButtonSpeed", "trackClickSpeed", "keyboardSpeed"], function() {
                t[this] = t[this] || t.speed
            }), this.each(function() {
                var n = e(this),
                    r = n.data("jsp");
                r ? r.reinitialise(t) : (e("script", n).filter('[type="text/javascript"],:not([type])').remove(), r = new i(n, t), n.data("jsp", r))
            })
        }, e.fn.jScrollPane.defaults = {
            showArrows: !1,
            maintainPosition: !0,
            stickToBottom: !1,
            stickToRight: !1,
            clickOnTrack: !0,
            autoReinitialise: !1,
            autoReinitialiseDelay: 500,
            verticalDragMinHeight: 0,
            verticalDragMaxHeight: 99999,
            horizontalDragMinWidth: 0,
            horizontalDragMaxWidth: 99999,
            contentWidth: void 0,
            animateScroll: !1,
            animateDuration: 300,
            animateEase: "linear",
            hijackInternalLinks: !1,
            verticalGutter: 4,
            horizontalGutter: 4,
            mouseWheelSpeed: 3,
            arrowButtonSpeed: 0,
            arrowRepeatFreq: 50,
            arrowScrollOnHover: !1,
            trackClickSpeed: 0,
            trackClickRepeatFreq: 70,
            verticalArrowPositions: "split",
            horizontalArrowPositions: "split",
            enableKeyboardNavigation: !0,
            hideFocus: !1,
            keyboardSpeed: 0,
            initialDelay: 300,
            speed: 30,
            scrollPagePercent: .8
        }
    }),
    function(e, t, i) {
        "use strict";

        function n(e) {
            var t = Array.prototype.slice.call(arguments, 1);
            return e.prop ? e.prop.apply(e, t) : e.attr.apply(e, t)
        }

        function r(e, t, i) {
            var n, r;
            for (n in i) i.hasOwnProperty(n) && (r = n.replace(/ |$/g, t.eventNamespace), e.bind(r, i[n]))
        }

        function o(e, t, i) {
            r(e, i, {
                focus: function() {
                    t.addClass(i.focusClass)
                },
                blur: function() {
                    t.removeClass(i.focusClass), t.removeClass(i.activeClass)
                },
                mouseenter: function() {
                    t.addClass(i.hoverClass)
                },
                mouseleave: function() {
                    t.removeClass(i.hoverClass), t.removeClass(i.activeClass)
                },
                "mousedown touchbegin": function() {
                    e.is(":disabled") || t.addClass(i.activeClass)
                },
                "mouseup touchend": function() {
                    t.removeClass(i.activeClass)
                }
            })
        }

        function a(e, t) {
            e.removeClass(t.hoverClass + " " + t.focusClass + " " + t.activeClass)
        }

        function s(e, t, i) {
            i ? e.addClass(t) : e.removeClass(t)
        }

        function l(e, t, i) {
            var n = "checked",
                r = t.is(":" + n);
            t.prop ? t.prop(n, r) : r ? t.attr(n, n) : t.removeAttr(n), s(e, i.checkedClass, r)
        }

        function c(e, t, i) {
            s(e, i.disabledClass, t.is(":disabled"))
        }

        function u(e, t, i) {
            switch (i) {
                case "after":
                    return e.after(t), e.next();
                case "before":
                    return e.before(t), e.prev();
                case "wrap":
                    return e.wrap(t), e.parent()
            }
            return null
        }

        function p(e, i, r) {
            var o, a, s;
            return r || (r = {}), r = t.extend({
                bind: {},
                divClass: null,
                divWrap: "wrap",
                spanClass: null,
                spanHtml: null,
                spanWrap: "wrap"
            }, r), o = t("<div />"), a = t("<span />"), i.autoHide && e.is(":hidden") && "none" === e.css("display") && o.hide(), r.divClass && o.addClass(r.divClass), i.wrapperClass && o.addClass(i.wrapperClass), r.spanClass && a.addClass(r.spanClass), s = n(e, "id"), i.useID && s && n(o, "id", i.idPrefix + "-" + s), r.spanHtml && a.html(r.spanHtml), o = u(e, o, r.divWrap), a = u(e, a, r.spanWrap), c(o, e, i), {
                div: o,
                span: a
            }
        }

        function d(e, i) {
            return i.wrapperClass ? u(e, t("<span />").addClass(i.wrapperClass), "wrap") : null
        }

        function f(e) {
            return e ? t("<span />").text(e).html() : ""
        }

        function h() {
            return navigator.cpuClass && !navigator.product
        }

        function g(e) {
            var t;
            return !!e[0].multiple || !(!(t = n(e, "size")) || t <= 1)
        }

        function m() {
            return !1
        }

        function v(e, t) {
            r(e, t, {
                "selectstart dragstart mousedown": m
            }), e.css({
                MozUserSelect: "none",
                msUserSelect: "none",
                webkitUserSelect: "none",
                userSelect: "none"
            })
        }

        function b(e, t, i) {
            var n = e.val();
            "" === n ? n = i.fileDefaultHtml : n = (n = n.split(/[\/\\]+/))[n.length - 1], t.text(n)
        }

        function y(e, t, i) {
            var n, r;
            for (n = [], e.each(function() {
                    var e;
                    for (e in t) Object.prototype.hasOwnProperty.call(t, e) && (n.push({
                        el: this,
                        name: e,
                        old: this.style[e]
                    }), this.style[e] = t[e])
                }), i(); n.length;)(r = n.pop()).el.style[r.name] = r.old
        }

        function S(e, t) {
            var i;
            (i = e.parents()).push(e[0]), y(i = i.not(":visible"), {
                visibility: "hidden",
                display: "block",
                position: "absolute"
            }, t)
        }

        function w(e, t) {
            return function() {
                e.unwrap().unwrap().unbind(t.eventNamespace)
            }
        }
        var C = !0,
            x = !1,
            j = [{
                match: function(e) {
                    return e.is("a, button, :submit, :reset, input[type='button']")
                },
                apply: function(t, i) {
                    var s, l, u, d, h;
                    return l = i.submitDefaultHtml, t.is(":reset") && (l = i.resetDefaultHtml), d = t.is("a, button") ? function() {
                        return t.html() || l
                    } : function() {
                        return f(n(t, "value")) || l
                    }, u = p(t, i, {
                        divClass: i.buttonClass,
                        spanHtml: d()
                    }), s = u.div, o(t, s, i), h = !1, r(s, i, {
                        "click touchend": function() {
                            var i, r, o, a;
                            h || t.is(":disabled") || (h = !0, t[0].dispatchEvent ? ((i = document.createEvent("MouseEvents")).initEvent("click", !0, !0), r = t[0].dispatchEvent(i), t.is("a") && r && (o = n(t, "target"), a = n(t, "href"), o && "_self" !== o ? e.open(a, o) : document.location.href = a)) : t.click(), h = !1)
                        }
                    }), v(s, i), {
                        remove: function() {
                            return s.after(t), s.remove(), t.unbind(i.eventNamespace), t
                        },
                        update: function() {
                            a(s, i), c(s, t, i), t.detach(), u.span.html(d()).append(t)
                        }
                    }
                }
            }, {
                match: function(e) {
                    return e.is(":checkbox")
                },
                apply: function(e, t) {
                    var i, n, s;
                    return i = p(e, t, {
                        divClass: t.checkboxClass
                    }), n = i.div, s = i.span, o(e, n, t), r(e, t, {
                        "click touchend": function() {
                            l(s, e, t)
                        }
                    }), l(s, e, t), {
                        remove: w(e, t),
                        update: function() {
                            a(n, t), s.removeClass(t.checkedClass), l(s, e, t), c(n, e, t)
                        }
                    }
                }
            }, {
                match: function(e) {
                    return e.is(":file")
                },
                apply: function(e, i) {
                    function s() {
                        b(e, f, i)
                    }
                    var l, d, f, g;
                    return l = p(e, i, {
                        divClass: i.fileClass,
                        spanClass: i.fileButtonClass,
                        spanHtml: i.fileButtonHtml,
                        spanWrap: "after"
                    }), d = l.div, g = l.span, (f = t("<span />").html(i.fileDefaultHtml)).addClass(i.filenameClass), f = u(e, f, "after"), n(e, "size") || n(e, "size", d.width() / 10), o(e, d, i), s(), h() ? r(e, i, {
                        click: function() {
                            e.trigger("change"), setTimeout(s, 0)
                        }
                    }) : r(e, i, {
                        change: s
                    }), v(f, i), v(g, i), {
                        remove: function() {
                            return f.remove(), g.remove(), e.unwrap().unbind(i.eventNamespace)
                        },
                        update: function() {
                            a(d, i), b(e, f, i), c(d, e, i)
                        }
                    }
                }
            }, {
                match: function(e) {
                    return !!e.is("input") && " color date datetime datetime-local email month number password search tel text time url week ".indexOf((" " + n(e, "type") + " ").toLowerCase()) >= 0
                },
                apply: function(e, t) {
                    var i, r;
                    return i = n(e, "type"), e.addClass(t.inputClass), r = d(e, t), o(e, e, t), t.inputAddTypeAsClass && e.addClass(i), {
                        remove: function() {
                            e.removeClass(t.inputClass), t.inputAddTypeAsClass && e.removeClass(i), r && e.unwrap()
                        },
                        update: m
                    }
                }
            }, {
                match: function(e) {
                    return e.is(":radio")
                },
                apply: function(e, i) {
                    var s, u, d;
                    return s = p(e, i, {
                        divClass: i.radioClass
                    }), u = s.div, d = s.span, o(e, u, i), r(e, i, {
                        "click touchend": function() {
                            t.uniform.update(t(':radio[name="' + n(e, "name") + '"]'))
                        }
                    }), l(d, e, i), {
                        remove: w(e, i),
                        update: function() {
                            a(u, i), l(d, e, i), c(u, e, i)
                        }
                    }
                }
            }, {
                match: function(e) {
                    return !(!e.is("select") || g(e))
                },
                apply: function(e, i) {
                    var n, s, l, u;
                    return i.selectAutoWidth && S(e, function() {
                        u = e.width()
                    }), n = p(e, i, {
                        divClass: i.selectClass,
                        spanHtml: (e.find(":selected:first") || e.find("option:first")).html(),
                        spanWrap: "before"
                    }), s = n.div, l = n.span, i.selectAutoWidth ? S(e, function() {
                        y(t([l[0], s[0]]), {
                            display: "block"
                        }, function() {
                            var e;
                            e = l.outerWidth() - l.width(), s.width(u + e), l.width(u)
                        })
                    }) : s.addClass("fixedWidth"), o(e, s, i), r(e, i, {
                        change: function() {
                            l.html(e.find(":selected").html()), s.removeClass(i.activeClass)
                        },
                        "click touchend": function() {
                            var t = e.find(":selected").html();
                            l.html() !== t && e.trigger("change")
                        },
                        keyup: function() {
                            l.html(e.find(":selected").html())
                        }
                    }), v(l, i), {
                        remove: function() {
                            return l.remove(), e.unwrap().unbind(i.eventNamespace), e
                        },
                        update: function() {
                            i.selectAutoWidth ? (t.uniform.restore(e), e.uniform(i)) : (a(s, i), e[0].selectedIndex = e[0].selectedIndex, l.html(e.find(":selected").html()), c(s, e, i))
                        }
                    }
                }
            }, {
                match: function(e) {
                    return !(!e.is("select") || !g(e))
                },
                apply: function(e, t) {
                    var i;
                    return e.addClass(t.selectMultiClass), i = d(e, t), o(e, e, t), {
                        remove: function() {
                            e.removeClass(t.selectMultiClass), i && e.unwrap()
                        },
                        update: m
                    }
                }
            }, {
                match: function(e) {
                    return e.is("textarea")
                },
                apply: function(e, t) {
                    var i;
                    return e.addClass(t.textareaClass), i = d(e, t), o(e, e, t), {
                        remove: function() {
                            e.removeClass(t.textareaClass), i && e.unwrap()
                        },
                        update: m
                    }
                }
            }];
        h() && !(void 0 !== e.XMLHttpRequest) && (C = !1), t.uniform = {
            defaults: {
                activeClass: "active",
                autoHide: !0,
                buttonClass: "button",
                checkboxClass: "checker",
                checkedClass: "checked",
                disabledClass: "disabled",
                eventNamespace: ".uniform",
                fileButtonClass: "action",
                fileButtonHtml: "Choose File",
                fileClass: "uploader",
                fileDefaultHtml: "No file selected",
                filenameClass: "filename",
                focusClass: "focus",
                hoverClass: "hover",
                idPrefix: "uniform",
                inputAddTypeAsClass: !0,
                inputClass: "uniform-input",
                radioClass: "radio",
                resetDefaultHtml: "Reset",
                resetSelector: !1,
                selectAutoWidth: !0,
                selectClass: "selector",
                selectMultiClass: "uniform-multiselect",
                submitDefaultHtml: "Submit",
                textareaClass: "uniform",
                useID: !0,
                wrapperClass: null
            },
            elements: []
        }, t.fn.uniform = function(i) {
            var n = this;
            return i = t.extend({}, t.uniform.defaults, i), x || (x = !0, function() {
                var i, n, r, o;
                return n = t('<div style="width:0;height:0;color:' + (o = "rgb(120,2,153)") + '">'), t("body").append(n), r = n.get(0), i = e.getComputedStyle ? e.getComputedStyle(r, "").color : (r.currentStyle || r.style || {}).color, n.remove(), i.replace(/ /g, "") !== o
            }() && (C = !1)), C ? (i.resetSelector && t(i.resetSelector).mouseup(function() {
                e.setTimeout(function() {
                    t.uniform.update(n)
                }, 10)
            }), this.each(function() {
                var e, n, r, o = t(this);
                if (o.data("uniformed")) t.uniform.update(o);
                else
                    for (e = 0; e < j.length; e += 1)
                        if ((n = j[e]).match(o, i)) return r = n.apply(o, i), o.data("uniformed", r), void t.uniform.elements.push(o.get(0))
            })) : this
        }, t.uniform.restore = t.fn.uniform.restore = function(e) {
            void 0 === e && (e = t.uniform.elements), t(e).each(function() {
                var e, i, n = t(this);
                (i = n.data("uniformed")) && (i.remove(), (e = t.inArray(this, t.uniform.elements)) >= 0 && t.uniform.elements.splice(e, 1), n.removeData("uniformed"))
            })
        }, t.uniform.update = t.fn.uniform.update = function(e) {
            void 0 === e && (e = t.uniform.elements), t(e).each(function() {
                var e, i = t(this);
                (e = i.data("uniformed")) && e.update(i, e.options)
            })
        }
    }(this, jQuery),
    function(e) {
        "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? module.exports = e() : window.noUiSlider = e()
    }(function() {
        "use strict";

        function e(e, t) {
            var i = document.createElement("div");
            return o(i, t), e.appendChild(i), i
        }

        function t(e) {
            return "number" == typeof e && !isNaN(e) && isFinite(e)
        }

        function i(e, t, i) {
            i > 0 && (o(e, t), setTimeout(function() {
                a(e, t)
            }, i))
        }

        function n(e) {
            return Array.isArray(e) ? e : [e]
        }

        function r(e) {
            var t = (e = String(e)).split(".");
            return t.length > 1 ? t[1].length : 0
        }

        function o(e, t) {
            e.classList ? e.classList.add(t) : e.className += " " + t
        }

        function a(e, t) {
            e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " ")
        }

        function s() {
            var e = void 0 !== window.pageXOffset,
                t = "CSS1Compat" === (document.compatMode || "");
            return {
                x: e ? window.pageXOffset : t ? document.documentElement.scrollLeft : document.body.scrollLeft,
                y: e ? window.pageYOffset : t ? document.documentElement.scrollTop : document.body.scrollTop
            }
        }

        function l(e, t) {
            return 100 / (t - e)
        }

        function c(e, t) {
            return 100 * t / (e[1] - e[0])
        }

        function u(e, t) {
            for (var i = 1; e >= t[i];) i += 1;
            return i
        }

        function p(e, t, i) {
            if (i >= e.slice(-1)[0]) return 100;
            var n, r, o, a, s = u(i, e);
            return n = e[s - 1], r = e[s], o = t[s - 1], a = t[s], o + function(e, t) {
                return c(e, e[0] < 0 ? t + Math.abs(e[0]) : t - e[0])
            }([n, r], i) / l(o, a)
        }

        function d(e, t, i, n) {
            if (100 === n) return n;
            var r, o, a = u(n, e);
            return i ? n - (r = e[a - 1]) > ((o = e[a]) - r) / 2 ? o : r : t[a - 1] ? e[a - 1] + function(e, t) {
                return Math.round(e / t) * t
            }(n - e[a - 1], t[a - 1]) : n
        }

        function f(e, i, n) {
            var r;
            if ("number" == typeof i && (i = [i]), "[object Array]" !== Object.prototype.toString.call(i)) throw new Error("noUiSlider: 'range' contains invalid value.");
            if (!t(r = "min" === e ? 0 : "max" === e ? 100 : parseFloat(e)) || !t(i[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
            n.xPct.push(r), n.xVal.push(i[0]), r ? n.xSteps.push(!isNaN(i[1]) && i[1]) : isNaN(i[1]) || (n.xSteps[0] = i[1]), n.xHighestCompleteStep.push(0)
        }

        function h(e, t, i) {
            if (!t) return !0;
            i.xSteps[e] = c([i.xVal[e], i.xVal[e + 1]], t) / l(i.xPct[e], i.xPct[e + 1]);
            var n = (i.xVal[e + 1] - i.xVal[e]) / i.xNumSteps[e],
                r = Math.ceil(Number(n.toFixed(3)) - 1),
                o = i.xVal[e] + i.xNumSteps[e] * r;
            i.xHighestCompleteStep[e] = o
        }

        function g(e, t, i, n) {
            this.xPct = [], this.xVal = [], this.xSteps = [n || !1], this.xNumSteps = [!1], this.xHighestCompleteStep = [], this.snap = t, this.direction = i;
            var r, o = [];
            for (r in e) e.hasOwnProperty(r) && o.push([e[r], r]);
            for (o.length && "object" == typeof o[0][0] ? o.sort(function(e, t) {
                    return e[0][0] - t[0][0]
                }) : o.sort(function(e, t) {
                    return e[0] - t[0]
                }), r = 0; r < o.length; r++) f(o[r][1], o[r][0], this);
            for (this.xNumSteps = this.xSteps.slice(0), r = 0; r < this.xNumSteps.length; r++) h(r, this.xNumSteps[r], this)
        }

        function m(e, i) {
            if (!t(i)) throw new Error("noUiSlider: 'step' is not numeric.");
            e.singleStep = i
        }

        function v(e, t) {
            if ("object" != typeof t || Array.isArray(t)) throw new Error("noUiSlider: 'range' is not an object.");
            if (void 0 === t.min || void 0 === t.max) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
            if (t.min === t.max) throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
            e.spectrum = new g(t, e.snap, e.dir, e.singleStep)
        }

        function b(e, t) {
            if (t = n(t), !Array.isArray(t) || !t.length) throw new Error("noUiSlider: 'start' option is incorrect.");
            e.handles = t.length, e.start = t
        }

        function y(e, t) {
            if (e.snap = t, "boolean" != typeof t) throw new Error("noUiSlider: 'snap' option must be a boolean.")
        }

        function S(e, t) {
            if (e.animate = t, "boolean" != typeof t) throw new Error("noUiSlider: 'animate' option must be a boolean.")
        }

        function w(e, t) {
            if (e.animationDuration = t, "number" != typeof t) throw new Error("noUiSlider: 'animationDuration' option must be a number.")
        }

        function C(e, t) {
            var i, n = [!1];
            if (!0 === t || !1 === t) {
                for (i = 1; i < e.handles; i++) n.push(t);
                n.push(!1)
            } else {
                if (!Array.isArray(t) || !t.length || t.length !== e.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
                n = t
            }
            e.connect = n
        }

        function x(e, t) {
            switch (t) {
                case "horizontal":
                    e.ort = 0;
                    break;
                case "vertical":
                    e.ort = 1;
                    break;
                default:
                    throw new Error("noUiSlider: 'orientation' option is invalid.")
            }
        }

        function j(e, i) {
            if (!t(i)) throw new Error("noUiSlider: 'margin' option must be numeric.");
            if (0 !== i && (e.margin = e.spectrum.getMargin(i), !e.margin)) throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.")
        }

        function T(e, i) {
            if (!t(i)) throw new Error("noUiSlider: 'limit' option must be numeric.");
            if (e.limit = e.spectrum.getMargin(i), !e.limit || e.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.")
        }

        function P(e, t) {
            switch (t) {
                case "ltr":
                    e.dir = 0;
                    break;
                case "rtl":
                    e.dir = 1;
                    break;
                default:
                    throw new Error("noUiSlider: 'direction' option was not recognized.")
            }
        }

        function F(e, t) {
            if ("string" != typeof t) throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
            var i = t.indexOf("tap") >= 0,
                n = t.indexOf("drag") >= 0,
                r = t.indexOf("fixed") >= 0,
                o = t.indexOf("snap") >= 0,
                a = t.indexOf("hover") >= 0;
            if (r) {
                if (2 !== e.handles) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
                j(e, e.start[1] - e.start[0])
            }
            e.events = {
                tap: i || o,
                drag: n,
                fixed: r,
                snap: o,
                hover: a
            }
        }

        function O(e, t) {
            if (!1 !== t)
                if (!0 === t) {
                    e.tooltips = [];
                    for (var i = 0; i < e.handles; i++) e.tooltips.push(!0)
                } else {
                    if (e.tooltips = n(t), e.tooltips.length !== e.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
                    e.tooltips.forEach(function(e) {
                        if ("boolean" != typeof e && ("object" != typeof e || "function" != typeof e.to)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.")
                    })
                }
        }

        function k(e, t) {
            if (e.format = t, "function" == typeof t.to && "function" == typeof t.from) return !0;
            throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.")
        }

        function _(e, t) {
            if (void 0 !== t && "string" != typeof t && !1 !== t) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
            e.cssPrefix = t
        }

        function B(e, t) {
            if (void 0 !== t && "object" != typeof t) throw new Error("noUiSlider: 'cssClasses' must be an object.");
            if ("string" == typeof e.cssPrefix)
                for (var i in e.cssClasses = {}, t) t.hasOwnProperty(i) && (e.cssClasses[i] = e.cssPrefix + t[i]);
            else e.cssClasses = t
        }

        function L(e, t) {
            if (!0 !== t && !1 !== t) throw new Error("noUiSlider: 'useRequestAnimationFrame' option should be true (default) or false.");
            e.useRequestAnimationFrame = t
        }

        function Q(e) {
            var t, i = {
                margin: 0,
                limit: 0,
                animate: !0,
                animationDuration: 300,
                format: E
            };
            t = {
                step: {
                    r: !1,
                    t: m
                },
                start: {
                    r: !0,
                    t: b
                },
                connect: {
                    r: !0,
                    t: C
                },
                direction: {
                    r: !0,
                    t: P
                },
                snap: {
                    r: !1,
                    t: y
                },
                animate: {
                    r: !1,
                    t: S
                },
                animationDuration: {
                    r: !1,
                    t: w
                },
                range: {
                    r: !0,
                    t: v
                },
                orientation: {
                    r: !1,
                    t: x
                },
                margin: {
                    r: !1,
                    t: j
                },
                limit: {
                    r: !1,
                    t: T
                },
                behaviour: {
                    r: !0,
                    t: F
                },
                format: {
                    r: !1,
                    t: k
                },
                tooltips: {
                    r: !1,
                    t: O
                },
                cssPrefix: {
                    r: !1,
                    t: _
                },
                cssClasses: {
                    r: !1,
                    t: B
                },
                useRequestAnimationFrame: {
                    r: !1,
                    t: L
                }
            };
            var n = {
                connect: !1,
                direction: "ltr",
                behaviour: "tap",
                orientation: "horizontal",
                cssPrefix: "noUi-",
                cssClasses: {
                    target: "target",
                    base: "base",
                    origin: "origin",
                    handle: "handle",
                    horizontal: "horizontal",
                    vertical: "vertical",
                    background: "background",
                    connect: "connect",
                    ltr: "ltr",
                    rtl: "rtl",
                    draggable: "draggable",
                    drag: "state-drag",
                    tap: "state-tap",
                    active: "active",
                    tooltip: "tooltip",
                    pips: "pips",
                    pipsHorizontal: "pips-horizontal",
                    pipsVertical: "pips-vertical",
                    marker: "marker",
                    markerHorizontal: "marker-horizontal",
                    markerVertical: "marker-vertical",
                    markerNormal: "marker-normal",
                    markerLarge: "marker-large",
                    markerSub: "marker-sub",
                    value: "value",
                    valueHorizontal: "value-horizontal",
                    valueVertical: "value-vertical",
                    valueNormal: "value-normal",
                    valueLarge: "value-large",
                    valueSub: "value-sub"
                },
                useRequestAnimationFrame: !0
            };
            Object.keys(t).forEach(function(r) {
                if (void 0 === e[r] && void 0 === n[r]) {
                    if (t[r].r) throw new Error("noUiSlider: '" + r + "' is required.");
                    return !0
                }
                t[r].t(i, void 0 === e[r] ? n[r] : e[r])
            }), i.pips = e.pips;
            var r = [
                ["left", "top"],
                ["right", "bottom"]
            ];
            return i.style = r[i.dir][i.ort], i.styleOposite = r[i.dir ? 0 : 1][i.ort], i
        }

        function M(t, r, l) {
            function c(t, i) {
                var n = e(t, r.cssClasses.origin);
                return e(n, r.cssClasses.handle).setAttribute("data-handle", i), n
            }

            function u(t, i) {
                return !!i && e(t, r.cssClasses.connect)
            }

            function p(t, i) {
                return !!r.tooltips[i] && e(t.firstChild, r.cssClasses.tooltip)
            }

            function d(e, t, i) {
                function n(e, t, i) {
                    return 'class="' + function(e, t) {
                        var i = t === r.cssClasses.value,
                            n = i ? c : u;
                        return t + " " + (i ? p : d)[r.ort] + " " + n[e]
                    }(i[1], t) + '" style="' + r.style + ": " + e + '%"'
                }

                function a(e, o) {
                    o[1] = o[1] && t ? t(o[0], o[1]) : o[1], l += "<div " + n(e, r.cssClasses.marker, o) + "></div>", o[1] && (l += "<div " + n(e, r.cssClasses.value, o) + ">" + i.to(o[0]) + "</div>")
                }
                var s = document.createElement("div"),
                    l = "",
                    c = [r.cssClasses.valueNormal, r.cssClasses.valueLarge, r.cssClasses.valueSub],
                    u = [r.cssClasses.markerNormal, r.cssClasses.markerLarge, r.cssClasses.markerSub],
                    p = [r.cssClasses.valueHorizontal, r.cssClasses.valueVertical],
                    d = [r.cssClasses.markerHorizontal, r.cssClasses.markerVertical];
                return o(s, r.cssClasses.pips), o(s, 0 === r.ort ? r.cssClasses.pipsHorizontal : r.cssClasses.pipsVertical), Object.keys(e).forEach(function(t) {
                    a(t, e[t])
                }), s.innerHTML = l, s
            }

            function f(e) {
                var t = e.mode,
                    i = e.density || 1,
                    n = e.filter || !1,
                    r = function(e, t, i) {
                        if ("range" === e || "steps" === e) return q.xVal;
                        if ("count" === e) {
                            var n, r = 100 / (t - 1),
                                o = 0;
                            for (t = [];
                                (n = o++ * r) <= 100;) t.push(n);
                            e = "positions"
                        }
                        return "positions" === e ? t.map(function(e) {
                            return q.fromStepping(i ? q.getStep(e) : e)
                        }) : "values" === e ? i ? t.map(function(e) {
                            return q.fromStepping(q.getStep(q.toStepping(e)))
                        }) : t : void 0
                    }(t, e.values || !1, e.stepped || !1),
                    o = function(e, t, i) {
                        function n(e, t) {
                            return (e + t).toFixed(7) / 1
                        }
                        var r = {},
                            o = q.xVal[0],
                            a = q.xVal[q.xVal.length - 1],
                            s = !1,
                            l = !1,
                            c = 0;
                        return (i = function(e) {
                            return e.filter(function(e) {
                                return !this[e] && (this[e] = !0)
                            }, {})
                        }(i.slice().sort(function(e, t) {
                            return e - t
                        })))[0] !== o && (i.unshift(o), s = !0), i[i.length - 1] !== a && (i.push(a), l = !0), i.forEach(function(o, a) {
                            var u, p, d, f, h, g, m, v, b, y = o,
                                S = i[a + 1];
                            if ("steps" === t && (u = q.xNumSteps[a]), u || (u = S - y), !1 !== y && void 0 !== S)
                                for (u = Math.max(u, 1e-7), p = y; p <= S; p = n(p, u)) {
                                    for (m = (h = (f = q.toStepping(p)) - c) / e, b = h / (v = Math.round(m)), d = 1; d <= v; d += 1) r[(c + d * b).toFixed(5)] = ["x", 0];
                                    g = i.indexOf(p) > -1 ? 1 : "steps" === t ? 2 : 0, !a && s && (g = 0), p === S && l || (r[f.toFixed(5)] = [p, g]), c = f
                                }
                        }), r
                    }(i, t, r),
                    a = e.format || {
                        to: Math.round
                    };
                return H.appendChild(d(o, n, a))
            }

            function h() {
                var e = E.getBoundingClientRect(),
                    t = "offset" + ["Width", "Height"][r.ort];
                return 0 === r.ort ? e.width || E[t] : e.height || E[t]
            }

            function g(e, t, i, n) {
                var o = function(t) {
                        return !H.hasAttribute("disabled") && ! function(e, t) {
                            return e.classList ? e.classList.contains(t) : new RegExp("\\b" + t + "\\b").test(e.className)
                        }(H, r.cssClasses.tap) && (t = function(e, t) {
                            e.preventDefault();
                            var i, n, r = 0 === e.type.indexOf("touch"),
                                o = 0 === e.type.indexOf("mouse"),
                                a = 0 === e.type.indexOf("pointer"),
                                l = e;
                            if (0 === e.type.indexOf("MSPointer") && (a = !0), r) {
                                if (l.touches.length > 1) return !1;
                                i = e.changedTouches[0].pageX, n = e.changedTouches[0].pageY
                            }
                            return t = t || s(), (o || a) && (i = e.clientX + t.x, n = e.clientY + t.y), l.pageOffset = t, l.points = [i, n], l.cursor = o || a, l
                        }(t, n.pageOffset), !(e === D.start && void 0 !== t.buttons && t.buttons > 1) && (!n.hover || !t.buttons) && (t.calcPoint = t.points[r.ort], void i(t, n)))
                    },
                    a = [];
                return e.split(" ").forEach(function(e) {
                    t.addEventListener(e, o, !1), a.push([e, o])
                }), a
            }

            function m(e) {
                var t = 100 * (e - function(e, t) {
                    var i = e.getBoundingClientRect(),
                        n = e.ownerDocument.documentElement,
                        r = s();
                    return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (r.x = 0), t ? i.top + r.y - n.clientTop : i.left + r.x - n.clientLeft
                }(E, r.ort)) / h();
                return r.dir ? 100 - t : t
            }

            function v(e, t, i, n) {
                var r = i.slice(),
                    o = [!e, e],
                    a = [e, !e];
                n = n.slice(), e && n.reverse(), n.length > 1 ? n.forEach(function(e, i) {
                    var n = T(r, e, r[e] + t, o[i], a[i]);
                    !1 === n ? t = 0 : (t = n - r[e], r[e] = n)
                }) : o = a = [!0];
                var s = !1;
                n.forEach(function(e, n) {
                    s = O(e, i[e] + t, o[n], a[n]) || s
                }), s && n.forEach(function(e) {
                    b("update", e), b("slide", e)
                })
            }

            function b(e, t, i) {
                Object.keys(W).forEach(function(n) {
                    var o = n.split(".")[0];
                    e === o && W[n].forEach(function(e) {
                        e.call(V, z.map(r.format.to), t, z.slice(), i || !1, N.slice())
                    })
                })
            }

            function y(e, t) {
                "mouseout" === e.type && "HTML" === e.target.nodeName && null === e.relatedTarget && w(e, t)
            }

            function S(e, t) {
                if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === e.buttons && 0 !== t.buttonsProperty) return w(e, t);
                var i = (r.dir ? -1 : 1) * (e.calcPoint - t.startCalcPoint);
                v(i > 0, 100 * i / t.baseSize, t.locations, t.handleNumbers)
            }

            function w(e, t) {
                var i = E.querySelector("." + r.cssClasses.active);
                null !== i && a(i, r.cssClasses.active), e.cursor && (document.body.style.cursor = "", document.body.removeEventListener("selectstart", document.body.noUiListener)), document.documentElement.noUiListeners.forEach(function(e) {
                    document.documentElement.removeEventListener(e[0], e[1])
                }), a(H, r.cssClasses.drag), F(), t.handleNumbers.forEach(function(e) {
                    b("set", e), b("change", e), b("end", e)
                })
            }

            function C(e, t) {
                if (1 === t.handleNumbers.length) {
                    var i = I[t.handleNumbers[0]];
                    if (i.hasAttribute("disabled")) return !1;
                    o(i.children[0], r.cssClasses.active)
                }
                e.preventDefault(), e.stopPropagation();
                var n = g(D.move, document.documentElement, S, {
                        startCalcPoint: e.calcPoint,
                        baseSize: h(),
                        pageOffset: e.pageOffset,
                        handleNumbers: t.handleNumbers,
                        buttonsProperty: e.buttons,
                        locations: N.slice()
                    }),
                    a = g(D.end, document.documentElement, w, {
                        handleNumbers: t.handleNumbers
                    }),
                    s = g("mouseout", document.documentElement, y, {
                        handleNumbers: t.handleNumbers
                    });
                if (document.documentElement.noUiListeners = n.concat(a, s), e.cursor) {
                    document.body.style.cursor = getComputedStyle(e.target).cursor, I.length > 1 && o(H, r.cssClasses.drag);
                    var l = function() {
                        return !1
                    };
                    document.body.noUiListener = l, document.body.addEventListener("selectstart", l, !1)
                }
                t.handleNumbers.forEach(function(e) {
                    b("start", e)
                })
            }

            function x(e) {
                e.stopPropagation();
                var t = m(e.calcPoint),
                    n = function(e) {
                        var t = 100,
                            i = !1;
                        return I.forEach(function(n, r) {
                            if (!n.hasAttribute("disabled")) {
                                var o = Math.abs(N[r] - e);
                                o < t && (i = r, t = o)
                            }
                        }), i
                    }(t);
                return !1 !== n && (r.events.snap || i(H, r.cssClasses.tap, r.animationDuration), O(n, t, !0, !0), F(), b("slide", n, !0), b("set", n, !0), b("change", n, !0), b("update", n, !0), void(r.events.snap && C(e, {
                    handleNumbers: [n]
                })))
            }

            function j(e) {
                var t = m(e.calcPoint),
                    i = q.getStep(t),
                    n = q.fromStepping(i);
                Object.keys(W).forEach(function(e) {
                    "hover" === e.split(".")[0] && W[e].forEach(function(e) {
                        e.call(V, n)
                    })
                })
            }

            function T(e, t, i, n, o) {
                return I.length > 1 && (n && t > 0 && (i = Math.max(i, e[t - 1] + r.margin)), o && t < I.length - 1 && (i = Math.min(i, e[t + 1] - r.margin))), I.length > 1 && r.limit && (n && t > 0 && (i = Math.min(i, e[t - 1] + r.limit)), o && t < I.length - 1 && (i = Math.max(i, e[t + 1] - r.limit))), (i = function(e) {
                    return Math.max(Math.min(e, 100), 0)
                }(i = q.getStep(i))) !== e[t] && i
            }

            function P(e) {
                return e + "%"
            }

            function F() {
                R.forEach(function(e) {
                    var t = N[e] > 50 ? -1 : 1,
                        i = 3 + (I.length + t * e);
                    I[e].childNodes[0].style.zIndex = i
                })
            }

            function O(e, t, i, n) {
                return !1 !== (t = T(N, e, t, i, n)) && (function(e, t) {
                    N[e] = t, z[e] = q.fromStepping(t);
                    var i = function() {
                        I[e].style[r.style] = P(t), k(e), k(e + 1)
                    };
                    window.requestAnimationFrame && r.useRequestAnimationFrame ? window.requestAnimationFrame(i) : i()
                }(e, t), !0)
            }

            function k(e) {
                if (A[e]) {
                    var t = 0,
                        i = 100;
                    0 !== e && (t = N[e - 1]), e !== A.length - 1 && (i = N[e]), A[e].style[r.style] = P(t), A[e].style[r.styleOposite] = P(100 - i)
                }
            }

            function _(e, t) {
                null !== e && !1 !== e && ("number" == typeof e && (e = String(e)), !1 === (e = r.format.from(e)) || isNaN(e) || O(t, q.toStepping(e), !1, !1))
            }

            function B(e, t) {
                var o = n(e),
                    a = void 0 === N[0];
                t = void 0 === t || !!t, o.forEach(_), r.animate && !a && i(H, r.cssClasses.tap, r.animationDuration), R.forEach(function(e) {
                    O(e, N[e], !0, !1)
                }), F(), R.forEach(function(e) {
                    b("update", e), null !== o[e] && t && b("set", e)
                })
            }

            function L() {
                var e = z.map(r.format.to);
                return 1 === e.length ? e[0] : e
            }

            function M(e, t) {
                W[e] = W[e] || [], W[e].push(t), "update" === e.split(".")[0] && I.forEach(function(e, t) {
                    b("update", t)
                })
            }
            var E, I, A, V, D = window.navigator.pointerEnabled ? {
                    start: "pointerdown",
                    move: "pointermove",
                    end: "pointerup"
                } : window.navigator.msPointerEnabled ? {
                    start: "MSPointerDown",
                    move: "MSPointerMove",
                    end: "MSPointerUp"
                } : {
                    start: "mousedown touchstart",
                    move: "mousemove touchmove",
                    end: "mouseup touchend"
                },
                H = t,
                N = [],
                R = [],
                q = r.spectrum,
                z = [],
                W = {};
            if (H.noUiSlider) throw new Error("Slider was already initialized.");
            return function(t) {
                    o(t, r.cssClasses.target), 0 === r.dir ? o(t, r.cssClasses.ltr) : o(t, r.cssClasses.rtl), 0 === r.ort ? o(t, r.cssClasses.horizontal) : o(t, r.cssClasses.vertical), E = e(t, r.cssClasses.base)
                }(H),
                function(e, t) {
                    I = [], (A = []).push(u(t, e[0]));
                    for (var i = 0; i < r.handles; i++) I.push(c(t, i)), R[i] = i, A.push(u(t, e[i + 1]))
                }(r.connect, E), V = {
                    destroy: function() {
                        for (var e in r.cssClasses) r.cssClasses.hasOwnProperty(e) && a(H, r.cssClasses[e]);
                        for (; H.firstChild;) H.removeChild(H.firstChild);
                        delete H.noUiSlider
                    },
                    steps: function() {
                        return N.map(function(e, t) {
                            var i = q.getNearbySteps(e),
                                n = z[t],
                                r = i.thisStep.step,
                                o = null;
                            !1 !== r && n + r > i.stepAfter.startValue && (r = i.stepAfter.startValue - n), o = n > i.thisStep.startValue ? i.thisStep.step : !1 !== i.stepBefore.step && n - i.stepBefore.highestStep, 100 === e ? r = null : 0 === e && (o = null);
                            var a = q.countStepDecimals();
                            return null !== r && !1 !== r && (r = Number(r.toFixed(a))), null !== o && !1 !== o && (o = Number(o.toFixed(a))), [o, r]
                        })
                    },
                    on: M,
                    off: function(e) {
                        var t = e && e.split(".")[0],
                            i = t && e.substring(t.length);
                        Object.keys(W).forEach(function(e) {
                            var n = e.split(".")[0],
                                r = e.substring(n.length);
                            t && t !== n || i && i !== r || delete W[e]
                        })
                    },
                    get: L,
                    set: B,
                    reset: function(e) {
                        B(r.start, e)
                    },
                    __moveHandles: function(e, t, i) {
                        v(e, t, N, i)
                    },
                    options: l,
                    updateOptions: function(e, t) {
                        var i = L(),
                            n = ["margin", "limit", "range", "animate", "snap", "step", "format"];
                        n.forEach(function(t) {
                            void 0 !== e[t] && (l[t] = e[t])
                        });
                        var o = Q(l);
                        n.forEach(function(t) {
                            void 0 !== e[t] && (r[t] = o[t])
                        }), o.spectrum.direction = q.direction, q = o.spectrum, r.margin = o.margin, r.limit = o.limit, N = [], B(e.start || i, t)
                    },
                    target: H,
                    pips: f
                },
                function(e) {
                    e.fixed || I.forEach(function(e, t) {
                        g(D.start, e.children[0], C, {
                            handleNumbers: [t]
                        })
                    }), e.tap && g(D.start, E, x, {}), e.hover && g(D.move, E, j, {
                        hover: !0
                    }), e.drag && A.forEach(function(t, i) {
                        if (!1 !== t && 0 !== i && i !== A.length - 1) {
                            var n = I[i - 1],
                                a = I[i],
                                s = [t];
                            o(t, r.cssClasses.draggable), e.fixed && (s.push(n.children[0]), s.push(a.children[0])), s.forEach(function(e) {
                                g(D.start, e, C, {
                                    handles: [n, a],
                                    handleNumbers: [i - 1, i]
                                })
                            })
                        }
                    })
                }(r.events), B(r.start), r.pips && f(r.pips), r.tooltips && function() {
                    var e = I.map(p);
                    M("update", function(t, i, n) {
                        if (e[i]) {
                            var o = t[i];
                            !0 !== r.tooltips[i] && (o = r.tooltips[i].to(n[i])), e[i].innerHTML = o
                        }
                    })
                }(), V
        }
        g.prototype.getMargin = function(e) {
            var t = this.xNumSteps[0];
            if (t && e % t) throw new Error("noUiSlider: 'limit' and 'margin' must be divisible by step.");
            return 2 === this.xPct.length && c(this.xVal, e)
        }, g.prototype.toStepping = function(e) {
            return p(this.xVal, this.xPct, e)
        }, g.prototype.fromStepping = function(e) {
            return function(e, t, i) {
                if (i >= 100) return e.slice(-1)[0];
                var n, r = u(i, t);
                return function(e, t) {
                    return t * (e[1] - e[0]) / 100 + e[0]
                }([e[r - 1], e[r]], (i - (n = t[r - 1])) * l(n, t[r]))
            }(this.xVal, this.xPct, e)
        }, g.prototype.getStep = function(e) {
            return d(this.xPct, this.xSteps, this.snap, e)
        }, g.prototype.getNearbySteps = function(e) {
            var t = u(e, this.xPct);
            return {
                stepBefore: {
                    startValue: this.xVal[t - 2],
                    step: this.xNumSteps[t - 2],
                    highestStep: this.xHighestCompleteStep[t - 2]
                },
                thisStep: {
                    startValue: this.xVal[t - 1],
                    step: this.xNumSteps[t - 1],
                    highestStep: this.xHighestCompleteStep[t - 1]
                },
                stepAfter: {
                    startValue: this.xVal[t - 0],
                    step: this.xNumSteps[t - 0],
                    highestStep: this.xHighestCompleteStep[t - 0]
                }
            }
        }, g.prototype.countStepDecimals = function() {
            var e = this.xNumSteps.map(r);
            return Math.max.apply(null, e)
        }, g.prototype.convert = function(e) {
            return this.getStep(this.toStepping(e))
        };
        var E = {
            to: function(e) {
                return void 0 !== e && e.toFixed(2)
            },
            from: Number
        };
        return {
            create: function(e, t) {
                if (!e.nodeName) throw new Error("noUiSlider.create requires a single element.");
                var i = M(e, Q(t), t);
                return e.noUiSlider = i, i
            }
        }
    }),
    function() {
        "use strict";

        function e(e) {
            return e.split("").reverse().join("")
        }

        function t(e, t) {
            return e.substring(0, t.length) === t
        }

        function i(e, t, i) {
            if ((e[t] || e[i]) && e[t] === e[i]) throw new Error(t)
        }

        function n(e) {
            return "number" == typeof e && isFinite(e)
        }

        function r(t, i, r, o, a, s, l, c, u, p, d, f) {
            var h, g, m, v = f,
                b = "",
                y = "";
            return s && (f = s(f)), !!n(f) && (!1 !== t && 0 === parseFloat(f.toFixed(t)) && (f = 0), f < 0 && (h = !0, f = Math.abs(f)), !1 !== t && (f = function(e, t) {
                var i = Math.pow(10, t);
                return (Math.round(e * i) / i).toFixed(t)
            }(f, t)), -1 !== (f = f.toString()).indexOf(".") ? (m = (g = f.split("."))[0], r && (b = r + g[1])) : m = f, i && (m = e(m).match(/.{1,3}/g), m = e(m.join(e(i)))), h && c && (y += c), o && (y += o), h && u && (y += u), y += m, y += b, a && (y += a), p && (y = p(y, v)), y)
        }

        function o(e, i, r, o, a, s, l, c, u, p, d, f) {
            var h, g = "";
            return d && (f = d(f)), !(!f || "string" != typeof f) && (c && t(f, c) && (f = f.replace(c, ""), h = !0), o && t(f, o) && (f = f.replace(o, "")), u && t(f, u) && (f = f.replace(u, ""), h = !0), a && function(e, t) {
                return e.slice(-1 * t.length) === t
            }(f, a) && (f = f.slice(0, -1 * a.length)), i && (f = f.split(i).join("")), r && (f = f.replace(r, ".")), h && (g += "-"), "" !== (g = (g += f).replace(/[^0-9\.\-.]/g, "")) && (g = Number(g), l && (g = l(g)), !!n(g) && g))
        }

        function a(e, t, i) {
            var n, r = [];
            for (n = 0; n < s.length; n += 1) r.push(e[s[n]]);
            return r.push(i), t.apply("", r)
        }
        var s = ["decimals", "thousand", "mark", "prefix", "postfix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
        window.wNumb = function e(t) {
            if (!(this instanceof e)) return new e(t);
            "object" == typeof t && (t = function(e) {
                var t, n, r, o = {};
                for (t = 0; t < s.length; t += 1)
                    if (void 0 === (r = e[n = s[t]])) "negative" !== n || o.negativeBefore ? "mark" === n && "." !== o.thousand ? o[n] = "." : o[n] = !1 : o[n] = "-";
                    else if ("decimals" === n) {
                    if (!(r >= 0 && r < 8)) throw new Error(n);
                    o[n] = r
                } else if ("encoder" === n || "decoder" === n || "edit" === n || "undo" === n) {
                    if ("function" != typeof r) throw new Error(n);
                    o[n] = r
                } else {
                    if ("string" != typeof r) throw new Error(n);
                    o[n] = r
                }
                return i(o, "mark", "thousand"), i(o, "prefix", "negative"), i(o, "prefix", "negativeBefore"), o
            }(t), this.to = function(e) {
                return a(t, r, e)
            }, this.from = function(e) {
                return a(t, o, e)
            })
        }
    }();
var jQ = jQuery.noConflict(!0),
    BCSfFilter = function() {
        this.version = "v2", this.prefix = "pf", this.queryParams = {}, this.internalClick = !1, this.selectFilter = !1, this.imutableFilterTree = ["page", "sort", "limit", "display", "_"], this.hasFilterOptionParam = !1, this.scrollData = [], this.shopName = "", this.shopDomain = "", this.fileUrl = "", this.defaultCurrency = "", this.moneyFormat = "", this.collectionId = "", this.collectionTags = "", this.currentTags = "", this.defaultSorting = "", this.swatchExtension = "", this.productAvailable = !0, this.variantAvailable = !0, this.loadProductFirst = !1, this.searchTermKey = "q", this.suggestionCache = {}, this.currentTerm = "", this.class = {
            filterOption: "bc-sf-filter-option-block", filterBlockTitle: "bc-sf-filter-block-title", filterBlockContent: "bc-sf-filter-block-content", selectFilterOptionButton: "bc-sf-filter-select-button", filterOptionItem: "bc-sf-filter-option-item", filterOptionLabel: "bc-sf-filter-option-label", filterOptionRange: "bc-sf-filter-option-range", filterRefineWrapper: "bc-sf-filter-selection-wrapper", filterSelectedItems: "bc-sf-filter-selected-items", filterSelectedItemsMobile: "bc-sf-filter-selected-items-mobile", filterOptionHidden: "bc-sf-filter-option-hidden", filterOptionOpenList: "bc-sf-filter-option-open-list", filterOptionCloseList: "bc-sf-filter-option-close-list", filterOptionMultipleList: "bc-sf-filter-option-multiple-list", filterOptionViewMore: "bc-sf-filter-option-view-more", filterOptionViewLess: "bc-sf-filter-option-view-less", filterOptionViewMoreList: "bc-sf-filter-view-more-list", clearButton: "bc-sf-filter-clear", clearAllButton: "bc-sf-filter-clear-all", collectionHeader: "bc-sf-filter-collection-header", collectionDescription: "bc-sf-filter-collection-description", filterOptionTooltip: "bc-sf-filter-option-tooltip", searchBox: "bc-sf-search-box", searchResultHeader: "bc-sf-search-result-header", searchResultNumber: "bc-sf-search-result-number", searchSuggestion: "bc-sf-search-suggestion", searchSuggestionWrapper: "bc-sf-search-suggestion-wrapper", searchSuggestionHeader: "bc-sf-search-suggestion-header", searchSuggestionItem: "bc-sf-search-suggestion-item", searchSuggestionMobile: "bc-sf-search-suggestion-mobile", searchSuggestionLoading: "bc-sf-search-suggestion-loading", searchSuggestionMobileOpen: "bc-sf-search-suggestion-mobile-open", mobileButtonOpen: "bc-sf-filter-tree-mobile-button-open", mobileDetectiOS: "bc-sf-filter-mobile-detect-ios"
        }, this.selector = {
            filterWrapper: "#bc-sf-filter-wrapper",
            filterTree: "#bc-sf-filter-tree",
            filterTreeHorizontal: "#bc-sf-filter-tree-h",
            filterTreeMobile: "#bc-sf-filter-tree-mobile",
            filterTreeMobileButton: "#bc-sf-filter-tree-mobile-button",
            filterOptionOpenValue: "bc-sf-filter-filter-option-open",
            filterOptionSubmitOpenValue: "bc-sf-filter-filter-option-s-open",
            products: "#bc-sf-filter-products",
            searchBoxMobile: "#bc-sf-search-box-mobile",
            topShowLimit: "#bc-sf-filter-top-show-limit",
            topSorting: "#bc-sf-filter-top-sorting",
            topDisplayType: "#bc-sf-filter-top-display-type",
            pagination: "#bc-sf-filter-bottom-pagination,#bc-sf-filter-top-pagination",
            bottomPagination: "#bc-sf-filter-bottom-pagination",
            loadMore: "#bc-sf-filter-load-more",
            loadMoreButtonContainer: "#bc-sf-filter-load-more-button-container",
            btnLoadPreviousPageWrapperSelector: "#bc-sf-filter-btn-load-previous-page-wrapper",
            btnLoadPreviousPageSelector: "#bc-sf-filter-btn-load-previous-page",
            loadMoreLoading: "#bc-sf-filter-load-more-loading",
            topNotification: "#bc-sf-filter-top-notification",
            breadcrumb: "#bc-sf-filter-breadcrumb",
            scrollToTop: "#bc-sf-filter-scroll-to-top"
        }, this.template = {
            filterOptionWrapper: '<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}}" data-block-id="{{blockId}}"><div class="{{class.filterBlockTitle}}"><h3><span>{{blockTitle}}</span></h3>{{tooltip}}{{clearButton}}</div><div class="{{class.filterBlockContent}}">{{blockContent}}</div></div>',
            filterOptionHorizontalWrapper: '<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}}" data-block-id="{{blockId}}"><div class="{{class.filterBlockTitle}}" id={{blockTitleId}}><a tabindex="0" role="button" aria-controls="{{blockContentId}}" aria-expanded="false" href="javascript:;"><span>{{blockTitle}}{{tooltip}}</span><div></div></a></div><div class="{{class.filterBlockContent}}" id={{blockContentId}}><div class="{{class.filterBlockContent}}-inner">{{blockContent}}</div>{{btnApply}}{{clearButton}}</div></div>',
            filterOptionLabel: '<span></span><span class="bc-sf-filter-option-value">{{itemValue}}</span><span class="bc-sf-filter-option-amount">{{itemAmount}}</span>',
            filterOptionSingleList: '<ul class="bc-sf-filter-option-single-list">{{itemList}}</ul>',
            filterOptionSingleListItem: '<li><a href="{{itemLink}}" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}">{{itemLabel}}</a></li>',
            filterOptionMultipleList: '<ul class="bc-sf-filter-option-multiple-list">{{itemList}}</ul>',
            filterOptionMultipleListItem: '<li><a href="javascript:;" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}">{{itemLabel}}</a></li>',
            filterOptionBox: '<ul class="bc-sf-filter-option-box">{{itemList}}</ul>',
            filterOptionBoxItem: '<li><a  href="javascript:;" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}">{{itemLabel}}</a></li>',
            filterOptionRange: '<div><div class="bc-sf-filter-option-range-amount" id="{{rangeAmountId}}"><input class="bc-sf-filter-option-range-amount-min" aria-label="Min Price" type="text" /><div class="bc-sf-filter-option-range-amount-split"> - </div><input class="bc-sf-filter-option-range-amount-max" aria-label="Max Price" type="text" /></div><div class="bc-sf-filter-option-range-slider {{itemSelected}}" id="{{rangeSliderId}}" data-id="{{itemParentId}}" data-value="{{itemValue}}" data-parent-label="{{itemParentLabel}}"></div></div>',
            filterOptionRange2: '<div><div class="bc-sf-filter-option-range-amount" id="{{rangeAmountId}}">{{itemLabel}}</div><div class="bc-sf-filter-option-range-slider {{itemSelected}}" id="{{rangeSliderId}}" data-id="{{itemParentId}}" data-value="{{itemValue}}" data-parent-label="{{itemParentLabel}}"></div></div>',
            filterOptionAdvancedRange: '<div><div class="bc-sf-filter-option-range-slider bc-sf-filter-option-advanced-range-slider {{itemSelected}}" id="{{rangeSliderId}}" data-id="{{itemParentId}}" data-value="{{itemValue}}" data-parent-label="{{itemParentLabel}}"></div></div>',
            filterOptionRangeLabel: "<span>{{minValue}}</span> <span>-</span> <span>{{maxValue}}</span>",
            filterOptionSwatch: '<ul class="bc-sf-filter-option-swatch {{swatchStyle}}">{{itemList}}</ul>',
            filterOptionSwatchItem: '<li><a href="javascript:;" title="{{itemTitle}}" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{itemSelected}}" title="{{itemTitle}}"><span class="bc-sf-filter-option-swatch-image" style="background-color: {{itemValue}}; background-image: url({{itemImageValue}}); border: {{itemBorder}}"></span>{{itemLabel}}</a></li>',
            filterOptionSwatchHorizontalItem: '<li><a href="javascript:;" title="{{itemTitle}}" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}"><span style="background-color: {{itemValue}}; background-image: url({{itemImageValue}}); border: {{itemBorder}}"></span></a><span data-id="{{itemParentId}}" data-value="{{itemValue}}" data-parent-label="{{itemParentLabel}}" title="{{itemTitle}}" onClick="{{itemFunc}}" class="{{itemSelected}}">{{itemLabel}}</span></li>',
            filterOptionRating: '<ul class="bc-sf-filter-option-rating {{itemMultipleSelect}}">{{itemList}}</ul>',
            filterOptionRatingItem: '<li><a href="{{itemLink}}" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}">{{itemLabel}}</span></a></li>',
            filterOptionRatingStar: "{{itemStars}}<span>{{label.ratingUp}}</span>",
            filterOptionRatingIconStar: '<i style="color: {{ratingStartColor}};" class="bc-sf-filter-icon-star">&#xe801;</i>',
            filterOptionRatingIconStarActive: '<i style="color: {{ratingStartColor}};" class="bc-sf-filter-icon-star bc-sf-filter-icon-star-active ">&#xe800;</i>',
            filterRefineWrapper: '<div class="{{class.filterRefineWrapper}}"><div class="{{class.filterBlockTitle}}"><h3><span>{{label}}</span></h3></div><div class="{{class.filterSelectedItems}}">{{selectedItems}}</div></div>',
            filterRefineItem: '<div class="selected-item {{class.filterOptionLabel}}"><a href="{{itemLink}}"><span class="selected-type"><span>{{itemType}}</span>: <strong>{{itemLabel}}</strong></span><span class="{{class.clearButton}}"></span></a></div>',
            filterRefineHorizontalWrapper: '<div class="bc-sf-filter-pc {{class.filterRefineWrapper}}"><span>{{label}}</span><div class="{{class.filterSelectedItems}}">{{selectedItems}}</div></div>',
            filterRefineHorizontalItem: '<div class="selected-item"><a href="{{itemLink}}"><span class="{{class.filterOptionLabel}} selected-type">{{itemLabel}}</span><span class="{{class.clearButton}}"></span></a></div>',
            filterTreeMobileButton: '<button id="bc-sf-filter-tree-mobile-button" type="button">{{label}}</button>',
            filterOptionViewMore: '<div class="bc-sf-filter-option-view-more"><a href="javascript:;" aria-label="{{label.viewMore}}" onclick="viewMoreFilterOption(this)">{{label.viewMore}}</a></div>',
            filterOptionViewLess: '<div class="bc-sf-filter-option-view-less"><a href="javascript:;" aria-label="{{label.viewLess}}" onclick="viewLessFilterOption(this)">{{label.viewLess}}</a></div>',
            clearAllButton: '<a href="javascript:;" aria-label="{{label.clearAll}}" class="{{class.clearAllButton}}" onClick="clearAllFilterOptions(event)">{{label.clearAll}}</a>',
            loadMoreButton: '<div id="bc-sf-filter-load-more-total"></div><div id="bc-sf-filter-load-more-button-container"><a href="javascript:;" aria-label="{{label.loadMore}}" class="bc-sf-filter-load-more-button">{{label.loadMore}}</a></div>',
            btnLoadPreviousPageTemplate: '<div id="bc-sf-filter-btn-load-previous-page"><a href="javascript:void(0)" aria-label="{{label.loadPreviousPage}}" class="js-bc-sf-filter-btn-load-previous-page">{{label.loadPreviousPage}}</a></div>',
            loadMoreLoading: '<div id="bc-sf-filter-load-more-loading">{{loadingIcon}}</div>',
            loading: '<div id="bc-sf-filter-loading"></div>',
            error: '<div id="bc-sf-filter-error">{{content}}<div class="btn-wrapper"><button>Close</button></div></div>',
            noResult: '<div id="bc-sf-filter-message"><p><em>{{content}}</em></p></div>',
            scrollToTop: '<a href="javascript:;" aria-label="Back to top" id="bc-sf-filter-scroll-to-top"><span>Back to top</span></a>',
            skeletonProduct: '<div class="{{wrapClass}} bc-sf-filter-product-skeleton"><div class="bc-sf-filter-skeleton-image" style="padding-top: {{paddingTop}}%"></div><div class="bc-sf-filter-skeleton-meta"><span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton"></span><span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton-width1"></span></div></div>',
            skeletonSpan: '<span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton-width{{skeletonWidth}}"></span>'
        }, this.defaultSettings = {
            general: {
                filterPrefixParam: "pf_",
                limit: 16,
                showSingleOption: !0,
                activeFilterScrollbar: !0,
                activeFilterScrollbarPC: !0,
                showMoreType: "",
                activeScrollToTop: !1,
                styleScrollToTop: "style1",
                showLoading: !1,
                showLoadMoreLoading: !0,
                showMobileLoading: !1,
                positionShowInfiniteLoading: 700,
                showRefineBy: !0,
                showOutOfStockOption: !1,
                showFilterOptionCount: !0,
                capitalizeFilterOptionValues: !0,
                forceCapitalizeFilterOptionValues: !1,
                capitalizeFirstLetterFilterOptionValues: !1,
                collapseOnMobileByDefault: !1,
                refineByHorizontalPosition: "bottom",
                keepScrollState: !0,
                keepToggleState: !1,
                rangeStyle: "style1",
                decimalPriceRange: 0,
                removePriceDecimal: !1,
                decimalDelimiter: ".",
                roundPriceSlider: !1,
                oneValueRangeSlider: !1,
                advancedRangeSliders: [],
                shortenPipsRange: !1,
                formatPipsRange: [{
                    node: 1e3,
                    symbol: "K",
                    fix: 0,
                    suffix: !1
                }, {
                    node: 1e6,
                    symbol: "M",
                    fix: 3,
                    suffix: !1
                }],
                sortManualValues: !1,
                requestInstantly: !1,
                showUnavailableSelection: !1,
                changeMobileButtonLabel: !1,
                vendorParam: "pf_v_vendor",
                typeParam: "pf_pt_product_type",
                priceMode: "",
                tagMode: "",
                breakpointMobile: "767",
                startViewMore: {
                    list: 5,
                    box: 6,
                    swatch: 7
                },
                startViewMoreH: {
                    list: 15,
                    box: 30,
                    swatch: 15
                },
                imageExtension: ["jpg", "JPG", "png", "PNG", "jpeg", "JPEG", "gif", "GIF"],
                colorOptionsArr: [],
                swatchStyle: "",
                swatchImageVersion: "1111111",
                removePrefixFromSwatchFile: !0,
                scrollFirstLoadLength: {
                    list: 90,
                    box: 120,
                    swatch: 90
                },
                filterTreeMobileStyle: "",
                ratingSelectionStyle: "text",
                paginationType: "default",
                paginationTypeAdvanced: !0,
                activeLoadPreviousPage: !1,
                sessionStorageCurrentPreviousPage: "bcSfFilterCurrentPreviousPage",
                sessionStorageCurrentPage: "bcSfFilterCurrentPage",
                sessionStorageCurrentNextPage: "bcSfFilterCurrentNextPage",
                sessionStoragePreviousPageEvent: "bcSfFilterPreviousPageEvent",
                sortingList: ["relevance", "best-selling", "manual", "price-ascending", "price-descending", "title-ascending", "title-descending", "created-descending", "created-ascending"],
                customSortingList: "",
                extraSortingList: "",
                sortingAvailableFirst: !1,
                showLimitList: "4,8,12,16",
                defaultDisplay: "grid",
                selectionHorizontalPlace: "#bc-sf-filter-tree-h",
                enableFilterOptionBoxStyle: !0,
                filterOptionBoxCharWidth: 14,
                enableFilter: !0,
                enableSeo: !0,
                productAvailable: !1,
                variantAvailable: !1,
                availableAfterFiltering: !1,
                loadProductFirst: !1,
                enableKeepScrollbackPosition: !0,
                activeScrollToTop: !1,
                styleScrollToTop: "style1",
                showLoading: !1,
                showLoadMoreLoading: !0,
                showMobileLoading: !1,
                positionShowInfiniteLoading: 700,
                ratingStarItemColor: "#FFD117",
                showPlaceholderProductList: !1,
                placeholderImageRatio: 1.4,
                placeholderProductGridItemClass: "",
                placeholderProductPerRow: 0,
                loadProductFromLiquid: !1,
                loadProductFromLiquidType: "ajax",
                adParams: ["utm_", "sa=", "source=", "ust=", "usg=", "gclid="]
            },
            search: {
                enableSearch: !0,
                enableSuggestion: !0,
                suggestionBlocks: [{
                    type: "suggestions",
                    label: "Suggestions",
                    status: "active",
                    number: 3
                }, {
                    type: "collections",
                    label: "Collections",
                    status: "active",
                    number: 2
                }, {
                    type: "pages",
                    label: "Pages",
                    status: "active",
                    number: 2
                }, {
                    type: "products",
                    label: "Products",
                    status: "active",
                    number: 3
                }],
                suggestionDymLimit: 2,
                suggestionMinLength: 1,
                suggestionPosition: "",
                suggestionWidth: "auto",
                suggestionTypes: [],
                suggestionStyle: "",
                suggestionStyle2MainContainerSelector: "header:first",
                suggestionStyle2ReverseProductBlock: !1,
                suggestionStyle2ProductPerRow: 3,
                suggestionMobileStyle: "style1",
                showSuggestionLoading: !0,
                showSuggestionProductVendor: !0,
                showSuggestionProductPrice: !0,
                showSuggestionProductSalePrice: !0,
                showSuggestionProductImage: !0,
                showSuggestionProductSku: !1,
                showSearchBtnMobile: !1,
                enableDefaultResult: !0,
                enableFuzzy: !0,
                productAvailable: !1,
                removePriceDecimal: !1,
                highlightSuggestionResult: !0,
                openProductNewTab: !1,
                suggestionMode: "prod",
                termKey: "q",
                skipFields: [],
                reduceMinMatch: !1,
                fullMinMatch: !1,
                enablePlusCharacterSearch: !1,
                fontSizeSuggestionHeader: "",
                bgSuggestionHeader: "",
                colorSuggestionHeader: "",
                enableFixHeadTitle: !0
            },
            label: {}
        }, window.suggestionCallback = function() {}
    };
BCSfFilter.prototype.init = function() {
    this.initAppConfig(), this.initLabel(), this.initGlobalVariable(), this.initHistory(), this.initMobileDetect()
}, BCSfFilter.prototype.initFilter = function() {
    this.updateApiParams(!1), this.getFilterData("init")
}, BCSfFilter.prototype.initAppConfig = function() {
    var e = bcSfFilterConfig.shop,
        t = bcSfFilterConfig.general;
    this.shopName = e.name, this.shopDomain = e.domain, this.defaultCurrency = e.currency, this.moneyFormat = e.money_format, this.fileUrl = t.file_url, this.collectionId = t.collection_id, this.collectionTags = t.collection_tags, this.collectionCount = t.collection_count, this.currentTags = t.current_tags, this.defaultSorting = t.default_sort_by.trim(), this.swatchExtension = t.swatch_extension
}, BCSfFilter.prototype.initGlobalVariable = function() {
    this.productAvailable = this.getSettingValue("general.productAvailable"), this.variantAvailable = this.getSettingValue("general.variantAvailable"), this.getSettingValue("general.productAndVariantAvailable") && (this.productAvailable = !0, this.variantAvailable = !0), this.loadProductFirst = this.getSettingValue("general.loadProductFirst"), this.searchTermKey = this.getSettingValue("search.termKey"), this.mobileStyle = this.getSettingValue("general.filterTreeMobileStyle"), this.suggestionTypes = this.getSettingValue("search.suggestionTypes")
}, BCSfFilter.prototype.initLabel = function() {
    this.defaultSettings.label = {
        refine: this.getLabel("label", "refine", "Filters"),
        refineMobile: this.getLabel("label", "refine_mobile", "Refine By"),
        refineMobileCollapse: this.getLabel("label", "refine_mobile_collapse", "Hide Filter"),
        clear: this.getLabel("label", "clear", "Clear"),
        clearAll: this.getLabel("label", "clear_all", "Clear All"),
        apply: this.getLabel("label", "apply", "Apply"),
        close: this.getLabel("label", "close", "Close"),
        loadMore: this.getLabel("label", "load_more", "Load more {{ amountProduct }} Products"),
        loadMoreTotal: this.getLabel("label", "load_more_total", "{{ from }} - {{ to }} of {{ total }} Products"),
        loadPreviousPage: this.getLabel("label", "load_previous_page", "Load Previous Page"),
        collectionAll: "All",
        viewMore: "View More",
        viewLess: "View Less",
        under: "Under",
        above: "Above",
        ratingStar: "Star",
        ratingStars: "Stars",
        ratingUp: "& Up",
        showResult: "Show Results",
        showLimit: "Show",
        sorting: {
            "best-selling": this.getLabel("label", "sorting_best_selling", "Best Selling"),
            manual: this.getLabel("label", "sorting_featured", "Featured"),
            "price-ascending": this.getLabel("label", "sorting_price_ascending", "Lowest Price"),
            "price-descending": this.getLabel("label", "sorting_price_descending", "Highest Price"),
            "title-ascending": this.getLabel("label", "sorting_title_ascending", "Alphabetically, A-Z"),
            "title-descending": this.getLabel("label", "sorting_title_descending", "Alphabetically, Z-A"),
            "created-descending": this.getLabel("label", "sorting_date_descending", "Date, New to Old"),
            "created-ascending": this.getLabel("label", "sorting_date_ascending", "Date, Old to New"),
            "published-descending": this.getLabel("label", "sorting_date_descending", "Date, New to Old"),
            "published-ascending": this.getLabel("label", "sorting_date_ascending", "Date, Old to New"),
            "sale-descending": this.getLabel("label", "sorting_sale_descending", "% Off"),
            relevance: this.getLabel("label", "sorting_relevance", "Relevance")
        },
        search: {
            generalTitle: this.getLabel("label", "search_general_title", "Search"),
            resultHeader: this.getLabel("label", "search_result_header", 'Search Results for "{{ terms }}"'),
            resultEmpty: this.getLabel("label", "search_result_empty", "Your search for {{ terms }} didn't match any results"),
            resultNumber: this.getLabel("label", "search_result_number", 'Showing {{ count }} results for "{{ terms }}"')
        },
        suggestion: {
            placeholder: this.getLabel("label_suggestion", "suggestion_placeholder", "Search"),
            viewAll: this.getLabel("label_suggestion", "suggestion_view_all", '{{ count }} results for "{{ terms }}"'),
            popularHeader: this.getLabel("label_suggestion", "suggestion_popular_header", "Popular Suggestions"),
            productHeader: this.getLabel("label_suggestion", "suggestion_product_header", "Products"),
            didYouMeanHeader: this.getLabel("label_suggestion", "suggestion_did_you_mean_header", "Did you mean"),
            suggestQuery: this.getLabel("label_suggestion", "suggestion_suggest_query", "Showing results for {{ terms }}."),
            didYouMean: this.getLabel("label_suggestion", "suggestion_did_you_mean", "Did you mean: {{ terms }}?"),
            searchBoxPlaceholder: this.getLabel("label_suggestion", "suggestion_placeholder", "Search")
        },
        error: {
            noFilterResult: this.getLabel("label_error", "error_no_filter_result", "Sorry, no products matched your selection"),
            noSearchResult: this.getLabel("label_error", "error_no_search_result", "Sorry, no products matched the keyword"),
            noProducts: this.getLabel("label_error", "error_no_products", "No products found in this collection"),
            noSuggestionProducts: 'Sorry, nothing found."',
            noSuggestionResult: 'Sorry, nothing found for "{{ terms }}"'
        }
    }
}, BCSfFilter.prototype.initHistory = function() {
    var e = this;
    History.Adapter.bind(window, "statechange", function() {
        e.internalClick || (e.updateApiParams(!1), e.getFilterData("history")), e.internalClick = !1
    })
}, BCSfFilter.prototype.destroy = function() {
    bcsffilter = void 0
}, BCSfFilter.prototype.updateApiParams = function(e) {
    var t = this.getFilterParams(e);
    t = this.setDefaultParams(t), this.queryParams = t
}, BCSfFilter.prototype.getFilterParams = function(e) {
    var t = this,
        i = {},
        n = "";
    if (void 0 !== e && !1 !== e || (e = window.location.search), -1 != e.indexOf("?") && (n = e.split("?")[1]), void 0 !== n && "" != n && (n = t.removeAdParams(n)).length > 0) {
        var r, o = "",
            a = n.split("&"),
            s = a.length;
        for (r = 0; r < s; r++)
            if ((o = a[r].split("=")).length > 1) {
                var l = decodeURIComponent(o[0]),
                    c = decodeURIComponent(o[1].replace(/\+/g, "%20")); - 1 == c.indexOf("cache:") && (i.hasOwnProperty(l) ? i[l].push(c) : i[l] = t.findIndexArray(l, t.imutableFilterTree) > -1 || "q" == l || l.indexOf("_and_condition") > -1 || l.indexOf("_show_exact_rating") > -1 ? c : [c]), l.indexOf("pf_") > -1 && (t.hasFilterOptionParam = !0)
            }
    }
    return i
}, BCSfFilter.prototype.removeAdParams = function(e) {
    var t, i, n = (t = this.getSettingValue("general.adParams")).length;
    if (n > 0)
        for (i = 0; i < n; i++) {
            var r = new RegExp("[?|&]" + t[i] + "[^&]+&?", "g");
            e = e.replace(r, "").replace(/&$/, "").replace(/\?\s*$/, "")
        }
    return e
}, BCSfFilter.prototype.setDefaultParams = function(e) {
    e.shop = e.hasOwnProperty("shop") ? e.shop : this.shopDomain, e.page = e.hasOwnProperty("page") ? parseInt(e.page) : 1;
   var sortBy =this.defaultSorting;
   if (typeof e.sort_by !== 'undefined' && e.sort_by.length > 0) {
	   sortBy = e.sort_by[0] ;
	   }
    var t = this.getSettingValue("general.limit");
    return "default" == this.getSettingValue("general.paginationType") || this.getSettingValue("general.paginationTypeAdvanced") ? e.limit = e.hasOwnProperty("limit") ? e.limit : t : e.limit = (e.hasOwnProperty("limit") ? e.limit : t) * e.page, this.isSearchPage() && (this.defaultSorting = "relevance"), e.sort = sortBy, e.display = e.hasOwnProperty("display") ? e.display : this.getSettingValue("general.defaultDisplay"), this.setThirdPartyAppParams(e)
}, BCSfFilter.prototype.setThirdPartyAppParams = function(e) {
    return e = this.setShopifyMultiCurrencyParams(e), this.setShopifyMultiLanguageParams(e)
}, BCSfFilter.prototype.setShopifyMultiCurrencyParams = function(e) {
    if ("undefined" != typeof bcSfFilterConfig && void 0 !== bcSfFilterConfig.general.currencies && bcSfFilterConfig.general.currencies.length > 1) {
        var t = bcSfFilterConfig.general.current_currency.toLowerCase().trim();
        e.currency = t, "undefined" != typeof Shopify && void 0 !== Shopify.currency && void 0 !== Shopify.currency.rate && (e.currency_rate = Shopify.currency.rate)
    }
    return e
}, BCSfFilter.prototype.setShopifyMultiLanguageParams = function(e) {
    return "undefined" != typeof bcSfFilterConfig && bcSfFilterConfig.hasOwnProperty("general") && bcSfFilterConfig.general.hasOwnProperty("published_locales") && Object.keys(bcSfFilterConfig.general.published_locales).length > 1 && void 0 !== bcSfFilterConfig.general.current_locale && (e.locale = bcSfFilterConfig.general.current_locale), e
}, BCSfFilter.prototype.changeAddressBar = function(e, t, i) {
    var n = ("?" + e.split("?")[1]).substr(1).split("&");
    1 != n.length && !1 !== this.checkExistFilterOptionParam() || (e = n.length > 1 && !1 === this.checkExistFilterOptionParam() ? e.replace("&_=" + this.prefix, "") : e.replace("?_=" + this.prefix, ""));
    var r = document.title;
    void 0 === t || void 0 === i || "collection" != t || this.isSearchPage() || (r = this.textify(i) + " - " + this.shopName), History.pushState({
        param: this.queryParams
    }, r, e)
}, BCSfFilter.prototype.prepareRequestParams = function(e) {
    var t = mergeObject({}, this.queryParams);
    t = this.prepareFilterParams(t, e), t = this.prepareSearchParams(t, e), this.queryParams = t
}, BCSfFilter.prototype.prepareFilterParams = function(e, t) {
    if (this.queryParams.hasOwnProperty("collection_scope")) e.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams.collection_scope[0] : this.queryParams.collection_scope;
    else if (this.isSearchPage()) e.collection_scope = 0;
    else if (e.collection_scope = parseInt(this.collectionId), "history" == t) {
        var i = History.getState().data;
        i.hasOwnProperty("param") && i.param.hasOwnProperty("collection_scope") ? e.collection_scope = this.collectionId = parseInt(i.param.collection_scope) : e.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id)
    }
    return 1 == this.getSettingValue("general.availableAfterFiltering") ? (e.product_available = !0 === this.checkExistFilterOptionParam() || this.productAvailable, e.variant_available = !0 === this.checkExistFilterOptionParam() || this.variantAvailable) : (e.product_available = this.productAvailable, e.variant_available = this.variantAvailable), void 0 !== this.collectionTags && null !== this.collectionTags && (e.tag = this.collectionTags), this.getSettingValue("general.showOutOfStockOption") && (e.zero_options = !0), e.build_filter_tree = !(void 0 !== t && this.imutableFilterTree.indexOf(t) > -1), e.check_cache = !(!1 !== this.checkExistFilterOptionParam() || 1 != e.page || e.sort != this.defaultSorting || e.limit != this.getSettingValue("general.limit") || this.isSearchPage() || this.isVendorPage() || this.isTypePage()), "" != this.getSettingValue("general.priceMode") && (e.price_mode = this.getSettingValue("general.priceMode")), "" != this.getSettingValue("general.tagMode") && (e.tag_mode = this.getSettingValue("general.tagMode")), this.getSettingValue("general.sortingAvailableFirst") && (e.sort_first = "available"), this.isVendorPage() && e.hasOwnProperty("q") && (e[this.getSettingValue("general.vendorParam")] = [e.q], delete e.q), this.isTypePage() && e.hasOwnProperty("q") && (e[this.getSettingValue("general.typeParam")] = [e.q], delete e.q), e
}, BCSfFilter.prototype.prepareSearchParams = function(e, t) {
    if (this.isSearchPage()) {
        e.q = this.getSearchTerm(), "q" != this.searchTermKey && delete e[this.searchTermKey];
        var i = this.getSettingValue("search.enableFuzzy");
        !0 !== i && (e.fuzzy = i), !1 !== this.getSettingValue("search.reduceMinMatch") && (e.reduce_min_match = this.getSettingValue("search.reduceMinMatch")), this.getSettingValue("search.fullMinMatch") && (e.full_min_match = !0), this.getSettingValue("general.sortingAvailableFirst") && (e.sort_first = "available"), this.getSettingValue("search.enablePlusCharacterSearch") && (e.enable_plus_character_search = !0)
    }
    return e
}, BCSfFilter.prototype.beforeGetFilterData = function(e) {
    var t = this;
    this.getSettingValue("general.keepScrollState") && jQ("." + this.class.filterOption).each(function(e) {
        if (jQ(this).find(".jspScrollable").length > 0) {
            var i = jQ(this).find(".jspScrollable").eq(0).data("jsp"),
                n = jQ(this).data("block-id");
            if (t.scrollData = jQ.grep(t.scrollData, function(e) {
                    return e.id !== n
                }), void 0 !== i) {
                var r = jQ(this).data("keep-scroll-disabled") ? 0 : i.getContentPositionY();
                t.scrollData.push({
                    id: n,
                    position: r
                })
            }
        }
    })
}, BCSfFilter.prototype.getFilterData = function(e, t) {
    this.requestFilter(function(e, t) {
        var i = bcsffilter;
        t = void 0 !== t ? t : 0, i.showLoading(), i.buildPlaceholderProductList(e), i.beforeGetFilterData(e), i.prepareRequestParams(e), i.queryParams.callback = "BCSfFilterCallback", i.queryParams.event_type = "sort";
        var n = i.isSearchPage() ? i.getApiUrl("search") : i.getApiUrl("filter"),
            r = document.createElement("script");
        r.type = "text/javascript";
        var o, a = (new Date).getTime();
        r.src = n + "?t=" + a + "&" + jQ.param(i.queryParams), r.id = "bc-sf-filter-script", r.async = !0, r.addEventListener("error", function(n) {
            "function" == typeof document.getElementById(r.id).remove ? document.getElementById(r.id).remove() : document.getElementById(r.id).outerHTML = "", t < 2 ? (t++, o && clearTimeout(o), o = setTimeout(i.getFilterData("resend", t), 2e3)) : i.buildDefaultElements(e)
        }), document.getElementsByTagName("head")[0].appendChild(r), r.onload = function() {
            "function" == typeof document.getElementById(r.id).remove ? document.getElementById(r.id).remove() : document.getElementById(r.id).outerHTML = ""
        }
    }, e, t)
}, BCSfFilter.prototype.requestFilter = function(e, t, i) {
    e(t, i)
}, BCSfFilter.prototype.afterGetFilterData = function(e, t) {
    if (!this.pageOverFallback(e)) {
        if (this.hideLoading(), this.removePlaceholderForFilterTree(), ["infinite", "load_more"].indexOf(this.getSettingValue("general.paginationType")) > -1 && this.getSettingValue("general.showLoadMoreLoading") && !1 === this.getSettingValue("general.showLoading") && this.hideLoadMoreLoading(), "collection" == t) {
            var i = bcsffilter.class.filterOptionOpenList,
                n = bcsffilter.class.filterOptionCloseList;
            jQ("." + i).length > 0 && jQ("." + i).remove(), jQ("." + n).length > 0 && jQ("." + n).remove()
        }
        e.hasOwnProperty("errorMessage") || (this.catchError(e, t), this.buildAll(e, this.queryParams.build_filter_tree, t))
    }
}, BCSfFilter.prototype.buildAll = function(e, t, i) {
    var n = this.selector.pagination,
        r = e.total_product;
    if (!0 === t && e.hasOwnProperty("filter") && (this.buildFilterTree(e.filter.options), this.getSettingValue("general.showRefineBy") && this.buildFilterSelection(e), this.buildFilterTreeMobile(), this.buildFilterTreeMobileButton(e), this.buildAdditionalFilterEvent()), r > 0) {
        this.buildProductList(e.products, i), "default" == this.getSettingValue("general.paginationType") ? this.buildPagination(r) : (jQ(n).empty(), this.isLoadMorePaginationType() && (this.buildLoadMoreButton(r), this.buildLoadPreviousButton(r, i))), this.buildToolbar(), this.buildToolbarEvent(e), jQ(this.selector.filterWrapper).show();
        var o = this.selector.topNotification;
        jQ(o).length > 0 && jQ(o).empty()
    }
    jQ(this.selector.products).removeAttr("data-bc-sort"), jQ(n).show(), this.buildAdditionalElements(e, i), this.buildScrollToTop(), this.scrollBackPositionHistoryBack(), "collection" == i && this.buildPageInfo(e), this.isSearchPage() && (this.buildSEOTitle(e), this.buildSearchResultHeader(e), this.buildSearchResultNumber(e)), this.buildRobotsMetaTag(e), this.selectFilter = !1
}, BCSfFilter.prototype.prepareFilterOptionData = function(e) {
    return e
}, BCSfFilter.prototype.beforeBuildFilterTree = function(e) {
    return jQ(this.selector.filterTree).html(""), jQ(this.selector.filterTreeHorizontal).html(""), e = this.removeVendorOptionInVendorPage(e), e = this.removeProductTypeOptionInTypePage(e), this.prepareAdvancedRangeSlider(e)
}, BCSfFilter.prototype.removeVendorOptionInVendorPage = function(e) {
    var t = this,
        i = e.filter(function(e) {
            return e.filterOptionId == t.getSettingValue("general.vendorParam")
        });
    if (this.isVendorPage() && void 0 !== i[0]) {
        var n = this.findIndexArray(this.getSettingValue("general.vendorParam"), e, "filterOptionId");
        e.splice(n, 1)
    }
    return e
}, BCSfFilter.prototype.removeProductTypeOptionInTypePage = function(e) {
    var t = this,
        i = e.filter(function(e) {
            return e.filterOptionId == t.getSettingValue("general.typeParam")
        });
    if (this.isTypePage() && void 0 !== i[0]) {
        var n = this.findIndexArray(this.getSettingValue("general.typeParam"), e, "filterOptionId");
        e.splice(n, 1)
    }
    return e
}, BCSfFilter.prototype.buildFilterTree = function(e) {
    if (jQ(this.selector.filterTree).length > 0 && jQ(this.selector.filterTreeHorizontal).length > 0) {
        e = this.beforeBuildFilterTree(e);
        var t = this;
        jQ.each(e, function(e, i) {
            if ("active" == i.status) switch (i = t.prepareFilterOptionData(i), i.displayType) {
                case "list":
                    "single" == i.selectType ? t.buildFilterOptionSingleList(i) : t.buildFilterOptionMultipleList(i);
                    break;
                case "box":
                    t.buildFilterOptionBox(i);
                    break;
                case "range":
                    t.buildFilterOptionRange(i);
                    break;
                case "swatch":
                    t.buildFilterOptionSwatch(i);
                    break;
                case "rating":
                    t.buildFilterOptionRating(i)
            }
        }), this.afterBuildFilterTree(e), this.buildFilterTreeCallback(e)
    }
}, BCSfFilter.prototype.afterBuildFilterTree = function(e) {
    jQ(this.selector.filterTree).children().wrapAll('<div id="bc-sf-filter-options-wrapper"></div>'), this.buildFilterOptionBoxStyle(), this.triggerOpenHorizontalFilterEvent(), this.buildFilterShowMore(), this.checkIsFullWidthMobile() || this.collapseFilterOption()
}, BCSfFilter.prototype.buildFilterTreeCallback = function(e) {
    var t = this;
    jQ(window).on("resize", function() {
        t.isMobile() && t.isMobileDevice() || ("style2" != t.mobileStyle && "style3" != t.mobileStyle || (t.removeFilterTreeMobileStyle(), t.buildFilterShowMore()), closeFilterMobile())
    })
}, BCSfFilter.prototype.triggerOpenHorizontalFilterEvent = function(e) {
    if (0 == jQ("#" + this.selector.filterOptionOpenValue).length && jQ("body").append('<input type="hidden" id="' + this.selector.filterOptionOpenValue + '" />'), 0 == jQ("#" + this.selector.filterOptionSubmitOpenValue).length && jQ("body").append('<input type="hidden" id="' + this.selector.filterOptionSubmitOpenValue + '" />'), "" != jQ("#" + this.selector.filterOptionOpenValue).val() && jQ("#" + this.selector.filterOptionOpenValue).val() != jQ("#" + this.selector.filterOptionSubmitOpenValue).val()) {
        var t = jQ("#" + this.selector.filterOptionOpenValue).val();
        jQ("#" + t).stop().toggle(), 1 == jQ("#" + t).siblings().children().hasClass("selected") ? (jQ("#" + t).siblings().children().removeClass("selected"), jQ("#" + t).siblings().children().attr("aria-expanded", "false")) : (jQ("#" + t).siblings().children().addClass("selected"), jQ("#" + t).siblings().children().attr("aria-expanded", "true"));
        var i = jQ("#" + t).parent().data("block-id");
        this.setOpenPositionFilterOptionContent(i)
    }
}, BCSfFilter.prototype.addFilterTreeItem = function(e, t, i, n) {
    if (e = jQ.parseHTML(e), n != this.selector.filterTree && n != this.selector.filterTreeHorizontal && jQ(n).html(""), void 0 === n) n = "vertical" == i ? this.selector.filterTree : this.selector.filterTreeHorizontal;
    void 0 !== t && "before" == t ? jQ(n).prepend(e) : jQ(n).append(e)
}, BCSfFilter.prototype.buildFilterTreeClass = function(e, t) {
    var i = this.class;
    if (void 0 !== t) {
        if (i.hasOwnProperty(t)) {
            var n = new RegExp("{{class." + t + "}}", "g");
            e = e.replace(n, i[t])
        }
    } else
        for (var r in i) {
            n = new RegExp("{{class." + r + "}}", "g");
            e = e.replace(n, i[r])
        }
    return e
}, BCSfFilter.prototype.buildFilterOption = function(e, t, i) {
    var n = t.label,
        r = this.class.filterOption + "-" + this.slugify(n),
        o = "vertical" == i ? this.getTemplate("filterOptionWrapper") : this.getTemplate("filterOptionHorizontalWrapper");
    o = (o = (o = (o = (o = (o = (o = (o = o.replace(/{{blockTitle}}/g, n)).replace(/{{blockTitleId}}/g, this.class.filterBlockTitle + "-" + this.slugify(n))).replace(/{{blockTypeClass}}/g, this.class.filterOption + "-" + t.displayType)).replace(/{{blockId}}/g, r)).replace(/{{blockContent}}/g, e)).replace(/{{blockContentId}}/g, this.class.filterBlockContent + "-" + this.slugify(n))).replace(/{{btnApply}}/g, "collection" == t.filterType || "review_ratings" == t.filterType ? "" : '<button class="' + this.class.selectFilterOptionButton + '" data-id="' + r + '">' + this.getSettingValue("label.apply") + "</button>")).replace(/{{tooltip}}/g, this.buildFilterOptionTooltip(t));
    var a = "",
        s = "vertical" == i ? this.getSettingValue("label.clear") : this.getSettingValue("label.clearAll");
    if (this.queryParams.hasOwnProperty(t.filterOptionId) && this.queryParams[t.filterOptionId] && (a = '<a href="javascript:;" role="button" aria-label="' + this.getSettingValue("label.clear") + '" class="' + this.class.clearButton + '" onClick="clearFilterOption(event, this, \'' + t.filterOptionId + "')\">" + s + "</a>"), o = o.replace(/{{clearButton}}/g, a), "" !== (o = this.buildFilterTreeClass(o))) {
        var l = jQ(o);
        l.attr({
            "data-id": t.filterOptionId,
            "data-type": t.filterType,
            "data-display-type": t.displayType,
            "data-select-type": t.selectType,
            "data-title": n,
            "data-prefix": t.prefix
        });
        var c = !!t.hasOwnProperty("isCollapseMobile") && t.isCollapseMobile;
        this.getSettingValue("general.collapseOnMobileByDefault") && (c = !0), l.attr("data-collapse-mobile", c);
        var u = null;
        if (["list", "box", "swatch"].indexOf(t.displayType) > -1 && (u = "scrollbar"), t.hasOwnProperty("showMoreType") && t.showMoreType && (u = t.showMoreType), "" != this.getSettingValue("general.showMoreType") && ["list"].indexOf(t.displayType) > -1 && (u = this.getSettingValue("general.showMoreType")), u && l.attr({
                "data-show-more-type": u
            }), this.getSettingValue("general.requestInstantly") && l.find("." + this.class.selectFilterOptionButton).hide(), t.hasOwnProperty("useAndCondition") && t.useAndCondition && l.attr("data-and-condition", !0), t.hasOwnProperty("showExactRating") && t.showExactRating && l.attr("data-exact-rating", !0), l.attr("data-filter-option", JSON.stringify(t)), this.queryParams.hasOwnProperty(t.filterOptionId) && this.queryParams[t.filterOptionId] && (!i || "vertical" != i)) {
            var p = this.queryParams[t.filterOptionId].map(function(e) {
                return encodeURIParamValue(e)
            });
            l.attr("data-selected", JSON.stringify(p))
        }
        this.addFilterTreeItem(jQ(l)[0].outerHTML, "after", i), this.checkShowFilterOption(t) || jQ("." + r).addClass(this.class.filterOptionHidden)
    }
}, BCSfFilter.prototype.buildFilterOptionItem = function(e, t, i, n, r, o, a, s, l, c, u) {
    var p = !!c.hasOwnProperty("keepValuesStatic") && c.keepValuesStatic;
    if ("review_ratings" == n && "text" == this.getSettingValue("general.ratingSelectionStyle")) var d = this.getReviewRatingsLabel(l.from);
    else d = this.customizeFilterOptionLabel(t, c.prefix, n);
    if (!0 === p) var f = null;
    else f = l.hasOwnProperty("doc_count") ? l.doc_count : 0;
    if (e = (e = (e = (e = e.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(t, f, c))).replace(/{{itemLink}}/g, this.buildFilterOptionLink(r, i, n, a, s, p))).replace(/{{itemValue}}/g, encodeURIParamValue(i))).replace(/{{itemTitle}}/g, d), "vertical" == u || "both" == u || "single" == s) var h = "onInteractWithFilterOptionValue(event, this, '" + n + "', '" + a + "', '" + s + "', '" + p + "')";
    else if (this.getSettingValue("general.requestInstantly") || "collection" == n) h = "onInteractWithFilterOptionValue(event, this, '" + n + "', '" + a + "', '" + s + "', '" + p + "')";
    else h = "onSelectFilterOptionItem(event, this)";
    e = e.replace(/{{itemFunc}}/g, h), e = this.checkFilterOptionSelected(r, i, n, a) ? e.replace(/{{itemSelected}}/g, "selected") : e.replace(/{{itemSelected}}/g, "");
    var g = jQ(e);
    return g.children().attr({
        "data-id": r,
        "data-value": encodeURIParamValue(i),
        "data-parent-label": o,
        "data-title": d,
        "data-count": f
    }), g.find("a").length > 0 && g.find("a").attr("aria-label", o + " - " + d), "review_ratings" == n && "text" == this.getSettingValue("general.ratingSelectionStyle") && g.children().attr("aria-label", o + " - " + d), this.getSettingValue("general.enableSeo") && "collection" != n && g.children().attr("rel", "nofollow"), "collection" == n && g.children().attr("data-collection-scope", l.key), jQ(g)[0].outerHTML
}, BCSfFilter.prototype.buildFilterOptionSingleList = function(e) {
    e.hasOwnProperty("values") && ("all" == e.valueType || this.getSettingValue("general.sortManualValues") || "all" != e.valueType && e.sortManualValues) && (e.values = this.sortFilterOptionValue(e));
    var t = "",
        i = e.filterType,
        n = e.displayType,
        r = e.selectType,
        o = e.filterOptionId,
        a = e.label;
    if ("collection" == e.filterType && e.activeCollectionAll && -1 == this.findIndexArray("all", e.values, "handle")) {
        var s = {
            doc_count: null,
            handle: "all",
            key: 0,
            label: this.getSettingValue("label.collectionAll"),
            tags: null
        };
        e.values.unshift(s)
    }
    for (var l in e.values) t += this.buildFilterOptionSingleListData(i, o, a, n, r, e.values[l], e, "both");
    if ("" != t) {
        var c = this.getTemplate("filterOptionSingleList");
        c = c.replace(/{{itemList}}/g, t), this.buildFilterOption(c, e, "vertical"), this.buildFilterOption(c, e)
    }
}, BCSfFilter.prototype.buildFilterOptionSingleListData = function(e, t, i, n, r, o, a, s) {
    if (this.checkShowFilterOptionItem(o, a)) {
        var l = (!!a.hasOwnProperty("keepValuesStatic") && a.keepValuesStatic, o.key),
            c = o.key;
        "collection" == e && (l = o.label, c = o.handle + ":" + o.key);
        var u = this.getTemplate("filterOptionSingleListItem");
        return this.buildFilterOptionItem(u, l, c, e, t, i, n, r, o, a, s)
    }
    return ""
}, BCSfFilter.prototype.buildFilterOptionMultipleList = function(e) {
    e.hasOwnProperty("values") && ("all" == e.valueType || this.getSettingValue("general.sortManualValues") || "all" != e.valueType && e.sortManualValues) && (e.values = this.sortFilterOptionValue(e)), "percent_sale" == e.filterType && e.values.reverse();
    var t = horizontalContent = "",
        i = e.filterType,
        n = e.filterOptionId,
        r = e.label,
        o = e.displayType,
        a = e.selectType;
    for (var s in (e = this.scrollbarPrepareData(e, e.values)).firstBuild) t += this.buildFilterOptionMultipleListData(i, n, r, o, a, e.firstBuild[s], e, "vertical"), horizontalContent += this.buildFilterOptionMultipleListData(i, n, r, o, a, e.firstBuild[s], e, "horizontal");
    if ("" != t && "" != horizontalContent) {
        var l = this.getTemplate("filterOptionMultipleList"),
            c = l.replace(/{{itemList}}/g, t),
            u = l.replace(/{{itemList}}/g, horizontalContent);
        this.buildFilterOption(c, e, "vertical"), this.buildFilterOption(u, e)
    }
}, BCSfFilter.prototype.buildFilterOptionMultipleListData = function(e, t, i, n, r, o, a, s) {
    if (this.checkShowFilterOptionItem(o, a)) {
        var l = o.key,
            c = o.key;
        "price" == e || "percent_sale" == e ? (c = c.replace(/\*/g, "").replace(/\-/g, ":"), r = "multiple") : "stock" == e && (l = o.label, c = "in-stock" == o.key);
        var u = this.getTemplate("filterOptionMultipleListItem");
        return (u = this.buildFilterOptionItem(u, l, c, e, t, i, n, r, o, a, s)).replace(/\$/g, "&#36;")
    }
    return ""
}, BCSfFilter.prototype.buildFilterOptionBox = function(e) {
    e.hasOwnProperty("values") && ("all" == e.valueType || this.getSettingValue("general.sortManualValues") || "all" != e.valueType && e.sortManualValues) && (e.values = this.sortFilterOptionValue(e));
    var t = horizontalContent = "",
        i = e.filterType,
        n = e.displayType,
        r = e.selectType,
        o = e.filterOptionId,
        a = e.label;
    for (var s in (e = this.scrollbarPrepareData(e, e.values)).firstBuild) t += this.buildFilterOptionBoxData(i, o, a, n, r, e.firstBuild[s], e, "vertical"), horizontalContent += this.buildFilterOptionBoxData(i, o, a, n, r, e.firstBuild[s], e, "horizontal");
    if ("" != t && "" != horizontalContent) {
        var l = this.getTemplate("filterOptionBox"),
            c = l.replace(/{{itemList}}/g, t),
            u = l.replace(/{{itemList}}/g, horizontalContent);
        this.buildFilterOption(c, e, "vertical"), this.buildFilterOption(u, e)
    }
}, BCSfFilter.prototype.buildFilterOptionBoxData = function(e, t, i, n, r, o, a, s) {
    if (this.checkShowFilterOptionItem(o, a)) {
        var l = o.key,
            c = o.key,
            u = this.getTemplate("filterOptionBoxItem");
        return this.buildFilterOptionItem(u, l, c, e, t, i, n, r, o, a, s)
    }
    return ""
}, BCSfFilter.prototype.buildFilterOptionBoxStyle = function(e) {
    if (!0 === this.getSettingValue("general.enableFilterOptionBoxStyle")) {
        var t = void 0 !== e ? e.find(".bc-sf-filter-option-box") : jQ(this.selector.filterTree).find(".bc-sf-filter-option-box");
        if (t.length) {
            var i, n = t.length;
            for (i = 0; i < n; i++) {
                var r = t.eq(i);
                if (r.is(":visible") && r.children("li").length > 1) {
                    var o = r.parents("." + this.class.filterBlockContent).data("columns") || !1;
                    if (o) var a = 100 / o;
                    else {
                        var s = (r.parents("." + this.getClass("filterOption")).data("id"), r.parents("." + this.class.filterOption).data("filter-option") || !1),
                            l = (s.prefix || "").toString().replace(/\\/g, ""),
                            c = this.getSettingValue("general.filterOptionBoxCharWidth") || 14;
                        if (!s || 0 == s.values.length) continue;
                        for (var u = 4, p = 0; p < s.values.length; p++) u = Math.max(u, s.values[p].key.toString().length - l.length);
                        var d = u * parseFloat(c),
                            f = Math.floor(t.width() / (d + 8)) || 1;
                        a = 100 / f;
                        r.parents("." + this.class.filterBlockContent).attr("data-columns", f)
                    }
                    r.children("li").each(function() {
                        0 == jQ(this).get(0).style.width.length && jQ(this).css({
                            width: a - 2 + "%"
                        })
                    })
                }
            }
        }
    }
}, BCSfFilter.prototype.buildFilterOptionSwatch = function(e) {
    e.hasOwnProperty("values") && ("all" == e.valueType || this.getSettingValue("general.sortManualValues") || "all" != e.valueType && e.sortManualValues) && (e.values = this.sortFilterOptionValue(e));
    var t = horizontalContent = "",
        i = e.filterType,
        n = e.displayType,
        r = e.selectType,
        o = e.filterOptionId,
        a = e.label;
    for (var s in (e = this.scrollbarPrepareData(e, e.values)).firstBuild) t += this.buildFilterOptionSwatchData(i, o, a, n, r, e.firstBuild[s], e, "vertical"), horizontalContent += this.buildFilterOptionSwatchData(i, o, a, n, r, e.firstBuild[s], e, "horizontal");
    if ("" != t && "" != horizontalContent) {
        var l = this.getTemplate("filterOptionSwatch"),
            c = l.replace(/{{itemList}}/g, t).replace(/{{swatchStyle}}/g, this.buildSwatchStyle(e, "vertical")),
            u = l.replace(/{{itemList}}/g, horizontalContent).replace(/{{swatchStyle}}/g, this.buildSwatchStyle(e, "horizontal"));
        this.buildFilterOption(c, e, "vertical"), this.buildFilterOption(u, e)
    }
}, BCSfFilter.prototype.buildFilterOptionSwatchData = function(e, t, i, n, r, o, a, s) {
    if (this.checkShowFilterOptionItem(o, a)) {
        var l = o.key,
            c = o.key,
            u = l;
        "collection" == e && (c = o.label, l = o.handle, u = c);
        var p = this.getSettingValue("general.colorOptionsArr"),
            d = t.replace("pf_t_", "").replace("pf_opt_", "");
        "" != p && void 0 !== p.filter(function(e) {
            return t.indexOf(e) > -1
        })[0] && (d = "color"), u = this.customizeSwatchFileName(u, o, a);
        var f = this.getTemplate("filterOptionSwatchItem");
        f = this.buildFilterOptionItem(f, c, l, e, t, i, n, r, o, a, s);
        var h = getFilePath(d + "-" + u, this.swatchExtension, this.getSettingValue("general.swatchImageVersion"));
        f = f.replace(/{{itemImageValue}}/g, h);
        var g = a.hasOwnProperty("borderSwatch") && "" != a.borderSwatch ? a.borderSwatch : "none";
        return f.replace(/{{itemBorder}}/g, g)
    }
    return ""
}, BCSfFilter.prototype.buildSwatchStyle = function(e, t) {
    if ("" != this.getSettingValue("general.swatchStyle")) return this.getSettingValue("general.swatchStyle");
    var i = "circle-list";
    return this.checkIsFullWidthMobile() && (i = "circle-list"), e.hasOwnProperty("swatchStyle") && (i = e.swatchStyle), i
}, BCSfFilter.prototype.buildFilterOptionRange = function(e) {
    e.hasOwnProperty("values") && null !== e.values && !Array.isArray(e.values) && 2 == Object.keys(e.values).length ? this.buildFilterOptionGeneralRange(e) : this.buildFilterOptionAdvancedRange(e)
}, BCSfFilter.prototype.buildFilterOptionGeneralRange = function(e) {
    if (e && e.hasOwnProperty("values") && 2 == Object.keys(e.values).length) {
        var t = (e.filterType, e.displayType, e.selectType, e.filterOptionId),
            i = e.label,
            n = e.values;
        if (n.hasOwnProperty("min") && n.hasOwnProperty("max") && null !== n.min && null !== n.max) {
            var r = parseFloat(n.min),
                o = parseFloat(n.max),
                a = this.customizeRangeValue(r, o, e.filterType, e);
            r = a[0], o = a[1];
            if (this.checkShowFilterOptionRange(r, o, e)) {
                var s = this.class.filterOptionRange,
                    l = s + "-slider-" + t + "-v",
                    c = s + "-amount-" + t + "-v",
                    u = s + "-slider-" + t + "-h",
                    p = s + "-amount-" + t + "-h",
                    d = r,
                    f = o;
                if (this.queryParams.hasOwnProperty(t)) {
                    var h = this.queryParams[t][0].split(":");
                    h && 2 == h.length && (d = h[0], f = h[1])
                }
                var g = "style2" == this.getSettingValue("general.rangeStyle") ? this.getTemplate("filterOptionRange2") : this.getTemplate("filterOptionRange"),
                    m = this.customizeDisplayRangeValue(d, f, e.filterType, e),
                    v = this.getTemplate("filterOptionRangeLabel").replace("{{minValue}}", m[0]).replace("{{maxValue}}", m[1]),
                    b = d + ":" + f,
                    y = d != r || f != o ? "selected" : "",
                    S = (g = g.replace(/{{itemLabel}}/g, v).replace(/{{itemParentId}}/g, t).replace(/{{itemValue}}/g, b).replace(/{{itemParentLabel}}/g, i).replace(/{{itemSelected}}/g, y)).replace(/{{rangeAmountId}}/g, c).replace(/{{rangeSliderId}}/g, l),
                    w = g.replace(/{{rangeAmountId}}/g, p).replace(/{{rangeSliderId}}/g, u),
                    C = jQ(S),

                    x = jQ(w),
                    j = '<input type="hidden" class="' + s + "-" + t + '-set" />';
                C.append(j), x.append(j), this.buildFilterOption(jQ(C)[0].outerHTML, e, "vertical"), this.buildFilterOption(jQ(x)[0].outerHTML, e), this.buildFilterOptionGeneralRangeSlider(l, c, d, f, r, o, e), this.buildFilterOptionGeneralRangeSlider(u, p, d, f, r, o, e)
            }
        }
    }
}, BCSfFilter.prototype.buildFilterOptionGeneralRangeSlider = function(e, t, i, n, r, o, a) {
    var s = this,
        l = document.getElementById(e),
        c = a.hasOwnProperty("sliderRange") && null !== a.sliderRange ? parseInt(a.sliderRange) : 4,
        u = a.hasOwnProperty("sliderStep") && null !== a.sliderStep ? parseFloat(a.sliderStep) : 1,
        p = a.hasOwnProperty("sliderDelimiter") && null !== a.sliderDelimiter ? a.sliderDelimiter : "",
        d = this.class.filterOptionRange,
        f = a.filterType.indexOf("price") > -1 ? this.getSettingValue("general.decimalPriceRange") : 0;
    if (u <= .1 && (f = 1), u <= .01 && (f = 2), u <= .001 && (f = 3), (o - r < u || null == r || null == o) && this.getSettingValue("general.oneValueRangeSlider")) r -= 1e-4, o += 1e-4, noUiSlider.create(l, {
        start: [i, n],
        connect: !0,
        behaviour: "tap",
        animate: !0,
        animationDuration: 300,
        step: u,
        range: {
            min: r,
            max: o
        }
    }), jQ(l).attr("disabled", " disabled");
    else {
        if (c > 0) {
            var h = Math.floor((o - r) / u);
            h < c && (c = h);
            for (var g = [], m = 0; m < c; m++) g.push(m * (100 / c));
            g.push(100), noUiSlider.create(l, {
                start: [i, n],
                connect: !0,
                behaviour: "tap",
                animate: !0,
                animationDuration: 300,
                step: u,
                range: {
                    min: r,
                    max: o
                },
                pips: {
                    mode: "positions",
                    values: g,
                    density: c,
                    format: wNumb({
                        decimals: f,
                        thousand: p,
                        edit: function(e) {
                            return s.buildShortenPipLabels(e, p)
                        }
                    })
                }
            }), this.getSettingValue("general.enableSliderRuler") || jQ("#" + e).addClass("no-ruler"), jQ("#" + e).addClass("has-pips"), l.noUiSlider.on("update", function() {
                var t = jQ("#" + e + " .noUi-pips").find(".noUi-marker").last();
                t.hasClass("noUi-marker-normal") && (t.removeClass("noUi-marker-normal"), t.addClass("noUi-marker-large"), t.after('<div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 100.00000%">' + Math.ceil(o) + "</div>"))
            })
        } else noUiSlider.create(l, {
            start: [i, n],
            connect: !0,
            behaviour: "tap",
            animate: !0,
            animationDuration: 300,
            step: u,
            range: {
                min: r,
                max: o
            }
        });
        if (this.slideEvent(e, t, r, o, a), "style1" == this.getSettingValue("general.rangeStyle")) {
            var v = d + "-amount-min",
                b = d + "-amount-max",
                y = this.customizeDisplayRangeValue(i, n, a.filterType, a),
                S = y[0],
                w = y[1];
            jQ("#" + t).find("." + v).val(S), jQ("#" + t).find("." + b).val(w), jQ("#" + t).on("change", "." + v, function() {
                var e = jQ(this).val(),
                    i = jQ("#" + t + " ." + b).val();
                e = s.convertMoneyToDefaultFormat(e), i = s.convertMoneyToDefaultFormat(i), l.noUiSlider.set([e, i])
            }), jQ("#" + t).on("change", "." + b, function() {
                var e = jQ(this).val(),
                    i = jQ("#" + t + " ." + v).val();
                i = s.convertMoneyToDefaultFormat(i), e = s.convertMoneyToDefaultFormat(e), l.noUiSlider.set([i, e])
            })
        }
        this.setRangeValueEvent(e, r, o, a)
    }
}, BCSfFilter.prototype.slideEvent = function(e, t, i, n, r) {
    var o = this,
        a = document.getElementById(e),
        s = o.class.filterOptionRange;
    a.noUiSlider.on("slide", function(e, i) {
        var n = o.customizeDisplayRangeValue(e[0], e[1], r.filterType, r),
            a = n[0],
            l = n[1];
        "style2" == o.getSettingValue("general.rangeStyle") ? jQ("#" + t).html(a + " - " + l) : (jQ("#" + t).find("." + s + "-amount-min").val(a), jQ("#" + t).find("." + s + "-amount-max").val(l))
    })
}, BCSfFilter.prototype.customizeRangeValue = function(e, t, i, n) {
    return i.indexOf("price") > -1 ? this.getSettingValue("general.roundPriceSlider") && (e = Math.floor(e), t = Math.ceil(t, 100)) : (getNumberDecimals(e) > 2 && (e = parseFloat(e.toFixed(2))), getNumberDecimals(t) > 2 && (t = parseFloat(t.toFixed(2)))), [e, t]
}, BCSfFilter.prototype.customizeDisplayRangeValue = function(e, t, i, n) {
    return i.indexOf("price") > -1 ? (e = this.formatMoney(100 * e), t = this.formatMoney(100 * t), e = this.removeCurrencySymbol(e), t = this.removeCurrencySymbol(t), this.getSettingValue("general.removePriceDecimal") && (e = this.removeDecimal(e), t = this.removeDecimal(t))) : (e = parseFloat(e), t = parseFloat(t)), [e, t]
}, BCSfFilter.prototype.setRangeValueEvent = function(e, t, i, n) {
    var r = this,
        o = document.getElementById(e),
        a = n.hasOwnProperty("values") && null !== n.values && Array.isArray(n.values);
    o.noUiSlider.on("set", function(o, s) {
        if (o[0] == t && o[1] == i) jQ("#" + e).removeClass("selected"), jQ("#" + e).attr("data-value", "");
        else {
            var l = [];
            if (a)
                for (var c = n.values.map(function(e) {
                        return e.key
                    }), u = 0; u <= c.length; u++) u >= o[0] && u <= o[1] - 1 && l.push(c[u]);
            else l.push(parseFloat(o[0]) + ":" + parseFloat(o[1]));
            jQ("#" + e).addClass("selected"), jQ("#" + e).attr("data-value", l.join(","))
        }
        if (r.isMobile() && "style2" == r.mobileStyle) r.buildFilterSelectionMobile();
        else if (r.getSettingValue("general.requestInstantly") || e.indexOf("-v") > -1) {
            onInteractWithFilterOptionValue("undefined" != typeof event ? event : new Event("build"), jQ(this.target), n.filterType, n.displayType, n.selectType)
        } else r.selectFilter = !0
    })
}, BCSfFilter.prototype.buildFilterOptionAdvancedRange = function(e) {
    if (e && e.hasOwnProperty("values") && e.values.length) {
        var t = (e.filterType, e.displayType, e.selectType, e.filterOptionId),
            i = e.label,
            n = e.values,
            r = e.prefix;
        null != r && !1 !== r && (r = r.replace(/\\/g, ""));
        var o = n.map(function(e) {
                return e.key
            }),
            a = o.length;
        e.sliderRange = o.length, e.sliderStep = 1, e.sliderDelimiter = "";
        var s = this.class.filterOptionRange,
            l = s + "-slider-" + t + "-v",
            c = s + "-amount-" + t + "-v",
            u = s + "-slider-" + t + "-h",
            p = s + "-amount-" + t + "-h",
            d = "",
            f = 0,
            h = a;
        if (this.queryParams.hasOwnProperty(t)) {
            var g = this.queryParams[t],
                m = this.getAdvancedRangeSelectedValues(g, o, !0);
            f = m[0] || 0, h = m[1] || o.length - 1;
            d = g.join(",")
        }
        var v = this.getTemplate("filterOptionAdvancedRange"),
            b = (this.customizeDisplayRangeValue(f, h, e.filterType, e), 0 != f || h != a ? "selected" : ""),
            y = (v = v.replace(/{{itemParentId}}/g, t).replace(/{{itemValue}}/g, d).replace(/{{itemParentLabel}}/g, i).replace(/{{itemSelected}}/g, b)).replace(/{{rangeAmountId}}/g, c).replace(/{{rangeSliderId}}/g, l),
            S = v.replace(/{{rangeAmountId}}/g, p).replace(/{{rangeSliderId}}/g, u),
            w = jQ(y),
            C = jQ(S),
            x = '<input type="hidden" class="' + s + "-" + t + '-set" />';
        w.append(x), C.append(x), this.buildFilterOption(jQ(w)[0].outerHTML, e, "vertical"), this.buildFilterOption(jQ(C)[0].outerHTML, e), this.buildFilterOptionGeneralRangeSlider(l, c, f, h, 0, a, e), this.buildFilterOptionGeneralRangeSlider(u, p, f, h, 0, a, e);
        var j = jQ("#" + l).find(".noUi-value"),
            T = jQ("#" + u).find(".noUi-value");
        if (j.length && T.length) {
            var P = 100 / (j.length - 1);
            for (var F in j) {
                var O = o[parseInt(j.eq(F).html())] || "bc";
                j.eq(F).html(O.toString().replace(r, "")).css("width", P + "%"), T.eq(F).html(O.toString().replace(r, "")).css("width", P + "%")
            }
        }
    }
}, BCSfFilter.prototype.buildFilterOptionAdvancedRangeSlider = function(e, t, i, n, r, o, a) {}, BCSfFilter.prototype.buildFilterOptionRating = function(e) {
    var t = "",
        i = e.filterType,
        n = e.displayType,
        r = e.selectType,
        o = e.filterOptionId,
        a = e.label,
        s = void 0 !== e.showExactRating && 1 == e.showExactRating;
    if (s) {
        var l = bcSfFilterMainConfig.settings.general.showOutOfStockOption || !1;
        bcSfFilterMainConfig.settings.general.showOutOfStockOption = !0
    }
    for (var c in e.values.reverse(), e.values)(s || 0 != c) && (t += this.buildFilterOptionRatingData(i, o, a, n, r, e.values[c], e, "both"));
    if (s && (bcSfFilterMainConfig.settings.general.showOutOfStockOption = l), "" != t) {
        var u = this.getTemplate("filterOptionRating"),
            p = "multiple" == e.selectType && void 0 !== e.showExactRating && 1 == e.showExactRating ? this.getClass("filterOptionMultipleList") : "";
        u = (u = u.replace(/{{itemMultipleSelect}}/g, p)).replace(/{{itemList}}/g, t), this.buildFilterOption(u, e, "vertical"), this.buildFilterOption(u, e)
    }
}, BCSfFilter.prototype.buildFilterOptionRatingData = function(e, t, i, n, r, o, a, s) {
    if (this.checkShowFilterOptionItem(o, a)) {
        var l = parseFloat(o.from).toFixed();
        void 0 !== a.starColor && "" != a.starColor && null != a.starColor || (a.starColor = this.getSettingValue("general.ratingStarItemColor"));
        var c = this.buildRatingStars(l, a.starColor),
            u = "";
        void 0 !== a.showExactRating && a.showExactRating || (u = this.getSettingValue("label.ratingUp"));
        var p = this.getTemplate("filterOptionRatingStar").replace(/{{itemStars}}/g, c).replace(/{{label.ratingUp}}/g, u),
            d = this.getTemplate("filterOptionRatingItem");
        return this.buildFilterOptionItem(d, p, l, e, t, i, n, r, o, a, s)
    }
    return ""
}, BCSfFilter.prototype.buildRatingStars = function(e, t) {
    for (var i = "", n = 1; n <= 5; n++) i += n <= e ? this.getTemplate("filterOptionRatingIconStarActive") : this.getTemplate("filterOptionRatingIconStar");
    return i.replace(/{{ratingStartColor}}/g, t)
}, BCSfFilter.prototype.buildFilterViewMore = function(e, t) {
    var i = this.getClass("filterOptionViewMore"),
        n = this.getClass("filterOptionViewLess"),
        r = this.getClass("filterOptionViewMoreList"),
        o = jQ(e).parents(this.selector.filterTreeHorizontal).length > 0 ? jQ(e).find("." + this.getClass("filterBlockContent") + "-inner") : jQ(e),
        a = jQ(e).parents(this.selector.filterTreeHorizontal).length > 0,
        s = jQ(e).parents("." + bcsffilter.class.filterOption).data("display-type"),
        l = a ? this.getSettingValue("general.startViewMoreH") : this.getSettingValue("general.startViewMore"),
        c = l.hasOwnProperty(s) ? l[s] : 15;
    if (o.find("li").length <= c) return !1;
    0 == jQ("." + r).length && jQ("body").append('<input type="hidden" class="' + r + '" />'), jQ(e).attr("data-has-scrollbar", t);
    var u = !0,
        p = jQ("." + r).val().split(",");
    if (p.length > 0 && p.indexOf(jQ(e).parent().attr("data-id")) > -1) {
        u = !1, t ? this.buildFilterScrollbar(jQ(e)) : o.addClass("no-scrollbar");
        var d = this.getTemplate("filterOptionViewLess").replace(/{{label.viewLess}}/g, this.getSettingValue("label.viewLess"));
        o.siblings("." + n).length > 0 && o.siblings("." + n).remove(), o.after(d)
    }
    if (u) {
        o.find("li:gt(" + (c - 1) + ")").hide(), o.css({
            overflow: "hidden"
        }), t || o.addClass("no-scrollbar");
        d = this.getTemplate("filterOptionViewMore").replace(/{{label.viewMore}}/g, this.getSettingValue("label.viewMore"));
        o.siblings("." + i).length > 0 && o.siblings("." + i).remove(), o.after(d)
    }
}, BCSfFilter.prototype.collapseFilterOption = function() {
    var e = this;
    if (this.isMobile()) {
        0 == jQ(".bc-sf-filter-option-open-list").length && jQ("body").append('<input type="hidden" class="bc-sf-filter-option-open-list" />'), 0 == jQ(".bc-sf-filter-option-close-list").length && jQ("body").append('<input type="hidden" class="bc-sf-filter-option-close-list" />');
        var t = "" != jQ(".bc-sf-filter-option-open-list").val() ? jQ(".bc-sf-filter-option-open-list").val().split(",") : [],
            i = "" != jQ(".bc-sf-filter-option-close-list").val() ? jQ(".bc-sf-filter-option-close-list").val().split(",") : [];
        0 == t.length && 0 == i.length && jQ("." + this.class.filterOption).each(function() {
            var n = "true" == jQ(this).attr("data-collapse-mobile"),
                r = jQ(this).closest("." + e.class.filterOption).attr("data-id");
            n ? -1 == i.indexOf(r) && (i.push(r), t.length > 0 && t.indexOf(r) > -1 && t.splice(t.indexOf(r), 1)) : -1 == t.indexOf(r) && (t.push(r), i.length > 0 && i.indexOf(r) > -1 && i.splice(i.indexOf(r), 1))
        }), jQ(".bc-sf-filter-option-open-list").val(t.join(",")), jQ(".bc-sf-filter-option-close-list").val(i.join(",")), jQ("." + this.class.filterOption).each(function() {
            var n = jQ(this).closest("." + e.class.filterOption).attr("data-id");
            i.indexOf(n) > -1 ? (jQ(this).find("." + e.class.filterBlockTitle + " h3 span").addClass("up"), jQ(this).find("." + e.class.filterBlockTitle + " h3").attr("aria-expanded", "false"), jQ(this).children().not("." + e.class.filterBlockTitle).hide()) : t.indexOf(n) > -1 && (jQ(this).find("." + e.class.filterBlockTitle + " h3 span").removeClass("up"), jQ(this).find("." + e.class.filterBlockTitle + " h3").attr("aria-expanded", "true"), jQ(this).children().show())
        })
    }
}, BCSfFilter.prototype.checkShowFilterOption = function(e) {
    if ("disabled" == e.status || e.hasOwnProperty("values") && 0 == e.values.length) return !1;
    if ("percent_sale" == e.filterType && void 0 !== e.values.filter(function(e) {
            return "*-100" == e.key && e.doc_count > 0
        })[0]) return !0;
    if (!0 === e.keepValuesStatic) return !0;
    if ("range" == e.displayType) return e.hasOwnProperty("values") && null !== e.values && !Array.isArray(e.values) && 2 == Object.keys(e.values).length ? this.checkShowFilterOptionRange(e.values.min, e.values.max, e) : e.hasOwnProperty("values") && e.values.length > 1;
    if (!this.getSettingValue("general.showOutOfStockOption") && !0 === this.getSettingValue("general.showSingleOption") && "range" != e.displayType) {
        if (e.hasOwnProperty("values") && e.values.length > 1) {
            var t = 0;
            for (var i in e.values)
                if (e.values[i].doc_count > 0 && t++, t > 1) return !0
        }
        return !1
    }
    return !0
}, BCSfFilter.prototype.checkShowFilterOptionItem = function(e, t) {
    return !(null === e || !e.hasOwnProperty("key") || !(e.hasOwnProperty("doc_count") && (e.doc_count > 0 || null === e.doc_count) || t.hasOwnProperty("keepValuesStatic") && t.keepValuesStatic || this.getSettingValue("general.showOutOfStockOption")))
}, BCSfFilter.prototype.checkShowFilterOptionRange = function(e, t, i) {
    var n = i.hasOwnProperty("sliderStep") && null !== i.sliderStep ? parseInt(i.sliderStep) : 1;
    return !!(!this.getSettingValue("general.oneValueRangeSlider") && t - e > n || this.getSettingValue("general.oneValueRangeSlider"))
}, BCSfFilter.prototype.buildFilterSelection = function(e) {
    var t = this.buildFilterSelectionData(e),
        i = t[0],
        n = t[1],
        r = this.buildClearAllButton();
    if ("" != i) {
        var o = this.getTemplate("filterRefineWrapper");
        o = (o = o.replace(/{{label}}/g, this.getSettingValue("label.refine"))).replace(/{{selectedItems}}/g, i), o = this.buildFilterTreeClass(o), this.addFilterTreeItem(o, "before", "vertical"), jQ(this.selector.filterTree).find("." + this.class.filterRefineWrapper + " ." + this.class.filterBlockTitle).append(r)
    }
    var a = this.getSettingValue("general.selectionHorizontalPlace");
    if ("#bc-sf-filter-tree-h" != a && jQ(a).empty(), "" != n) {
        var s = this.getTemplate("filterRefineHorizontalWrapper");
        s = (s = s.replace(/{{label}}/g, this.getSettingValue("label.refine"))).replace(/{{selectedItems}}/g, n), s = this.buildFilterTreeClass(s), "top" == this.getSettingValue("general.refineByHorizontalPosition") ? this.addFilterTreeItem(s, "before", "horizontal", a) : this.addFilterTreeItem(s, "after", "horizontal", a), jQ(".bc-sf-filter-pc." + this.class.filterRefineWrapper).append(r)
    }
}, BCSfFilter.prototype.buildFilterSelectionData = function(e) {
    function t(e, t, i, n) {
        return (e = (e = e.replace(/{{itemType}}/g, t)).replace(/{{itemLabel}}/g, i)).replace(/{{itemLink}}/g, n)
    }
    var i = this,
        n = horizontalContent = "",
        r = this.getTemplate("filterRefineItem"),
        o = this.getTemplate("filterRefineHorizontalItem"),
        a = e.filter.options,
        s = Object.keys(i.queryParams);
    return s = s.filter(function(e) {
        return 0 == e.indexOf("pf_")
    }), jQ.each(s, function(e, s) {
        var l = a.filter(function(e) {
            return e.filterOptionId == s
        })[0];
        if (void 0 !== l && i.queryParams.hasOwnProperty(s) && i.queryParams[s] && i.queryParams[s].length) {
            var c = i.queryParams[s],
                u = l.filterOptionId,
                p = l.prefix,
                d = l.label,
                f = l.filterType,
                h = l.displayType;
            if (p = null != p && !1 !== p ? p.replace(/\\/g, "") : "", Array.isArray(c) || (c = [c]), "range" == h) {
                var g = "";
                if (-1 == f.indexOf("price") && "weight" !== f && -1 == f.indexOf("range_slider")) {
                    var m = [];
                    l && l.hasOwnProperty("values") && (m = l.values.map(function(e) {
                        return e.key
                    }));
                    var v = m.length ? i.getAdvancedRangeSelectedValues(c, m) : [c[0], c[c.length - 1]];
                    g = v[0].toString().replace(p, ""), c.length > 1 && (g += " - " + v[1].toString().replace(p, ""))
                } else {
                    var b = (C = c[0]).split(":");
                    if ("price" == f) {
                        var y = i.formatMoney(100 * b[0]),
                            S = i.formatMoney(100 * b[1]);
                        i.getSettingValue("general.removePriceDecimal") && (y = i.removeDecimal(y), S = i.removeDecimal(S)), g = y + " - " + S
                    } else g = b[0] + " - " + b[1]
                }
                var w = i.buildClearFilterOptionLink(u, d, c);
                n += t(r, d, g, w), horizontalContent += t(o, d, g, w)
            } else
                for (e = 0; e < c.length; e++) {
                    var C;
                    g = C = c[e];
                    g = i.customizeFilterOptionLabel(g, p, f);
                    w = i.buildClearFilterOptionLink(u, d, C);
                    switch (null != p && !1 !== p && (p = p.replace(/\\/g, ""), C = C.replace(p, "").trim()), f) {
                        case "price":
                            g = i.getPriceLabel(C);
                            break;
                        case "percent_sale":
                            g = i.getPercentSaleLabel(C);
                            break;
                        case "stock":
                            g = "true" === C ? l.values[0].label : l.values[1].label;
                            break;
                        case "review_ratings":
                            var x = !!l.hasOwnProperty("showExactRating") && l.showExactRating;
                            g = i.getReviewRatingsLabel(C, x)
                    }
                    n += t(r, d, g, w), horizontalContent += t(o, d, g, w)
                }
        }
    }), [n, horizontalContent]
}, BCSfFilter.prototype.checkFilterOptionSelected = function(e, t, i) {
    if ("collection" == i && (t = t.split(":")[0]), "collection" != i || this.isSearchPage()) {
        if ("stock" == i) {
            if (this.queryParams.hasOwnProperty(e) && (n = this.queryParams[e]).indexOf(t.toString()) > -1) return !0
        } else if (this.queryParams.hasOwnProperty(e)) {
            var n = this.queryParams[e];
            if (Array.isArray(n)) {
                for (var r = 0; r < n.length; r++)
                    if (n[r] == t) return !0
            } else if (n == t) return !0
        }
    } else if (decodeURIComponent(window.location.pathname).split("/").slice(2).join("/") == t) return !0;
    return !1
}, BCSfFilter.prototype.buildClearAllButton = function() {
    var e = this.getTemplate("clearAllButton");
    return e = e.replace(/{{label.clearAll}}/g, this.getSettingValue("label.clearAll")), this.buildFilterTreeClass(e, "clearAllButton")
}, BCSfFilter.prototype.onChangeData = function(e, t, i, n) {
    this.updateApiParams(e), this.getFilterData(t), this.changeAddressBar(e, t, i)
}, BCSfFilter.prototype.buildAdditionalFilterEvent = function() {
    this.buildApplyEvent(), this.buildTitleClickEvent(), this.buildMouseUpEvent(), this.checkIsFullWidthMobile() || this.buildToggleEvent(), this.buildClearEvent(), this.buildTooltipEvent()
}, BCSfFilter.prototype.buildMouseUpEvent = function(e) {
    var t = this;
    jQ(document).mouseup(function(i) {
        var n = jQ(t.selector.filterTreeHorizontal).find("." + t.class.filterBlockContent);
        n.is(i.target) || 0 !== n.has(i.target).length || t.buildSubmitEvent(e, !0, i)
    })
}, BCSfFilter.prototype.buildApplyEvent = function(e) {
    var t = this;
    jQ("." + this.class.selectFilterOptionButton).click(function(i) {
        t.buildSubmitEvent(e, !0, i)
    })
}, BCSfFilter.prototype.buildSubmitEvent = function(e, t, i) {
    var n = jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).filter(function() {
            return "block" == jQ(this).css("display")
        }).eq(0),
        r = jQ(n[0]).parent();
    jQ("#" + this.selector.filterOptionOpenValue).val(jQ(n[0]).attr("id"));
    var o = r.data("type"),
        a = r.data("display-type"),
        s = r.data("select-type"),
        l = r.attr("data-id"),
        c = [];
    if (r.find(".noUi-target").length > 0 && r.find(".noUi-target").hasClass("selected")) {
        var u = r.find(".noUi-target").attr("data-value");
        if ("range" == a && "price" !== o && -1 == o.indexOf("range_slider"))
            for (var p in u = u.split(",")) "" !== u[p] && c.push(encodeURIParamValue(u[p]));
        else c.push(encodeURIParamValue(u))
    } else c = (jQ(n).parent().data("selected") || []).filter(function(e) {
        return e.length > 0
    });
    var d = this.buildSubmitLink(l, c, o, a, s);
    !1 !== d && !0 === this.selectFilter && (jQ("#" + this.selector.filterOptionSubmitOpenValue).val(jQ(n[0]).attr("id")), this.internalClick = !0, this.onChangeData(d, o, c, l));
    var f = jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle);
    (!t || t && !f.is(i.target) && 0 === f.has(i.target).length) && (jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).hide(), jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle).children("a").removeClass("selected"))
}, BCSfFilter.prototype.buildTitleClickEvent = function(e) {
    var t = this;
    jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle + " a").on("click", function(e) {
        e.stopPropagation(), jQ(t.selector.filterTreeHorizontal).find("." + t.class.filterBlockContent).not(jQ(this).parent().siblings()[0]).hide(), jQ(t.selector.filterTreeHorizontal).find("." + t.class.filterBlockTitle).not(jQ(this).parent()[0]).children("a").removeClass("selected"), 1 == jQ(this).hasClass("selected") ? (jQ(this).removeClass("selected"), jQ(this).attr("aria-expanded", "false")) : (jQ(this).addClass("selected"), jQ(this).attr("aria-expanded", "true")), jQ(this).parent().siblings().stop().toggle();
        var i = jQ(this).closest("." + t.class.filterOption).data("block-id");
        t.setOpenPositionFilterOptionContent(i), "collection" != jQ(this).closest("." + t.class.filterOption).attr("data-type") && (jQ(this).hasClass("selected") ? jQ("#" + t.selector.filterOptionOpenValue).val(jQ(this).parent().siblings().attr("id")) : jQ("#" + t.selector.filterOptionOpenValue).val(null))
    })
}, BCSfFilter.prototype.setOpenPositionFilterOptionContent = function(e) {
    if (void 0 !== e) {
        var t = jQ(this.selector.filterTreeHorizontal).find("." + e),
            i = jQ(this.selector.filterTreeHorizontal).offset().top,
            n = t.offset().top + t.outerHeight(!0) - i - 5;
        t.children("." + this.class.filterBlockContent).css("top", n + "px"), this.buildFilterShowMore()
    }
}, BCSfFilter.prototype.buildToggleEvent = function(e) {
    var t = this,
        i = this.class.filterOptionOpenList,
        n = this.class.filterOptionCloseList,
        r = this.class.filterOption,
        o = jQ("." + i).length > 0 ? jQ("." + i).val().split(",") : [],
        a = jQ("." + n).length > 0 ? jQ("." + n).val().split(",") : [];
    jQ(this.selector.filterTree + " ." + this.class.filterBlockTitle + " h3").on("click", function(e) {
        e.preventDefault();
        var s = jQ(this).closest("." + r).attr("data-id");
        jQ(this).children().hasClass("up") ? (t.getSettingValue("general.keepToggleState") && (o.push(s), a.length > 0 && a.indexOf(s) > -1 && a.splice(a.indexOf(s), 1)), jQ(this).children().removeClass("up"), jQ(this).attr("aria-expanded", "true"), jQ(this).parent().siblings().slideDown(function() {
            "range" != jQ(this).parent().attr("data-display-type") && (t.buildFilterOptionBoxStyle(jQ(this)), t.buildFilterScrollbar(this))
        })) : (t.getSettingValue("general.keepToggleState") && (a.push(s), o.length > 0 && o.indexOf(s) > -1 && o.splice(a.indexOf(s), 1)), jQ(this).children().addClass("up"), jQ(this).attr("aria-expanded", "false"), jQ(this).parent().siblings().slideUp()), jQ("." + i).val(o.join(",")), jQ("." + n).val(a.join(","))
    })
}, BCSfFilter.prototype.buildClearEvent = function(e) {
    var t = this;
    jQ("." + this.class.filterSelectedItems + " a").click(function(e) {
        jQ("#" + t.selector.filterOptionOpenValue).val(null), e.preventDefault(), t.internalClick = !0;
        var i = jQ(this).attr("href");
        t.onChangeData(i, "clearFilterOptionItem")
    })
}, BCSfFilter.prototype.buildFilterOptionLink = function(e, t, i, n, r, o) {
    var a = "";
    if ("" != (a = this.buildFilterOptionCustomLink(e, t, i, n, r, o))) return a;
    if ("collection" == i) {
        var s = t.split(":"),
            l = s[1];
        t = s[0]
    }
    if ("collection" != i || this.isSearchPage()) {
        if (a = window.location.href.replace(/\+/g, "%20"), 0 == window.location.search.length) a += "?_=" + this.prefix;
        else if (null === getParam("_")) {
            var c = a.split("?");
            a = c[0] + "?_=" + this.prefix, c.length > 1 && (a += "&" + c[1])
        }
        if ("range" == n && "price" !== i && -1 == i.indexOf("range_slider")) {
            if (this.queryParams.hasOwnProperty(e)) {
                var u = this.queryParams[e];
                for (var p in u) a = a.replace("&" + e + "=" + encodeURIParamValue(u[p]), "")
            }
            if ("" != t) {
                var d = "",
                    f = t.split(",");
                for (var p in f) "" != f[p] && (d += "&" + e + "=" + encodeURIParamValue(f[p]));
                "" != d && (a += d)
            }
        } else if ("" !== t && null !== t) {
            d = "&" + e + "=" + encodeURIParamValue(t);
            if ("range" != n && "single" != r || !this.queryParams.hasOwnProperty(e)) {
                var h = window.location.href.replace(/\+/g, "%20") + "&";
                if (h.indexOf(d + "&") > -1) "&" == (a = h.replace(d + "&", "&"))[a.length - 1] && (a = a.slice(0, -1));
                else {
                    a = window.location.href.replace(/\+/g, "%20");
                    0 === window.location.search.length ? a += "?_=" + this.prefix : (a = window.location.href.replace(/\+/g, "%20"), this.queryParams.hasOwnProperty("_") || (a += "&_=" + this.prefix)), a += d
                }
            } else {
                var g = "&" + e + "=" + encodeURIParamValue(this.queryParams[e][0]);
                a = window.location.href.replace(g, d)
            }
        } else a = window.location.href.replace(/\+/g, "%20").replace("&" + e + "=" + encodeURIParamValue(this.queryParams[e]), "")
    } else {
        o = void 0 !== o ? o : null;
        var m = window.location.pathname;
        if ("/" == m.slice(-1) && (m = m.substring(0, m.length - 1)), "pf_cs_collection" == e) a = window.location.href.indexOf(t) > -1 ? m.replace(t, "") + t.split("/")[0] : "/" + m.split("/")[1] + "/" + t;
        else if ("" != m) {
            var v = "",
                b = m.split("/");
            3 == b.length ? v = b.slice(0, -1).join("/") + "/" + t : b.length > 3 && (v = b.slice(0, -2).join("/") + "/" + t), a = (a = !0 === o ? window.location.href.split("?")[0] : window.location.href).replace(m, v)
        }
    }
    "collection" == i && this.isSearchPage() && (a = a.replace("&collection_scope=" + this.queryParams.collection_scope, ""), a += "&collection_scope=" + l);
    var y = "&" + e + "_and_condition=true";
    if (-1 == a.indexOf(y) ? jQ('[data-id="' + e + '"]').attr("data-and-condition") && (a += y) : -1 == a.indexOf(e + "=") && (a = a.replace(y, "")), "review_ratings" == i) {
        var S = "&" + e + "_show_exact_rating=true"; - 1 == a.indexOf(S) ? jQ('[data-id="' + e + '"]').attr("data-exact-rating") && (a += S) : -1 == a.indexOf(e + "=") && (a = a.replace(S, ""))
    }
    return a = removePageParamFromUrl(a), this.customizeFilterOptionLink(a, e, t, i, n, r, o)
}, BCSfFilter.prototype.buildSubmitLink = function(e, t, i, n, r) {
    var o = newParamValue = "";
    if (this.queryParams.hasOwnProperty(e))
        for (var a = 0; a < this.queryParams[e].length; a++) o += "&" + e + "=" + encodeURIParamValue(this.queryParams[e][a]);
    for (var s = 0; s < t.length; s++) newParamValue += "&" + e + "=" + t[s];
    if (o != newParamValue) {
        if ("" != o) var l = window.location.href.replace(o, newParamValue);
        else {
            l = window.location.href;
            0 === window.location.search.length ? l += "?_=" + this.prefix : (l = window.location.href, this.queryParams.hasOwnProperty("_") || (l += "&_=" + this.prefix)), l += newParamValue
        }
        var c = "&" + e + "_and_condition=true";
        return -1 == l.indexOf(c) ? jQ('[data-id="' + e + '"]').attr("data-and-condition") && (l += c) : -1 == l.indexOf(e + "=") && (l = l.replace(c, "")), l = removePageParamFromUrl(l), this.customizeSubmitLink(l, e, t, i, n, r)
    }
    return !1
}, BCSfFilter.prototype.buildFilterOptionCustomLink = function(e, t, i, n, r, o) {
    return ""
}, BCSfFilter.prototype.customizeFilterOptionLink = function(e, t, i, n, r, o, a) {
    return e
}, BCSfFilter.prototype.customizeSubmitLink = function(e, t, i, n, r, o) {
    return e
}, BCSfFilter.prototype.buildClearFilterOptionLink = function(e, t, i) {
    if (Array.isArray(i)) {
        for (var n = "", r = 0; r < i.length; r++) n += "&" + e + "=" + encodeURIParamValue(i[r]);
        var o = window.location.href.replace(/\+/g, "%20").replace(n, "")
    } else {
        var a = new RegExp("&" + e + "=" + encodeURIParamValue(i).replace(/(?=[() ])/g, "\\") + "&", "g");
        o = (window.location.href.replace(/\+/g, "%20") + "&").replace(a, "&")
    }
    return -1 == o.indexOf(e + "=") && o.indexOf(e + "_and_condition") > -1 && (o = o.replace("&" + e + "_and_condition=true", "")), -1 == o.indexOf(e + "=") && o.indexOf(e + "_show_exact_rating") > -1 && (o = o.replace("&" + e + "_show_exact_rating=true", "")), e.indexOf("pf_c_") > -1 && (o = removeCollectionScopeParamFromUrl(o)), "&" == o[o.length - 1] && (o = o.slice(0, -1)), removePageParamFromUrl(o)
}, BCSfFilter.prototype.getPriceLabel = function(e) {
    if (0 == e.indexOf(":")) return this.getSettingValue("label.under") + " " + this.formatMoney(100 * parseFloat(e.substr(1)));
    if (e.indexOf(":") == e.length - 1) return this.getSettingValue("label.above") + " " + this.formatMoney(100 * parseFloat(e.slice(0, -1)));
    if (2 == e.split(":").length) {
        var t = e.split(":");
        return this.formatMoney(100 * parseFloat(t[0])) + " - " + this.formatMoney(100 * parseFloat(t[1]))
    }
}, BCSfFilter.prototype.getPercentSaleLabel = function(e) {
    return 0 == (e = this.removeDecimal(e)).indexOf(":") ? this.getSettingValue("label.under") + " " + e.substr(1) + "%" : e.indexOf(":") == e.length - 1 ? this.getSettingValue("label.above") + " " + e.slice(0, -1) + "%" : 2 == e.split(":").length ? e.split(":")[0] + "% - " + e.split(":").pop() + "%" : void 0
}, BCSfFilter.prototype.buildFilterTreeMobileButton = function(e) {
    var t = !1;
    if (e.hasOwnProperty("filter") && e.filter.hasOwnProperty("options") && e.filter.options.length > 0)
        for (var i = e.filter.options, n = 0; n < i.length; n++)
            if (this.checkShowFilterOption(i[n])) {
                t = !0;
                break
            } if (t) {
        var r = this.getSelector("filterTreeMobile"),
            o = this.getSelector("filterTreeMobileButton"),
            a = !1,
            s = this.class.mobileButtonOpen,
            l = this.getSettingValue("label.refineMobile");
        jQ(o).hasClass(s) && (a = !0, l = this.getSettingValue("label.refineMobileCollapse"));
        var c = this.getTemplate("filterTreeMobileButton").replace(/{{label}}/g, l);
        jQ(r).html(c), a && jQ(o).addClass(s), this.buildFilterTreeMobileButtonEvent()
    }
}, BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var e = this,
        t = this.getSelector("filterTree"),
        i = this.getSelector("filterTreeMobileButton");
    jQ(i).unbind("click"), jQ(i).on("click", function() {
        var i = e.mobileStyle;
        if ("style2" == i || "style3" == i) jQ(t).toggleClass("bc-sf-filter-tree-mobile-open"), e.buildFilterTreeMobile(), e.removeScrollbar(jQ("." + e.class.filterBlockContent));
        else {
            if (e.getSettingValue("general.changeMobileButtonLabel")) {
                var n = e.class.mobileButtonOpen;
                jQ(this).toggleClass(n);
                var r = jQ(this).hasClass(n) ? e.getSettingValue("label.refineMobileCollapse") : e.getSettingValue("label.refineMobile");
                jQ(this).text(r)
            }
            jQ(t).slideToggle(function() {
                jQ(t).toggleClass("bc-sf-filter-tree-mobile-open"), e.buildFilterOptionBoxStyle(jQ(this)), e.buildFilterScrollbar()
            })
        }
    })
}, BCSfFilter.prototype.getFilterTreeMobileTemplate = function(e) {
    switch (e) {
        case "style2":
        case "style3":
            return {
                toolbar: '<div id="bc-sf-filter-mobile-toolbar"><div class="bc-sf-filter-mobile-toolbar-header">' + bcsffilter.getSettingValue("label.refineMobile") + '</div><div class="bc-sf-filter-mobile-toolbar-items"><div class="bc-sf-filter-mobile-toolbar-left"></div><div class="bc-sf-filter-mobile-toolbar-right"></div></div></div>', footer: '<div id="bc-sf-filter-mobile-footer"><button type="button" onClick="showResultMobile(true)">' + bcsffilter.getSettingValue("label.showResult") + "</button></div>"
            };
        default:
            return ""
    }
}, BCSfFilter.prototype.buildFilterTreeMobile = function() {
    var e = this.mobileStyle;
    if (this.isMobile() && "" != e) {
        jQ(this.selector.filterTree).addClass("bc-sf-filter-tree-mobile-" + e), "style2" != e && "style3" != e || jQ(this.selector.filterTree).addClass("bc-sf-filter-tree-mobile-full-width");
        var t = this.getFilterTreeMobileTemplate(e);
        switch (e) {
            case "style2":
                this.buildFilterTreeMobileStyle2(t);
                break;
            case "style3":
                this.buildFilterTreeMobileStyle3(t)
        }
    }
}, BCSfFilter.prototype.removeFilterTreeMobileStyle = function() {
    var e = this.mobileStyle;
    if ("" != e) switch (jQ(this.selector.filterTree).removeClass("bc-sf-filter-tree-mobile-" + e), closeFilterMobile(), e) {
        case "style2":
            this.removeFilterTreeMobileStyle2();
            break;
        case "style3":
            this.removeFilterTreeMobileStyle3()
    }
}, BCSfFilter.prototype.buildFilterTreeMobileStyle2 = function(e) {
    jQ("#bc-sf-filter-mobile-toolbar").remove(), jQ("#bc-sf-filter-mobile-footer").remove(), jQ(this.selector.filterTree).prepend(e.toolbar).append(e.footer), jQ('[data-display-type="range"] .' + this.class.filterBlockContent).addClass("no-scrollbar"), this.buildToolbarFilterTreeMobile("close"), this.buildFilterSelectionMobile(), this.buildFilterOptionTitleEvent()
}, BCSfFilter.prototype.removeFilterTreeMobileStyle2 = function() {
    jQ(this.selector.filterTree).children("#bc-sf-filter-mobile-toolbar").remove(), jQ(this.selector.filterTree).children("#bc-sf-filter-mobile-footer").remove(), jQ("." + this.class.filterSelectedItemsMobile).remove(), jQ("." + this.class.filterBlockContent).removeClass("no-scrollbar")
}, BCSfFilter.prototype.buildFilterTreeMobileStyle3 = function(e) {
    this.buildFilterTreeMobileStyle2(e);
    var t = this,
        i = this.class.filterOptionOpenList;
    0 == jQ("." + i).length && jQ("body").append('<input type="hidden" class="' + i + '" />');
    var n = "" != jQ("." + i).val() ? jQ("." + i).val().split(",") : [];
    jQ("." + this.class.filterOption).each(function() {
        var e = jQ(this).closest("." + t.class.filterOption).attr("data-id");
        n.indexOf(e) > -1 && (jQ(this).find("." + t.class.filterBlockContent).show(0, function() {
            t.buildFilterScrollbar(jQ(this)), t.buildFilterOptionBoxStyle(jQ(this))
        }), jQ(this).find("." + t.class.filterBlockContent).siblings("." + t.class.filterOptionShowSearchBox + "-wrapper").length > 0 && jQ(this).find("." + t.class.filterBlockContent).siblings("." + t.class.filterOptionShowSearchBox + "-wrapper").show())
    })
}, BCSfFilter.prototype.removeFilterTreeMobileStyle3 = function() {
    this.removeFilterTreeMobileStyle2()
}, BCSfFilter.prototype.buildToolbarFilterTreeMobile = function(e) {
    "open" == e ? (jQ(".bc-sf-filter-mobile-toolbar-left").html('<a class="bc-sf-filter-mobile-apply" onclick="applyFilterOption()">' + this.getSettingValue("label.apply") + "</a>"), "collection" != jQ(".bc-sf-filter-option-block-active").data("type") ? jQ(".bc-sf-filter-mobile-toolbar-right").html('<a class="' + this.class.clearButton + '" onClick="clearFilterOptionMobile()">' + this.getSettingValue("label.clear") + "</a>") : jQ(".bc-sf-filter-mobile-toolbar-right").empty()) : (jQ(".bc-sf-filter-mobile-toolbar-left").html('<a href="javascript:;" class="bc-sf-filter-close-btn" onClick="closeFilterMobile()">' + this.getSettingValue("label.close") + "</a>"), this.checkExistFilterOptionParam() ? jQ(".bc-sf-filter-mobile-toolbar-right").html(this.buildClearAllButton()) : jQ(".bc-sf-filter-mobile-toolbar-right").empty())
}, BCSfFilter.prototype.buildFilterSelectionMobile = function() {
    var e = [],
        t = this;
    if (jQ(this.selector.filterTree + " ." + this.class.filterOption).each(function() {
            var i = jQ(this).data("type"),
                n = jQ(this);
            if (!t.isCollectionParam(i)) {
                var r = [],
                    o = jQ(this).attr("data-id"),
                    a = jQ(this).attr("data-display-type"),
                    s = jQ(this).attr("data-type"),
                    l = jQ(this).attr("data-select-type");
                if (f = null != (f = jQ(this).attr("data-prefix")) && !1 !== f ? f.replace(/\\/g, "") : "", "range" !== a) {
                    if (jQ(this).find("a.selected").each(function() {
                            e.push(o + "=" + jQ(this).attr("data-value"))
                        }), t.queryParams.hasOwnProperty(o) && t.queryParams[o] && t.queryParams[o].length) {
                        var c = t.queryParams[o];
                        Array.isArray(c) || (c = [c]);
                        for (var u = 0; u < c.length; u++) {
                            var p = t.customizeFilterOptionLabel(c[u], f, s);
                            r.push(p), "single" !== l && e.push(o + "=" + encodeURIParamValue(c[u]))
                        }
                    }
                    e = e.filter(function(e, t, i) {
                        var r = !0;
                        if (e.length && (iValue = e.split("="), iValue.length > 1)) {
                            var o = n.find('a[data-id="' + iValue[0] + '"][data-value="' + iValue[1] + '"]');
                            o.length && !o.hasClass("selected") && (r = !1)
                        }
                        return i.indexOf(e) === t && r
                    })
                } else if (jQ(this).find("." + t.class.filterOptionRange + "-slider").hasClass("selected")) {
                    var d = jQ(this).find("." + t.class.filterOptionRange + "-slider").attr("data-value");
                    p = "";
                    if (d.length) {
                        if (jQ(this).find("." + t.class.filterOptionRange + "-slider").hasClass("bc-sf-filter-option-advanced-range-slider")) {
                            var f, h = jQ(this).data("filter-option");
                            f = (f = jQ(this).data("prefix") || "").replace(/\\/g, "");
                            var g = d.split(","),
                                m = [];
                            if (h && h.hasOwnProperty("values")) m = h.values.map(function(e) {
                                return e.key
                            });
                            var v = m.length ? t.getAdvancedRangeSelectedValues(g, m) : [g[0], g[g.length - 1]];
                            for (var u in p = v[0].toString().replace(f, ""), g.length > 1 && (p += " - " + v[1].toString().replace(f, "")), g) e += "&" + o + "=" + encodeURIParamValue(g[u])
                        } else {
                            g = d.split(":");
                            if ("price" == i) {
                                var b = t.formatMoney(100 * g[0]),
                                    y = t.formatMoney(100 * g[1]);
                                t.getSettingValue("general.removePriceDecimal") && (b = t.removeDecimal(b), y = t.removeDecimal(y));
                                p = b + " - " + y
                            } else p = g[0] + " - " + g[1];
                            e.push(o + "=" + encodeURIParamValue(d))
                        }
                        r.push(p)
                    }
                }
                jQ(this).find("." + t.class.filterBlockTitle + " p").remove(), jQ(this).find("." + t.class.filterBlockTitle).append('<p class="' + t.class.filterSelectedItemsMobile + '">' + r.join(", ") + "</p>")
            }
        }), e.length && (e = "&" + e.join("&")), this.isSearchPage) {
        var i = this.getSearchTerm();
        null !== i && "" != i && (e += "&" + this.searchTermKey + "=" + i)
    }
    jQ("#bc-sf-filter-params").remove(), jQ(this.selector.filterTree).append('<input type="hidden" id="bc-sf-filter-params" value="' + e + '"/>')
}, BCSfFilter.prototype.buildFilterOptionTitleEvent = function() {
    switch (this.mobileStyle) {
        case "style2":
            this.buildFilterOptionTitleEventStyle2();
            break;
        case "style3":
            this.buildFilterOptionTitleEventStyle3()
    }
}, BCSfFilter.prototype.buildFilterOptionTitleEventStyle2 = function() {
    var e = this,
        t = this.selector.filterTree,
        i = jQ(t).find("#bc-sf-filter-options-wrapper"),
        n = jQ(t).find("." + this.class.filterBlockTitle);
    n.unbind("click"), n.click(function() {
        i.css("opacity", .5);
        var n = this;
        jQ("." + e.class.filterBlockContent).hide(), jQ(this).children().css("white-space", "nowrap"), i.animate({
            width: "toggle"
        }, "fast", function() {
            jQ(t + " ." + e.class.filterOption).hide(), jQ(t).find("." + e.class.filterBlockTitle).hide(), jQ(n).parent().show(), jQ(n).parent().addClass("bc-sf-filter-option-block-active"), jQ(n).siblings().show(), i.css("opacity", 1), e.buildToolbarFilterTreeMobile("open")
        }), i.animate({
            width: "toggle"
        }, "fast", function() {
            var t = jQ(n).siblings("." + e.class.filterBlockContent);
            e.buildFilterOptionBoxStyle(t), e.buildFilterScrollbar(t)
        })
    })
}, BCSfFilter.prototype.buildFilterOptionTitleEventStyle3 = function() {
    var e = this,
        t = this.selector.filterTree,
        i = (jQ(t).find("#bc-sf-filter-options-wrapper"), jQ(t).find("." + this.class.filterBlockTitle)),
        n = this.class.filterOptionOpenList,
        r = jQ("." + n).length > 0 ? jQ("." + n).val().split(",") : [];
    i.unbind("click"), i.click(function() {
        var t = jQ(this),
            i = jQ(this).parent().attr("data-id");
        "block" == jQ(this).siblings("." + e.class.filterBlockContent).css("display") ? (jQ(this).siblings().slideUp(), t.parents("." + e.class.filterOption).removeClass("bc-sf-filter-option-block-active"), r.length > 0 && r.indexOf(i) > -1 && r.splice(r.indexOf(i), 1)) : (jQ(this).siblings().slideDown(function() {
            t.parents("." + e.class.filterOption).addClass("bc-sf-filter-option-block-active"), e.buildFilterScrollbar(t.siblings("." + e.class.filterBlockContent))
        }), r.push(i), e.buildFilterOptionBoxStyle(jQ(this).siblings("." + e.class.filterBlockContent))), jQ("." + n).val(r.join(","))
    })
}, BCSfFilter.prototype.checkIsFullWidthMobile = function() {
    return !(!this.isMobile() || "style2" != this.mobileStyle && "style3" != this.mobileStyle)
}, BCSfFilter.prototype.isLoadMorePaginationType = function() {
    return "load_more" == this.getSettingValue("general.paginationType")
}, BCSfFilter.prototype.isDefaultPaginationType = function() {
    return "default" == this.getSettingValue("general.paginationType")
}, BCSfFilter.prototype.isInfiniteLoadingPaginationType = function() {
    return "infinite" == this.getSettingValue("general.paginationType")
}, BCSfFilter.prototype.isLoadPreviousPagePaginationType = function() {
    var e = this;
    return e.isLoadMorePaginationType() && e.isAdvancedPaginationType() && e.getSettingValue("general.activeLoadPreviousPage") && jQ(e.getSelector("btnLoadPreviousPageWrapperSelector")).length > 0
}, BCSfFilter.prototype.isAdvancedPaginationType = function() {
    return this.getSettingValue("general.paginationTypeAdvanced")
}, BCSfFilter.prototype.buildToolbarEvent = function(e) {
    this.buildPaginationEvent(e), this.buildSortingEvent(), this.buildShowLimitEvent(), this.buildDisplayTypeEvent()
}, BCSfFilter.prototype.buildPaginationEvent = function(e) {
    switch (this.getSettingValue("general.paginationType")) {
        case "default":
            this.buildDefaultPaginationEvent(e);
            break;
        case "load_more":
            this.buildLoadMoreEvent(e), this.buildLoadPreviousPageEvent(e);
            break;
        default:
            this.buildInfiniteLoadingEvent(e)
    }
}, BCSfFilter.prototype.buildDefaultPaginationEvent = function(e) {
    var t = this,
        i = this.getSelector("pagination");
    jQ(i).find("a").unbind("click"), jQ(i).find("a").on("click", function(e) {
        e.preventDefault(), t.internalClick = !0;
        var i = jQ(this).attr("href");
        t.onChangeData(i, "page"), jQ("body,html").animate({
            scrollTop: jQ(t.getSelector("products")).offset().top - 50
        }, 600)
    })
}, BCSfFilter.prototype.buildInfiniteLoadingEvent = function(e) {
    var t = this,
        i = parseInt(e.total_product),
        n = parseInt(t.getSettingValue("general.limit")),
        r = parseInt(t.queryParams.page);
    if (i > n * r) {
        var o = 0,
            a = !1,
            s = jQ(t.getSelector("bottomPagination"));
        s.length > 0 && jQ(window).scroll(function(i) {
            if (i.preventDefault(), i.stopPropagation(), jQ(t.selector.products).hasClass("bc-sf-product-loading")) return !1;
            var n = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight()),
                l = parseInt(s.offset().top),
                c = parseInt(jQ(window).scrollTop()) + n + t.getSettingValue("general.positionShowInfiniteLoading");
            if (jQ(window).scrollTop() + jQ(window).height() + n >= jQ(document).outerHeight() - 100 && (a = !0), 0 == o && e.products.length > 0 && (c >= l || c < l && a)) {
                t.showLoadMoreLoading(), o = 1, r++;
                var u = Math.ceil(e.total_product / t.getSettingValue("general.limit"));
                if (r <= u)
                    if (t.internalClick = !0, t.queryParams.limit = t.getSettingValue("general.limit"), t.queryParams.page = r, t.getSettingValue("general.paginationTypeAdvanced")) {
                        var p = t.buildToolbarLink("page", r - 1, r);
                        t.onChangeData(p, "page")
                    } else t.getFilterData("page")
            }
        })
    }
}, BCSfFilter.prototype.buildLoadMoreEvent = function(e) {
    var t = this;
    if (e.total_product > 0) {
        var i = (1 == this.queryParams.page ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1) + e.products.length - 1,
            n = (this.queryParams.page - 1) * this.queryParams.limit + 1;
        jQ(t.getSelector("products") + " > *").length && (n -= jQ(t.getSelector("products") + " > *").length - this.queryParams.limit);
        var r = this.getSettingValue("label.loadMoreTotal").replace(/{{ from }}/g, n).replace(/{{ to }}/g, i).replace(/{{ total }}/g, e.total_product);
        jQ("#bc-sf-filter-load-more-total").empty().html(r);
        var o = t.getSettingValue("label.loadMore").replace(/{{ amountProduct }}/g, this.queryParams.limit);
        jQ(t.getSelector("loadMoreButtonContainer") + " .bc-sf-filter-load-more-button").empty().html(o)
    }
    var a, s = (bcsffilter.queryParams, parseInt(this.queryParams.page));
    a = t.isLoadPreviousPagePaginationType() ? parseInt(sessionStorage.getItem(t.getSettingValue("general.sessionStorageCurrentNextPage"))) : s, jQ(this.getSelector("loadMore")).find("a").off("click").on("click", function(e) {
        if (e.preventDefault(), jQ(t.getSelector("loadMoreButtonContainer")).hide(), t.showLoadMoreLoading(), a++, t.internalClick = !0, t.queryParams.limit = t.getSettingValue("general.limit"), t.queryParams.page = a, t.isAdvancedPaginationType()) {
            var i = t.buildToolbarLink("page", s, a);
            t.isLoadPreviousPagePaginationType() && (sessionStorage.setItem(t.getSettingValue("general.sessionStorageCurrentNextPage"), a), sessionStorage.setItem(t.getSettingValue("general.sessionStoragePreviousPageEvent"), 0)), t.onChangeData(i, "page")
        } else t.getFilterData("page")
    })
}, BCSfFilter.prototype.buildLoadPreviousPageEvent = function(e) {
    var t = this;
    if (t.isLoadPreviousPagePaginationType()) {
        var i = jQ(t.getSelector("btnLoadPreviousPageWrapperSelector"));
        i.unbind("click"), i.on("click", function(e) {
            e.preventDefault();
            var i, n = parseInt(t.queryParams.page),
                r = jQ(this);
            if ((i = null != sessionStorage.getItem(t.getSettingValue("general.sessionStorageCurrentPreviousPage")) ? parseInt(sessionStorage.getItem(t.getSettingValue("general.sessionStorageCurrentPreviousPage"))) : n) < 2) return r.hide(), !1;
            t.internalClick = !0, t.queryParams.limit = t.getSettingValue("general.limit"), i--, t.queryParams.page = i;
            var o = t.buildToolbarLink("page", n, i);
            sessionStorage.setItem(t.getSettingValue("general.sessionStorageCurrentPreviousPage"), i), sessionStorage.setItem(t.getSettingValue("general.sessionStoragePreviousPageEvent"), 1), t.onChangeData(o, "page"), i < 2 && r.hide()
        })
    }
}, BCSfFilter.prototype.buildSortingEvent = function() {
    var e = this;
    jQ(this.getSelector("topSorting") + " select").change(function(t) {
        onInteractWithToolbar(t, "sort", e.queryParams.sort, jQ(this).val())
    })
}, BCSfFilter.prototype.buildShowLimitEvent = function() {
    var e = this;
    jQ(this.getSelector("topShowLimit") + " select").change(function(t) {
        onInteractWithToolbar(t, "limit", e.queryParams.limit, jQ(this).val())
    })
}, BCSfFilter.prototype.buildDisplayTypeEvent = function() {
    var e = this;
    jQ(this.getSelector("topDisplayType") + " a").click(function(t) {
        t.preventDefault(), e.internalClick = !0, jQ(this).parent().children().removeClass("active"), jQ(this).addClass("active");
        var i = jQ(this).attr("href");
        e.onChangeData(i, "display")
    })
}, BCSfFilter.prototype.buildToolbarLink = function(e, t, i) {
    var n = window.location.href,
        r = e + "=" + t,
        o = e + "=" + i;
    n.indexOf("?" + e + "=") > -1 ? n = n.replace("?" + r, "?" + o) : n.indexOf("&" + e + "=") > -1 ? n = n.replace("&" + r, "&" + o) : 0 === window.location.search.length ? n += "?" + o : n = n.replace("?", "?" + o + "&"), "page" == e && 1 == i && (n = n.replace("?page=1&", "?").replace("?page=1", ""));
    if (this.queryParams.hasOwnProperty("page") && -1 == ["display", "sort", "page", "limit"].indexOf(e)) {
        var a = "&page=" + this.queryParams.page;
        n = n.replace(a, "")
    }
    return n
}, BCSfFilter.prototype.showLoading = function() {
    (!this.isMobile() && this.getSettingValue("general.showLoading") || this.isMobile() && this.getSettingValue("general.showMobileLoading")) && (0 == jQ("#bc-sf-filter-loading").length && jQ("body").append(this.getTemplate("loading")), jQ("#bc-sf-filter-loading").show())
}, BCSfFilter.prototype.hideLoading = function() {
    (!this.isMobile() && this.getSettingValue("general.showLoading") || this.isMobile() && this.getSettingValue("general.showMobileLoading")) && jQ("#bc-sf-filter-loading").hide()
}, BCSfFilter.prototype.removePlaceholderForFilterTree = function() {
    jQ(this.getSelector("filterTree")).find(".bc-sf-filter-option-skeleton").remove(), jQ(this.getSelector("filterTreeHorizontal")).find(".bc-sf-filter-option-skeleton").remove(), jQ("body").find(".bc-sf-filter-skeleton-text, .bc-sf-filter-skeleton-button").remove(), this.getSettingValue("general.loadProductFromLiquid") && "ajax" == this.getSettingValue("general.loadProductFromLiquidType") || this.removePlaceholderForProductList()
}, BCSfFilter.prototype.removePlaceholderForProductList = function() {
    var e = this;
    jQ(this.getSelector("products")).find(".bc-sf-filter-product-skeleton").remove(), setTimeout(function() {
        jQ(e.getSelector("products")).removeClass("bc-sf-product-loading").css("min-height", 0)
    })
}, BCSfFilter.prototype.showLoadMoreLoading = function() {
    if (this.getSettingValue("general.showLoadMoreLoading") && !1 === this.getSettingValue("general.showLoading")) {
        var e = this.getTemplate("loadMoreLoading").replace("{{loadingIcon}}", '<div id="bc-sf-filter-load-more-icon"></div>');
        jQ(this.getSelector("loadMore")).append(e), jQ(this.getSelector("loadMore")).show()
    }
}, BCSfFilter.prototype.hideLoadMoreLoading = function() {
    this.getSettingValue("general.showLoadMoreLoading") && jQ(this.getSelector("loadMoreLoading")).remove()
}, BCSfFilter.prototype.showError = function(e) {}, BCSfFilter.prototype.buildPagination = function(e) {}, BCSfFilter.prototype.buildLoadMoreButton = function(e) {
    var t = this.getSelector("loadMore"),
        i = this.getSelector("loadMoreButtonContainer"),
        n = this.queryParams,
        r = Math.ceil(e / n.limit);
    if (0 == jQ(this.getSelector("loadMoreButtonContainer")).length) {
        var o = this.getTemplate("loadMoreButton").replace(/{{label.loadMore}}/g, this.getSettingValue("label.loadMore"));
        jQ(t).prepend(o)
    }
    parseInt(n.page) < r ? (jQ(t).show(), jQ(i).show()) : jQ(t).hide()
}, BCSfFilter.prototype.buildLoadPreviousButton = function(e, t) {
    var i = this;
    if (i.isLoadPreviousPagePaginationType()) {
        var n = jQ(this.getSelector("btnLoadPreviousPageWrapperSelector"));
        if (0 == jQ(i.getSelector("btnLoadPreviousPageSelector")).length) {
            var r = i.getTemplate("btnLoadPreviousPageTemplate").replace(/{{label.loadPreviousPage}}/g, this.getSettingValue("label.loadPreviousPage"));
            n.html(r)
        }
        var o = i.queryParams,
            a = Math.ceil(e / o.limit),
            s = o.page,
            l = a > 1 && s > 1;
        "init" != t && "page" == t || (sessionStorage.setItem(i.getSettingValue("general.sessionStorageCurrentPreviousPage"), s), sessionStorage.setItem(i.getSettingValue("general.sessionStorageCurrentPage"), s), sessionStorage.setItem(i.getSettingValue("general.sessionStorageCurrentNextPage"), s), sessionStorage.setItem(i.getSettingValue("general.sessionStoragePreviousPageEvent"), 1), l ? n.show() : n.hide())
    }
}, BCSfFilter.prototype.buildToolbar = function() {
    this.buildFilterShowLimit(), this.buildFilterSorting(), this.buildFilterDisplayType()
}, BCSfFilter.prototype.buildFilterShowLimit = function() {}, BCSfFilter.prototype.buildFilterSorting = function() {}, BCSfFilter.prototype.buildFilterDisplayType = function() {}, BCSfFilter.prototype.getSortingList = function() {
    var e = this.getSettingValue("general.sortingList"),
        t = this.getSettingValue("general.customSortingList");
    if ("" != t)
        for (var i = (e = t.trim().split("|")).length - 1; i >= 0; i--) "" == e[i] && e.splice(i, 1);
    var n = this.getSettingValue("general.extraSortingList");
    if (n && (e = e.concat(n.split("|"))), this.isSearchPage()) {
        var r = this.findIndexArray("manual", e);
        r >= 0 && e.splice(r, 1)
    } else {
        var o = this.findIndexArray("relevance", e);
        o >= 0 && e.splice(o, 1)
    }
    for (var a = {}, s = 0; s < e.length; s++) {
        var l = this.getSettingValue("label.sorting." + e[s]);
        n.length > 0 && n.indexOf(e[s]) > -1 && (l = this.getLabel("label", e[s].replace(/-/g, "_"))), a[e[s]] = l
    }
    return a
}, BCSfFilter.prototype.buildScrollToTop = function() {
    if (1 == this.getSettingValue("general.activeScrollToTop")) {
        var e = this.getSelector("scrollToTop");
        if (0 == jQ(e).length) {
            var t = this.getTemplate("scrollToTop");
            jQ("body").append(t)
        }
        "style1" != this.getSettingValue("general.styleScrollToTop") && jQ(e).addClass(this.getSettingValue("general.styleScrollToTop")), jQ(e).click(function() {
            jQ("html,body").stop().animate({
                scrollTop: 0
            })
        }), jQ(window).scroll(function(t) {
            jQ(window).scrollTop() > 100 ? jQ(e).show() : jQ(e).hide()
        })
    }
}, BCSfFilter.prototype.buildPageInfo = function(e) {
    function t(e, t) {
        i.buildBreadcrumb(e, t), i.buildCollectionDetail(e, t), i.buildDocumentInfo(e, t)
    }
    var i = this,
        n = window.location.pathname;
    if ("/" != n) {
        var r = {
            collection: {
                description: "",
                handle: bcSfFilterConfig.general.collection_handle,
                title: this.getSettingValue("label.collectionAll")
            }
        };
        if ("/collections/all" == n) t(r, e);
        else if (this.isVendorPage()) {
            t({
                collection: {
                    description: "",
                    handle: "",
                    title: getParam("q")
                }
            }, e)
        } else if (this.isTypePage()) {
            t({
                collection: {
                    description: "",
                    handle: "",
                    title: getParam("q")
                }
            }, e)
        } else if ("/search" != n) {
            var o = window.location.href.split("?")[0] + "?view=desc";
            jQ.ajax({
                method: "GET",
                url: o,
                dataType: "json",
                success: function(i) {
                    t(i, e)
                },
                error: function() {
                    t(r, e)
                }
            })
        }
    }
}, BCSfFilter.prototype.buildBreadcrumb = function(e, t) {}, BCSfFilter.prototype.buildCollectionDetail = function(e, t) {
    if (void 0 !== e && e.hasOwnProperty("collection")) {
        var i = e.collection,
            n = i.hasOwnProperty("title") && "" != i.title ? i.title : null,
            r = i.hasOwnProperty("description") && "" != i.description ? i.description : null,
            o = this.class.collectionHeader,
            a = this.class.collectionDescription;
        n ? (jQ("." + o).html(n).show(), jQ("#" + o).html(n).show()) : (jQ("." + o).hide(), jQ("#" + o).hide()), r ? (jQ("." + a).html(r).show(), jQ("#" + a).html(r).show()) : (jQ("." + a).hide(), jQ("#" + a).hide())
    }
}, BCSfFilter.prototype.buildDocumentInfo = function(e, t) {
    if (void 0 !== e && e.hasOwnProperty("collection")) {
        var i = e.collection.title;
        void 0 !== this.collectionTags && null !== this.collectionTags && (i += " - " + this.collectionTags[0]), i += " - " + this.shopName, document.title = i
    }
}, BCSfFilter.prototype.buildRobotsMetaTag = function(e) {
    if (this.getSettingValue("general.enableSeo") && !0 === this.checkIfPFParamsPartOfAURL() && 0 === jQ("head").find('meta[content="noindex,nofollow"]').length) {
        var t = document.createElement("meta");
        t.name = "robots", t.content = "noindex,nofollow", document.head.appendChild(t)
    }
}, BCSfFilter.prototype.buildAdditionalElements = function(e, t) {}, BCSfFilter.prototype.buildDefaultElements = function(e) {}, BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() {
    return window.location.search.length > 0 && window.location.search.indexOf(this.getSettingValue("general.filterPrefixParam")) > 0
}, BCSfFilter.prototype.buildSEOTitle = function(e) {
    if (this.getSettingValue("search.enableFixHeadTitle")) {
        var t = e.total_product <= 1 ? this.getLabel("label", "search_seo_title_one", "Search result: {{ count }} result for &quot;{{ terms }}&quot;") : this.getLabel("label", "search_seo_title_other", "Search results: {{ count }} results for &quot;{{ terms }}&quot;"),
            i = this.getSearchTerm();
        t && null !== i && "" != i && (i = this.escape(i), t = t.replace(/{{ count }}/g, e.total_product).replace(/{{ terms }}/g, i), document.title = t.replace(/&quot;/g, '"'))
    }
}, BCSfFilter.prototype.buildSearchResultHeader = function(e) {
    var t = this.getSearchTerm();
    if (null !== t && "" != t) {
        t = this.escape(t);
        var i = e.total_product > 0 ? this.getSettingValue("label.search.resultHeader") : this.getSettingValue("label.search.resultEmpty")
    } else i = this.getSettingValue("label.search.generalTitle");
    jQ("." + this.class.searchResultHeader).html(i.replace(/{{ terms }}/g, t))
}, BCSfFilter.prototype.buildSearchResultNumber = function(e) {
    var t = "",
        i = this.getSearchTerm();
    null !== i && "" != i && (i = this.escape(i), t = (t = this.getSettingValue("label.search.resultNumber")).replace(/{{ count }}/g, "<strong>" + e.total_product + "</strong>").replace(/{{ terms }}/g, "<strong>" + i + "</strong>")), jQ("." + this.class.searchResultNumber).html(t)
}, BCSfFilter.prototype.getSearchTerm = function() {
    return getParam(this.searchTermKey)
}, BCSfFilter.prototype.buildSuggestion = function(e, t, i, n) {
    var r = this,
        o = (e = this.escape(e), jQ(i)),
        a = "",
        s = getValueInObjectArray("all_empty", t);
    if (o.closest("." + r.class.searchSuggestionWrapper).show(), s) getValueInObjectArray("redirect", t) ? o.closest("." + r.class.searchSuggestionWrapper).hide() : (a += r.buildSuggestionNoResult(e, i), o.append(a));
    else {
        var l = r.getSettingValue("search.suggestionBlocks");
        if (r.isSuggestionStyle2() && "products" != l[0].type) {
            var c = l.findIndex(function(e) {
                    return "products" == e.type
                }),
                u = l[c];
            l.splice(c, 1), r.getSettingValue("search.suggestionStyle2ReverseProductBlock") ? l.push(u) : l.unshift(u)
        }
        if ("" === getValueInObjectArray("suggest_query", t)) {
            var p = r.buildSuggestionViewAll(e, t, i);
            o.append(p)
        }
        var d, f = l.length;
        for (d = 0; d < f; d++) {
            var h = l[d];
            if (h.hasOwnProperty("status") && "active" == h.status) {
                var g = r.findIndexArray(h.type, t, "key");
                if (g > -1 && t[g].hasOwnProperty("values")) {
                    var m = t[g],
                        v = '<li class="bc-sf-search-suggestion-group" data-group="' + h.type + '" aria-label="' + l[d].label + '"><ul>';
                    switch (h.type) {
                        case "suggestions":
                            v += r.buildSuggestionPopular(e, m.values, i, h, t);
                            break;
                        case "products":
                            v += r.buildSuggestionProductList(e, m.values, i, h, t);
                            break;
                        case "pages":
                            v += r.buildSuggestionPage(e, m.values, i, h, t);
                            break;
                        case "collections":
                            v += r.buildSuggestionCollection(e, m.values, i, h, t)
                    }
                    v += "</ul></li>", o.append(v)
                }
            }
        }
    }
    o.find("." + r.class.searchSuggestionItem + "[data-label]").each(function() {
        var e = jQ(this),
            t = e.data("label") || "",
            i = e.data("value") || "";
        "" !== i && e.data("ui-autocomplete-item", {
            label: t.toString(),
            value: i
        }).addClass("bc-ui-item")
    }), r.buildSuggestionWrapper(i, n)
}, BCSfFilter.prototype.buildSuggestionWrapper = function(e, t) {
    var i = this,
        n = getSuggestionPosition(t);
    if (i.isSuggestionStyle2()) {
        var r = i.getSettingValue("search.suggestionStyle2MainContainerSelector") || "header:first";
        jQ(r).css("position", "relative")
    }
    var o = this.class.searchSuggestionWrapper,
        a = "bc-sf-search-suggestion-popover";
    if (!jQ(e).parent().hasClass(o)) {
        var s = this.checkIsFullWidthSuggestionMobile(t) ? this.class.searchSuggestionMobile : "";
        jQ(e).wrap('<div class="' + o + " " + s + '"></div>'), jQ(e).parent().prepend('<div class="' + a + '" data-direction="' + n + '"></div>')
    }
    i.isSuggestionStyle2() && jQ("." + i.class.searchSuggestionWrapper).length > 0 && jQ("." + i.class.searchSuggestionWrapper).addClass(i.class.searchSuggestionWrapper + "-" + i.getSettingValue("search.suggestionStyle")).addClass(i.class.searchSuggestionWrapper + "-" + i.getSettingValue("search.suggestionStyle") + "-width-fullwidth").addClass(i.class.searchSuggestion + "-products-per-row-" + i.getSettingValue("search.suggestionStyle2ProductPerRow")).addClass(i.class.searchSuggestion + "-reverse-product-block-" + i.getSettingValue("search.suggestionStyle2ReverseProductBlock")), jQ(e).siblings().show();
    var l = this.checkIsFullWidthSuggestionMobile(t) ? "top" : "top+12";
    if ("left" == n) {
        jQ(e).parent().position({
            my: "left " + l,
            at: "left bottom",
            of: jQ(t)[0]
        });
        var c = function() {
            jQ("." + a).position({
                my: "left+20 top-8" + l,
                at: "left bottom",
                of: jQ(t)[0]
            })
        }
    } else {
        jQ(e).parent().position({
            my: "right " + l,
            at: "right bottom",
            of: jQ(t)[0]
        });
        c = function() {
            jQ("." + a).position({
                my: "right-20 top-8",
                at: "right bottom",
                of: jQ(t)[0]
            })
        }
    }
    if (c(), i.isSuggestionStyle2()) jQ(window).resize(function() {
        c()
    });
    else {
        var u = this.getSuggestionWidth(t);
        jQ(e).parent().outerWidth(u)
    }
}, BCSfFilter.prototype.buildSuggestionPopular = function(e, t, i, n, r) {
    var o = "";
    if (Object.keys(t).length > 0) {
        o = this.buildSuggestionHeader(n.label, "popular");
        var a, s = t.length;
        for (a = 0; a < s; a++) {
            var l = this.highlightSuggestionResult(t[a], e);
            o += '<li class="' + this.class.searchSuggestionItem + '" data-label="' + this.escape(n.label) + ": " + this.escape(t[a]) + '" data-value="' + this.escape(t[a]) + '" aria-label="' + this.escape(n.label) + ": " + this.escape(t[a]) + '">', o += '<a href="' + this.buildSearchLink(t[a]) + '">' + l + "</a>", o += "</li>"
        }
    }
    return o
}, BCSfFilter.prototype.buildSuggestionProductList = function(e, t, i, n, r) {
    var o = "";
    o += this.buildSuggestionHeader(n.label, "product");
    var a = this.buildSuggestionDidYouMean(e, r, i);
    if ("" != a && (o += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + a + "</li>"), Object.keys(t).length > 0) {
        var s, l = t.length;
        for (s = 0; s < l; s++) {
            var c = t[s],
                u = this.customizeSuggetionProductTitle(c.title, e, t);
            u = this.highlightSuggestionResult(u, e);
            var p = this.buildProductItemUrl(c, !1),
                d = c.images_info.length > 0 ? this.optimizeImage(c.images_info[0].src, "200x") : bcSfFilterConfig.general.no_image_url,
                f = null !== c.skus && c.skus.length > 0 ? c.skus[0] : "",
                h = this.class.searchSuggestion,
                g = this.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";
            o += '<li class="' + this.class.searchSuggestionItem + " " + this.class.searchSuggestionItem + '-product" data-label="' + this.escape(c.id) + '" data-value="' + this.escape(c.title) + '" aria-label="' + this.escape(n.label) + ": " + this.escape(c.title) + '">', o += '<a href="' + p + '" ' + g + ">", this.getSettingValue("search.showSuggestionProductImage") && (o += '<div class="' + h + '-left"><img src="' + d + '" /></div>'), o += '<div class="' + h + '-right">', o += '<div class="' + h + '-product-title">' + u + "</div>", this.getSettingValue("search.showSuggestionProductSku") && (o += '<div class="' + h + '-product-sku">SKU: ' + f + "</div>"), this.getSettingValue("search.showSuggestionProductVendor") && (o += '<div class="' + h + '-product-vendor">' + c.vendor + "</div>"), o += this.buildSuggestionProductPrice(c), o += "</div>", o += "</a>", o += "</li>"
        }
    }
    return o
}, BCSfFilter.prototype.customizeSuggetionProductTitle = function(e, t, i) {
    return e
}, BCSfFilter.prototype.buildSuggestionProductPrice = function(e) {
    this.prepareSuggestionProductPriceData(e);
    var t = e.compare_at_price_min > e.price_min,
        i = this.formatMoney(100 * e.price_min),
        n = this.formatMoney(100 * e.compare_at_price_min);
    this.getSettingValue("search.removePriceDecimal") && (i = this.removeDecimal(i), n = this.removeDecimal(n));
    var r = "";
    return this.getSettingValue("search.showSuggestionProductPrice") && (r += '<div class="' + this.class.searchSuggestion + '-product-price">', t && this.getSettingValue("search.showSuggestionProductSalePrice") ? (r += "<s>" + n + "</s>  ", r += '<span class="bc-sf-product-sale-price">' + i + "</span>") : r += '<span class="bc-sf-product-regular-price">' + i + "</span>", r += "</div>"), r
}, BCSfFilter.prototype.prepareSuggestionProductPriceData = function(e) {
    function t(e, t) {
        return void 0 !== t ? t : e
    }
    if (void 0 !== bcSfFilterConfig.general.currencies && bcSfFilterConfig.general.currencies.length > 1) {
        var i = bcSfFilterConfig.general.current_currency.toLowerCase().trim();
        e.price_min = t(e.price_min, e["price_min_" + i]), e.price_max = t(e.price_max, e["price_max_" + i]), e.compare_at_price_min = t(e.compare_at_price_min, e["compare_at_price_min_" + i]), e.compare_at_price_max = t(e.compare_at_price_max, e["compare_at_price_max_" + i])
    }
}, BCSfFilter.prototype.buildSuggestionPage = function(e, t, i, n, r) {
    var o = "";
    if (Object.keys(t).length > 0) {
        o = this.buildSuggestionHeader(n.label, "page");
        var a, s = t.length;
        for (a = 0; a < s; a++) {
            var l = this.highlightSuggestionResult(t[a].title, e);
            o += '<li class="' + this.class.searchSuggestionItem + '" data-label="' + this.escape(n.label) + ": " + this.escape(t[a].title) + '" data-value="' + this.escape(t[a].title) + '" aria-label="' + this.escape(n.label) + ": " + this.escape(t[a].title) + '">', o += '<a href="' + t[a].url + '">' + l + "</a>", o += "</li>"
        }
    }
    return o
}, BCSfFilter.prototype.buildSuggestionCollection = function(e, t, i, n, r) {
    var o = "";
    if (Object.keys(t).length > 0) {
        o = bcsffilter.buildSuggestionHeader(n.label, "collection");
        var a, s = t.length;
        for (a = 0; a < s; a++) {
            var l = bcsffilter.highlightSuggestionResult(t[a].title, e);
            o += '<li class="' + bcsffilter.class.searchSuggestionItem + '" data-label="' + this.escape(t[a].id) + '" data-value="' + this.escape(t[a].title) + '" aria-label="' + this.escape(n.label) + ": " + this.escape(t[a].title) + '">', o += '<a href="/collections/' + t[a].handle + '">' + l + "</a>", o += "</li>"
        }
    }
    return o
}, BCSfFilter.prototype.buildSuggestionDidYouMean = function(e, t, i) {
    var n = "";
    if (void 0 !== t && Object.keys(t).length > 0) {
        var r = getValueInObjectArray("suggest_query", t),
            o = getValueInObjectArray("total_product", t),
            a = getValueInObjectArray("prev_total_product", t);
        "" !== a && o > 0 && (o = a);
        var s = getValueInObjectArray("did_you_mean", t),
            l = "";
        if ("" != s && s.length > 0) {
            var c, u = s.length;
            for (c = 0; c < u; c++) l += '<a href="' + this.buildSearchLink(s[c]) + '">' + s[c] + "</a>", c < s.length - 1 && (l += "<span>,</span> ")
        }
        r != e && (0 == o && (n += "<p>" + this.getSettingValue("label.error.noSuggestionProducts").replace(/{{ terms }}/g, "<strong>" + e + "</strong>") + "</p>"), "" != r && (n += "<p>" + this.getSettingValue("label.suggestion.suggestQuery").replace(/{{ terms }}/g, '<a href="' + this.buildSearchLink(r) + '">' + r + "</a>") + "</p>"), "" != l && (n += "<p>" + this.getSettingValue("label.suggestion.didYouMean").replace(/{{ terms }}/g, l) + "</p>"))
    }
    return n
}, BCSfFilter.prototype.buildSuggestionViewAll = function(e, t, i) {
    var n = this.class.searchSuggestionHeader,
        r = "",
        o = getValueInObjectArray("total_product", t),
        a = getValueInObjectArray("suggest_total_product", t);
    return "" !== a && (o = a), o > getValueInObjectArray("products", this.getSettingValue("search.suggestionBlocks"), "type", "number") && o > 0 && (r += '<li class="' + n + "-view-all " + n + '" aria-label="View All">', r += '<a href="' + this.buildSearchLink(e) + '">' + this.getSettingValue("label.suggestion.viewAll").replace(/{{ count }}/g, o).replace(/{{ terms }}/g, e) + "</a>", r += "</li>"), r
}, BCSfFilter.prototype.buildSuggestionHeader = function(e, t) {
    var i = this.class.searchSuggestionHeader;
    return '<li class="' + i + "-" + t + " " + i + '" aria-label="' + this.escape(e) + '">' + e + "</li>"
}, BCSfFilter.prototype.highlightSuggestionResult = function(e, t) {
    function i(e) {
        return new RegExp(e.replace(/([\(\)\{\}\[\]\.\+\-\=\\\/])/g, "\\$&"), "ig")
    }
    if (this.getSettingValue("search.highlightSuggestionResult") && t.length > 1) {
        var n, r = t.split(" "),
            o = r.length;
        for (n = 0; n < o; n++) {
            var a = i(r[n]),
                s = e.match(a);
            if (null !== s && s.length > 0) {
                var l, c = (s = s.filter(function(e, t) {
                    return s.indexOf(e) == t && "" != e
                })).length;
                for (l = 0; l < c; l++)
                    if (s[l].length > 1) {
                        a = i(s[l]);
                        e = e.replace(a, "<b>" + s[l] + "</b>")
                    }
            }
        }
    }
    return e
}, BCSfFilter.prototype.buildSuggestionNoResult = function(e, t, i) {
    var n = this.getSettingValue("label.error.noSuggestionResult").replace(/{{ terms }}/g, e),
        r = '<li class="bc-sf-search-suggestion-no-result ' + this.class.searchSuggestionItem + '" data-label="No Results: ' + e + '" data-value="' + e + '" aria-label="No Results">';
    return (r += "<span>" + n + "</span>") + "</li>"
}, BCSfFilter.prototype.buildSuggestionStyle = function() {
    jQ("." + this.class.searchSuggestionHeader).css({
        "font-size": this.getSettingValue("search.fontSizeSuggestionHeader"),
        background: this.getSettingValue("search.bgSuggestionHeader"),
        color: this.getSettingValue("search.colorSuggestionHeader")
    })
}, BCSfFilter.prototype.buildSearchLink = function(e) {
    return "/search?" + this.searchTermKey + "=" + encodeURIParamValue(e)
}, BCSfFilter.prototype.initSearchBox = function(e) {
    if (this.getSettingValue("search.enableSuggestion")) {
        var t = this;
        void 0 === e ? jQ('input[name="' + this.searchTermKey + '"]').each(function(e) {
            if (!jQ(this)[0].hasAttribute("data-no-bc-search")) {
                var i = "bc-sf-search-box-" + e;
                jQ(this).attr({
                    id: i,
                    "aria-live": "polite",
                    placeholder: t.getSettingValue("label.suggestion.searchBoxPlaceholder")
                }), t.buildSearchBox("#" + i)
            }
        }) : this.buildSearchBox(e), this.isMobile() && (window.onpageshow = function(e) {
            e.persisted && window.location.reload()
        }, "style1" == this.getSettingValue("search.suggestionMobileStyle") && this.buildSuggestionMobile())
    }
}, BCSfFilter.prototype.beforeBuildSearchBox = function(e) {
    this.checkIsFullWidthSuggestionMobile(e) && (jQ(e).removeAttr("autofocus"), jQ(e).is(":focus") && jQ(e).blur())
}, BCSfFilter.prototype.buildSearchBox = function(e) {
    this.beforeBuildSearchBox(e);
    var t = this;
    if (jQ(e).length > 0) {
        var i;
        i = t.isSuggestionStyle2() ? t.getSettingValue("search.suggestionStyle2MainContainerSelector") || "header:first" : "body";
        var n = this.currentTerm = getParam(this.searchTermKey);
        jQ(e).val(n), jQ(e).autocomplete({
            appendTo: i,
            minLength: t.getSettingValue("search.suggestionMinLength"),
            delay: 200,
            source: function(i, n) {
                window.suggestionCallback = n, t.currentTerm = i.term;
                var r = i.term.trim().replace(/\s+/g, " ");
                "" != r && t.requestSuggestion(r, e)
            },
            classes: {
                "ui-autocomplete": t.class.searchSuggestion
            },
            response: function(i, n) {
                var r = n.content,
                    o = getValueInObjectArray("query", r),
                    a = getValueInObjectArray("event_type", r),
                    s = getValueInObjectArray("suggest_query", r),
                    l = getValueInObjectArray("local_cache", r),
                    c = getValueInObjectArray("redirect", r);
                25 == Object.keys(t.suggestionCache).length && (t.suggestionCache = {}), o in t.suggestionCache || "suggest_dym" == a || (t.suggestionCache[o] = r), "" == s || "suggest" != a || l || t.getSuggestionData(s, 0, "suggest_dym", o), t.checkForSearchRedirect(e, c), t.hideSuggestionLoading(e)
            },
            focus: function(i, n) {
                return t.focusSuggestionEvent(e, i, n)
            },
            open: function(i, n) {
                t.openSuggestionEvent(e, i)
            },
            close: function(i, n) {
                t.closeSuggestionEvent(e, i)
            },
            select: function(i, n) {
                return t.selectSuggestionEvent(e, i)
            }
        }).addClass(t.class.searchBox).attr("data-search-box", e), jQ(e).autocomplete("instance")._renderMenu = function(i, n) {
            return i.attr("data-search-box", e), t.buildSuggestion(this.term, n, i, e)
        }, jQ(e).autocomplete("instance")._resizeMenu = function() {
            var i = this.menu.element,
                n = this.element;
            t.buildStyleSuggestion(i, n, e)
        }, t.customSearchMenuWidget(e), t.clickOutsideSuggestionEvent(e)
    }
    this.setSuggestionPosition(e), this.buildSearchBoxEvent(e), this.afterBuildSearchBox(e)
}, BCSfFilter.prototype.buildSearchBoxEvent = function(e) {
    var t = this;
    if (jQ(e).length > 0 && (jQ(e).on("click", function(i) {
            t.clickSearchBoxEvent(e, i)
        }).on("focus", function(i) {
            t.focusSearchBoxEvent(e, i)
        }).on("keyup", function(i) {
            t.typeSearchBoxEvent(e, i)
        }).on("keydown", function(i) {
            13 == i.keyCode && t.enterSearchBoxEvent(e, i)
        }), jQ(e).closest("form").length > 0)) {
        var i = jQ(e).closest("form").find('[type="submit"]');
        i && i.length > 0 && i.each(function(t, i) {
            i.setAttribute("onclick", "beforeSubmitSearchForm('" + e + "', event)")
        })
    }
}, BCSfFilter.prototype.afterBuildSearchBox = function(e) {}, BCSfFilter.prototype.requestSuggestion = function(e, t) {
    var i = this;
    ! function(e) {
        var n = getSuggestionInstance(t);
        i.showSuggestionLoading(n, t), e in i.suggestionCache ? suggestionCallback(i.suggestionCache[e]) : i.getSuggestionData(e, 0, "suggest")
    }(e)
}, BCSfFilter.prototype.buildSuggestionMobile = function() {
    var e = this.selector.searchBoxMobile;
    if (0 == jQ(e).length) {
        var t = '<button type="button" class="bc-sf-search-btn-close-suggestion" onclick="closeSuggestionMobile(\'' + e + "', true);\"><-</button>",
            i = this.getSettingValue("search.showSearchBtnMobile") ? '<a href="javascript:;" class="bc-sf-search-submit-mobile" onclick="submitSearchFormMobile(this, event)"><span>Submit</span></a>' : "",
            n = '<button type="button" class="bc-sf-search-btn-clear-suggestion" onclick="clearSuggestionMobile(\'' + e + "');\">X</button>";
        jQ("body").append('<div class="bc-sf-search-suggestion-mobile-overlay"></div><div class="bc-sf-search-suggestion-mobile-top-panel"><form action="/search" method="get">' + t + i + '<input type="text" name="' + this.searchTermKey + '" placeholder="' + this.getSettingValue("label.suggestion.searchBoxPlaceholder") + '" id="' + e.substr(1) + '" />' + n + "</form></div>"), this.buildSearchBox(e)
    }
}, BCSfFilter.prototype.beforeOpenSuggestionMobile = function(e) {}, BCSfFilter.prototype.openSuggestionMobile = function(e) {
    this.beforeOpenSuggestionMobile(e), jQ("body").hasClass(this.getClass("searchSuggestionMobileOpen")) || jQ("body").addClass(this.getClass("searchSuggestionMobileOpen")), this.showSearchBoxMobile(e);
    var t = this.selector.searchBoxMobile;
    jQ(t).autocomplete("search"), jQ("." + this.class.searchSuggestion + '[data-search-box="' + t + '"]').parent().show(), jQ("html,body").scrollTop(), this.afterOpenSuggestionMobile()
}, BCSfFilter.prototype.afterOpenSuggestionMobile = function() {}, BCSfFilter.prototype.showSearchBoxMobile = function(e) {
    this.clickOutsideSuggestionMobileEvent(), this.scrollSuggestionMobileEvent(), "" == jQ(e).val() ? hideClearSuggestionBtn() : showClearSuggestionBtn();
    var t = this.selector.searchBoxMobile;
    jQ(t).is(":focus") || (jQ(".bc-sf-search-suggestion-mobile-top-panel,.bc-sf-search-suggestion-mobile-overlay").show(), jQ("[tabindex=-1]").removeAttr("tabindex").addClass("bc-sf-search-no-tabindex"), setTimeout(function() {
        jQ(t).focus()
    }, 100), this.afterShowSearchBoxMobile())
}, BCSfFilter.prototype.afterShowSearchBoxMobile = function(e) {}, BCSfFilter.prototype.clickOutsideSuggestionMobileEvent = function() {
    var e = this;
    jQ(document).on("touchstart", function(t) {
        var i = jQ(".bc-sf-search-suggestion-mobile-top-panel"),
            n = jQ(".bc-sf-search-suggestion-wrapper");
        0 != n.length && "none" != n.css("display") || !i.is(t.target) || closeSuggestionMobile(e.selector.searchBoxMobile, !0)
    })
}, BCSfFilter.prototype.afterCloseSuggestionMobile = function(e, t) {}, BCSfFilter.prototype.clickSearchBoxEvent = function(e, t) {
    "" != jQ(e).val() && (this.checkIsFullWidthSuggestionMobile(e) ? (jQ(this.selector.searchBoxMobile).val(jQ(e).val()), this.openSuggestionMobile(e)) : jQ(e).data("ui-autocomplete") && jQ(e).autocomplete("search", jQ(e).val()))
}, BCSfFilter.prototype.focusSearchBoxEvent = function(e, t) {
    this.checkIsFullWidthSuggestionMobile(e) && e != this.selector.searchBoxMobile && (this.showSearchBoxMobile(e), this.clickSearchBoxEvent(e, t))
}, BCSfFilter.prototype.typeSearchBoxEvent = function(e, t) {
    this.currentTerm = t.target.value, this.checkIsFullWidthSuggestionMobile(e) && (jQ("." + this.class.searchSuggestion + '[data-search-box="' + e + '"]').parent().show(), "" == t.target.value ? (closeSuggestionMobile(e), hideClearSuggestionBtn()) : showClearSuggestionBtn())
}, BCSfFilter.prototype.enterSearchBoxEvent = function(e, t) {
    var i = jQ(e).val();
    !i && t && t.target && (i = t.target.value);
    var n = this.getSearchRedirectUrl(i);
    this.submitSearch(i, e, n, t)
}, BCSfFilter.prototype.checkForSearchRedirect = function(e, t) {
    jQ(e).data("search-submit") && (jQ(e).removeData("search-submit"), t ? (t = (t = t.replace("https://" + bcSfFilterMainConfig.shop.domain, "")).replace("http://" + bcSfFilterMainConfig.shop.domain, ""), window.location.href = t) : jQ(e).closest("form").submit())
}, BCSfFilter.prototype.getSearchRedirectUrl = function(e) {
    var t = "";
    if (e && ("string" != typeof e && (e = e.toString()), e = e.trim().toLowerCase(), this.suggestionCache.hasOwnProperty(e)))
        for (var i = this.suggestionCache[e], n = 0; n < i.length; n++) "redirect" == i[n].key && i[n].values && (t = (t = (t = i[n].values).replace("https://" + bcSfFilterMainConfig.shop.domain, "")).replace("http://" + bcSfFilterMainConfig.shop.domain, ""));
    return t
}, BCSfFilter.prototype.submitSearch = function(e, t, i, n) {
    n.stopImmediatePropagation(), n.stopPropagation(), n.preventDefault(), this.suggestionCache.hasOwnProperty(e.toString().trim()) ? i ? window.location.href = i : jQ(t).closest("form").submit() : jQ(t).closest('input[name="' + this.searchTermKey + '"]').data("search-submit", !0)
}, BCSfFilter.prototype.focusSuggestionEvent = function(e, t, i) {
    var n = jQ(e).autocomplete("instance").widget();
    return n.find("." + this.class.searchSuggestionItem).removeClass("selected"), !(!i.item || void 0 === i.item.label || (n.find("." + this.class.searchSuggestionItem + '[data-label="' + i.item.label + '"]').addClass("selected"), 0))
}, BCSfFilter.prototype.selectSuggestionEvent = function(e, t) {
    var i = jQ(e).autocomplete("instance").widget().find("." + this.class.searchSuggestionItem + ".selected");
    if (i.length) {
        var n = i.find("> a");
        n.length && (window.location.href = n.eq(0).attr("href"))
    }
    return !1
}, BCSfFilter.prototype.openSuggestionEvent = function(e, t) {
    var i = this;
    i.isiOS() && jQ("." + this.class.searchSuggestionItem + " a").on("touchstart", function() {
        isScrolling = !1
    }).on("touchmove", function(e) {
        isScrolling = !0
    }).on("touchend", function(e) {
        isScrolling || (window.location = jQ(this).attr("href"))
    });
    var n = jQ("body");
    i.checkIsFullWidthSuggestionMobile(e) && !n.hasClass(i.getClass("searchSuggestionMobileOpen")) && n.addClass(i.getClass("searchSuggestionMobileOpen"))
}, BCSfFilter.prototype.closeSuggestionEvent = function(e) {
    "test" == this.getSettingValue("search.suggestionMode") || this.checkIsFullWidthSuggestionMobile(e) ? jQ("." + this.class.searchSuggestion).show() : jQ("." + this.class.searchSuggestion + '[data-search-box="' + e + '"]').siblings().hide()
}, BCSfFilter.prototype.customSearchMenuWidget = function(e) {
    var t = jQ(e).autocomplete("instance").menu,
        i = "." + this.class.searchSuggestionItem + ".bc-ui-item";
    t._setOption("items", i), t._setOption("blur", function(e, t) {
        t.item && jQ(t.item).removeClass("selected")
    }), t.isFirstItem = function() {
        return !!this.active && !this.element.find(i).index(this.active)
    }, t.isLastItem = function() {
        if (this.active) {
            var e = this.element.find(i),
                t = e.index(this.active) + 1;
            return !(e.length - t)
        }
        return !1
    }, t._move = function(e, t, n) {
        var r, o = this.element.find(i);
        if (this.active)
            if ("first" === e || "last" === e);
            else {
                var a;
                a = "next" == e ? o.index(this.active) + 1 : o.index(this.active) - 1, r = o.eq(a)
            } r && r.length && this.active || (r = this.element.find(this.options.items)[t]()), this.focus(n, r)
    }
}, BCSfFilter.prototype.checkIsFullWidthSuggestionMobile = function(e) {
    return !(!this.isMobile() || "style1" != this.getSettingValue("search.suggestionMobileStyle"))
}, BCSfFilter.prototype.clickOutsideSuggestionEvent = function(e) {
    if (!this.checkIsFullWidthSuggestionMobile(e)) {
        var t = this;
        jQ(document).bind("click", function(i) {
            jQ(e).data("ui-autocomplete") && void 0 !== jQ(e).autocomplete("instance") && (jQ(i.target).parents().addBack().is("." + t.class.searchSuggestion) || jQ(i.target).parents().addBack().is("." + t.class.searchBox) || jQ(e).autocomplete("close"))
        })
    }
}, BCSfFilter.prototype.scrollSuggestionMobileEvent = function(e) {
    var t = jQ(this.getSelector("searchBoxMobile"));
    jQ(document).on("touchmove", function(e) {
        t.is(":focus") && t.blur()
    })
}, BCSfFilter.prototype.buildStyleSuggestion = function(e, t, i) {
    var n = this.getSuggestionWidth(i);
    this.setSuggestionWidth(i, n), this.customizeSuggestionStyle(e, t, i), this.customizeSuggestion(e, t, i)
}, BCSfFilter.prototype.customizeSuggestionStyle = function(e, t, i) {
    var n = this;
    if (n.isSuggestionStyle2()) {
        var r = function(e) {
            var t = 0;
            return e.each(function(e, i) {
                t += jQ(i).outerHeight(!0)
            }), t
        };
        if (jQ("." + n.class.searchSuggestionWrapper).length > 0) {
            var o = 20;
            if (jQ(e).find('.bc-sf-search-suggestion-group[data-group="products"]').length > 0) {
                var a = jQ(e).find('.bc-sf-search-suggestion-group[data-group="products"]');
                jQ(e).find('.bc-sf-search-suggestion-group[data-group="pages"]').find("." + n.class.searchSuggestionItem).length > 0 && (o += r(jQ(e).find('.bc-sf-search-suggestion-group[data-group="pages"]').find("." + n.class.searchSuggestionItem))), jQ(e).find('.bc-sf-search-suggestion-group[data-group="collections"]').find("." + n.class.searchSuggestionItem).length > 0 && (o += r(jQ(e).find('.bc-sf-search-suggestion-group[data-group="collections"]').find("." + n.class.searchSuggestionItem))), jQ(e).find('.bc-sf-search-suggestion-group[data-group="suggestions"]').find("." + n.class.searchSuggestionItem).length > 0 && (o += r(jQ(e).find('.bc-sf-search-suggestion-group[data-group="suggestions"]').find("." + n.class.searchSuggestionItem))), a.css("min-height", o + "px")
            }
        }
    }
}, BCSfFilter.prototype.isSuggestionStyle2 = function() {
    var e = this;
    return void 0 !== e.getSettingValue("search.suggestionStyle") && "style2" == e.getSettingValue("search.suggestionStyle") && !e.isMobile()
}, BCSfFilter.prototype.getSuggestionWidth = function(e) {
    if ("auto" == this.getSettingValue("search.suggestionWidth") || this.isMobile()) var t = jQ(e).outerWidth();
    else t = this.getSettingValue("search.suggestionWidth");
    return t
}, BCSfFilter.prototype.setSuggestionPosition = function(e) {
    var t = getSuggestionPosition(e),
        i = this.checkIsFullWidthSuggestionMobile(e) ? "top" : "top+12";
    this.isSuggestionStyle2() || ("left" == t ? jQ(e).autocomplete("option", "position", {
        my: "left " + i,
        at: "left bottom",
        collision: "none"
    }) : jQ(e).autocomplete("option", "position", {
        my: "right " + i,
        at: "right bottom",
        collision: "none"
    }))
}, BCSfFilter.prototype.setSuggestionWidth = function(e, t) {
    jQ("ul." + this.class.searchSuggestion + '[data-search-box="' + e + '"]').outerWidth(t)
}, BCSfFilter.prototype.customizeSuggestion = function(e, t, i) {}, BCSfFilter.prototype.prepareSuggestionParams = function(e, t) {
    var i = {};
    i.shop = this.shopDomain, i.t = (new Date).getTime(), this.getSettingValue("search.enableDefaultResult") || (i.enable_default_result = !1);
    var n = this.getSettingValue("search.enableFuzzy");
    !0 !== n && (i.fuzzy = n), this.getSettingValue("search.fullMinMatch") && (i.full_min_match = !0), !1 !== this.getSettingValue("search.reduceMinMatch") && (i.reduce_min_match = this.getSettingValue("search.reduceMinMatch")), this.getSettingValue("search.enablePlusCharacterSearch") && (i.enable_plus_character_search = !0), 1 == this.getSettingValue("search.productAvailable") && (i.product_available = !0);
    var r, o = this.getSettingValue("search.suggestionBlocks"),
        a = o.length;
    for (r = 0; r < a; r++) i[o[r].type.slice(0, -1) + "_limit"] = o[r].number;
    i.dym_limit = this.getSettingValue("search.suggestionDymLimit");
    var s = this.getSettingValue("search.skipFields");
    s.length > 0 && (param.skipFields = s), i.callback = "BCSfSuggestionCallback", i.event_type = t;
    var l = "suggest_dym" == t ? ["products"] : this.getSettingValue("search.suggestionTypes");
    return i.suggest_types = l, i
}, BCSfFilter.prototype.beforeGetSuggestionData = function(e) {}, BCSfFilter.prototype.getSuggestionData = function(e, t, i, n) {
    t = void 0 !== t ? t : 0, n = void 0 !== n ? n : "";
    var r = this;
    this.beforeGetSuggestionData(i), e = this.customizeSearchTerm(e);
    var o = this.prepareSuggestionParams(e, i);
    "" != n && (o.prev_query = n);
    var a = document.createElement("script");
    a.type = "text/javascript", a.src = this.getApiUrl("suggestion") + "?q=" + e + "&" + jQ.param(o), a.async = !0, a.addEventListener("error", function(o) {
        this.remove(), t < 3 && (t++, r.getSuggestionData(e, t, i, n))
    }), document.getElementsByTagName("head")[0].appendChild(a), a.onload = function() {
        this.remove()
    }
}, BCSfFilter.prototype.customizeSearchTerm = function(e) {
    return encodeURIParamValue(e.trim())
}, BCSfFilter.prototype.showSuggestionLoading = function(e, t) {
    if (this.getSettingValue("search.showSuggestionLoading")) {
        jQ(e).children().hide();
        var i = this.class.searchSuggestionLoading;
        if (0 == jQ("." + i).length) {
            this.buildSuggestionWrapper(e, t);
            var n = i + "-img",
                r = '<li class="' + i + '"><ul><li><div class="' + n + '"></div></li><li><div class="' + n + '"></div></li><li><div class="' + n + '"></div></li></ul></li>';
            if (jQ(e).prepend(r), jQ(e).show(), !this.isSuggestionStyle2()) {
                var o = this.getSuggestionWidth(t);
                jQ(e).outerWidth(o);
                var a = getSuggestionPosition(t),
                    s = this.checkIsFullWidthSuggestionMobile(t) ? "top" : "top+12";
                "left" == a ? jQ(e).position({
                    my: "left " + s,
                    at: "left bottom",
                    of: jQ(t)[0]
                }) : jQ(e).position({
                    my: "right " + s,
                    at: "right bottom",
                    of: jQ(t)[0]
                })
            }
        }
        jQ("." + i).show()
    }
}, BCSfFilter.prototype.hideSuggestionLoading = function(e) {
    this.getSettingValue("search.showSuggestionLoading") && jQ("." + this.class.searchSuggestionLoading).hide()
}, BCSfFilter.prototype.prepareProductData = function(e) {
    return e
}, BCSfFilter.prototype.buildProductList = function(e, t) {
    (0 == this.loadProductFirst || this.isSearchPage() || this.isVendorPage() || this.isTagPage() || this.isTypePage() || "best-selling" == this.defaultSorting || 1 == this.getSettingValue("general.productAndVariantAvailable") || 1 == this.loadProductFirst && ("init" != t || window.location.search.length > 0) || 1 == this.getSettingValue("general.sortingAvailableFirst")) && (e = this.prepareProductData(e), this.getSettingValue("general.loadProductFromLiquid") ? this.buildProductListDataFromLiquid(e, t) : (this.buildProductListData(e, t), this.buildExtrasProductList(e, t)))
}, BCSfFilter.prototype.buildProductListData = function(e, t) {
    (this.isDefaultPaginationType() || !this.isDefaultPaginationType() && "page" != t) && (jQ(this.getSelector("products")).html(""), jQ(window).unbind("scroll"));
    for (var i = "", n = e.length, r = 0; r < n; r++) {
        switch (this.queryParams.display) {
            case "list":
                var o = this.buildProductListItem(e[r], r + 1, n);
                break;
            case "collage":
                o = this.buildProductCollageItem(e[r], r + 1, n);
                break;
            default:
                o = this.buildProductGridItem(e[r], r + 1, n)
        }
        i += this.buildProductItemAdvanced(e[r], o)
    }
    this.buildProductListDataHtml(i)
}, BCSfFilter.prototype.buildProductListDataHtml = function(e) {
    this.isLoadPreviousPagePaginationType() && 1 == sessionStorage.getItem(this.getSettingValue("general.sessionStoragePreviousPageEvent")) ? jQ(this.getSelector("products")).prepend(e) : jQ(this.getSelector("products")).append(e)
}, BCSfFilter.prototype.buildProductListDataFromLiquid = function(e, t) {
    (this.isDefaultPaginationType() || !this.isDefaultPaginationType() && "page" != t) && jQ(window).unbind("scroll"), "sync" == this.getSettingValue("general.loadProductFromLiquidType") ? this.getProductHtmlBySync(e, t) : this.getProductHtmlByAjax(e, t)
}, BCSfFilter.prototype.getProductHtmlByAjax = function(e, t, i) {
    var n = this;
    i || (i = 0);
    for (var r = 20 * i, o = Math.min(e.length, 20 * (i + 1)), a = [], s = r; s < o; s++) a.push(e[s].handle);
    var l = a.join("+");
    jQ.ajax({
        type: "GET",
        url: "/collections/all/" + l + "?view=bc-sf-product-item",
        success: function(r) {
            n.afterGetProductHtmlByAjax(e, t, i, r)
        }
    })
}, BCSfFilter.prototype.afterGetProductHtmlByAjax = function(e, t, i, n) {
    var r = [];
    try {
        r = JSON.parse(n).products
    } catch (e) {
        return void console.log("Could not parse json from collection.bc-sf-product-item.liquid")
    }

    for (var o = 0; o < r.length; o++)
        for (var a = 0; a < e.length; a++) e[a].id == r[o].id && (e[a].html = r[o].html.value);
    var s = "",
        l = e.length,
        c = 20 * i;
    for (o = c; o < c + r.length; o++) {
        switch (this.queryParams.display) {
            case "list":
                var u = this.buildProductListItem(e[o], o + 1, l);
                break;
            case "collage":
                u = this.buildProductCollageItem(e[o], o + 1, l);
                break;
            default:
                u = this.buildProductGridItem(e[o], o + 1, l)
        }
        s += this.buildProductItemAdvanced(e[o], u)
    }
    0 == i && (this.removePlaceholderForProductList(), (this.isDefaultPaginationType() || !this.isDefaultPaginationType() && "page" != t) && jQ(this.getSelector("products")).html(""));
    var p = this.isLoadPreviousPagePaginationType() && 1 == sessionStorage.getItem(this.getSettingValue("general.sessionStoragePreviousPageEvent"));
    0 == i && p ? jQ(this.getSelector("products")).prepend(s) : jQ(this.getSelector("products")).append(s), c < e.length - 1 ? (i++, this.getProductHtmlByAjax(e, t, i)) : this.buildExtrasProductList(e, t)
}, BCSfFilter.prototype.getProductHtmlBySync = function(e, t) {
    for (var i = "", n = e.length, r = 0; r < n; r++) {
        if (!(e[r].html && e[r].html.value && e[r].html.theme_id && bcSfFilterMainConfig.general.theme_id && bcSfFilterMainConfig.general.theme_id == e[r].html.theme_id)) {
            console.log("Error getting product by metafield, fallback to get by ajax"), this.getProductHtmlByAjax(e, t);
            break
        }
        switch (e[r].html = e[r].html.value, this.queryParams.display) {
            case "list":
                var o = this.buildProductListItem(e[r], r + 1, n);
                break;
            case "collage":
                o = this.buildProductCollageItem(e[r], r + 1, n);
                break;
            default:
                o = this.buildProductGridItem(e[r], r + 1, n)
        }
        i += this.buildProductItemAdvanced(e[r], o)
    }
    this.buildProductListDataHtml(i), this.buildExtrasProductList(e, t)
}, BCSfFilter.prototype.buildExtrasProductList = function(e, t) {}, BCSfFilter.prototype.buildExtrasProductListByAjax = function(e, t, i, n, r, o) {
    var a = this;
    o || (o = 0), (!n || n > 20) && (n = 20);
    for (var s = n * o, l = Math.min(e.length, n * (o + 1)), c = [], u = s; u < l; u++) c.push(e[u].handle);
    var p = c.join("+");
    r || (r = []);
    var d = "/collections/all/" + p + "?view=" + t;
    jQ.ajax({
        type: "GET",
        url: d,
        success: function(l) {
            try {
                r = r.concat(JSON.parse(l).products)
            } catch (e) {
                return void console.log("Could not parse json from " + d + ": " + e.message)
            }
            s < e.length - 1 ? (o++, a.buildExtrasProductListByAjax(e, t, i, n, r, o)) : "function" == typeof i && i(r)
        }
    })
}, BCSfFilter.prototype.scrollBackPositionHistoryBack = function() {
    if (this.getSettingValue("general.enableKeepScrollbackPosition")) {
        var e = jQ(this.selector.products).children();
        if (this.isAdvancedPaginationType() && e.length > 0) {
            var t = parseInt(this.queryParams.page);
            if (e.each(function() {
                    if (void 0 === jQ(this).attr("id")) {
                        var e = "";
                        jQ(this).find("a").each(function() {
                            var t = jQ(this).attr("href") || "";
                            if (t.length > 0 && t.match(/(?:\/products\/)(?:[^\?]*)/)) return e = t.split("?")[0], !1
                        });
                        var i = e.toString().replace(/^_+|_+$|\//g, "") + "-" + t;
                        jQ(this).attr("id", i)
                    }
                    void 0 === jQ(this).data("page") && jQ(this).attr("data-page", t)
                }), this.isMobile()) {
                var i = !1;
                e.on("touchstart", function() {
                    i = !1
                }).on("touchmove", function(e) {
                    i = !0
                }).on("touchend", function(e) {
                    var t = jQ(this).attr("id") || !1;
                    if (!i && t) {
                        var n = new URL(window.location.href),
                            r = jQ(this).data("page") || 1,
                            o = {
                                productId: t,
                                page: r
                            };
                        null !== n.searchParams.get("page") && n.searchParams.delete("page"), parseInt(r) > 1 && n.searchParams.append("page", r), window.history.replaceState(o, "", n.toString().replace(/\+/g, "%20"))
                    }
                })
            } else e.click(function(e) {
                var t = jQ(this).attr("id") || !1;
                if (t) {
                    var i = new URL(window.location.href),
                        n = jQ(this).data("page") || 1,
                        r = {
                            productId: t,
                            page: n
                        };
                    null !== i.searchParams.get("page") && i.searchParams.delete("page"), parseInt(n) > 1 && i.searchParams.append("page", n), window.history.replaceState(r, "", i.toString().replace(/\+/g, "%20"))
                }
            });
            if ("scrollRestoration" in history && (history.scrollRestoration = "manual"), null !== history.state && history.state.hasOwnProperty("productId")) {
                var n = new URL(window.location.href),
                    r = history.state.productId;
                null !== r && (window.history.replaceState("", "", n.toString().replace(/\+/g, "%20")), jQ("html, body").animate({
                    scrollTop: jQ("#" + r).offset().top
                }, 0))
            }
        }
    }
}, BCSfFilter.prototype.buildProductGridItem = function(e, t, i) {
    return ""
}, BCSfFilter.prototype.buildProductListItem = function(e, t, i) {
    return ""
}, BCSfFilter.prototype.buildProductCollageItem = function(e, t, i) {
    return ""
}, BCSfFilter.prototype.buildProductItemUrl = function(e, t) {
    var i = window.location.search.substring(1),
        n = window.location.pathname,
        r = "object" == typeof e && e.hasOwnProperty("handle") ? e.handle : e;
    if (t = void 0 === t || t) {
        if ("/" == n || this.isSearchPage() || this.isVendorPage() || this.isTypePage()) return (o = (c = n.split("/")).indexOf(bcSfFilterMainConfig.general.current_locale) > -1 ? "/" + bcSfFilterMainConfig.general.current_locale + "/collections/all/products/" : "/collections/all/products/") + r;
        if (this.isTagPage()) {
            var o = (c = n.split("/")).indexOf(bcSfFilterMainConfig.general.current_locale) > -1 ? "/" + bcSfFilterMainConfig.general.current_locale + "/collections/" : "/collections/",
                a = c.indexOf("collections") + 1;
            return c.length >= 4 ? o + c[a] + "/products/" + r : "/collections/all/products/" + r
        }
        if (i.indexOf("cache:") > -1) {
            var s = "all",
                l = i.split("&")[0].split("?")[0].split("collections/");
            return l.length > 1 && (s = l[1].indexOf("/") > -1 ? l[1].split("/")[0] : l[1]), "/collections/" + (s = s.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, "")) + "/products/" + r
        }
        var c;
        a = (c = n.split("/")).indexOf("collections") + 1, o = c.indexOf(bcSfFilterMainConfig.general.current_locale) > -1 ? "/" + bcSfFilterMainConfig.general.current_locale + "/collections/" : "/collections/";
        return void 0 !== c[2] ? o + c[a] + "/products/" + r : window.location.pathname + "/products/" + r
    }
    return "/products/" + r
}, BCSfFilter.prototype.buildProductItemVendorUrl = function(e) {
    return window.location.protocol + "//" + window.location.hostname + "/collections/vendors?q=" + encodeURIParamValue(e)
}, BCSfFilter.prototype.buildProductItemAdvanced = function(e, t) {
    return t
}, BCSfFilter.prototype.getFeaturedImage = function(e, t) {
    t = void 0 !== t ? t : "large";
    var i = this.optimizeImage(bcSfFilterConfig.general.no_image_url, t);
    return e.length > 0 && (i = "object" == typeof e[0] ? this.optimizeImage(e[0].src, t) : this.optimizeImage(e[0], t)), i
}, BCSfFilter.prototype.optimizeImage = function(e, t) {
    null === e && (e = bcSfFilterConfig.general.no_image_url);
    t = void 0 !== t ? t : "large";
    for (var i = this.getSettingValue("general.imageExtension"), n = 0; n < i.length; n++) e = e.replace("." + i[n] + "?", "_" + t + "." + i[n] + "?");
    return e
}, BCSfFilter.prototype.getProductMetafield = function(e, t, i) {
    if (e.hasOwnProperty("metafields")) {
        var n = e.metafields.filter(function(e) {
            return e.namespace == t && e.key == i
        });
        if (void 0 !== n[0]) return n[0].value
    }
    return null
}, BCSfFilter.prototype.buildPlaceholderProductList = function(e) {
    var t = this.getSettingValue("general.showPlaceholderProductList");
    if (void 0 !== t && t && (0 == this.loadProductFirst || this.isSearchPage() || this.isVendorPage() || this.isTagPage() || this.isTypePage() || "best-selling" == this.defaultSorting || 1 == this.getSettingValue("general.productAndVariantAvailable") || 1 == this.loadProductFirst && ("init" != e || window.location.search.length > 0))) {
        if (void 0 === this.queryParams.display || "grid" == this.queryParams.display || "function" != typeof this.buildPlaceholderProductExtra) {
            var i = 140,
                n = bcSfFilterConfig.custom.product_grid_class || this.getSettingValue("general.placeholderProductGridItemClass"),
                r = this.getTemplate("skeletonProduct"),
                o = this.getSettingValue("general.placeholderImageRatio");
            "" == n && (n = jQ(this.selector.products).find("> *").length > 0 ? jQ(this.selector.products).find("> *").first().attr("class") : "bc-sf-filter-skeleton-def-width"), r = r.replace(/{{wrapClass}}/g, n), parseInt(o) > 0 && (i = 100 * o), r = r.replace(/{{paddingTop}}/g, i), jQ(this.selector.products).addClass("bc-sf-product-loading").css("min-height", jQ(this.selector.products).height()), (this.isDefaultPaginationType() || !this.isDefaultPaginationType() && "page" != e) && jQ(this.selector.products).html("");
            var a = parseInt(this.getSettingValue("general.placeholderProductPerRow"));
            a <= 0 && (a = bcSfFilterConfig.custom.products_per_row || 3);
            for (var s = 0; s < a; s++) jQ(this.selector.products).append(r)
        } else this.buildPlaceholderProductExtra(e);
        jQ(this.getSelector("bottomPagination")).hide(), jQ(this.getSelector("loadMore")).hide()
    }
}, BCSfFilter.prototype.pageOverFallback = function(e) {
    if (e.total_product > 0 && Array.isArray(e.products) && 0 == e.products.length) {
        var t = this.queryParams.limit || !1,
            i = this.queryParams.page || 1,
            n = Math.ceil(e.total_product / t);
        if (t && i > 1 && i > n) {
            this.queryParams.page = n;
            var r = new URL(window.location.href);
            if (null !== r.searchParams.get("page") && r.searchParams.delete("page"), r.searchParams.append("page", n), "undefined" != typeof History) return History.replaceState("", "", r.toString().replace(/\+/g, "%20")), !0
        }
    }
    return !1
}, BCSfFilter.prototype.buildFilterOptionLabel = function(e, t, i) {
    e = (e = this.customizeFilterOptionLabel(e, i.prefix, i.filterType, i.displayAllValuesInUppercaseForm)).replace(/\$/g, "&#36;");
    var n = this.getTemplate("filterOptionLabel").replace(/{{itemValue}}/g, e);
    return this.getSettingValue("general.showFilterOptionCount") && "box" != i.displayType && !0 !== i.keepValuesStatic && null !== t && (t > 0 && 0 == this.getSettingValue("general.showOutOfStockOption") || 1 == this.getSettingValue("general.showOutOfStockOption")) ? n.replace(/{{itemAmount}}/g, "(" + t + ")") : n.replace(/{{itemAmount}}/g, "")
}, BCSfFilter.prototype.customizeFilterOptionLabel = function(e, t, i, n) {
    return "price" != i && "percent_sale" != i || (e = e.replace(/\*/g, "").replace(/\-/g, ":"), e = "price" == i ? this.getPriceLabel(e) : this.getPercentSaleLabel(e)), null != t && !1 !== t && (t = t.replace(/\\/g, ""), e = e.replace(t, "").trim()), e.indexOf("bc-sf-filter-icon-star") > -1 ? e : (n = n || !1) ? e.toUpperCase() : this.getSettingValue("general.forceCapitalizeFilterOptionValues") ? capitalize(e, !0) : this.getSettingValue("general.capitalizeFirstLetterFilterOptionValues") ? capitalize(e, !0, !0) : this.getSettingValue("general.capitalizeFilterOptionValues") ? capitalize(e) : e
}, BCSfFilter.prototype.customizeSwatchFileName = function(e, t, i) {
    if (this.getSettingValue("general.removePrefixFromSwatchFile") && i.prefix) {
        var n = i.prefix.replace(/\\/g, "");
        e = e.replace(n, "")
    }
    return this.slugify(e).replace(/\#/g, "")
}, BCSfFilter.prototype.buildFilterOptionTooltip = function(e) {
    var t = "";
    if (!this.isMobile() && e.hasOwnProperty("tooltip") && e.tooltip) {
        var i = this.escape(stripScriptTag(e.tooltip));
        t = '<span class="' + this.class.filterOptionTooltip + '" data-bc-tooltip-title="' + i + '">', t += '<span class="bc-sf-filter-tooltip-arrow"></span>', t += "</span>", t += '<div class="bc-sf-filter-tooltip-wrapper"><div class="bc-sf-filter-qtip-content">' + i + "</div></div>"
    }
    return t
}, BCSfFilter.prototype.buildTooltipEvent = function() {
    jQ(".bc-sf-filter-option-tooltip").hover(function() {
        var e = jQ(this).parent().find(".bc-sf-filter-tooltip-wrapper"),
            t = jQ(this).parent().find(".bc-sf-filter-qtip-content"),
            i = jQ(this).position(),
            n = t.outerWidth();
        e.css("left", i.left + "px"), n / 2 < i.left ? e.css("margin-left", -(n / 2 - 12) + "px") : n / 2 > i.left && e.css("margin-left", -i.left / 2 + "px")
    })
}, BCSfFilter.prototype.buildFilterShowMore = function(e, t) {
    var i = this;
    if (void 0 !== e)
        if ("none" == t) jQ(e).addClass("no-scrollbar");
        else switch (this.getSettingValue("general.activeFilterScrollbar") && (this.isMobile() || this.getSettingValue("general.activeFilterScrollbarPC")) || jQ(e).addClass("no-scrollbar"), t) {
            case "viewmore":
                i.buildFilterViewMore(e, !1);
                break;
            case "viewmore_scrollbar":
                i.buildFilterViewMore(e, !0);
                break;
            default:
                i.buildFilterScrollbar(e)
        } else jQ("." + this.class.filterOption).each(function() {
            var e = jQ(this).data("show-more-type");
            e && "range" != jQ(this).data("display-type") && i.buildFilterShowMore(jQ(this).find("." + i.class.filterBlockContent), e)
        })
}, BCSfFilter.prototype.isEnableScrollbar = function(e) {
    var t = e.hasOwnProperty("showMoreType") ? e.showMoreType : "scrollbar",
        i = this.getSettingValue("general.activeFilterScrollbar") && (this.isMobile() || this.getSettingValue("general.activeFilterScrollbarPC"));
    return t.indexOf("scrollbar") > -1 && i
}, BCSfFilter.prototype.buildFilterScrollbar = function(e) {
    function t() {
        for (var t in i.scrollData) {
            var n = i.scrollData[t];
            if (jQ('div[data-block-id="' + n.id + '"]').find(".jspScrollable").length > 0) {
                var r = jQ('div[data-block-id="' + n.id + '"]').find(".jspScrollable").eq(0),
                    o = r.data("jsp");
                if (void 0 !== o)
                    for (var a = -1; o.getContentPositionY() < parseInt(n.position) && a < o.getContentPositionY();) a = o.getContentPositionY(), o.scrollToY(parseInt(n.position))
            }
        }
        jQ(".jspScrollable").removeClass("bc-scrollmore-loading bc-icon-center"), e && r && !r.hasClass("bc-scrollmore-loaded") && r.addClass("bc-scrollmore-loaded")
    }
    var i = this;
    if (void 0 !== e ? jQ(function() {
            if (jQ(e).hasClass(i.class.filterBlockContent) && !jQ(e).hasClass("no-scrollbar")) try {
                var t = jQ(e),
                    n = jQ(i.selector.filterTreeHorizontal).length > 0;
                if (!i.isMobile() && n) {
                    var r = " ." + i.class.filterBlockContent + "-inner";
                    t = t.find(r)
                }
                if (t[0].scrollHeight > t[0].clientHeight && t.bind("jsp-scroll-y", function(e, t, n, r) {
                        i.triggerScrollYFilterOption(e, t, n, r)
                    }).jScrollPane({
                        contentWidth: "0px"
                    }), jQ(e).is(":visible")) {
                    var o = Math.floor(jQ(e).width() / (jQ(e).find("li:first").width() + parseInt(jQ(e).find("li:first").css("margin-right"))));
                    t.attr("data-columns", o)
                }
            } catch (t) {
                jQ(e).css("overflow-y", "auto")
            }
        }) : jQ("." + this.class.filterOption).each(function() {
            "scrollbar" == jQ(this).data("show-more-type") && "range" != jQ(this).data("display-type") && i.buildFilterScrollbar(jQ(this).find("." + i.class.filterBlockContent))
        }), this.getSettingValue("general.keepScrollState") && this.hasOwnProperty("scrollData") && this.scrollData.length > 0) {
        var n = jQ(i.selector.filterTreeHorizontal).length > 0,
            r = !i.isMobile() && n ? 3e3 : 12e3; - 1 == this.scrollData.findIndex(function(e) {
            return e.position > r
        }) ? t() : (jQ(".jspScrollable").addClass("bc-scrollmore-loading bc-icon-center"), setTimeout(t, 200))
    }
}, BCSfFilter.prototype.removeScrollbar = function(e) {
    var t = this;
    1 == e.length ? e.jScrollPane().data("jsp").destroy() : e.length > 1 && e.each(function() {
        t.removeScrollbar(jQ(this))
    })
}, BCSfFilter.prototype.triggerScrollYFilterOption = function(e, t, i, n) {
    if (n) {
        var r = jQ(e.delegateTarget).data("jsp"),
            o = jQ(e.delegateTarget).parents("." + this.class.filterOption).data("filter-option") || !1;
        if (o && o.hasOwnProperty("showMoreDataDown") && o.showMoreDataDown.length > 0) {
            var a = o.filterType,
                s = o.filterOptionId,
                l = o.label,
                c = o.displayType,
                u = o.selectType,
                p = jQ(e.delegateTarget).data("columns") || 1,
                d = p > 4 ? 20 * p : 30 * p,
                f = o.showMoreDataDown;
            if (jQ(e.delegateTarget).addClass("bc-scrollmore-loading"), setTimeout(function() {
                    jQ(e.delegateTarget).removeClass("bc-scrollmore-loading")
                }, 500), f.length > d) var h = f.splice(0, d);
            else {
                h = f;
                f = []
            }
            for (var g = this.selector.filterTreeHorizontal && jQ(e.delegateTarget).parents(this.selector.filterTreeHorizontal).length > 0 ? "horizontal" : "vertical", m = "", v = 0; v < h.length; v++) switch (c) {
                case "list":
                    m += this.buildFilterOptionMultipleListData(a, s, l, c, u, h[v], o, g);
                    break;
                case "box":
                    m += this.buildFilterOptionBoxData(a, s, l, c, u, h[v], o, g);
                    break;
                case "swatch":
                    m += this.buildFilterOptionSwatchData(a, s, l, c, u, h[v], o, g)
            }
            o.showMoreDataDown = f, r.getContentPane().find("ul").append(m), "box" == c && "vertical" == g && this.buildFilterOptionBoxStyle(jQ(e.delegateTarget)), r.reinitialise(), jQ(e.delegateTarget).parents("." + this.class.filterOption).attr("data-filter-option", JSON.stringify(o))
        }
    }
}, BCSfFilter.prototype.scrollbarPrepareData = function(e, t) {
    var i = this.getSettingValue("general.scrollFirstLoadLength");
    if (i.hasOwnProperty(e.displayType) && null !== i[e.displayType] && (i = i[e.displayType]), this.isEnableScrollbar(e) && t.length > i) {
        var n = t.slice(0, i);
        t = t.slice(i)
    } else {
        n = t;
        t = []
    }
    return e.showMoreDataDown = t, e.firstBuild = n, e
}, BCSfFilter.prototype.prepareAdvancedRangeSlider = function(e) {
    var t = this,
        i = this.getSettingValue("general.advancedRangeSliders") || [];
    return Array.isArray(i) && i.length && jQ.each(i, function(i, n) {
        var r = t.findIndexArray(n, e, "filterOptionId");
        r > -1 && (e[r].displayType = "range")
    }), e
}, BCSfFilter.prototype.buildShortenPipLabels = function(e, t) {
    if (this.getSettingValue("general.shortenPipsRange")) {
        var i = this.getSettingValue("general.formatPipsRange");
        if (Array.isArray(i)) {
            i.sort(function(e, t) {
                return t.node - e.node
            });
            for (var n = new RegExp(t, "g"), r = parseFloat(e.replace(n, "")), o = 0; o < i.length; o++)
                if (r > i[o].node) {
                    var a = Math.abs(i[o].fix);
                    if (e = parseFloat((r / i[o].node).toFixed(a)), (null == i[o].suffix || 0 == i[o].suffix) && a > 0 && e % 1 != 0) e = e.toString().replace(".", i[o].symbol);
                    else {
                        var s = this.getSettingValue("general.decimalDelimiter") || ".";
                        e = e.toString().replace(".", s), e += i[o].symbol
                    }
                    break
                }
        }
    }
    return e
}, BCSfFilter.prototype.getAdvancedRangeSelectedValues = function(e, t, i) {
    function n(e, t, i) {
        var n = bcsffilter.findIndexArray(e, t);
        return 1 == i ? n + 1 : n
    }
    var r = i ? [0, t.length] : [t[0], t[t.length - 1]];
    if (Array.isArray(e) && (e = e.filter(function(e) {
            return e.toString().trim().length > 0
        })).length) {
        for (var o = 0, a = -1, s = 1, l = 0; a < 0;) a = n(e[o], t), o++;
        for (; 0 == l;) l = n(e[e.length - s], t, !0), s++;
        i || (a = t[a], l = t[l - 1]), r = [a, l]
    }
    return r
}, BCSfFilter.prototype.catchError = function(e, t) {
    if (!(e.total_product <= 0) || "init" === t && this.getSettingValue("general.productAndVariantAvailable") && this.getSettingValue("general.availableAfterFiltering"));
    else {
        var i = this.getSettingValue("label.error.noProducts");
        if (this.checkExistFilterOptionParam() ? i = this.getSettingValue("label.error.noFilterResult") : this.isSearchPage() ? i = this.getSettingValue("label.error.noSearchResult") : 0 == this.collectionCount && (i = this.getSettingValue("label.error.noProducts")), "" != i) {
            var n = this.getTemplate("noResult").replace(/{{content}}/g, i);
            jQ(this.getSelector("products")).html(n), jQ(this.getSelector("pagination")).empty(), jQ(this.getSelector("topShowLimit")).empty(), jQ(this.getSelector("topSorting")).empty("")
        }
    }
}, BCSfFilter.prototype.formatMoney = function(e, t, i) {
    function n(e, t) {
        return void 0 === e ? t : e
    }

    function r(e, t, r, o) {
        if (t = n(t, 2), r = n(r, ","), o = n(o, "."), isNaN(e) || null == e) return 0;
        var a = (e = (e / 100).toFixed(t)).split("."),
            s = a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r),
            l = a[1] ? o + a[1] : "";
        return 1 == i ? (s + l).replace(/((\,00)|(\.00))$/g, "") : s + l
    }
    if (void 0 === t) t = this.moneyFormat;
    if (void 0 === i) i = !1;
    "string" == typeof e && (e = e.replace(".", ""));
    var o = "",
        a = /\{\{\s*(\w+)\s*\}\}/,
        s = t || "${{amount}}";
    switch (s.match(a)[1]) {
        case "amount":
            o = r(e, 2);
            break;
        case "amount_no_decimals":
            o = r(e, 0);
            break;
        case "amount_with_comma_separator":
            o = r(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            o = r(e, 0, ".", ",");
            break;
        case "amount_with_space_separator_no_comma":
        default:
            o = r(e, 2)
    }
    return s.replace(a, o)
}, BCSfFilter.prototype.convertMoneyToDefaultFormat = function(e) {
    switch (this.moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/)[1]) {
        case "amount_with_comma_separator":
        case "amount_no_decimals_with_comma_separator":
            var t = ".",
                i = ",";
            break;
        default:
            t = ",", i = "."
    }
    var n = new RegExp("\\" + t, "g"),
        r = new RegExp("\\" + i, "g");
    return e.toString().replace(n, "").replace(r, ".")
}, BCSfFilter.prototype.getCurrency = function() {
    return jQ("<p>" + bcSfFilterConfig.shop.money_format + "</p>").text().replace(/{{[^}]*}}/g, "")
}, BCSfFilter.prototype.removeCurrencySymbol = function(e) {
    e = jQ("<p>" + e + "</p>").text();
    for (var t = this.getCurrency().split(" "), i = 0; i < t.length; i++) e = e.replace(t[i].trim(), "");
    return e.trim()
}, BCSfFilter.prototype.isMobile = function() {
    return jQ(window).width() <= this.getSettingValue("general.breakpointMobile")
}, BCSfFilter.prototype.isMobileDevice = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}, BCSfFilter.prototype.isiOS = function() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}, BCSfFilter.prototype.initMobileDetect = function() {
    var e = this;
    e.isiOS() && (jQ("html").hasClass(e.getClass("mobileDetectiOS")) || jQ("html").addClass(e.getClass("mobileDetectiOS")))
}, BCSfFilter.prototype.checkExistFilterOptionParam = function() {
    for (var e in this.queryParams)
        if (e.indexOf("pf_") > -1) return !0;
    return !1
}, BCSfFilter.prototype.checkExistBCParam = function() {
    return this.queryParams.hasOwnProperty("_") && this.queryParams._ == this.prefix
}, BCSfFilter.prototype.isCollectionParam = function(e) {
    return !("collection" != e || "collection" == e && this.isSearchPage())
}, BCSfFilter.prototype.isVendorPage = function() {
    return window.location.pathname.indexOf("/collections/vendors") > -1
}, BCSfFilter.prototype.isTypePage = function() {
    return window.location.pathname.indexOf("/collections/types") > -1
}, BCSfFilter.prototype.isTagPage = function() {
    return void 0 !== this.currentTags && null !== this.currentTags && this.currentTags.length > 0
}, BCSfFilter.prototype.isSearchPage = function() {
    var e = window.location.search,
        t = window.location.pathname;
    return e.indexOf("search?") > -1 || -1 == t.indexOf("collections") && t.indexOf("/search") > -1 && -1 == e.indexOf("=cache")
}, BCSfFilter.prototype.removeDecimal = function(e, t) {
    t = void 0 !== t ? t : this.getSettingValue("general.decimalDelimiter");
    var i = new RegExp("(\\" + t + "\\d+)+", "gi");
    return e.replace(i, "")
}, BCSfFilter.prototype.slugify = function(e) {
    e = e.toLowerCase();
    for (var t = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;", i = 0, n = t.length; i < n; i++) e = e.replace(new RegExp(t.charAt(i), "g"), "aaaaaeeeeeiiiiiooooouuuuunc------".charAt(i));
    return e.replace(/[\s\/]+/g, "-").replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, "-").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
}, BCSfFilter.prototype.textify = function(e, t) {
    t = void 0 !== t ? t : "-";
    for (var i = e.split(t), n = "", r = 0; r < i.length; r++) n += i[r].charAt(0).toUpperCase() + i[r].slice(1), r < i.length - 1 && (n += " ");
    return n
}, BCSfFilter.prototype.escape = function(e, t) {
    return t = t ? "&#13;" : "\n", ("" + e).replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r\n/g, t).replace(/[\r\n]/g, t)
}, BCSfFilter.prototype.sortFilterOptionValue = function(e) {
    var t = e.hasOwnProperty("sortType") && e.sortType ? e.sortType : "key-asc",
        i = t.split("-")[0];
    return "collection" == e.filterType && "key" == i && (i = "label"), e.values && e.values.length > 0 && e.values.sort(function(e, t) {
        function n(e) {
            for (var t, i, n = new Array, r = 0, o = -1, a = 0; t = (i = e.charAt(r++)).charCodeAt(0);) {
                var s = 46 == t || t >= 48 && t <= 57;
                s !== a && (n[++o] = "", a = s), n[o] += i
            }
            return n
        }
        e = e[i].toString().toLowerCase(), t = t[i].toString().toLowerCase();
        var r = n(e),
            o = n(t);
        for (x = 0; r[x] && o[x]; x++)
            if (r[x] !== o[x]) {
                var a = Number(r[x]),
                    s = Number(o[x]);
                return a == r[x] && s == o[x] ? a - s : r[x] > o[x] ? 1 : -1
            } return r.length - o.length
    }), t.indexOf("desc") > -1 && e.values.reverse(), e.values
}, BCSfFilter.prototype.truncateByChar = function(e, t, i) {
    return void 0 === i && (i = "..."), t -= i.length, e.length > t ? e.substring(0, t) + i : e.substring(0, t)
}, BCSfFilter.prototype.truncateByWord = function(e, t, i) {
    return void 0 === i && (i = "..."), e.split(" ").length > t ? e.split(" ").splice(0, t).join(" ") + i : e.split(" ").splice(0, t).join(" ")
}, BCSfFilter.prototype.findIndexArray = function(e, t, i, n) {
    if (null != i) {
        for (var r = 0; r < t.length; r++)
            if (void 0 !== n && 0 == n && (t[r][i] = t[r][i].toLowerCase(), e = e.toLowerCase()), t[r][i] == e) return r
    } else
        for (r = 0; r < t.length; r++)
            if (void 0 !== n && 0 == n && (t[r] = t[r].toLowerCase(), e = e.toLowerCase()), t[r] == e) return r;
    return -1
}, BCSfFilter.prototype.getApiUrl = function(e) {
    var t = bcSfFilterConfig.api.filterUrl;
    switch (e) {
        case "search":
            t = bcSfFilterConfig.api.searchUrl;
            break;
        case "suggestion":
            t = bcSfFilterConfig.api.suggestionUrl
    }
    return t
}, BCSfFilter.prototype.getPriceLabel = function(e) {
    if (0 == e.indexOf(":")) return this.getSettingValue("label.under") + " " + this.formatMoney(100 * parseFloat(e.substr(1)), this.moneyFormat, this.getSettingValue("general.removePriceDecimal"));
    if (e.indexOf(":") == e.length - 1) return this.getSettingValue("label.above") + " " + this.formatMoney(100 * parseFloat(e.slice(0, -1)), this.moneyFormat, this.getSettingValue("general.removePriceDecimal"));
    if (2 == e.split(":").length) {
        var t = e.split(":");
        return this.formatMoney(100 * parseFloat(t[0]), this.moneyFormat, this.getSettingValue("general.removePriceDecimal")) + " - " + this.formatMoney(100 * parseFloat(t[1]), this.moneyFormat, this.getSettingValue("general.removePriceDecimal"))
    }
}, BCSfFilter.prototype.getPercentSaleLabel = function(e) {
    return 0 == (e = this.removeDecimal(e)).indexOf(":") ? this.getSettingValue("label.under") + " " + e.substr(1) + "%" : e.indexOf(":") == e.length - 1 ? this.getSettingValue("label.above") + " " + e.slice(0, -1) + "%" : 2 == e.split(":").length ? e.split(":")[0] + "% - " + e.split(":").pop() + "%" : void 0
}, BCSfFilter.prototype.getReviewRatingsLabel = function(e, t) {
    var i = e + " ";
    return i += 1 == e ? this.getSettingValue("label.ratingStar") : this.getSettingValue("label.ratingStars"), t || (i += " " + this.getSettingValue("label.ratingUp")), i
}, BCSfFilter.prototype.getSettingValue = function(e, t) {
    var i = void 0 !== t ? t : this.defaultSettings;
    bcSfFilterConfig.hasOwnProperty("settings") && null !== bcSfFilterConfig.settings && (i = mergeObject(i, bcSfFilterConfig.settings)), "undefined" != typeof bcSfFilterSettings && Object.keys(bcSfFilterSettings).length > 0 && (i = mergeObject(i, bcSfFilterSettings)), "undefined" != typeof bcSfSearchSettings && Object.keys(bcSfSearchSettings).length > 0 && (i = mergeObject(i, bcSfSearchSettings));
    var n = "";
    if (i.hasOwnProperty(e)) return i[e];
    if (e.indexOf(".") > -1)
        for (var r = e.split("."), o = 0; o < r.length; o++)
            if ("" == n) {
                if (!i.hasOwnProperty(r[o])) return "";

                n = i[r[o]]
            } else {
                if (!n.hasOwnProperty(r[o])) return "";
                n = n[r[o]]
            } return n
}, BCSfFilter.prototype.getTemplate = function(e) {
    var t = {
        template: this.template
    };
    return this.getSettingValue("template." + e, t)
}, BCSfFilter.prototype.getSelector = function(e) {
    var t = {
        selector: this.selector
    };
    return this.getSettingValue("selector." + e, t)
}, BCSfFilter.prototype.getClass = function(e) {
    var t = {
        class: this.class
    };
    return this.getSettingValue("class." + e, t)
}, BCSfFilter.prototype.getLabel = function(e, t, i) {
    return bcSfFilterConfig.hasOwnProperty(e) && bcSfFilterConfig[e].hasOwnProperty(t) ? bcSfFilterConfig[e][t] : i
};